import "core-js/modules/esnext.global-this.js";
import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import "core-js/modules/es.string.trim-end.js";
import "core-js/modules/es.string.trim-start.js";
import * as n from "react";
import t, { useReducer as e, useContext as r, useRef as o, useEffect as i, forwardRef as a, createElement as u, createContext as s, Fragment as c, useLayoutEffect as l, useCallback as f, useMemo as p, useState as d, cloneElement as h, Children as v, isValidElement as m, useImperativeHandle as g, Component as y } from "react";
import b from "process";
import w from "react-dom";
var x = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {},
    S = {
  exports: {}
},
    _ = {
  exports: {}
},
    E = {},
    T = "function" == typeof Symbol && Symbol.for,
    P = T ? Symbol.for("react.element") : 60103,
    C = T ? Symbol.for("react.portal") : 60106,
    A = T ? Symbol.for("react.fragment") : 60107,
    L = T ? Symbol.for("react.strict_mode") : 60108,
    O = T ? Symbol.for("react.profiler") : 60114,
    k = T ? Symbol.for("react.provider") : 60109,
    R = T ? Symbol.for("react.context") : 60110,
    N = T ? Symbol.for("react.async_mode") : 60111,
    z = T ? Symbol.for("react.concurrent_mode") : 60111,
    I = T ? Symbol.for("react.forward_ref") : 60112,
    D = T ? Symbol.for("react.suspense") : 60113,
    j = T ? Symbol.for("react.suspense_list") : 60120,
    M = T ? Symbol.for("react.memo") : 60115,
    B = T ? Symbol.for("react.lazy") : 60116,
    V = T ? Symbol.for("react.block") : 60121,
    F = T ? Symbol.for("react.fundamental") : 60117,
    W = T ? Symbol.for("react.responder") : 60118,
    Y = T ? Symbol.for("react.scope") : 60119;

function H(n) {
  if ("object" == typeof n && null !== n) {
    var t = n.$$typeof;

    switch (t) {
      case P:
        switch (n = n.type) {
          case N:
          case z:
          case A:
          case O:
          case L:
          case D:
            return n;

          default:
            switch (n = n && n.$$typeof) {
              case R:
              case I:
              case B:
              case M:
              case k:
                return n;

              default:
                return t;
            }

        }

      case C:
        return t;
    }
  }
}

function U(n) {
  return H(n) === z;
}

E.AsyncMode = N, E.ConcurrentMode = z, E.ContextConsumer = R, E.ContextProvider = k, E.Element = P, E.ForwardRef = I, E.Fragment = A, E.Lazy = B, E.Memo = M, E.Portal = C, E.Profiler = O, E.StrictMode = L, E.Suspense = D, E.isAsyncMode = function (n) {
  return U(n) || H(n) === N;
}, E.isConcurrentMode = U, E.isContextConsumer = function (n) {
  return H(n) === R;
}, E.isContextProvider = function (n) {
  return H(n) === k;
}, E.isElement = function (n) {
  return "object" == typeof n && null !== n && n.$$typeof === P;
}, E.isForwardRef = function (n) {
  return H(n) === I;
}, E.isFragment = function (n) {
  return H(n) === A;
}, E.isLazy = function (n) {
  return H(n) === B;
}, E.isMemo = function (n) {
  return H(n) === M;
}, E.isPortal = function (n) {
  return H(n) === C;
}, E.isProfiler = function (n) {
  return H(n) === O;
}, E.isStrictMode = function (n) {
  return H(n) === L;
}, E.isSuspense = function (n) {
  return H(n) === D;
}, E.isValidElementType = function (n) {
  return "string" == typeof n || "function" == typeof n || n === A || n === z || n === O || n === L || n === D || n === j || "object" == typeof n && null !== n && (n.$$typeof === B || n.$$typeof === M || n.$$typeof === k || n.$$typeof === R || n.$$typeof === I || n.$$typeof === F || n.$$typeof === W || n.$$typeof === Y || n.$$typeof === V);
}, E.typeOf = H;
var $ = {};
"production" !== b.env.NODE_ENV && function () {
  var n = "function" == typeof Symbol && Symbol.for,
      t = n ? Symbol.for("react.element") : 60103,
      e = n ? Symbol.for("react.portal") : 60106,
      r = n ? Symbol.for("react.fragment") : 60107,
      o = n ? Symbol.for("react.strict_mode") : 60108,
      i = n ? Symbol.for("react.profiler") : 60114,
      a = n ? Symbol.for("react.provider") : 60109,
      u = n ? Symbol.for("react.context") : 60110,
      s = n ? Symbol.for("react.async_mode") : 60111,
      c = n ? Symbol.for("react.concurrent_mode") : 60111,
      l = n ? Symbol.for("react.forward_ref") : 60112,
      f = n ? Symbol.for("react.suspense") : 60113,
      p = n ? Symbol.for("react.suspense_list") : 60120,
      d = n ? Symbol.for("react.memo") : 60115,
      h = n ? Symbol.for("react.lazy") : 60116,
      v = n ? Symbol.for("react.block") : 60121,
      m = n ? Symbol.for("react.fundamental") : 60117,
      g = n ? Symbol.for("react.responder") : 60118,
      y = n ? Symbol.for("react.scope") : 60119;

  function b(n) {
    if ("object" == typeof n && null !== n) {
      var p = n.$$typeof;

      switch (p) {
        case t:
          var v = n.type;

          switch (v) {
            case s:
            case c:
            case r:
            case i:
            case o:
            case f:
              return v;

            default:
              var m = v && v.$$typeof;

              switch (m) {
                case u:
                case l:
                case h:
                case d:
                case a:
                  return m;

                default:
                  return p;
              }

          }

        case e:
          return p;
      }
    }
  }

  var w = s,
      x = c,
      S = u,
      _ = a,
      E = t,
      T = l,
      P = r,
      C = h,
      A = d,
      L = e,
      O = i,
      k = o,
      R = f,
      N = !1;

  function z(n) {
    return b(n) === c;
  }

  $.AsyncMode = w, $.ConcurrentMode = x, $.ContextConsumer = S, $.ContextProvider = _, $.Element = E, $.ForwardRef = T, $.Fragment = P, $.Lazy = C, $.Memo = A, $.Portal = L, $.Profiler = O, $.StrictMode = k, $.Suspense = R, $.isAsyncMode = function (n) {
    return N || (N = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), z(n) || b(n) === s;
  }, $.isConcurrentMode = z, $.isContextConsumer = function (n) {
    return b(n) === u;
  }, $.isContextProvider = function (n) {
    return b(n) === a;
  }, $.isElement = function (n) {
    return "object" == typeof n && null !== n && n.$$typeof === t;
  }, $.isForwardRef = function (n) {
    return b(n) === l;
  }, $.isFragment = function (n) {
    return b(n) === r;
  }, $.isLazy = function (n) {
    return b(n) === h;
  }, $.isMemo = function (n) {
    return b(n) === d;
  }, $.isPortal = function (n) {
    return b(n) === e;
  }, $.isProfiler = function (n) {
    return b(n) === i;
  }, $.isStrictMode = function (n) {
    return b(n) === o;
  }, $.isSuspense = function (n) {
    return b(n) === f;
  }, $.isValidElementType = function (n) {
    return "string" == typeof n || "function" == typeof n || n === r || n === c || n === i || n === o || n === f || n === p || "object" == typeof n && null !== n && (n.$$typeof === h || n.$$typeof === d || n.$$typeof === a || n.$$typeof === u || n.$$typeof === l || n.$$typeof === m || n.$$typeof === g || n.$$typeof === y || n.$$typeof === v);
  }, $.typeOf = b;
}(), "production" === b.env.NODE_ENV ? _.exports = E : _.exports = $
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
;
var X = Object.getOwnPropertySymbols,
    q = Object.prototype.hasOwnProperty,
    G = Object.prototype.propertyIsEnumerable;

function K(n) {
  if (null == n) throw new TypeError("Object.assign cannot be called with null or undefined");
  return Object(n);
}

var Z = function () {
  try {
    if (!Object.assign) return !1;
    var n = new String("abc");
    if (n[5] = "de", "5" === Object.getOwnPropertyNames(n)[0]) return !1;

    for (var t = {}, e = 0; e < 10; e++) {
      t["_" + String.fromCharCode(e)] = e;
    }

    if ("0123456789" !== Object.getOwnPropertyNames(t).map(function (n) {
      return t[n];
    }).join("")) return !1;
    var r = {};
    return "abcdefghijklmnopqrst".split("").forEach(function (n) {
      r[n] = n;
    }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, r)).join("");
  } catch (n) {
    return !1;
  }
}() ? Object.assign : function (n, t) {
  for (var e, r, o = K(n), i = 1; i < arguments.length; i++) {
    for (var a in e = Object(arguments[i])) {
      q.call(e, a) && (o[a] = e[a]);
    }

    if (X) {
      r = X(e);

      for (var u = 0; u < r.length; u++) {
        G.call(e, r[u]) && (o[r[u]] = e[r[u]]);
      }
    }
  }

  return o;
},
    J = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED",
    Q = function Q() {};

if ("production" !== b.env.NODE_ENV) {
  var nn = J,
      tn = {},
      en = Function.call.bind(Object.prototype.hasOwnProperty);

  Q = function Q(n) {
    var t = "Warning: " + n;
    "undefined" != typeof console && console.error(t);

    try {
      throw new Error(t);
    } catch (n) {}
  };
}

function rn(n, t, e, r, o) {
  if ("production" !== b.env.NODE_ENV) for (var i in n) {
    if (en(n, i)) {
      var a;

      try {
        if ("function" != typeof n[i]) {
          var u = Error((r || "React class") + ": " + e + " type `" + i + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof n[i] + "`.");
          throw u.name = "Invariant Violation", u;
        }

        a = n[i](t, i, r, e, null, nn);
      } catch (n) {
        a = n;
      }

      if (!a || a instanceof Error || Q((r || "React class") + ": type specification of " + e + " `" + i + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof a + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."), a instanceof Error && !(a.message in tn)) {
        tn[a.message] = !0;
        var s = o ? o() : "";
        Q("Failed " + e + " type: " + a.message + (null != s ? s : ""));
      }
    }
  }
}

rn.resetWarningCache = function () {
  "production" !== b.env.NODE_ENV && (tn = {});
};

var on = rn,
    an = _.exports,
    un = Z,
    sn = J,
    cn = on,
    ln = Function.call.bind(Object.prototype.hasOwnProperty),
    fn = function fn() {};

function pn() {
  return null;
}

"production" !== b.env.NODE_ENV && (fn = function fn(n) {
  var t = "Warning: " + n;
  "undefined" != typeof console && console.error(t);

  try {
    throw new Error(t);
  } catch (n) {}
});

function dn() {}

function hn() {}

hn.resetWarningCache = dn;

if ("production" !== b.env.NODE_ENV) {
  var vn = _.exports;

  S.exports = function (n, t) {
    var e = "function" == typeof Symbol && Symbol.iterator,
        r = "<<anonymous>>",
        o = {
      array: s("array"),
      bool: s("boolean"),
      func: s("function"),
      number: s("number"),
      object: s("object"),
      string: s("string"),
      symbol: s("symbol"),
      any: u(pn),
      arrayOf: function arrayOf(n) {
        return u(function (t, e, r, o, i) {
          if ("function" != typeof n) return new a("Property `" + i + "` of component `" + r + "` has invalid PropType notation inside arrayOf.");
          var u = t[e];
          if (!Array.isArray(u)) return new a("Invalid " + o + " `" + i + "` of type `" + l(u) + "` supplied to `" + r + "`, expected an array.");

          for (var s = 0; s < u.length; s++) {
            var c = n(u, s, r, o, i + "[" + s + "]", sn);
            if (c instanceof Error) return c;
          }

          return null;
        });
      },
      element: u(function (t, e, r, o, i) {
        var u = t[e];
        return n(u) ? null : new a("Invalid " + o + " `" + i + "` of type `" + l(u) + "` supplied to `" + r + "`, expected a single ReactElement.");
      }),
      elementType: u(function (n, t, e, r, o) {
        var i = n[t];
        return an.isValidElementType(i) ? null : new a("Invalid " + r + " `" + o + "` of type `" + l(i) + "` supplied to `" + e + "`, expected a single ReactElement type.");
      }),
      instanceOf: function instanceOf(n) {
        return u(function (t, e, o, i, u) {
          if (!(t[e] instanceof n)) {
            var s = n.name || r;
            return new a("Invalid " + i + " `" + u + "` of type `" + ((c = t[e]).constructor && c.constructor.name ? c.constructor.name : r) + "` supplied to `" + o + "`, expected instance of `" + s + "`.");
          }

          var c;
          return null;
        });
      },
      node: u(function (n, t, e, r, o) {
        return c(n[t]) ? null : new a("Invalid " + r + " `" + o + "` supplied to `" + e + "`, expected a ReactNode.");
      }),
      objectOf: function objectOf(n) {
        return u(function (t, e, r, o, i) {
          if ("function" != typeof n) return new a("Property `" + i + "` of component `" + r + "` has invalid PropType notation inside objectOf.");
          var u = t[e],
              s = l(u);
          if ("object" !== s) return new a("Invalid " + o + " `" + i + "` of type `" + s + "` supplied to `" + r + "`, expected an object.");

          for (var c in u) {
            if (ln(u, c)) {
              var f = n(u, c, r, o, i + "." + c, sn);
              if (f instanceof Error) return f;
            }
          }

          return null;
        });
      },
      oneOf: function oneOf(n) {
        if (!Array.isArray(n)) return "production" !== b.env.NODE_ENV && fn(arguments.length > 1 ? "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])." : "Invalid argument supplied to oneOf, expected an array."), pn;

        function t(t, e, r, o, u) {
          for (var s = t[e], c = 0; c < n.length; c++) {
            if (i(s, n[c])) return null;
          }

          var l = JSON.stringify(n, function (n, t) {
            return "symbol" === f(t) ? String(t) : t;
          });
          return new a("Invalid " + o + " `" + u + "` of value `" + String(s) + "` supplied to `" + r + "`, expected one of " + l + ".");
        }

        return u(t);
      },
      oneOfType: function oneOfType(n) {
        if (!Array.isArray(n)) return "production" !== b.env.NODE_ENV && fn("Invalid argument supplied to oneOfType, expected an instance of array."), pn;

        for (var t = 0; t < n.length; t++) {
          var e = n[t];
          if ("function" != typeof e) return fn("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + p(e) + " at index " + t + "."), pn;
        }

        return u(function (t, e, r, o, i) {
          for (var u = 0; u < n.length; u++) {
            if (null == (0, n[u])(t, e, r, o, i, sn)) return null;
          }

          return new a("Invalid " + o + " `" + i + "` supplied to `" + r + "`.");
        });
      },
      shape: function shape(n) {
        return u(function (t, e, r, o, i) {
          var u = t[e],
              s = l(u);
          if ("object" !== s) return new a("Invalid " + o + " `" + i + "` of type `" + s + "` supplied to `" + r + "`, expected `object`.");

          for (var c in n) {
            var f = n[c];

            if (f) {
              var p = f(u, c, r, o, i + "." + c, sn);
              if (p) return p;
            }
          }

          return null;
        });
      },
      exact: function exact(n) {
        return u(function (t, e, r, o, i) {
          var u = t[e],
              s = l(u);
          if ("object" !== s) return new a("Invalid " + o + " `" + i + "` of type `" + s + "` supplied to `" + r + "`, expected `object`.");
          var c = un({}, t[e], n);

          for (var f in c) {
            var p = n[f];
            if (!p) return new a("Invalid " + o + " `" + i + "` key `" + f + "` supplied to `" + r + "`.\nBad object: " + JSON.stringify(t[e], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(n), null, "  "));
            var d = p(u, f, r, o, i + "." + f, sn);
            if (d) return d;
          }

          return null;
        });
      }
    };

    function i(n, t) {
      return n === t ? 0 !== n || 1 / n == 1 / t : n != n && t != t;
    }

    function a(n) {
      this.message = n, this.stack = "";
    }

    function u(n) {
      if ("production" !== b.env.NODE_ENV) var e = {},
          o = 0;

      function i(i, u, s, c, l, f, p) {
        if (c = c || r, f = f || s, p !== sn) {
          if (t) {
            var d = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
            throw d.name = "Invariant Violation", d;
          }

          if ("production" !== b.env.NODE_ENV && "undefined" != typeof console) {
            var h = c + ":" + s;
            !e[h] && o < 3 && (fn("You are manually calling a React.PropTypes validation function for the `" + f + "` prop on `" + c + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."), e[h] = !0, o++);
          }
        }

        return null == u[s] ? i ? null === u[s] ? new a("The " + l + " `" + f + "` is marked as required in `" + c + "`, but its value is `null`.") : new a("The " + l + " `" + f + "` is marked as required in `" + c + "`, but its value is `undefined`.") : null : n(u, s, c, l, f);
      }

      var u = i.bind(null, !1);
      return u.isRequired = i.bind(null, !0), u;
    }

    function s(n) {
      return u(function (t, e, r, o, i, u) {
        var s = t[e];
        return l(s) !== n ? new a("Invalid " + o + " `" + i + "` of type `" + f(s) + "` supplied to `" + r + "`, expected `" + n + "`.") : null;
      });
    }

    function c(t) {
      switch (typeof t) {
        case "number":
        case "string":
        case "undefined":
          return !0;

        case "boolean":
          return !t;

        case "object":
          if (Array.isArray(t)) return t.every(c);
          if (null === t || n(t)) return !0;

          var r = function (n) {
            var t = n && (e && n[e] || n["@@iterator"]);
            if ("function" == typeof t) return t;
          }(t);

          if (!r) return !1;
          var o,
              i = r.call(t);

          if (r !== t.entries) {
            for (; !(o = i.next()).done;) {
              if (!c(o.value)) return !1;
            }
          } else for (; !(o = i.next()).done;) {
            var a = o.value;
            if (a && !c(a[1])) return !1;
          }

          return !0;

        default:
          return !1;
      }
    }

    function l(n) {
      var t = typeof n;
      return Array.isArray(n) ? "array" : n instanceof RegExp ? "object" : function (n, t) {
        return "symbol" === n || !!t && ("Symbol" === t["@@toStringTag"] || "function" == typeof Symbol && t instanceof Symbol);
      }(t, n) ? "symbol" : t;
    }

    function f(n) {
      if (null == n) return "" + n;
      var t = l(n);

      if ("object" === t) {
        if (n instanceof Date) return "date";
        if (n instanceof RegExp) return "regexp";
      }

      return t;
    }

    function p(n) {
      var t = f(n);

      switch (t) {
        case "array":
        case "object":
          return "an " + t;

        case "boolean":
        case "date":
        case "regexp":
          return "a " + t;

        default:
          return t;
      }
    }

    return a.prototype = Error.prototype, o.checkPropTypes = cn, o.resetWarningCache = cn.resetWarningCache, o.PropTypes = o, o;
  }(vn.isElement, !0);
} else S.exports = function () {
  function n(n, t, e, r, o, i) {
    if ("SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED" !== i) {
      var a = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
      throw a.name = "Invariant Violation", a;
    }
  }

  function t() {
    return n;
  }

  n.isRequired = n;
  var e = {
    array: n,
    bool: n,
    func: n,
    number: n,
    object: n,
    string: n,
    symbol: n,
    any: n,
    arrayOf: t,
    element: n,
    elementType: n,
    instanceOf: t,
    node: n,
    objectOf: t,
    oneOf: t,
    oneOfType: t,
    shape: t,
    exact: t,
    checkPropTypes: hn,
    resetWarningCache: dn
  };
  return e.PropTypes = e, e;
}();

var mn = S.exports;

function gn(n, t) {
  (null == t || t > n.length) && (t = n.length);

  for (var e = 0, r = new Array(t); e < t; e++) {
    r[e] = n[e];
  }

  return r;
}

function yn(n, t) {
  if (n) {
    if ("string" == typeof n) return gn(n, t);
    var e = Object.prototype.toString.call(n).slice(8, -1);
    return "Object" === e && n.constructor && (e = n.constructor.name), "Map" === e || "Set" === e ? Array.from(n) : "Arguments" === e || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(e) ? gn(n, t) : void 0;
  }
}

function bn(n, t) {
  return function (n) {
    if (Array.isArray(n)) return n;
  }(n) || function (n, t) {
    var e = null == n ? null : "undefined" != typeof Symbol && n[Symbol.iterator] || n["@@iterator"];

    if (null != e) {
      var r,
          o,
          i = [],
          a = !0,
          u = !1;

      try {
        for (e = e.call(n); !(a = (r = e.next()).done) && (i.push(r.value), !t || i.length !== t); a = !0) {
          ;
        }
      } catch (n) {
        u = !0, o = n;
      } finally {
        try {
          a || null == e.return || e.return();
        } finally {
          if (u) throw o;
        }
      }

      return i;
    }
  }(n, t) || yn(n, t) || function () {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}

function wn(n, t, e) {
  return t in n ? Object.defineProperty(n, t, {
    value: e,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : n[t] = e, n;
}

function xn(n, t) {
  var e = Object.keys(n);

  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(n);
    t && (r = r.filter(function (t) {
      return Object.getOwnPropertyDescriptor(n, t).enumerable;
    })), e.push.apply(e, r);
  }

  return e;
}

function Sn(n) {
  for (var t = 1; t < arguments.length; t++) {
    var e = null != arguments[t] ? arguments[t] : {};
    t % 2 ? xn(Object(e), !0).forEach(function (t) {
      wn(n, t, e[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(e)) : xn(Object(e)).forEach(function (t) {
      Object.defineProperty(n, t, Object.getOwnPropertyDescriptor(e, t));
    });
  }

  return n;
}

var _n = {
  elements: [],
  isOpened: !1,
  isLoaded: !1,
  options: {
    buttons: {
      backgroundColor: "rgba(30,30,36,0.8)",
      iconColor: "rgba(255, 255, 255, 0.8)",
      iconPadding: "10px",
      showAutoplayButton: !0,
      showCloseButton: !0,
      showDownloadButton: !0,
      showFullscreenButton: !0,
      showNextButton: !0,
      showPrevButton: !0,
      size: "40px"
    },
    settings: {
      autoplaySpeed: 3e3,
      boxShadow: "none",
      disableKeyboardControls: !1,
      disablePanzoom: !1,
      disableWheelControls: !1,
      downloadedFileName: "SRL-image",
      hideControlsAfter: !1,
      lightboxTransitionSpeed: .3,
      lightboxTransitionTimingFunction: "linear",
      overlayColor: "rgba(30, 30, 30, 0.9)",
      slideAnimationType: "fade",
      slideSpringValues: [300, 50],
      slideTransitionSpeed: .6,
      slideTransitionTimingFunction: "linear",
      usingPreact: !1
    },
    caption: {
      captionAlignment: "start",
      captionColor: "#FFFFFF",
      captionFontFamily: "inherit",
      captionFontSize: "inherit",
      captionFontStyle: "inherit",
      captionFontWeight: "inherit",
      captionContainerPadding: "20px 0 30px 0",
      captionTextTransform: "inherit",
      showCaption: !0
    },
    thumbnails: {
      showThumbnails: !0,
      thumbnailsAlignment: "center",
      thumbnailsContainerPadding: "0",
      thumbnailsContainerBackgroundColor: "transparent",
      thumbnailsGap: "0 1px",
      thumbnailsIconColor: "#ffffff",
      thumbnailsPosition: "bottom",
      thumbnailsOpacity: .4,
      thumbnailsSize: ["100px", "80px"]
    },
    progressBar: {
      backgroundColor: "#f2f2f2",
      fillColor: "#000000",
      height: "3px",
      showProgressBar: !0
    }
  },
  selectedElement: {
    caption: "",
    height: 0,
    id: 0,
    source: "",
    thumbnail: "",
    width: 0
  },
  callbacks: {
    onCountSlides: function onCountSlides() {},
    onSlideChange: function onSlideChange() {},
    onLightboxClosed: function onLightboxClosed() {},
    onLightboxOpened: function onLightboxOpened() {}
  }
},
    En = t.createContext(_n),
    Tn = function Tn(n) {
  var r = bn(e(function (n, t) {
    switch (t.type) {
      case "READY_LIGHTBOX":
        return Sn(Sn(Sn({}, n), t.mergedSettings), {}, {
          elements: t.elements,
          isLoaded: !0
        });

      case "RESET_LIGHTBOX":
        return Sn({}, _n);

      case "HANDLE_ELEMENT":
        return Sn(Sn({}, n), {}, {
          isOpened: !0,
          selectedElement: Sn({}, t.element)
        });

      case "OPEN_AT_INDEX":
        return Sn(Sn({}, n), {}, {
          isOpened: !0,
          selectedElement: Sn({}, n.elements[t.index])
        });

      case "CLOSE_LIGHTBOX":
        return Sn(Sn({}, n), {}, {
          isOpened: !1
        });

      default:
        return n;
    }
  }, _n), 2),
      o = r[0],
      i = r[1];
  return t.createElement(En.Provider, {
    value: Sn(Sn({}, o), {}, {
      dispatch: i
    })
  }, n.children);
};

function Pn(n) {
  return function (n) {
    if (Array.isArray(n)) return gn(n);
  }(n) || function (n) {
    if ("undefined" != typeof Symbol && null != n[Symbol.iterator] || null != n["@@iterator"]) return Array.from(n);
  }(n) || yn(n) || function () {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}

function Cn(n, t, e) {
  n.addEventListener("click", function () {
    if (e) return e(t);
  });
}

function An(n) {
  var t = [].map.call(n, function (n) {
    return (t = n, e = new Promise(function (n, e) {
      function r() {
        "lazy" === t.loading || 0 !== t.naturalWidth ? n(t) : e(void 0), t.removeEventListener("load", r), t.removeEventListener("error", r);
      }

      "lazy" === t.loading || 0 !== t.naturalWidth ? n(t) : t.complete ? e(void 0) : (t.addEventListener("load", r), t.addEventListener("error", r));
    }), Object.assign(e, {
      image: t
    })).catch(function (n) {
      return n;
    });
    var t, e;
  });
  return Promise.all(t).then(function (n) {
    return Promise.resolve(n.filter(function (n) {
      return n;
    }));
  });
}

Tn.propTypes = {
  children: mn.oneOfType([mn.arrayOf(mn.node), mn.node]).isRequired
};

function Ln(n) {
  console.error(n), console.warn("An error as occurred with Simple React Lightbox. Make sure you wrapped your App with the <SimpleReactLightbox> component and then use the <SRLWrapper> component.");
}

var On,
    kn,
    Rn = {
  exports: {}
};
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

function Nn(n, t) {
  var e = Object.keys(n);

  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(n);
    t && (r = r.filter(function (t) {
      return Object.getOwnPropertyDescriptor(n, t).enumerable;
    })), e.push.apply(e, r);
  }

  return e;
}

function zn(n) {
  for (var t = 1; t < arguments.length; t++) {
    var e = null != arguments[t] ? arguments[t] : {};
    t % 2 ? Nn(Object(e), !0).forEach(function (t) {
      wn(n, t, e[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(e)) : Nn(Object(e)).forEach(function (t) {
      Object.defineProperty(n, t, Object.getOwnPropertyDescriptor(e, t));
    });
  }

  return n;
}

On = Rn, kn = Rn.exports, function () {
  var n,
      t = "Expected a function",
      e = "__lodash_hash_undefined__",
      r = "__lodash_placeholder__",
      o = 16,
      i = 32,
      a = 64,
      u = 128,
      s = 256,
      c = 1 / 0,
      l = 9007199254740991,
      f = NaN,
      p = 4294967295,
      d = [["ary", u], ["bind", 1], ["bindKey", 2], ["curry", 8], ["curryRight", o], ["flip", 512], ["partial", i], ["partialRight", a], ["rearg", s]],
      h = "[object Arguments]",
      v = "[object Array]",
      m = "[object Boolean]",
      g = "[object Date]",
      y = "[object Error]",
      b = "[object Function]",
      w = "[object GeneratorFunction]",
      S = "[object Map]",
      _ = "[object Number]",
      E = "[object Object]",
      T = "[object Promise]",
      P = "[object RegExp]",
      C = "[object Set]",
      A = "[object String]",
      L = "[object Symbol]",
      O = "[object WeakMap]",
      k = "[object ArrayBuffer]",
      R = "[object DataView]",
      N = "[object Float32Array]",
      z = "[object Float64Array]",
      I = "[object Int8Array]",
      D = "[object Int16Array]",
      j = "[object Int32Array]",
      M = "[object Uint8Array]",
      B = "[object Uint8ClampedArray]",
      V = "[object Uint16Array]",
      F = "[object Uint32Array]",
      W = /\b__p \+= '';/g,
      Y = /\b(__p \+=) '' \+/g,
      H = /(__e\(.*?\)|\b__t\)) \+\n'';/g,
      U = /&(?:amp|lt|gt|quot|#39);/g,
      $ = /[&<>"']/g,
      X = RegExp(U.source),
      q = RegExp($.source),
      G = /<%-([\s\S]+?)%>/g,
      K = /<%([\s\S]+?)%>/g,
      Z = /<%=([\s\S]+?)%>/g,
      J = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      Q = /^\w*$/,
      nn = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,
      tn = /[\\^$.*+?()[\]{}|]/g,
      en = RegExp(tn.source),
      rn = /^\s+/,
      on = /\s/,
      an = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      un = /\{\n\/\* \[wrapped with (.+)\] \*/,
      sn = /,? & /,
      cn = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g,
      ln = /[()=,{}\[\]\/\s]/,
      fn = /\\(\\)?/g,
      pn = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g,
      dn = /\w*$/,
      hn = /^[-+]0x[0-9a-f]+$/i,
      vn = /^0b[01]+$/i,
      mn = /^\[object .+?Constructor\]$/,
      gn = /^0o[0-7]+$/i,
      yn = /^(?:0|[1-9]\d*)$/,
      bn = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g,
      wn = /($^)/,
      xn = /['\n\r\u2028\u2029\\]/g,
      Sn = "\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff",
      _n = "\\u2700-\\u27bf",
      En = "a-z\\xdf-\\xf6\\xf8-\\xff",
      Tn = "A-Z\\xc0-\\xd6\\xd8-\\xde",
      Pn = "\\ufe0e\\ufe0f",
      Cn = "\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000",
      An = "['’]",
      Ln = "[\\ud800-\\udfff]",
      Rn = "[" + Cn + "]",
      Nn = "[" + Sn + "]",
      zn = "\\d+",
      In = "[\\u2700-\\u27bf]",
      Dn = "[" + En + "]",
      jn = "[^\\ud800-\\udfff" + Cn + zn + _n + En + Tn + "]",
      Mn = "\\ud83c[\\udffb-\\udfff]",
      Bn = "[^\\ud800-\\udfff]",
      Vn = "(?:\\ud83c[\\udde6-\\uddff]){2}",
      Fn = "[\\ud800-\\udbff][\\udc00-\\udfff]",
      Wn = "[" + Tn + "]",
      Yn = "(?:" + Dn + "|" + jn + ")",
      Hn = "(?:" + Wn + "|" + jn + ")",
      Un = "(?:['’](?:d|ll|m|re|s|t|ve))?",
      $n = "(?:['’](?:D|LL|M|RE|S|T|VE))?",
      Xn = "(?:" + Nn + "|" + Mn + ")?",
      qn = "[\\ufe0e\\ufe0f]?",
      Gn = qn + Xn + "(?:\\u200d(?:" + [Bn, Vn, Fn].join("|") + ")" + qn + Xn + ")*",
      Kn = "(?:" + [In, Vn, Fn].join("|") + ")" + Gn,
      Zn = "(?:" + [Bn + Nn + "?", Nn, Vn, Fn, Ln].join("|") + ")",
      Jn = RegExp(An, "g"),
      Qn = RegExp(Nn, "g"),
      nt = RegExp(Mn + "(?=" + Mn + ")|" + Zn + Gn, "g"),
      tt = RegExp([Wn + "?" + Dn + "+" + Un + "(?=" + [Rn, Wn, "$"].join("|") + ")", Hn + "+" + $n + "(?=" + [Rn, Wn + Yn, "$"].join("|") + ")", Wn + "?" + Yn + "+" + Un, Wn + "+" + $n, "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", zn, Kn].join("|"), "g"),
      et = RegExp("[\\u200d\\ud800-\\udfff" + Sn + Pn + "]"),
      rt = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/,
      ot = ["Array", "Buffer", "DataView", "Date", "Error", "Float32Array", "Float64Array", "Function", "Int8Array", "Int16Array", "Int32Array", "Map", "Math", "Object", "Promise", "RegExp", "Set", "String", "Symbol", "TypeError", "Uint8Array", "Uint8ClampedArray", "Uint16Array", "Uint32Array", "WeakMap", "_", "clearTimeout", "isFinite", "parseInt", "setTimeout"],
      it = -1,
      at = {};
  at[N] = at[z] = at[I] = at[D] = at[j] = at[M] = at[B] = at[V] = at[F] = !0, at[h] = at[v] = at[k] = at[m] = at[R] = at[g] = at[y] = at[b] = at[S] = at[_] = at[E] = at[P] = at[C] = at[A] = at[O] = !1;
  var ut = {};
  ut[h] = ut[v] = ut[k] = ut[R] = ut[m] = ut[g] = ut[N] = ut[z] = ut[I] = ut[D] = ut[j] = ut[S] = ut[_] = ut[E] = ut[P] = ut[C] = ut[A] = ut[L] = ut[M] = ut[B] = ut[V] = ut[F] = !0, ut[y] = ut[b] = ut[O] = !1;

  var st = {
    "\\": "\\",
    "'": "'",
    "\n": "n",
    "\r": "r",
    "\u2028": "u2028",
    "\u2029": "u2029"
  },
      ct = parseFloat,
      lt = parseInt,
      ft = "object" == typeof x && x && x.Object === Object && x,
      pt = "object" == typeof self && self && self.Object === Object && self,
      dt = ft || pt || Function("return this")(),
      ht = kn && !kn.nodeType && kn,
      vt = ht && On && !On.nodeType && On,
      mt = vt && vt.exports === ht,
      gt = mt && ft.process,
      yt = function () {
    try {
      var n = vt && vt.require && vt.require("util").types;

      return n || gt && gt.binding && gt.binding("util");
    } catch (n) {}
  }(),
      bt = yt && yt.isArrayBuffer,
      wt = yt && yt.isDate,
      xt = yt && yt.isMap,
      St = yt && yt.isRegExp,
      _t = yt && yt.isSet,
      Et = yt && yt.isTypedArray;

  function Tt(n, t, e) {
    switch (e.length) {
      case 0:
        return n.call(t);

      case 1:
        return n.call(t, e[0]);

      case 2:
        return n.call(t, e[0], e[1]);

      case 3:
        return n.call(t, e[0], e[1], e[2]);
    }

    return n.apply(t, e);
  }

  function Pt(n, t, e, r) {
    for (var o = -1, i = null == n ? 0 : n.length; ++o < i;) {
      var a = n[o];
      t(r, a, e(a), n);
    }

    return r;
  }

  function Ct(n, t) {
    for (var e = -1, r = null == n ? 0 : n.length; ++e < r && !1 !== t(n[e], e, n);) {
      ;
    }

    return n;
  }

  function At(n, t) {
    for (var e = null == n ? 0 : n.length; e-- && !1 !== t(n[e], e, n);) {
      ;
    }

    return n;
  }

  function Lt(n, t) {
    for (var e = -1, r = null == n ? 0 : n.length; ++e < r;) {
      if (!t(n[e], e, n)) return !1;
    }

    return !0;
  }

  function Ot(n, t) {
    for (var e = -1, r = null == n ? 0 : n.length, o = 0, i = []; ++e < r;) {
      var a = n[e];
      t(a, e, n) && (i[o++] = a);
    }

    return i;
  }

  function kt(n, t) {
    return !(null == n || !n.length) && Ft(n, t, 0) > -1;
  }

  function Rt(n, t, e) {
    for (var r = -1, o = null == n ? 0 : n.length; ++r < o;) {
      if (e(t, n[r])) return !0;
    }

    return !1;
  }

  function Nt(n, t) {
    for (var e = -1, r = null == n ? 0 : n.length, o = Array(r); ++e < r;) {
      o[e] = t(n[e], e, n);
    }

    return o;
  }

  function zt(n, t) {
    for (var e = -1, r = t.length, o = n.length; ++e < r;) {
      n[o + e] = t[e];
    }

    return n;
  }

  function It(n, t, e, r) {
    var o = -1,
        i = null == n ? 0 : n.length;

    for (r && i && (e = n[++o]); ++o < i;) {
      e = t(e, n[o], o, n);
    }

    return e;
  }

  function Dt(n, t, e, r) {
    var o = null == n ? 0 : n.length;

    for (r && o && (e = n[--o]); o--;) {
      e = t(e, n[o], o, n);
    }

    return e;
  }

  function jt(n, t) {
    for (var e = -1, r = null == n ? 0 : n.length; ++e < r;) {
      if (t(n[e], e, n)) return !0;
    }

    return !1;
  }

  var Mt = Ut("length");

  function Bt(n, t, e) {
    var r;
    return e(n, function (n, e, o) {
      if (t(n, e, o)) return r = e, !1;
    }), r;
  }

  function Vt(n, t, e, r) {
    for (var o = n.length, i = e + (r ? 1 : -1); r ? i-- : ++i < o;) {
      if (t(n[i], i, n)) return i;
    }

    return -1;
  }

  function Ft(n, t, e) {
    return t == t ? function (n, t, e) {
      for (var r = e - 1, o = n.length; ++r < o;) {
        if (n[r] === t) return r;
      }

      return -1;
    }(n, t, e) : Vt(n, Yt, e);
  }

  function Wt(n, t, e, r) {
    for (var o = e - 1, i = n.length; ++o < i;) {
      if (r(n[o], t)) return o;
    }

    return -1;
  }

  function Yt(n) {
    return n != n;
  }

  function Ht(n, t) {
    var e = null == n ? 0 : n.length;
    return e ? qt(n, t) / e : f;
  }

  function Ut(t) {
    return function (e) {
      return null == e ? n : e[t];
    };
  }

  function $t(t) {
    return function (e) {
      return null == t ? n : t[e];
    };
  }

  function Xt(n, t, e, r, o) {
    return o(n, function (n, o, i) {
      e = r ? (r = !1, n) : t(e, n, o, i);
    }), e;
  }

  function qt(t, e) {
    for (var r, o = -1, i = t.length; ++o < i;) {
      var a = e(t[o]);
      a !== n && (r = r === n ? a : r + a);
    }

    return r;
  }

  function Gt(n, t) {
    for (var e = -1, r = Array(n); ++e < n;) {
      r[e] = t(e);
    }

    return r;
  }

  function Kt(n) {
    return n ? n.slice(0, he(n) + 1).replace(rn, "") : n;
  }

  function Zt(n) {
    return function (t) {
      return n(t);
    };
  }

  function Jt(n, t) {
    return Nt(t, function (t) {
      return n[t];
    });
  }

  function Qt(n, t) {
    return n.has(t);
  }

  function ne(n, t) {
    for (var e = -1, r = n.length; ++e < r && Ft(t, n[e], 0) > -1;) {
      ;
    }

    return e;
  }

  function te(n, t) {
    for (var e = n.length; e-- && Ft(t, n[e], 0) > -1;) {
      ;
    }

    return e;
  }

  function ee(n, t) {
    for (var e = n.length, r = 0; e--;) {
      n[e] === t && ++r;
    }

    return r;
  }

  var re = $t({
    "À": "A",
    "Á": "A",
    "Â": "A",
    "Ã": "A",
    "Ä": "A",
    "Å": "A",
    "à": "a",
    "á": "a",
    "â": "a",
    "ã": "a",
    "ä": "a",
    "å": "a",
    "Ç": "C",
    "ç": "c",
    "Ð": "D",
    "ð": "d",
    "È": "E",
    "É": "E",
    "Ê": "E",
    "Ë": "E",
    "è": "e",
    "é": "e",
    "ê": "e",
    "ë": "e",
    "Ì": "I",
    "Í": "I",
    "Î": "I",
    "Ï": "I",
    "ì": "i",
    "í": "i",
    "î": "i",
    "ï": "i",
    "Ñ": "N",
    "ñ": "n",
    "Ò": "O",
    "Ó": "O",
    "Ô": "O",
    "Õ": "O",
    "Ö": "O",
    "Ø": "O",
    "ò": "o",
    "ó": "o",
    "ô": "o",
    "õ": "o",
    "ö": "o",
    "ø": "o",
    "Ù": "U",
    "Ú": "U",
    "Û": "U",
    "Ü": "U",
    "ù": "u",
    "ú": "u",
    "û": "u",
    "ü": "u",
    "Ý": "Y",
    "ý": "y",
    "ÿ": "y",
    "Æ": "Ae",
    "æ": "ae",
    "Þ": "Th",
    "þ": "th",
    "ß": "ss",
    "Ā": "A",
    "Ă": "A",
    "Ą": "A",
    "ā": "a",
    "ă": "a",
    "ą": "a",
    "Ć": "C",
    "Ĉ": "C",
    "Ċ": "C",
    "Č": "C",
    "ć": "c",
    "ĉ": "c",
    "ċ": "c",
    "č": "c",
    "Ď": "D",
    "Đ": "D",
    "ď": "d",
    "đ": "d",
    "Ē": "E",
    "Ĕ": "E",
    "Ė": "E",
    "Ę": "E",
    "Ě": "E",
    "ē": "e",
    "ĕ": "e",
    "ė": "e",
    "ę": "e",
    "ě": "e",
    "Ĝ": "G",
    "Ğ": "G",
    "Ġ": "G",
    "Ģ": "G",
    "ĝ": "g",
    "ğ": "g",
    "ġ": "g",
    "ģ": "g",
    "Ĥ": "H",
    "Ħ": "H",
    "ĥ": "h",
    "ħ": "h",
    "Ĩ": "I",
    "Ī": "I",
    "Ĭ": "I",
    "Į": "I",
    "İ": "I",
    "ĩ": "i",
    "ī": "i",
    "ĭ": "i",
    "į": "i",
    "ı": "i",
    "Ĵ": "J",
    "ĵ": "j",
    "Ķ": "K",
    "ķ": "k",
    "ĸ": "k",
    "Ĺ": "L",
    "Ļ": "L",
    "Ľ": "L",
    "Ŀ": "L",
    "Ł": "L",
    "ĺ": "l",
    "ļ": "l",
    "ľ": "l",
    "ŀ": "l",
    "ł": "l",
    "Ń": "N",
    "Ņ": "N",
    "Ň": "N",
    "Ŋ": "N",
    "ń": "n",
    "ņ": "n",
    "ň": "n",
    "ŋ": "n",
    "Ō": "O",
    "Ŏ": "O",
    "Ő": "O",
    "ō": "o",
    "ŏ": "o",
    "ő": "o",
    "Ŕ": "R",
    "Ŗ": "R",
    "Ř": "R",
    "ŕ": "r",
    "ŗ": "r",
    "ř": "r",
    "Ś": "S",
    "Ŝ": "S",
    "Ş": "S",
    "Š": "S",
    "ś": "s",
    "ŝ": "s",
    "ş": "s",
    "š": "s",
    "Ţ": "T",
    "Ť": "T",
    "Ŧ": "T",
    "ţ": "t",
    "ť": "t",
    "ŧ": "t",
    "Ũ": "U",
    "Ū": "U",
    "Ŭ": "U",
    "Ů": "U",
    "Ű": "U",
    "Ų": "U",
    "ũ": "u",
    "ū": "u",
    "ŭ": "u",
    "ů": "u",
    "ű": "u",
    "ų": "u",
    "Ŵ": "W",
    "ŵ": "w",
    "Ŷ": "Y",
    "ŷ": "y",
    "Ÿ": "Y",
    "Ź": "Z",
    "Ż": "Z",
    "Ž": "Z",
    "ź": "z",
    "ż": "z",
    "ž": "z",
    "Ĳ": "IJ",
    "ĳ": "ij",
    "Œ": "Oe",
    "œ": "oe",
    "ŉ": "'n",
    "ſ": "s"
  }),
      oe = $t({
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;"
  });

  function ie(n) {
    return "\\" + st[n];
  }

  function ae(n) {
    return et.test(n);
  }

  function ue(n) {
    var t = -1,
        e = Array(n.size);
    return n.forEach(function (n, r) {
      e[++t] = [r, n];
    }), e;
  }

  function se(n, t) {
    return function (e) {
      return n(t(e));
    };
  }

  function ce(n, t) {
    for (var e = -1, o = n.length, i = 0, a = []; ++e < o;) {
      var u = n[e];
      u !== t && u !== r || (n[e] = r, a[i++] = e);
    }

    return a;
  }

  function le(n) {
    var t = -1,
        e = Array(n.size);
    return n.forEach(function (n) {
      e[++t] = n;
    }), e;
  }

  function fe(n) {
    var t = -1,
        e = Array(n.size);
    return n.forEach(function (n) {
      e[++t] = [n, n];
    }), e;
  }

  function pe(n) {
    return ae(n) ? function (n) {
      for (var t = nt.lastIndex = 0; nt.test(n);) {
        ++t;
      }

      return t;
    }(n) : Mt(n);
  }

  function de(n) {
    return ae(n) ? function (n) {
      return n.match(nt) || [];
    }(n) : function (n) {
      return n.split("");
    }(n);
  }

  function he(n) {
    for (var t = n.length; t-- && on.test(n.charAt(t));) {
      ;
    }

    return t;
  }

  var ve = $t({
    "&amp;": "&",
    "&lt;": "<",
    "&gt;": ">",
    "&quot;": '"',
    "&#39;": "'"
  }),
      me = function x(on) {
    var Sn,
        _n = (on = null == on ? dt : me.defaults(dt.Object(), on, me.pick(dt, ot))).Array,
        En = on.Date,
        Tn = on.Error,
        Pn = on.Function,
        Cn = on.Math,
        An = on.Object,
        Ln = on.RegExp,
        On = on.String,
        kn = on.TypeError,
        Rn = _n.prototype,
        Nn = Pn.prototype,
        zn = An.prototype,
        In = on["__core-js_shared__"],
        Dn = Nn.toString,
        jn = zn.hasOwnProperty,
        Mn = 0,
        Bn = (Sn = /[^.]+$/.exec(In && In.keys && In.keys.IE_PROTO || "")) ? "Symbol(src)_1." + Sn : "",
        Vn = zn.toString,
        Fn = Dn.call(An),
        Wn = dt._,
        Yn = Ln("^" + Dn.call(jn).replace(tn, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"),
        Hn = mt ? on.Buffer : n,
        Un = on.Symbol,
        $n = on.Uint8Array,
        Xn = Hn ? Hn.allocUnsafe : n,
        qn = se(An.getPrototypeOf, An),
        Gn = An.create,
        Kn = zn.propertyIsEnumerable,
        Zn = Rn.splice,
        nt = Un ? Un.isConcatSpreadable : n,
        et = Un ? Un.iterator : n,
        st = Un ? Un.toStringTag : n,
        ft = function () {
      try {
        var n = hi(An, "defineProperty");
        return n({}, "", {}), n;
      } catch (n) {}
    }(),
        pt = on.clearTimeout !== dt.clearTimeout && on.clearTimeout,
        ht = En && En.now !== dt.Date.now && En.now,
        vt = on.setTimeout !== dt.setTimeout && on.setTimeout,
        gt = Cn.ceil,
        yt = Cn.floor,
        Mt = An.getOwnPropertySymbols,
        $t = Hn ? Hn.isBuffer : n,
        ge = on.isFinite,
        ye = Rn.join,
        be = se(An.keys, An),
        we = Cn.max,
        xe = Cn.min,
        Se = En.now,
        _e = on.parseInt,
        Ee = Cn.random,
        Te = Rn.reverse,
        Pe = hi(on, "DataView"),
        Ce = hi(on, "Map"),
        Ae = hi(on, "Promise"),
        Le = hi(on, "Set"),
        Oe = hi(on, "WeakMap"),
        ke = hi(An, "create"),
        Re = Oe && new Oe(),
        Ne = {},
        ze = Fi(Pe),
        Ie = Fi(Ce),
        De = Fi(Ae),
        je = Fi(Le),
        Me = Fi(Oe),
        Be = Un ? Un.prototype : n,
        Ve = Be ? Be.valueOf : n,
        Fe = Be ? Be.toString : n;

    function We(n) {
      if (ou(n) && !Xa(n) && !(n instanceof $e)) {
        if (n instanceof Ue) return n;
        if (jn.call(n, "__wrapped__")) return Wi(n);
      }

      return new Ue(n);
    }

    var Ye = function () {
      function t() {}

      return function (e) {
        if (!ru(e)) return {};
        if (Gn) return Gn(e);
        t.prototype = e;
        var r = new t();
        return t.prototype = n, r;
      };
    }();

    function He() {}

    function Ue(t, e) {
      this.__wrapped__ = t, this.__actions__ = [], this.__chain__ = !!e, this.__index__ = 0, this.__values__ = n;
    }

    function $e(n) {
      this.__wrapped__ = n, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = p, this.__views__ = [];
    }

    function Xe(n) {
      var t = -1,
          e = null == n ? 0 : n.length;

      for (this.clear(); ++t < e;) {
        var r = n[t];
        this.set(r[0], r[1]);
      }
    }

    function qe(n) {
      var t = -1,
          e = null == n ? 0 : n.length;

      for (this.clear(); ++t < e;) {
        var r = n[t];
        this.set(r[0], r[1]);
      }
    }

    function Ge(n) {
      var t = -1,
          e = null == n ? 0 : n.length;

      for (this.clear(); ++t < e;) {
        var r = n[t];
        this.set(r[0], r[1]);
      }
    }

    function Ke(n) {
      var t = -1,
          e = null == n ? 0 : n.length;

      for (this.__data__ = new Ge(); ++t < e;) {
        this.add(n[t]);
      }
    }

    function Ze(n) {
      var t = this.__data__ = new qe(n);
      this.size = t.size;
    }

    function Je(n, t) {
      var e = Xa(n),
          r = !e && $a(n),
          o = !e && !r && Za(n),
          i = !e && !r && !o && pu(n),
          a = e || r || o || i,
          u = a ? Gt(n.length, On) : [],
          s = u.length;

      for (var c in n) {
        !t && !jn.call(n, c) || a && ("length" == c || o && ("offset" == c || "parent" == c) || i && ("buffer" == c || "byteLength" == c || "byteOffset" == c) || xi(c, s)) || u.push(c);
      }

      return u;
    }

    function Qe(t) {
      var e = t.length;
      return e ? t[Kr(0, e - 1)] : n;
    }

    function nr(n, t) {
      return Mi(Ro(n), cr(t, 0, n.length));
    }

    function tr(n) {
      return Mi(Ro(n));
    }

    function er(t, e, r) {
      (r !== n && !Ya(t[e], r) || r === n && !(e in t)) && ur(t, e, r);
    }

    function rr(t, e, r) {
      var o = t[e];
      jn.call(t, e) && Ya(o, r) && (r !== n || e in t) || ur(t, e, r);
    }

    function or(n, t) {
      for (var e = n.length; e--;) {
        if (Ya(n[e][0], t)) return e;
      }

      return -1;
    }

    function ir(n, t, e, r) {
      return hr(n, function (n, o, i) {
        t(r, n, e(n), i);
      }), r;
    }

    function ar(n, t) {
      return n && No(t, zu(t), n);
    }

    function ur(n, t, e) {
      "__proto__" == t && ft ? ft(n, t, {
        configurable: !0,
        enumerable: !0,
        value: e,
        writable: !0
      }) : n[t] = e;
    }

    function sr(t, e) {
      for (var r = -1, o = e.length, i = _n(o), a = null == t; ++r < o;) {
        i[r] = a ? n : Lu(t, e[r]);
      }

      return i;
    }

    function cr(t, e, r) {
      return t == t && (r !== n && (t = t <= r ? t : r), e !== n && (t = t >= e ? t : e)), t;
    }

    function lr(t, e, r, o, i, a) {
      var u,
          s = 1 & e,
          c = 2 & e,
          l = 4 & e;
      if (r && (u = i ? r(t, o, i, a) : r(t)), u !== n) return u;
      if (!ru(t)) return t;
      var f = Xa(t);

      if (f) {
        if (u = function (n) {
          var t = n.length,
              e = new n.constructor(t);
          return t && "string" == typeof n[0] && jn.call(n, "index") && (e.index = n.index, e.input = n.input), e;
        }(t), !s) return Ro(t, u);
      } else {
        var p = gi(t),
            d = p == b || p == w;
        if (Za(t)) return Po(t, s);

        if (p == E || p == h || d && !i) {
          if (u = c || d ? {} : bi(t), !s) return c ? function (n, t) {
            return No(n, mi(n), t);
          }(t, function (n, t) {
            return n && No(t, Iu(t), n);
          }(u, t)) : function (n, t) {
            return No(n, vi(n), t);
          }(t, ar(u, t));
        } else {
          if (!ut[p]) return i ? t : {};

          u = function (n, t, e) {
            var r,
                o = n.constructor;

            switch (t) {
              case k:
                return Co(n);

              case m:
              case g:
                return new o(+n);

              case R:
                return function (n, t) {
                  var e = t ? Co(n.buffer) : n.buffer;
                  return new n.constructor(e, n.byteOffset, n.byteLength);
                }(n, e);

              case N:
              case z:
              case I:
              case D:
              case j:
              case M:
              case B:
              case V:
              case F:
                return Ao(n, e);

              case S:
                return new o();

              case _:
              case A:
                return new o(n);

              case P:
                return function (n) {
                  var t = new n.constructor(n.source, dn.exec(n));
                  return t.lastIndex = n.lastIndex, t;
                }(n);

              case C:
                return new o();

              case L:
                return r = n, Ve ? An(Ve.call(r)) : {};
            }
          }(t, p, s);
        }
      }

      a || (a = new Ze());
      var v = a.get(t);
      if (v) return v;
      a.set(t, u), cu(t) ? t.forEach(function (n) {
        u.add(lr(n, e, r, n, t, a));
      }) : iu(t) && t.forEach(function (n, o) {
        u.set(o, lr(n, e, r, o, t, a));
      });
      var y = f ? n : (l ? c ? ui : ai : c ? Iu : zu)(t);
      return Ct(y || t, function (n, o) {
        y && (n = t[o = n]), rr(u, o, lr(n, e, r, o, t, a));
      }), u;
    }

    function fr(t, e, r) {
      var o = r.length;
      if (null == t) return !o;

      for (t = An(t); o--;) {
        var i = r[o],
            a = e[i],
            u = t[i];
        if (u === n && !(i in t) || !a(u)) return !1;
      }

      return !0;
    }

    function pr(e, r, o) {
      if ("function" != typeof e) throw new kn(t);
      return zi(function () {
        e.apply(n, o);
      }, r);
    }

    function dr(n, t, e, r) {
      var o = -1,
          i = kt,
          a = !0,
          u = n.length,
          s = [],
          c = t.length;
      if (!u) return s;
      e && (t = Nt(t, Zt(e))), r ? (i = Rt, a = !1) : t.length >= 200 && (i = Qt, a = !1, t = new Ke(t));

      n: for (; ++o < u;) {
        var l = n[o],
            f = null == e ? l : e(l);

        if (l = r || 0 !== l ? l : 0, a && f == f) {
          for (var p = c; p--;) {
            if (t[p] === f) continue n;
          }

          s.push(l);
        } else i(t, f, r) || s.push(l);
      }

      return s;
    }

    We.templateSettings = {
      escape: G,
      evaluate: K,
      interpolate: Z,
      variable: "",
      imports: {
        _: We
      }
    }, We.prototype = He.prototype, We.prototype.constructor = We, Ue.prototype = Ye(He.prototype), Ue.prototype.constructor = Ue, $e.prototype = Ye(He.prototype), $e.prototype.constructor = $e, Xe.prototype.clear = function () {
      this.__data__ = ke ? ke(null) : {}, this.size = 0;
    }, Xe.prototype.delete = function (n) {
      var t = this.has(n) && delete this.__data__[n];
      return this.size -= t ? 1 : 0, t;
    }, Xe.prototype.get = function (t) {
      var r = this.__data__;

      if (ke) {
        var o = r[t];
        return o === e ? n : o;
      }

      return jn.call(r, t) ? r[t] : n;
    }, Xe.prototype.has = function (t) {
      var e = this.__data__;
      return ke ? e[t] !== n : jn.call(e, t);
    }, Xe.prototype.set = function (t, r) {
      var o = this.__data__;
      return this.size += this.has(t) ? 0 : 1, o[t] = ke && r === n ? e : r, this;
    }, qe.prototype.clear = function () {
      this.__data__ = [], this.size = 0;
    }, qe.prototype.delete = function (n) {
      var t = this.__data__,
          e = or(t, n);
      return !(e < 0 || (e == t.length - 1 ? t.pop() : Zn.call(t, e, 1), --this.size, 0));
    }, qe.prototype.get = function (t) {
      var e = this.__data__,
          r = or(e, t);
      return r < 0 ? n : e[r][1];
    }, qe.prototype.has = function (n) {
      return or(this.__data__, n) > -1;
    }, qe.prototype.set = function (n, t) {
      var e = this.__data__,
          r = or(e, n);
      return r < 0 ? (++this.size, e.push([n, t])) : e[r][1] = t, this;
    }, Ge.prototype.clear = function () {
      this.size = 0, this.__data__ = {
        hash: new Xe(),
        map: new (Ce || qe)(),
        string: new Xe()
      };
    }, Ge.prototype.delete = function (n) {
      var t = pi(this, n).delete(n);
      return this.size -= t ? 1 : 0, t;
    }, Ge.prototype.get = function (n) {
      return pi(this, n).get(n);
    }, Ge.prototype.has = function (n) {
      return pi(this, n).has(n);
    }, Ge.prototype.set = function (n, t) {
      var e = pi(this, n),
          r = e.size;
      return e.set(n, t), this.size += e.size == r ? 0 : 1, this;
    }, Ke.prototype.add = Ke.prototype.push = function (n) {
      return this.__data__.set(n, e), this;
    }, Ke.prototype.has = function (n) {
      return this.__data__.has(n);
    }, Ze.prototype.clear = function () {
      this.__data__ = new qe(), this.size = 0;
    }, Ze.prototype.delete = function (n) {
      var t = this.__data__,
          e = t.delete(n);
      return this.size = t.size, e;
    }, Ze.prototype.get = function (n) {
      return this.__data__.get(n);
    }, Ze.prototype.has = function (n) {
      return this.__data__.has(n);
    }, Ze.prototype.set = function (n, t) {
      var e = this.__data__;

      if (e instanceof qe) {
        var r = e.__data__;
        if (!Ce || r.length < 199) return r.push([n, t]), this.size = ++e.size, this;
        e = this.__data__ = new Ge(r);
      }

      return e.set(n, t), this.size = e.size, this;
    };
    var hr = Do(Sr),
        vr = Do(_r, !0);

    function mr(n, t) {
      var e = !0;
      return hr(n, function (n, r, o) {
        return e = !!t(n, r, o);
      }), e;
    }

    function gr(t, e, r) {
      for (var o = -1, i = t.length; ++o < i;) {
        var a = t[o],
            u = e(a);
        if (null != u && (s === n ? u == u && !fu(u) : r(u, s))) var s = u,
            c = a;
      }

      return c;
    }

    function yr(n, t) {
      var e = [];
      return hr(n, function (n, r, o) {
        t(n, r, o) && e.push(n);
      }), e;
    }

    function br(n, t, e, r, o) {
      var i = -1,
          a = n.length;

      for (e || (e = wi), o || (o = []); ++i < a;) {
        var u = n[i];
        t > 0 && e(u) ? t > 1 ? br(u, t - 1, e, r, o) : zt(o, u) : r || (o[o.length] = u);
      }

      return o;
    }

    var wr = jo(),
        xr = jo(!0);

    function Sr(n, t) {
      return n && wr(n, t, zu);
    }

    function _r(n, t) {
      return n && xr(n, t, zu);
    }

    function Er(n, t) {
      return Ot(t, function (t) {
        return nu(n[t]);
      });
    }

    function Tr(t, e) {
      for (var r = 0, o = (e = So(e, t)).length; null != t && r < o;) {
        t = t[Vi(e[r++])];
      }

      return r && r == o ? t : n;
    }

    function Pr(n, t, e) {
      var r = t(n);
      return Xa(n) ? r : zt(r, e(n));
    }

    function Cr(t) {
      return null == t ? t === n ? "[object Undefined]" : "[object Null]" : st && st in An(t) ? function (t) {
        var e = jn.call(t, st),
            r = t[st];

        try {
          t[st] = n;
          var o = !0;
        } catch (n) {}

        var i = Vn.call(t);
        return o && (e ? t[st] = r : delete t[st]), i;
      }(t) : function (n) {
        return Vn.call(n);
      }(t);
    }

    function Ar(n, t) {
      return n > t;
    }

    function Lr(n, t) {
      return null != n && jn.call(n, t);
    }

    function Or(n, t) {
      return null != n && t in An(n);
    }

    function kr(t, e, r) {
      for (var o = r ? Rt : kt, i = t[0].length, a = t.length, u = a, s = _n(a), c = 1 / 0, l = []; u--;) {
        var f = t[u];
        u && e && (f = Nt(f, Zt(e))), c = xe(f.length, c), s[u] = !r && (e || i >= 120 && f.length >= 120) ? new Ke(u && f) : n;
      }

      f = t[0];
      var p = -1,
          d = s[0];

      n: for (; ++p < i && l.length < c;) {
        var h = f[p],
            v = e ? e(h) : h;

        if (h = r || 0 !== h ? h : 0, !(d ? Qt(d, v) : o(l, v, r))) {
          for (u = a; --u;) {
            var m = s[u];
            if (!(m ? Qt(m, v) : o(t[u], v, r))) continue n;
          }

          d && d.push(v), l.push(h);
        }
      }

      return l;
    }

    function Rr(t, e, r) {
      var o = null == (t = Oi(t, e = So(e, t))) ? t : t[Vi(Qi(e))];
      return null == o ? n : Tt(o, t, r);
    }

    function Nr(n) {
      return ou(n) && Cr(n) == h;
    }

    function zr(t, e, r, o, i) {
      return t === e || (null == t || null == e || !ou(t) && !ou(e) ? t != t && e != e : function (t, e, r, o, i, a) {
        var u = Xa(t),
            s = Xa(e),
            c = u ? v : gi(t),
            l = s ? v : gi(e),
            f = (c = c == h ? E : c) == E,
            p = (l = l == h ? E : l) == E,
            d = c == l;

        if (d && Za(t)) {
          if (!Za(e)) return !1;
          u = !0, f = !1;
        }

        if (d && !f) return a || (a = new Ze()), u || pu(t) ? oi(t, e, r, o, i, a) : function (n, t, e, r, o, i, a) {
          switch (e) {
            case R:
              if (n.byteLength != t.byteLength || n.byteOffset != t.byteOffset) return !1;
              n = n.buffer, t = t.buffer;

            case k:
              return !(n.byteLength != t.byteLength || !i(new $n(n), new $n(t)));

            case m:
            case g:
            case _:
              return Ya(+n, +t);

            case y:
              return n.name == t.name && n.message == t.message;

            case P:
            case A:
              return n == t + "";

            case S:
              var u = ue;

            case C:
              var s = 1 & r;
              if (u || (u = le), n.size != t.size && !s) return !1;
              var c = a.get(n);
              if (c) return c == t;
              r |= 2, a.set(n, t);
              var l = oi(u(n), u(t), r, o, i, a);
              return a.delete(n), l;

            case L:
              if (Ve) return Ve.call(n) == Ve.call(t);
          }

          return !1;
        }(t, e, c, r, o, i, a);

        if (!(1 & r)) {
          var b = f && jn.call(t, "__wrapped__"),
              w = p && jn.call(e, "__wrapped__");

          if (b || w) {
            var x = b ? t.value() : t,
                T = w ? e.value() : e;
            return a || (a = new Ze()), i(x, T, r, o, a);
          }
        }

        return !!d && (a || (a = new Ze()), function (t, e, r, o, i, a) {
          var u = 1 & r,
              s = ai(t),
              c = s.length,
              l = ai(e).length;
          if (c != l && !u) return !1;

          for (var f = c; f--;) {
            var p = s[f];
            if (!(u ? p in e : jn.call(e, p))) return !1;
          }

          var d = a.get(t),
              h = a.get(e);
          if (d && h) return d == e && h == t;
          var v = !0;
          a.set(t, e), a.set(e, t);

          for (var m = u; ++f < c;) {
            var g = t[p = s[f]],
                y = e[p];
            if (o) var b = u ? o(y, g, p, e, t, a) : o(g, y, p, t, e, a);

            if (!(b === n ? g === y || i(g, y, r, o, a) : b)) {
              v = !1;
              break;
            }

            m || (m = "constructor" == p);
          }

          if (v && !m) {
            var w = t.constructor,
                x = e.constructor;
            w == x || !("constructor" in t) || !("constructor" in e) || "function" == typeof w && w instanceof w && "function" == typeof x && x instanceof x || (v = !1);
          }

          return a.delete(t), a.delete(e), v;
        }(t, e, r, o, i, a));
      }(t, e, r, o, zr, i));
    }

    function Ir(t, e, r, o) {
      var i = r.length,
          a = i,
          u = !o;
      if (null == t) return !a;

      for (t = An(t); i--;) {
        var s = r[i];
        if (u && s[2] ? s[1] !== t[s[0]] : !(s[0] in t)) return !1;
      }

      for (; ++i < a;) {
        var c = (s = r[i])[0],
            l = t[c],
            f = s[1];

        if (u && s[2]) {
          if (l === n && !(c in t)) return !1;
        } else {
          var p = new Ze();
          if (o) var d = o(l, f, c, t, e, p);
          if (!(d === n ? zr(f, l, 3, o, p) : d)) return !1;
        }
      }

      return !0;
    }

    function Dr(n) {
      return !(!ru(n) || (t = n, Bn && Bn in t)) && (nu(n) ? Yn : mn).test(Fi(n));
      var t;
    }

    function jr(n) {
      return "function" == typeof n ? n : null == n ? as : "object" == typeof n ? Xa(n) ? Yr(n[0], n[1]) : Wr(n) : vs(n);
    }

    function Mr(n) {
      if (!Pi(n)) return be(n);
      var t = [];

      for (var e in An(n)) {
        jn.call(n, e) && "constructor" != e && t.push(e);
      }

      return t;
    }

    function Br(n) {
      if (!ru(n)) return function (n) {
        var t = [];
        if (null != n) for (var e in An(n)) {
          t.push(e);
        }
        return t;
      }(n);
      var t = Pi(n),
          e = [];

      for (var r in n) {
        ("constructor" != r || !t && jn.call(n, r)) && e.push(r);
      }

      return e;
    }

    function Vr(n, t) {
      return n < t;
    }

    function Fr(n, t) {
      var e = -1,
          r = Ga(n) ? _n(n.length) : [];
      return hr(n, function (n, o, i) {
        r[++e] = t(n, o, i);
      }), r;
    }

    function Wr(n) {
      var t = di(n);
      return 1 == t.length && t[0][2] ? Ai(t[0][0], t[0][1]) : function (e) {
        return e === n || Ir(e, n, t);
      };
    }

    function Yr(t, e) {
      return _i(t) && Ci(e) ? Ai(Vi(t), e) : function (r) {
        var o = Lu(r, t);
        return o === n && o === e ? Ou(r, t) : zr(e, o, 3);
      };
    }

    function Hr(t, e, r, o, i) {
      t !== e && wr(e, function (a, u) {
        if (i || (i = new Ze()), ru(a)) !function (t, e, r, o, i, a, u) {
          var s = Ri(t, r),
              c = Ri(e, r),
              l = u.get(c);
          if (l) er(t, r, l);else {
            var f = a ? a(s, c, r + "", t, e, u) : n,
                p = f === n;

            if (p) {
              var d = Xa(c),
                  h = !d && Za(c),
                  v = !d && !h && pu(c);
              f = c, d || h || v ? Xa(s) ? f = s : Ka(s) ? f = Ro(s) : h ? (p = !1, f = Po(c, !0)) : v ? (p = !1, f = Ao(c, !0)) : f = [] : uu(c) || $a(c) ? (f = s, $a(s) ? f = wu(s) : ru(s) && !nu(s) || (f = bi(c))) : p = !1;
            }

            p && (u.set(c, f), i(f, c, o, a, u), u.delete(c)), er(t, r, f);
          }
        }(t, e, u, r, Hr, o, i);else {
          var s = o ? o(Ri(t, u), a, u + "", t, e, i) : n;
          s === n && (s = a), er(t, u, s);
        }
      }, Iu);
    }

    function Ur(t, e) {
      var r = t.length;
      if (r) return xi(e += e < 0 ? r : 0, r) ? t[e] : n;
    }

    function $r(n, t, e) {
      t = t.length ? Nt(t, function (n) {
        return Xa(n) ? function (t) {
          return Tr(t, 1 === n.length ? n[0] : n);
        } : n;
      }) : [as];
      var r = -1;
      return t = Nt(t, Zt(fi())), function (n, t) {
        var e = n.length;

        for (n.sort(t); e--;) {
          n[e] = n[e].value;
        }

        return n;
      }(Fr(n, function (n, e, o) {
        return {
          criteria: Nt(t, function (t) {
            return t(n);
          }),
          index: ++r,
          value: n
        };
      }), function (n, t) {
        return function (n, t, e) {
          for (var r = -1, o = n.criteria, i = t.criteria, a = o.length, u = e.length; ++r < a;) {
            var s = Lo(o[r], i[r]);
            if (s) return r >= u ? s : s * ("desc" == e[r] ? -1 : 1);
          }

          return n.index - t.index;
        }(n, t, e);
      });
    }

    function Xr(n, t, e) {
      for (var r = -1, o = t.length, i = {}; ++r < o;) {
        var a = t[r],
            u = Tr(n, a);
        e(u, a) && to(i, So(a, n), u);
      }

      return i;
    }

    function qr(n, t, e, r) {
      var o = r ? Wt : Ft,
          i = -1,
          a = t.length,
          u = n;

      for (n === t && (t = Ro(t)), e && (u = Nt(n, Zt(e))); ++i < a;) {
        for (var s = 0, c = t[i], l = e ? e(c) : c; (s = o(u, l, s, r)) > -1;) {
          u !== n && Zn.call(u, s, 1), Zn.call(n, s, 1);
        }
      }

      return n;
    }

    function Gr(n, t) {
      for (var e = n ? t.length : 0, r = e - 1; e--;) {
        var o = t[e];

        if (e == r || o !== i) {
          var i = o;
          xi(o) ? Zn.call(n, o, 1) : ho(n, o);
        }
      }

      return n;
    }

    function Kr(n, t) {
      return n + yt(Ee() * (t - n + 1));
    }

    function Zr(n, t) {
      var e = "";
      if (!n || t < 1 || t > l) return e;

      do {
        t % 2 && (e += n), (t = yt(t / 2)) && (n += n);
      } while (t);

      return e;
    }

    function Jr(n, t) {
      return Ii(Li(n, t, as), n + "");
    }

    function Qr(n) {
      return Qe(Yu(n));
    }

    function no(n, t) {
      var e = Yu(n);
      return Mi(e, cr(t, 0, e.length));
    }

    function to(t, e, r, o) {
      if (!ru(t)) return t;

      for (var i = -1, a = (e = So(e, t)).length, u = a - 1, s = t; null != s && ++i < a;) {
        var c = Vi(e[i]),
            l = r;
        if ("__proto__" === c || "constructor" === c || "prototype" === c) return t;

        if (i != u) {
          var f = s[c];
          (l = o ? o(f, c, s) : n) === n && (l = ru(f) ? f : xi(e[i + 1]) ? [] : {});
        }

        rr(s, c, l), s = s[c];
      }

      return t;
    }

    var eo = Re ? function (n, t) {
      return Re.set(n, t), n;
    } : as,
        ro = ft ? function (n, t) {
      return ft(n, "toString", {
        configurable: !0,
        enumerable: !1,
        value: rs(t),
        writable: !0
      });
    } : as;

    function oo(n) {
      return Mi(Yu(n));
    }

    function io(n, t, e) {
      var r = -1,
          o = n.length;
      t < 0 && (t = -t > o ? 0 : o + t), (e = e > o ? o : e) < 0 && (e += o), o = t > e ? 0 : e - t >>> 0, t >>>= 0;

      for (var i = _n(o); ++r < o;) {
        i[r] = n[r + t];
      }

      return i;
    }

    function ao(n, t) {
      var e;
      return hr(n, function (n, r, o) {
        return !(e = t(n, r, o));
      }), !!e;
    }

    function uo(n, t, e) {
      var r = 0,
          o = null == n ? r : n.length;

      if ("number" == typeof t && t == t && o <= 2147483647) {
        for (; r < o;) {
          var i = r + o >>> 1,
              a = n[i];
          null !== a && !fu(a) && (e ? a <= t : a < t) ? r = i + 1 : o = i;
        }

        return o;
      }

      return so(n, t, as, e);
    }

    function so(t, e, r, o) {
      var i = 0,
          a = null == t ? 0 : t.length;
      if (0 === a) return 0;

      for (var u = (e = r(e)) != e, s = null === e, c = fu(e), l = e === n; i < a;) {
        var f = yt((i + a) / 2),
            p = r(t[f]),
            d = p !== n,
            h = null === p,
            v = p == p,
            m = fu(p);
        if (u) var g = o || v;else g = l ? v && (o || d) : s ? v && d && (o || !h) : c ? v && d && !h && (o || !m) : !h && !m && (o ? p <= e : p < e);
        g ? i = f + 1 : a = f;
      }

      return xe(a, 4294967294);
    }

    function co(n, t) {
      for (var e = -1, r = n.length, o = 0, i = []; ++e < r;) {
        var a = n[e],
            u = t ? t(a) : a;

        if (!e || !Ya(u, s)) {
          var s = u;
          i[o++] = 0 === a ? 0 : a;
        }
      }

      return i;
    }

    function lo(n) {
      return "number" == typeof n ? n : fu(n) ? f : +n;
    }

    function fo(n) {
      if ("string" == typeof n) return n;
      if (Xa(n)) return Nt(n, fo) + "";
      if (fu(n)) return Fe ? Fe.call(n) : "";
      var t = n + "";
      return "0" == t && 1 / n == -1 / 0 ? "-0" : t;
    }

    function po(n, t, e) {
      var r = -1,
          o = kt,
          i = n.length,
          a = !0,
          u = [],
          s = u;
      if (e) a = !1, o = Rt;else if (i >= 200) {
        var c = t ? null : Jo(n);
        if (c) return le(c);
        a = !1, o = Qt, s = new Ke();
      } else s = t ? [] : u;

      n: for (; ++r < i;) {
        var l = n[r],
            f = t ? t(l) : l;

        if (l = e || 0 !== l ? l : 0, a && f == f) {
          for (var p = s.length; p--;) {
            if (s[p] === f) continue n;
          }

          t && s.push(f), u.push(l);
        } else o(s, f, e) || (s !== u && s.push(f), u.push(l));
      }

      return u;
    }

    function ho(n, t) {
      return null == (n = Oi(n, t = So(t, n))) || delete n[Vi(Qi(t))];
    }

    function vo(n, t, e, r) {
      return to(n, t, e(Tr(n, t)), r);
    }

    function mo(n, t, e, r) {
      for (var o = n.length, i = r ? o : -1; (r ? i-- : ++i < o) && t(n[i], i, n);) {
        ;
      }

      return e ? io(n, r ? 0 : i, r ? i + 1 : o) : io(n, r ? i + 1 : 0, r ? o : i);
    }

    function go(n, t) {
      var e = n;
      return e instanceof $e && (e = e.value()), It(t, function (n, t) {
        return t.func.apply(t.thisArg, zt([n], t.args));
      }, e);
    }

    function yo(n, t, e) {
      var r = n.length;
      if (r < 2) return r ? po(n[0]) : [];

      for (var o = -1, i = _n(r); ++o < r;) {
        for (var a = n[o], u = -1; ++u < r;) {
          u != o && (i[o] = dr(i[o] || a, n[u], t, e));
        }
      }

      return po(br(i, 1), t, e);
    }

    function bo(t, e, r) {
      for (var o = -1, i = t.length, a = e.length, u = {}; ++o < i;) {
        var s = o < a ? e[o] : n;
        r(u, t[o], s);
      }

      return u;
    }

    function wo(n) {
      return Ka(n) ? n : [];
    }

    function xo(n) {
      return "function" == typeof n ? n : as;
    }

    function So(n, t) {
      return Xa(n) ? n : _i(n, t) ? [n] : Bi(xu(n));
    }

    var _o = Jr;

    function Eo(t, e, r) {
      var o = t.length;
      return r = r === n ? o : r, !e && r >= o ? t : io(t, e, r);
    }

    var To = pt || function (n) {
      return dt.clearTimeout(n);
    };

    function Po(n, t) {
      if (t) return n.slice();
      var e = n.length,
          r = Xn ? Xn(e) : new n.constructor(e);
      return n.copy(r), r;
    }

    function Co(n) {
      var t = new n.constructor(n.byteLength);
      return new $n(t).set(new $n(n)), t;
    }

    function Ao(n, t) {
      var e = t ? Co(n.buffer) : n.buffer;
      return new n.constructor(e, n.byteOffset, n.length);
    }

    function Lo(t, e) {
      if (t !== e) {
        var r = t !== n,
            o = null === t,
            i = t == t,
            a = fu(t),
            u = e !== n,
            s = null === e,
            c = e == e,
            l = fu(e);
        if (!s && !l && !a && t > e || a && u && c && !s && !l || o && u && c || !r && c || !i) return 1;
        if (!o && !a && !l && t < e || l && r && i && !o && !a || s && r && i || !u && i || !c) return -1;
      }

      return 0;
    }

    function Oo(n, t, e, r) {
      for (var o = -1, i = n.length, a = e.length, u = -1, s = t.length, c = we(i - a, 0), l = _n(s + c), f = !r; ++u < s;) {
        l[u] = t[u];
      }

      for (; ++o < a;) {
        (f || o < i) && (l[e[o]] = n[o]);
      }

      for (; c--;) {
        l[u++] = n[o++];
      }

      return l;
    }

    function ko(n, t, e, r) {
      for (var o = -1, i = n.length, a = -1, u = e.length, s = -1, c = t.length, l = we(i - u, 0), f = _n(l + c), p = !r; ++o < l;) {
        f[o] = n[o];
      }

      for (var d = o; ++s < c;) {
        f[d + s] = t[s];
      }

      for (; ++a < u;) {
        (p || o < i) && (f[d + e[a]] = n[o++]);
      }

      return f;
    }

    function Ro(n, t) {
      var e = -1,
          r = n.length;

      for (t || (t = _n(r)); ++e < r;) {
        t[e] = n[e];
      }

      return t;
    }

    function No(t, e, r, o) {
      var i = !r;
      r || (r = {});

      for (var a = -1, u = e.length; ++a < u;) {
        var s = e[a],
            c = o ? o(r[s], t[s], s, r, t) : n;
        c === n && (c = t[s]), i ? ur(r, s, c) : rr(r, s, c);
      }

      return r;
    }

    function zo(n, t) {
      return function (e, r) {
        var o = Xa(e) ? Pt : ir,
            i = t ? t() : {};
        return o(e, n, fi(r, 2), i);
      };
    }

    function Io(t) {
      return Jr(function (e, r) {
        var o = -1,
            i = r.length,
            a = i > 1 ? r[i - 1] : n,
            u = i > 2 ? r[2] : n;

        for (a = t.length > 3 && "function" == typeof a ? (i--, a) : n, u && Si(r[0], r[1], u) && (a = i < 3 ? n : a, i = 1), e = An(e); ++o < i;) {
          var s = r[o];
          s && t(e, s, o, a);
        }

        return e;
      });
    }

    function Do(n, t) {
      return function (e, r) {
        if (null == e) return e;
        if (!Ga(e)) return n(e, r);

        for (var o = e.length, i = t ? o : -1, a = An(e); (t ? i-- : ++i < o) && !1 !== r(a[i], i, a);) {
          ;
        }

        return e;
      };
    }

    function jo(n) {
      return function (t, e, r) {
        for (var o = -1, i = An(t), a = r(t), u = a.length; u--;) {
          var s = a[n ? u : ++o];
          if (!1 === e(i[s], s, i)) break;
        }

        return t;
      };
    }

    function Mo(t) {
      return function (e) {
        var r = ae(e = xu(e)) ? de(e) : n,
            o = r ? r[0] : e.charAt(0),
            i = r ? Eo(r, 1).join("") : e.slice(1);
        return o[t]() + i;
      };
    }

    function Bo(n) {
      return function (t) {
        return It(ns($u(t).replace(Jn, "")), n, "");
      };
    }

    function Vo(n) {
      return function () {
        var t = arguments;

        switch (t.length) {
          case 0:
            return new n();

          case 1:
            return new n(t[0]);

          case 2:
            return new n(t[0], t[1]);

          case 3:
            return new n(t[0], t[1], t[2]);

          case 4:
            return new n(t[0], t[1], t[2], t[3]);

          case 5:
            return new n(t[0], t[1], t[2], t[3], t[4]);

          case 6:
            return new n(t[0], t[1], t[2], t[3], t[4], t[5]);

          case 7:
            return new n(t[0], t[1], t[2], t[3], t[4], t[5], t[6]);
        }

        var e = Ye(n.prototype),
            r = n.apply(e, t);
        return ru(r) ? r : e;
      };
    }

    function Fo(t) {
      return function (e, r, o) {
        var i = An(e);

        if (!Ga(e)) {
          var a = fi(r, 3);
          e = zu(e), r = function r(n) {
            return a(i[n], n, i);
          };
        }

        var u = t(e, r, o);
        return u > -1 ? i[a ? e[u] : u] : n;
      };
    }

    function Wo(e) {
      return ii(function (r) {
        var o = r.length,
            i = o,
            a = Ue.prototype.thru;

        for (e && r.reverse(); i--;) {
          var u = r[i];
          if ("function" != typeof u) throw new kn(t);
          if (a && !s && "wrapper" == ci(u)) var s = new Ue([], !0);
        }

        for (i = s ? i : o; ++i < o;) {
          var c = ci(u = r[i]),
              l = "wrapper" == c ? si(u) : n;
          s = l && Ei(l[0]) && 424 == l[1] && !l[4].length && 1 == l[9] ? s[ci(l[0])].apply(s, l[3]) : 1 == u.length && Ei(u) ? s[c]() : s.thru(u);
        }

        return function () {
          var n = arguments,
              t = n[0];
          if (s && 1 == n.length && Xa(t)) return s.plant(t).value();

          for (var e = 0, i = o ? r[e].apply(this, n) : t; ++e < o;) {
            i = r[e].call(this, i);
          }

          return i;
        };
      });
    }

    function Yo(t, e, r, o, i, a, s, c, l, f) {
      var p = e & u,
          d = 1 & e,
          h = 2 & e,
          v = 24 & e,
          m = 512 & e,
          g = h ? n : Vo(t);
      return function n() {
        for (var u = arguments.length, y = _n(u), b = u; b--;) {
          y[b] = arguments[b];
        }

        if (v) var w = li(n),
            x = ee(y, w);

        if (o && (y = Oo(y, o, i, v)), a && (y = ko(y, a, s, v)), u -= x, v && u < f) {
          var S = ce(y, w);
          return Ko(t, e, Yo, n.placeholder, r, y, S, c, l, f - u);
        }

        var _ = d ? r : this,
            E = h ? _[t] : t;

        return u = y.length, c ? y = ki(y, c) : m && u > 1 && y.reverse(), p && l < u && (y.length = l), this && this !== dt && this instanceof n && (E = g || Vo(E)), E.apply(_, y);
      };
    }

    function Ho(n, t) {
      return function (e, r) {
        return function (n, t, e, r) {
          return Sr(n, function (n, o, i) {
            t(r, e(n), o, i);
          }), r;
        }(e, n, t(r), {});
      };
    }

    function Uo(t, e) {
      return function (r, o) {
        var i;
        if (r === n && o === n) return e;

        if (r !== n && (i = r), o !== n) {
          if (i === n) return o;
          "string" == typeof r || "string" == typeof o ? (r = fo(r), o = fo(o)) : (r = lo(r), o = lo(o)), i = t(r, o);
        }

        return i;
      };
    }

    function $o(n) {
      return ii(function (t) {
        return t = Nt(t, Zt(fi())), Jr(function (e) {
          var r = this;
          return n(t, function (n) {
            return Tt(n, r, e);
          });
        });
      });
    }

    function Xo(t, e) {
      var r = (e = e === n ? " " : fo(e)).length;
      if (r < 2) return r ? Zr(e, t) : e;
      var o = Zr(e, gt(t / pe(e)));
      return ae(e) ? Eo(de(o), 0, t).join("") : o.slice(0, t);
    }

    function qo(t) {
      return function (e, r, o) {
        return o && "number" != typeof o && Si(e, r, o) && (r = o = n), e = mu(e), r === n ? (r = e, e = 0) : r = mu(r), function (n, t, e, r) {
          for (var o = -1, i = we(gt((t - n) / (e || 1)), 0), a = _n(i); i--;) {
            a[r ? i : ++o] = n, n += e;
          }

          return a;
        }(e, r, o = o === n ? e < r ? 1 : -1 : mu(o), t);
      };
    }

    function Go(n) {
      return function (t, e) {
        return "string" == typeof t && "string" == typeof e || (t = bu(t), e = bu(e)), n(t, e);
      };
    }

    function Ko(t, e, r, o, u, s, c, l, f, p) {
      var d = 8 & e;
      e |= d ? i : a, 4 & (e &= ~(d ? a : i)) || (e &= -4);
      var h = [t, e, u, d ? s : n, d ? c : n, d ? n : s, d ? n : c, l, f, p],
          v = r.apply(n, h);
      return Ei(t) && Ni(v, h), v.placeholder = o, Di(v, t, e);
    }

    function Zo(n) {
      var t = Cn[n];
      return function (n, e) {
        if (n = bu(n), (e = null == e ? 0 : xe(gu(e), 292)) && ge(n)) {
          var r = (xu(n) + "e").split("e");
          return +((r = (xu(t(r[0] + "e" + (+r[1] + e))) + "e").split("e"))[0] + "e" + (+r[1] - e));
        }

        return t(n);
      };
    }

    var Jo = Le && 1 / le(new Le([, -0]))[1] == c ? function (n) {
      return new Le(n);
    } : fs;

    function Qo(n) {
      return function (t) {
        var e = gi(t);
        return e == S ? ue(t) : e == C ? fe(t) : function (n, t) {
          return Nt(t, function (t) {
            return [t, n[t]];
          });
        }(t, n(t));
      };
    }

    function ni(e, c, l, f, p, d, h, v) {
      var m = 2 & c;
      if (!m && "function" != typeof e) throw new kn(t);
      var g = f ? f.length : 0;

      if (g || (c &= -97, f = p = n), h = h === n ? h : we(gu(h), 0), v = v === n ? v : gu(v), g -= p ? p.length : 0, c & a) {
        var y = f,
            b = p;
        f = p = n;
      }

      var w = m ? n : si(e),
          x = [e, c, l, f, p, y, b, d, h, v];
      if (w && function (n, t) {
        var e = n[1],
            o = t[1],
            i = e | o,
            a = i < 131,
            c = o == u && 8 == e || o == u && e == s && n[7].length <= t[8] || 384 == o && t[7].length <= t[8] && 8 == e;
        if (!a && !c) return n;
        1 & o && (n[2] = t[2], i |= 1 & e ? 0 : 4);
        var l = t[3];

        if (l) {
          var f = n[3];
          n[3] = f ? Oo(f, l, t[4]) : l, n[4] = f ? ce(n[3], r) : t[4];
        }

        (l = t[5]) && (f = n[5], n[5] = f ? ko(f, l, t[6]) : l, n[6] = f ? ce(n[5], r) : t[6]), (l = t[7]) && (n[7] = l), o & u && (n[8] = null == n[8] ? t[8] : xe(n[8], t[8])), null == n[9] && (n[9] = t[9]), n[0] = t[0], n[1] = i;
      }(x, w), e = x[0], c = x[1], l = x[2], f = x[3], p = x[4], !(v = x[9] = x[9] === n ? m ? 0 : e.length : we(x[9] - g, 0)) && 24 & c && (c &= -25), c && 1 != c) S = 8 == c || c == o ? function (t, e, r) {
        var o = Vo(t);
        return function i() {
          for (var a = arguments.length, u = _n(a), s = a, c = li(i); s--;) {
            u[s] = arguments[s];
          }

          var l = a < 3 && u[0] !== c && u[a - 1] !== c ? [] : ce(u, c);
          return (a -= l.length) < r ? Ko(t, e, Yo, i.placeholder, n, u, l, n, n, r - a) : Tt(this && this !== dt && this instanceof i ? o : t, this, u);
        };
      }(e, c, v) : c != i && 33 != c || p.length ? Yo.apply(n, x) : function (n, t, e, r) {
        var o = 1 & t,
            i = Vo(n);
        return function t() {
          for (var a = -1, u = arguments.length, s = -1, c = r.length, l = _n(c + u), f = this && this !== dt && this instanceof t ? i : n; ++s < c;) {
            l[s] = r[s];
          }

          for (; u--;) {
            l[s++] = arguments[++a];
          }

          return Tt(f, o ? e : this, l);
        };
      }(e, c, l, f);else var S = function (n, t, e) {
        var r = 1 & t,
            o = Vo(n);
        return function t() {
          return (this && this !== dt && this instanceof t ? o : n).apply(r ? e : this, arguments);
        };
      }(e, c, l);
      return Di((w ? eo : Ni)(S, x), e, c);
    }

    function ti(t, e, r, o) {
      return t === n || Ya(t, zn[r]) && !jn.call(o, r) ? e : t;
    }

    function ei(t, e, r, o, i, a) {
      return ru(t) && ru(e) && (a.set(e, t), Hr(t, e, n, ei, a), a.delete(e)), t;
    }

    function ri(t) {
      return uu(t) ? n : t;
    }

    function oi(t, e, r, o, i, a) {
      var u = 1 & r,
          s = t.length,
          c = e.length;
      if (s != c && !(u && c > s)) return !1;
      var l = a.get(t),
          f = a.get(e);
      if (l && f) return l == e && f == t;
      var p = -1,
          d = !0,
          h = 2 & r ? new Ke() : n;

      for (a.set(t, e), a.set(e, t); ++p < s;) {
        var v = t[p],
            m = e[p];
        if (o) var g = u ? o(m, v, p, e, t, a) : o(v, m, p, t, e, a);

        if (g !== n) {
          if (g) continue;
          d = !1;
          break;
        }

        if (h) {
          if (!jt(e, function (n, t) {
            if (!Qt(h, t) && (v === n || i(v, n, r, o, a))) return h.push(t);
          })) {
            d = !1;
            break;
          }
        } else if (v !== m && !i(v, m, r, o, a)) {
          d = !1;
          break;
        }
      }

      return a.delete(t), a.delete(e), d;
    }

    function ii(t) {
      return Ii(Li(t, n, qi), t + "");
    }

    function ai(n) {
      return Pr(n, zu, vi);
    }

    function ui(n) {
      return Pr(n, Iu, mi);
    }

    var si = Re ? function (n) {
      return Re.get(n);
    } : fs;

    function ci(n) {
      for (var t = n.name + "", e = Ne[t], r = jn.call(Ne, t) ? e.length : 0; r--;) {
        var o = e[r],
            i = o.func;
        if (null == i || i == n) return o.name;
      }

      return t;
    }

    function li(n) {
      return (jn.call(We, "placeholder") ? We : n).placeholder;
    }

    function fi() {
      var n = We.iteratee || us;
      return n = n === us ? jr : n, arguments.length ? n(arguments[0], arguments[1]) : n;
    }

    function pi(n, t) {
      var e,
          r,
          o = n.__data__;
      return ("string" == (r = typeof (e = t)) || "number" == r || "symbol" == r || "boolean" == r ? "__proto__" !== e : null === e) ? o["string" == typeof t ? "string" : "hash"] : o.map;
    }

    function di(n) {
      for (var t = zu(n), e = t.length; e--;) {
        var r = t[e],
            o = n[r];
        t[e] = [r, o, Ci(o)];
      }

      return t;
    }

    function hi(t, e) {
      var r = function (t, e) {
        return null == t ? n : t[e];
      }(t, e);

      return Dr(r) ? r : n;
    }

    var vi = Mt ? function (n) {
      return null == n ? [] : (n = An(n), Ot(Mt(n), function (t) {
        return Kn.call(n, t);
      }));
    } : ys,
        mi = Mt ? function (n) {
      for (var t = []; n;) {
        zt(t, vi(n)), n = qn(n);
      }

      return t;
    } : ys,
        gi = Cr;

    function yi(n, t, e) {
      for (var r = -1, o = (t = So(t, n)).length, i = !1; ++r < o;) {
        var a = Vi(t[r]);
        if (!(i = null != n && e(n, a))) break;
        n = n[a];
      }

      return i || ++r != o ? i : !!(o = null == n ? 0 : n.length) && eu(o) && xi(a, o) && (Xa(n) || $a(n));
    }

    function bi(n) {
      return "function" != typeof n.constructor || Pi(n) ? {} : Ye(qn(n));
    }

    function wi(n) {
      return Xa(n) || $a(n) || !!(nt && n && n[nt]);
    }

    function xi(n, t) {
      var e = typeof n;
      return !!(t = null == t ? l : t) && ("number" == e || "symbol" != e && yn.test(n)) && n > -1 && n % 1 == 0 && n < t;
    }

    function Si(n, t, e) {
      if (!ru(e)) return !1;
      var r = typeof t;
      return !!("number" == r ? Ga(e) && xi(t, e.length) : "string" == r && t in e) && Ya(e[t], n);
    }

    function _i(n, t) {
      if (Xa(n)) return !1;
      var e = typeof n;
      return !("number" != e && "symbol" != e && "boolean" != e && null != n && !fu(n)) || Q.test(n) || !J.test(n) || null != t && n in An(t);
    }

    function Ei(n) {
      var t = ci(n),
          e = We[t];
      if ("function" != typeof e || !(t in $e.prototype)) return !1;
      if (n === e) return !0;
      var r = si(e);
      return !!r && n === r[0];
    }

    (Pe && gi(new Pe(new ArrayBuffer(1))) != R || Ce && gi(new Ce()) != S || Ae && gi(Ae.resolve()) != T || Le && gi(new Le()) != C || Oe && gi(new Oe()) != O) && (gi = function gi(t) {
      var e = Cr(t),
          r = e == E ? t.constructor : n,
          o = r ? Fi(r) : "";
      if (o) switch (o) {
        case ze:
          return R;

        case Ie:
          return S;

        case De:
          return T;

        case je:
          return C;

        case Me:
          return O;
      }
      return e;
    });
    var Ti = In ? nu : bs;

    function Pi(n) {
      var t = n && n.constructor;
      return n === ("function" == typeof t && t.prototype || zn);
    }

    function Ci(n) {
      return n == n && !ru(n);
    }

    function Ai(t, e) {
      return function (r) {
        return null != r && r[t] === e && (e !== n || t in An(r));
      };
    }

    function Li(t, e, r) {
      return e = we(e === n ? t.length - 1 : e, 0), function () {
        for (var n = arguments, o = -1, i = we(n.length - e, 0), a = _n(i); ++o < i;) {
          a[o] = n[e + o];
        }

        o = -1;

        for (var u = _n(e + 1); ++o < e;) {
          u[o] = n[o];
        }

        return u[e] = r(a), Tt(t, this, u);
      };
    }

    function Oi(n, t) {
      return t.length < 2 ? n : Tr(n, io(t, 0, -1));
    }

    function ki(t, e) {
      for (var r = t.length, o = xe(e.length, r), i = Ro(t); o--;) {
        var a = e[o];
        t[o] = xi(a, r) ? i[a] : n;
      }

      return t;
    }

    function Ri(n, t) {
      if (("constructor" !== t || "function" != typeof n[t]) && "__proto__" != t) return n[t];
    }

    var Ni = ji(eo),
        zi = vt || function (n, t) {
      return dt.setTimeout(n, t);
    },
        Ii = ji(ro);

    function Di(n, t, e) {
      var r = t + "";
      return Ii(n, function (n, t) {
        var e = t.length;
        if (!e) return n;
        var r = e - 1;
        return t[r] = (e > 1 ? "& " : "") + t[r], t = t.join(e > 2 ? ", " : " "), n.replace(an, "{\n/* [wrapped with " + t + "] */\n");
      }(r, function (n, t) {
        return Ct(d, function (e) {
          var r = "_." + e[0];
          t & e[1] && !kt(n, r) && n.push(r);
        }), n.sort();
      }(function (n) {
        var t = n.match(un);
        return t ? t[1].split(sn) : [];
      }(r), e)));
    }

    function ji(t) {
      var e = 0,
          r = 0;
      return function () {
        var o = Se(),
            i = 16 - (o - r);

        if (r = o, i > 0) {
          if (++e >= 800) return arguments[0];
        } else e = 0;

        return t.apply(n, arguments);
      };
    }

    function Mi(t, e) {
      var r = -1,
          o = t.length,
          i = o - 1;

      for (e = e === n ? o : e; ++r < e;) {
        var a = Kr(r, i),
            u = t[a];
        t[a] = t[r], t[r] = u;
      }

      return t.length = e, t;
    }

    var Bi = function (n) {
      var t = ja(n, function (n) {
        return 500 === e.size && e.clear(), n;
      }),
          e = t.cache;
      return t;
    }(function (n) {
      var t = [];
      return 46 === n.charCodeAt(0) && t.push(""), n.replace(nn, function (n, e, r, o) {
        t.push(r ? o.replace(fn, "$1") : e || n);
      }), t;
    });

    function Vi(n) {
      if ("string" == typeof n || fu(n)) return n;
      var t = n + "";
      return "0" == t && 1 / n == -1 / 0 ? "-0" : t;
    }

    function Fi(n) {
      if (null != n) {
        try {
          return Dn.call(n);
        } catch (n) {}

        try {
          return n + "";
        } catch (n) {}
      }

      return "";
    }

    function Wi(n) {
      if (n instanceof $e) return n.clone();
      var t = new Ue(n.__wrapped__, n.__chain__);
      return t.__actions__ = Ro(n.__actions__), t.__index__ = n.__index__, t.__values__ = n.__values__, t;
    }

    var Yi = Jr(function (n, t) {
      return Ka(n) ? dr(n, br(t, 1, Ka, !0)) : [];
    }),
        Hi = Jr(function (t, e) {
      var r = Qi(e);
      return Ka(r) && (r = n), Ka(t) ? dr(t, br(e, 1, Ka, !0), fi(r, 2)) : [];
    }),
        Ui = Jr(function (t, e) {
      var r = Qi(e);
      return Ka(r) && (r = n), Ka(t) ? dr(t, br(e, 1, Ka, !0), n, r) : [];
    });

    function $i(n, t, e) {
      var r = null == n ? 0 : n.length;
      if (!r) return -1;
      var o = null == e ? 0 : gu(e);
      return o < 0 && (o = we(r + o, 0)), Vt(n, fi(t, 3), o);
    }

    function Xi(t, e, r) {
      var o = null == t ? 0 : t.length;
      if (!o) return -1;
      var i = o - 1;
      return r !== n && (i = gu(r), i = r < 0 ? we(o + i, 0) : xe(i, o - 1)), Vt(t, fi(e, 3), i, !0);
    }

    function qi(n) {
      return null != n && n.length ? br(n, 1) : [];
    }

    function Gi(t) {
      return t && t.length ? t[0] : n;
    }

    var Ki = Jr(function (n) {
      var t = Nt(n, wo);
      return t.length && t[0] === n[0] ? kr(t) : [];
    }),
        Zi = Jr(function (t) {
      var e = Qi(t),
          r = Nt(t, wo);
      return e === Qi(r) ? e = n : r.pop(), r.length && r[0] === t[0] ? kr(r, fi(e, 2)) : [];
    }),
        Ji = Jr(function (t) {
      var e = Qi(t),
          r = Nt(t, wo);
      return (e = "function" == typeof e ? e : n) && r.pop(), r.length && r[0] === t[0] ? kr(r, n, e) : [];
    });

    function Qi(t) {
      var e = null == t ? 0 : t.length;
      return e ? t[e - 1] : n;
    }

    var na = Jr(ta);

    function ta(n, t) {
      return n && n.length && t && t.length ? qr(n, t) : n;
    }

    var ea = ii(function (n, t) {
      var e = null == n ? 0 : n.length,
          r = sr(n, t);
      return Gr(n, Nt(t, function (n) {
        return xi(n, e) ? +n : n;
      }).sort(Lo)), r;
    });

    function ra(n) {
      return null == n ? n : Te.call(n);
    }

    var oa = Jr(function (n) {
      return po(br(n, 1, Ka, !0));
    }),
        ia = Jr(function (t) {
      var e = Qi(t);
      return Ka(e) && (e = n), po(br(t, 1, Ka, !0), fi(e, 2));
    }),
        aa = Jr(function (t) {
      var e = Qi(t);
      return e = "function" == typeof e ? e : n, po(br(t, 1, Ka, !0), n, e);
    });

    function ua(n) {
      if (!n || !n.length) return [];
      var t = 0;
      return n = Ot(n, function (n) {
        if (Ka(n)) return t = we(n.length, t), !0;
      }), Gt(t, function (t) {
        return Nt(n, Ut(t));
      });
    }

    function sa(t, e) {
      if (!t || !t.length) return [];
      var r = ua(t);
      return null == e ? r : Nt(r, function (t) {
        return Tt(e, n, t);
      });
    }

    var ca = Jr(function (n, t) {
      return Ka(n) ? dr(n, t) : [];
    }),
        la = Jr(function (n) {
      return yo(Ot(n, Ka));
    }),
        fa = Jr(function (t) {
      var e = Qi(t);
      return Ka(e) && (e = n), yo(Ot(t, Ka), fi(e, 2));
    }),
        pa = Jr(function (t) {
      var e = Qi(t);
      return e = "function" == typeof e ? e : n, yo(Ot(t, Ka), n, e);
    }),
        da = Jr(ua),
        ha = Jr(function (t) {
      var e = t.length,
          r = e > 1 ? t[e - 1] : n;
      return r = "function" == typeof r ? (t.pop(), r) : n, sa(t, r);
    });

    function va(n) {
      var t = We(n);
      return t.__chain__ = !0, t;
    }

    function ma(n, t) {
      return t(n);
    }

    var ga = ii(function (t) {
      var e = t.length,
          r = e ? t[0] : 0,
          o = this.__wrapped__,
          i = function i(n) {
        return sr(n, t);
      };

      return !(e > 1 || this.__actions__.length) && o instanceof $e && xi(r) ? ((o = o.slice(r, +r + (e ? 1 : 0))).__actions__.push({
        func: ma,
        args: [i],
        thisArg: n
      }), new Ue(o, this.__chain__).thru(function (t) {
        return e && !t.length && t.push(n), t;
      })) : this.thru(i);
    }),
        ya = zo(function (n, t, e) {
      jn.call(n, e) ? ++n[e] : ur(n, e, 1);
    }),
        ba = Fo($i),
        wa = Fo(Xi);

    function xa(n, t) {
      return (Xa(n) ? Ct : hr)(n, fi(t, 3));
    }

    function Sa(n, t) {
      return (Xa(n) ? At : vr)(n, fi(t, 3));
    }

    var _a = zo(function (n, t, e) {
      jn.call(n, e) ? n[e].push(t) : ur(n, e, [t]);
    }),
        Ea = Jr(function (n, t, e) {
      var r = -1,
          o = "function" == typeof t,
          i = Ga(n) ? _n(n.length) : [];
      return hr(n, function (n) {
        i[++r] = o ? Tt(t, n, e) : Rr(n, t, e);
      }), i;
    }),
        Ta = zo(function (n, t, e) {
      ur(n, e, t);
    });

    function Pa(n, t) {
      return (Xa(n) ? Nt : Fr)(n, fi(t, 3));
    }

    var Ca = zo(function (n, t, e) {
      n[e ? 0 : 1].push(t);
    }, function () {
      return [[], []];
    }),
        Aa = Jr(function (n, t) {
      if (null == n) return [];
      var e = t.length;
      return e > 1 && Si(n, t[0], t[1]) ? t = [] : e > 2 && Si(t[0], t[1], t[2]) && (t = [t[0]]), $r(n, br(t, 1), []);
    }),
        La = ht || function () {
      return dt.Date.now();
    };

    function Oa(t, e, r) {
      return e = r ? n : e, e = t && null == e ? t.length : e, ni(t, u, n, n, n, n, e);
    }

    function ka(e, r) {
      var o;
      if ("function" != typeof r) throw new kn(t);
      return e = gu(e), function () {
        return --e > 0 && (o = r.apply(this, arguments)), e <= 1 && (r = n), o;
      };
    }

    var Ra = Jr(function (n, t, e) {
      var r = 1;

      if (e.length) {
        var o = ce(e, li(Ra));
        r |= i;
      }

      return ni(n, r, t, e, o);
    }),
        Na = Jr(function (n, t, e) {
      var r = 3;

      if (e.length) {
        var o = ce(e, li(Na));
        r |= i;
      }

      return ni(t, r, n, e, o);
    });

    function za(e, r, o) {
      var i,
          a,
          u,
          s,
          c,
          l,
          f = 0,
          p = !1,
          d = !1,
          h = !0;
      if ("function" != typeof e) throw new kn(t);

      function v(t) {
        var r = i,
            o = a;
        return i = a = n, f = t, s = e.apply(o, r);
      }

      function m(n) {
        return f = n, c = zi(y, r), p ? v(n) : s;
      }

      function g(t) {
        var e = t - l;
        return l === n || e >= r || e < 0 || d && t - f >= u;
      }

      function y() {
        var n = La();
        if (g(n)) return b(n);
        c = zi(y, function (n) {
          var t = r - (n - l);
          return d ? xe(t, u - (n - f)) : t;
        }(n));
      }

      function b(t) {
        return c = n, h && i ? v(t) : (i = a = n, s);
      }

      function w() {
        var t = La(),
            e = g(t);

        if (i = arguments, a = this, l = t, e) {
          if (c === n) return m(l);
          if (d) return To(c), c = zi(y, r), v(l);
        }

        return c === n && (c = zi(y, r)), s;
      }

      return r = bu(r) || 0, ru(o) && (p = !!o.leading, u = (d = "maxWait" in o) ? we(bu(o.maxWait) || 0, r) : u, h = "trailing" in o ? !!o.trailing : h), w.cancel = function () {
        c !== n && To(c), f = 0, i = l = a = c = n;
      }, w.flush = function () {
        return c === n ? s : b(La());
      }, w;
    }

    var Ia = Jr(function (n, t) {
      return pr(n, 1, t);
    }),
        Da = Jr(function (n, t, e) {
      return pr(n, bu(t) || 0, e);
    });

    function ja(n, e) {
      if ("function" != typeof n || null != e && "function" != typeof e) throw new kn(t);

      var r = function r() {
        var t = arguments,
            o = e ? e.apply(this, t) : t[0],
            i = r.cache;
        if (i.has(o)) return i.get(o);
        var a = n.apply(this, t);
        return r.cache = i.set(o, a) || i, a;
      };

      return r.cache = new (ja.Cache || Ge)(), r;
    }

    function Ma(n) {
      if ("function" != typeof n) throw new kn(t);
      return function () {
        var t = arguments;

        switch (t.length) {
          case 0:
            return !n.call(this);

          case 1:
            return !n.call(this, t[0]);

          case 2:
            return !n.call(this, t[0], t[1]);

          case 3:
            return !n.call(this, t[0], t[1], t[2]);
        }

        return !n.apply(this, t);
      };
    }

    ja.Cache = Ge;

    var Ba = _o(function (n, t) {
      var e = (t = 1 == t.length && Xa(t[0]) ? Nt(t[0], Zt(fi())) : Nt(br(t, 1), Zt(fi()))).length;
      return Jr(function (r) {
        for (var o = -1, i = xe(r.length, e); ++o < i;) {
          r[o] = t[o].call(this, r[o]);
        }

        return Tt(n, this, r);
      });
    }),
        Va = Jr(function (t, e) {
      var r = ce(e, li(Va));
      return ni(t, i, n, e, r);
    }),
        Fa = Jr(function (t, e) {
      var r = ce(e, li(Fa));
      return ni(t, a, n, e, r);
    }),
        Wa = ii(function (t, e) {
      return ni(t, s, n, n, n, e);
    });

    function Ya(n, t) {
      return n === t || n != n && t != t;
    }

    var Ha = Go(Ar),
        Ua = Go(function (n, t) {
      return n >= t;
    }),
        $a = Nr(function () {
      return arguments;
    }()) ? Nr : function (n) {
      return ou(n) && jn.call(n, "callee") && !Kn.call(n, "callee");
    },
        Xa = _n.isArray,
        qa = bt ? Zt(bt) : function (n) {
      return ou(n) && Cr(n) == k;
    };

    function Ga(n) {
      return null != n && eu(n.length) && !nu(n);
    }

    function Ka(n) {
      return ou(n) && Ga(n);
    }

    var Za = $t || bs,
        Ja = wt ? Zt(wt) : function (n) {
      return ou(n) && Cr(n) == g;
    };

    function Qa(n) {
      if (!ou(n)) return !1;
      var t = Cr(n);
      return t == y || "[object DOMException]" == t || "string" == typeof n.message && "string" == typeof n.name && !uu(n);
    }

    function nu(n) {
      if (!ru(n)) return !1;
      var t = Cr(n);
      return t == b || t == w || "[object AsyncFunction]" == t || "[object Proxy]" == t;
    }

    function tu(n) {
      return "number" == typeof n && n == gu(n);
    }

    function eu(n) {
      return "number" == typeof n && n > -1 && n % 1 == 0 && n <= l;
    }

    function ru(n) {
      var t = typeof n;
      return null != n && ("object" == t || "function" == t);
    }

    function ou(n) {
      return null != n && "object" == typeof n;
    }

    var iu = xt ? Zt(xt) : function (n) {
      return ou(n) && gi(n) == S;
    };

    function au(n) {
      return "number" == typeof n || ou(n) && Cr(n) == _;
    }

    function uu(n) {
      if (!ou(n) || Cr(n) != E) return !1;
      var t = qn(n);
      if (null === t) return !0;
      var e = jn.call(t, "constructor") && t.constructor;
      return "function" == typeof e && e instanceof e && Dn.call(e) == Fn;
    }

    var su = St ? Zt(St) : function (n) {
      return ou(n) && Cr(n) == P;
    },
        cu = _t ? Zt(_t) : function (n) {
      return ou(n) && gi(n) == C;
    };

    function lu(n) {
      return "string" == typeof n || !Xa(n) && ou(n) && Cr(n) == A;
    }

    function fu(n) {
      return "symbol" == typeof n || ou(n) && Cr(n) == L;
    }

    var pu = Et ? Zt(Et) : function (n) {
      return ou(n) && eu(n.length) && !!at[Cr(n)];
    },
        du = Go(Vr),
        hu = Go(function (n, t) {
      return n <= t;
    });

    function vu(n) {
      if (!n) return [];
      if (Ga(n)) return lu(n) ? de(n) : Ro(n);
      if (et && n[et]) return function (n) {
        for (var t, e = []; !(t = n.next()).done;) {
          e.push(t.value);
        }

        return e;
      }(n[et]());
      var t = gi(n);
      return (t == S ? ue : t == C ? le : Yu)(n);
    }

    function mu(n) {
      return n ? (n = bu(n)) === c || n === -1 / 0 ? 17976931348623157e292 * (n < 0 ? -1 : 1) : n == n ? n : 0 : 0 === n ? n : 0;
    }

    function gu(n) {
      var t = mu(n),
          e = t % 1;
      return t == t ? e ? t - e : t : 0;
    }

    function yu(n) {
      return n ? cr(gu(n), 0, p) : 0;
    }

    function bu(n) {
      if ("number" == typeof n) return n;
      if (fu(n)) return f;

      if (ru(n)) {
        var t = "function" == typeof n.valueOf ? n.valueOf() : n;
        n = ru(t) ? t + "" : t;
      }

      if ("string" != typeof n) return 0 === n ? n : +n;
      n = Kt(n);
      var e = vn.test(n);
      return e || gn.test(n) ? lt(n.slice(2), e ? 2 : 8) : hn.test(n) ? f : +n;
    }

    function wu(n) {
      return No(n, Iu(n));
    }

    function xu(n) {
      return null == n ? "" : fo(n);
    }

    var Su = Io(function (n, t) {
      if (Pi(t) || Ga(t)) No(t, zu(t), n);else for (var e in t) {
        jn.call(t, e) && rr(n, e, t[e]);
      }
    }),
        _u = Io(function (n, t) {
      No(t, Iu(t), n);
    }),
        Eu = Io(function (n, t, e, r) {
      No(t, Iu(t), n, r);
    }),
        Tu = Io(function (n, t, e, r) {
      No(t, zu(t), n, r);
    }),
        Pu = ii(sr),
        Cu = Jr(function (t, e) {
      t = An(t);
      var r = -1,
          o = e.length,
          i = o > 2 ? e[2] : n;

      for (i && Si(e[0], e[1], i) && (o = 1); ++r < o;) {
        for (var a = e[r], u = Iu(a), s = -1, c = u.length; ++s < c;) {
          var l = u[s],
              f = t[l];
          (f === n || Ya(f, zn[l]) && !jn.call(t, l)) && (t[l] = a[l]);
        }
      }

      return t;
    }),
        Au = Jr(function (t) {
      return t.push(n, ei), Tt(ju, n, t);
    });

    function Lu(t, e, r) {
      var o = null == t ? n : Tr(t, e);
      return o === n ? r : o;
    }

    function Ou(n, t) {
      return null != n && yi(n, t, Or);
    }

    var ku = Ho(function (n, t, e) {
      null != t && "function" != typeof t.toString && (t = Vn.call(t)), n[t] = e;
    }, rs(as)),
        Ru = Ho(function (n, t, e) {
      null != t && "function" != typeof t.toString && (t = Vn.call(t)), jn.call(n, t) ? n[t].push(e) : n[t] = [e];
    }, fi),
        Nu = Jr(Rr);

    function zu(n) {
      return Ga(n) ? Je(n) : Mr(n);
    }

    function Iu(n) {
      return Ga(n) ? Je(n, !0) : Br(n);
    }

    var Du = Io(function (n, t, e) {
      Hr(n, t, e);
    }),
        ju = Io(function (n, t, e, r) {
      Hr(n, t, e, r);
    }),
        Mu = ii(function (n, t) {
      var e = {};
      if (null == n) return e;
      var r = !1;
      t = Nt(t, function (t) {
        return t = So(t, n), r || (r = t.length > 1), t;
      }), No(n, ui(n), e), r && (e = lr(e, 7, ri));

      for (var o = t.length; o--;) {
        ho(e, t[o]);
      }

      return e;
    }),
        Bu = ii(function (n, t) {
      return null == n ? {} : function (n, t) {
        return Xr(n, t, function (t, e) {
          return Ou(n, e);
        });
      }(n, t);
    });

    function Vu(n, t) {
      if (null == n) return {};
      var e = Nt(ui(n), function (n) {
        return [n];
      });
      return t = fi(t), Xr(n, e, function (n, e) {
        return t(n, e[0]);
      });
    }

    var Fu = Qo(zu),
        Wu = Qo(Iu);

    function Yu(n) {
      return null == n ? [] : Jt(n, zu(n));
    }

    var Hu = Bo(function (n, t, e) {
      return t = t.toLowerCase(), n + (e ? Uu(t) : t);
    });

    function Uu(n) {
      return Qu(xu(n).toLowerCase());
    }

    function $u(n) {
      return (n = xu(n)) && n.replace(bn, re).replace(Qn, "");
    }

    var Xu = Bo(function (n, t, e) {
      return n + (e ? "-" : "") + t.toLowerCase();
    }),
        qu = Bo(function (n, t, e) {
      return n + (e ? " " : "") + t.toLowerCase();
    }),
        Gu = Mo("toLowerCase"),
        Ku = Bo(function (n, t, e) {
      return n + (e ? "_" : "") + t.toLowerCase();
    }),
        Zu = Bo(function (n, t, e) {
      return n + (e ? " " : "") + Qu(t);
    }),
        Ju = Bo(function (n, t, e) {
      return n + (e ? " " : "") + t.toUpperCase();
    }),
        Qu = Mo("toUpperCase");

    function ns(t, e, r) {
      return t = xu(t), (e = r ? n : e) === n ? function (n) {
        return rt.test(n);
      }(t) ? function (n) {
        return n.match(tt) || [];
      }(t) : function (n) {
        return n.match(cn) || [];
      }(t) : t.match(e) || [];
    }

    var ts = Jr(function (t, e) {
      try {
        return Tt(t, n, e);
      } catch (n) {
        return Qa(n) ? n : new Tn(n);
      }
    }),
        es = ii(function (n, t) {
      return Ct(t, function (t) {
        t = Vi(t), ur(n, t, Ra(n[t], n));
      }), n;
    });

    function rs(n) {
      return function () {
        return n;
      };
    }

    var os = Wo(),
        is = Wo(!0);

    function as(n) {
      return n;
    }

    function us(n) {
      return jr("function" == typeof n ? n : lr(n, 1));
    }

    var ss = Jr(function (n, t) {
      return function (e) {
        return Rr(e, n, t);
      };
    }),
        cs = Jr(function (n, t) {
      return function (e) {
        return Rr(n, e, t);
      };
    });

    function ls(n, t, e) {
      var r = zu(t),
          o = Er(t, r);
      null != e || ru(t) && (o.length || !r.length) || (e = t, t = n, n = this, o = Er(t, zu(t)));
      var i = !(ru(e) && "chain" in e && !e.chain),
          a = nu(n);
      return Ct(o, function (e) {
        var r = t[e];
        n[e] = r, a && (n.prototype[e] = function () {
          var t = this.__chain__;

          if (i || t) {
            var e = n(this.__wrapped__),
                o = e.__actions__ = Ro(this.__actions__);
            return o.push({
              func: r,
              args: arguments,
              thisArg: n
            }), e.__chain__ = t, e;
          }

          return r.apply(n, zt([this.value()], arguments));
        });
      }), n;
    }

    function fs() {}

    var ps = $o(Nt),
        ds = $o(Lt),
        hs = $o(jt);

    function vs(n) {
      return _i(n) ? Ut(Vi(n)) : function (n) {
        return function (t) {
          return Tr(t, n);
        };
      }(n);
    }

    var ms = qo(),
        gs = qo(!0);

    function ys() {
      return [];
    }

    function bs() {
      return !1;
    }

    var ws,
        xs = Uo(function (n, t) {
      return n + t;
    }, 0),
        Ss = Zo("ceil"),
        _s = Uo(function (n, t) {
      return n / t;
    }, 1),
        Es = Zo("floor"),
        Ts = Uo(function (n, t) {
      return n * t;
    }, 1),
        Ps = Zo("round"),
        Cs = Uo(function (n, t) {
      return n - t;
    }, 0);

    return We.after = function (n, e) {
      if ("function" != typeof e) throw new kn(t);
      return n = gu(n), function () {
        if (--n < 1) return e.apply(this, arguments);
      };
    }, We.ary = Oa, We.assign = Su, We.assignIn = _u, We.assignInWith = Eu, We.assignWith = Tu, We.at = Pu, We.before = ka, We.bind = Ra, We.bindAll = es, We.bindKey = Na, We.castArray = function () {
      if (!arguments.length) return [];
      var n = arguments[0];
      return Xa(n) ? n : [n];
    }, We.chain = va, We.chunk = function (t, e, r) {
      e = (r ? Si(t, e, r) : e === n) ? 1 : we(gu(e), 0);
      var o = null == t ? 0 : t.length;
      if (!o || e < 1) return [];

      for (var i = 0, a = 0, u = _n(gt(o / e)); i < o;) {
        u[a++] = io(t, i, i += e);
      }

      return u;
    }, We.compact = function (n) {
      for (var t = -1, e = null == n ? 0 : n.length, r = 0, o = []; ++t < e;) {
        var i = n[t];
        i && (o[r++] = i);
      }

      return o;
    }, We.concat = function () {
      var n = arguments.length;
      if (!n) return [];

      for (var t = _n(n - 1), e = arguments[0], r = n; r--;) {
        t[r - 1] = arguments[r];
      }

      return zt(Xa(e) ? Ro(e) : [e], br(t, 1));
    }, We.cond = function (n) {
      var e = null == n ? 0 : n.length,
          r = fi();
      return n = e ? Nt(n, function (n) {
        if ("function" != typeof n[1]) throw new kn(t);
        return [r(n[0]), n[1]];
      }) : [], Jr(function (t) {
        for (var r = -1; ++r < e;) {
          var o = n[r];
          if (Tt(o[0], this, t)) return Tt(o[1], this, t);
        }
      });
    }, We.conforms = function (n) {
      return function (n) {
        var t = zu(n);
        return function (e) {
          return fr(e, n, t);
        };
      }(lr(n, 1));
    }, We.constant = rs, We.countBy = ya, We.create = function (n, t) {
      var e = Ye(n);
      return null == t ? e : ar(e, t);
    }, We.curry = function t(e, r, o) {
      var i = ni(e, 8, n, n, n, n, n, r = o ? n : r);
      return i.placeholder = t.placeholder, i;
    }, We.curryRight = function t(e, r, i) {
      var a = ni(e, o, n, n, n, n, n, r = i ? n : r);
      return a.placeholder = t.placeholder, a;
    }, We.debounce = za, We.defaults = Cu, We.defaultsDeep = Au, We.defer = Ia, We.delay = Da, We.difference = Yi, We.differenceBy = Hi, We.differenceWith = Ui, We.drop = function (t, e, r) {
      var o = null == t ? 0 : t.length;
      return o ? io(t, (e = r || e === n ? 1 : gu(e)) < 0 ? 0 : e, o) : [];
    }, We.dropRight = function (t, e, r) {
      var o = null == t ? 0 : t.length;
      return o ? io(t, 0, (e = o - (e = r || e === n ? 1 : gu(e))) < 0 ? 0 : e) : [];
    }, We.dropRightWhile = function (n, t) {
      return n && n.length ? mo(n, fi(t, 3), !0, !0) : [];
    }, We.dropWhile = function (n, t) {
      return n && n.length ? mo(n, fi(t, 3), !0) : [];
    }, We.fill = function (t, e, r, o) {
      var i = null == t ? 0 : t.length;
      return i ? (r && "number" != typeof r && Si(t, e, r) && (r = 0, o = i), function (t, e, r, o) {
        var i = t.length;

        for ((r = gu(r)) < 0 && (r = -r > i ? 0 : i + r), (o = o === n || o > i ? i : gu(o)) < 0 && (o += i), o = r > o ? 0 : yu(o); r < o;) {
          t[r++] = e;
        }

        return t;
      }(t, e, r, o)) : [];
    }, We.filter = function (n, t) {
      return (Xa(n) ? Ot : yr)(n, fi(t, 3));
    }, We.flatMap = function (n, t) {
      return br(Pa(n, t), 1);
    }, We.flatMapDeep = function (n, t) {
      return br(Pa(n, t), c);
    }, We.flatMapDepth = function (t, e, r) {
      return r = r === n ? 1 : gu(r), br(Pa(t, e), r);
    }, We.flatten = qi, We.flattenDeep = function (n) {
      return null != n && n.length ? br(n, c) : [];
    }, We.flattenDepth = function (t, e) {
      return null != t && t.length ? br(t, e = e === n ? 1 : gu(e)) : [];
    }, We.flip = function (n) {
      return ni(n, 512);
    }, We.flow = os, We.flowRight = is, We.fromPairs = function (n) {
      for (var t = -1, e = null == n ? 0 : n.length, r = {}; ++t < e;) {
        var o = n[t];
        r[o[0]] = o[1];
      }

      return r;
    }, We.functions = function (n) {
      return null == n ? [] : Er(n, zu(n));
    }, We.functionsIn = function (n) {
      return null == n ? [] : Er(n, Iu(n));
    }, We.groupBy = _a, We.initial = function (n) {
      return null != n && n.length ? io(n, 0, -1) : [];
    }, We.intersection = Ki, We.intersectionBy = Zi, We.intersectionWith = Ji, We.invert = ku, We.invertBy = Ru, We.invokeMap = Ea, We.iteratee = us, We.keyBy = Ta, We.keys = zu, We.keysIn = Iu, We.map = Pa, We.mapKeys = function (n, t) {
      var e = {};
      return t = fi(t, 3), Sr(n, function (n, r, o) {
        ur(e, t(n, r, o), n);
      }), e;
    }, We.mapValues = function (n, t) {
      var e = {};
      return t = fi(t, 3), Sr(n, function (n, r, o) {
        ur(e, r, t(n, r, o));
      }), e;
    }, We.matches = function (n) {
      return Wr(lr(n, 1));
    }, We.matchesProperty = function (n, t) {
      return Yr(n, lr(t, 1));
    }, We.memoize = ja, We.merge = Du, We.mergeWith = ju, We.method = ss, We.methodOf = cs, We.mixin = ls, We.negate = Ma, We.nthArg = function (n) {
      return n = gu(n), Jr(function (t) {
        return Ur(t, n);
      });
    }, We.omit = Mu, We.omitBy = function (n, t) {
      return Vu(n, Ma(fi(t)));
    }, We.once = function (n) {
      return ka(2, n);
    }, We.orderBy = function (t, e, r, o) {
      return null == t ? [] : (Xa(e) || (e = null == e ? [] : [e]), Xa(r = o ? n : r) || (r = null == r ? [] : [r]), $r(t, e, r));
    }, We.over = ps, We.overArgs = Ba, We.overEvery = ds, We.overSome = hs, We.partial = Va, We.partialRight = Fa, We.partition = Ca, We.pick = Bu, We.pickBy = Vu, We.property = vs, We.propertyOf = function (t) {
      return function (e) {
        return null == t ? n : Tr(t, e);
      };
    }, We.pull = na, We.pullAll = ta, We.pullAllBy = function (n, t, e) {
      return n && n.length && t && t.length ? qr(n, t, fi(e, 2)) : n;
    }, We.pullAllWith = function (t, e, r) {
      return t && t.length && e && e.length ? qr(t, e, n, r) : t;
    }, We.pullAt = ea, We.range = ms, We.rangeRight = gs, We.rearg = Wa, We.reject = function (n, t) {
      return (Xa(n) ? Ot : yr)(n, Ma(fi(t, 3)));
    }, We.remove = function (n, t) {
      var e = [];
      if (!n || !n.length) return e;
      var r = -1,
          o = [],
          i = n.length;

      for (t = fi(t, 3); ++r < i;) {
        var a = n[r];
        t(a, r, n) && (e.push(a), o.push(r));
      }

      return Gr(n, o), e;
    }, We.rest = function (e, r) {
      if ("function" != typeof e) throw new kn(t);
      return Jr(e, r = r === n ? r : gu(r));
    }, We.reverse = ra, We.sampleSize = function (t, e, r) {
      return e = (r ? Si(t, e, r) : e === n) ? 1 : gu(e), (Xa(t) ? nr : no)(t, e);
    }, We.set = function (n, t, e) {
      return null == n ? n : to(n, t, e);
    }, We.setWith = function (t, e, r, o) {
      return o = "function" == typeof o ? o : n, null == t ? t : to(t, e, r, o);
    }, We.shuffle = function (n) {
      return (Xa(n) ? tr : oo)(n);
    }, We.slice = function (t, e, r) {
      var o = null == t ? 0 : t.length;
      return o ? (r && "number" != typeof r && Si(t, e, r) ? (e = 0, r = o) : (e = null == e ? 0 : gu(e), r = r === n ? o : gu(r)), io(t, e, r)) : [];
    }, We.sortBy = Aa, We.sortedUniq = function (n) {
      return n && n.length ? co(n) : [];
    }, We.sortedUniqBy = function (n, t) {
      return n && n.length ? co(n, fi(t, 2)) : [];
    }, We.split = function (t, e, r) {
      return r && "number" != typeof r && Si(t, e, r) && (e = r = n), (r = r === n ? p : r >>> 0) ? (t = xu(t)) && ("string" == typeof e || null != e && !su(e)) && !(e = fo(e)) && ae(t) ? Eo(de(t), 0, r) : t.split(e, r) : [];
    }, We.spread = function (n, e) {
      if ("function" != typeof n) throw new kn(t);
      return e = null == e ? 0 : we(gu(e), 0), Jr(function (t) {
        var r = t[e],
            o = Eo(t, 0, e);
        return r && zt(o, r), Tt(n, this, o);
      });
    }, We.tail = function (n) {
      var t = null == n ? 0 : n.length;
      return t ? io(n, 1, t) : [];
    }, We.take = function (t, e, r) {
      return t && t.length ? io(t, 0, (e = r || e === n ? 1 : gu(e)) < 0 ? 0 : e) : [];
    }, We.takeRight = function (t, e, r) {
      var o = null == t ? 0 : t.length;
      return o ? io(t, (e = o - (e = r || e === n ? 1 : gu(e))) < 0 ? 0 : e, o) : [];
    }, We.takeRightWhile = function (n, t) {
      return n && n.length ? mo(n, fi(t, 3), !1, !0) : [];
    }, We.takeWhile = function (n, t) {
      return n && n.length ? mo(n, fi(t, 3)) : [];
    }, We.tap = function (n, t) {
      return t(n), n;
    }, We.throttle = function (n, e, r) {
      var o = !0,
          i = !0;
      if ("function" != typeof n) throw new kn(t);
      return ru(r) && (o = "leading" in r ? !!r.leading : o, i = "trailing" in r ? !!r.trailing : i), za(n, e, {
        leading: o,
        maxWait: e,
        trailing: i
      });
    }, We.thru = ma, We.toArray = vu, We.toPairs = Fu, We.toPairsIn = Wu, We.toPath = function (n) {
      return Xa(n) ? Nt(n, Vi) : fu(n) ? [n] : Ro(Bi(xu(n)));
    }, We.toPlainObject = wu, We.transform = function (n, t, e) {
      var r = Xa(n),
          o = r || Za(n) || pu(n);

      if (t = fi(t, 4), null == e) {
        var i = n && n.constructor;
        e = o ? r ? new i() : [] : ru(n) && nu(i) ? Ye(qn(n)) : {};
      }

      return (o ? Ct : Sr)(n, function (n, r, o) {
        return t(e, n, r, o);
      }), e;
    }, We.unary = function (n) {
      return Oa(n, 1);
    }, We.union = oa, We.unionBy = ia, We.unionWith = aa, We.uniq = function (n) {
      return n && n.length ? po(n) : [];
    }, We.uniqBy = function (n, t) {
      return n && n.length ? po(n, fi(t, 2)) : [];
    }, We.uniqWith = function (t, e) {
      return e = "function" == typeof e ? e : n, t && t.length ? po(t, n, e) : [];
    }, We.unset = function (n, t) {
      return null == n || ho(n, t);
    }, We.unzip = ua, We.unzipWith = sa, We.update = function (n, t, e) {
      return null == n ? n : vo(n, t, xo(e));
    }, We.updateWith = function (t, e, r, o) {
      return o = "function" == typeof o ? o : n, null == t ? t : vo(t, e, xo(r), o);
    }, We.values = Yu, We.valuesIn = function (n) {
      return null == n ? [] : Jt(n, Iu(n));
    }, We.without = ca, We.words = ns, We.wrap = function (n, t) {
      return Va(xo(t), n);
    }, We.xor = la, We.xorBy = fa, We.xorWith = pa, We.zip = da, We.zipObject = function (n, t) {
      return bo(n || [], t || [], rr);
    }, We.zipObjectDeep = function (n, t) {
      return bo(n || [], t || [], to);
    }, We.zipWith = ha, We.entries = Fu, We.entriesIn = Wu, We.extend = _u, We.extendWith = Eu, ls(We, We), We.add = xs, We.attempt = ts, We.camelCase = Hu, We.capitalize = Uu, We.ceil = Ss, We.clamp = function (t, e, r) {
      return r === n && (r = e, e = n), r !== n && (r = (r = bu(r)) == r ? r : 0), e !== n && (e = (e = bu(e)) == e ? e : 0), cr(bu(t), e, r);
    }, We.clone = function (n) {
      return lr(n, 4);
    }, We.cloneDeep = function (n) {
      return lr(n, 5);
    }, We.cloneDeepWith = function (t, e) {
      return lr(t, 5, e = "function" == typeof e ? e : n);
    }, We.cloneWith = function (t, e) {
      return lr(t, 4, e = "function" == typeof e ? e : n);
    }, We.conformsTo = function (n, t) {
      return null == t || fr(n, t, zu(t));
    }, We.deburr = $u, We.defaultTo = function (n, t) {
      return null == n || n != n ? t : n;
    }, We.divide = _s, We.endsWith = function (t, e, r) {
      t = xu(t), e = fo(e);
      var o = t.length,
          i = r = r === n ? o : cr(gu(r), 0, o);
      return (r -= e.length) >= 0 && t.slice(r, i) == e;
    }, We.eq = Ya, We.escape = function (n) {
      return (n = xu(n)) && q.test(n) ? n.replace($, oe) : n;
    }, We.escapeRegExp = function (n) {
      return (n = xu(n)) && en.test(n) ? n.replace(tn, "\\$&") : n;
    }, We.every = function (t, e, r) {
      var o = Xa(t) ? Lt : mr;
      return r && Si(t, e, r) && (e = n), o(t, fi(e, 3));
    }, We.find = ba, We.findIndex = $i, We.findKey = function (n, t) {
      return Bt(n, fi(t, 3), Sr);
    }, We.findLast = wa, We.findLastIndex = Xi, We.findLastKey = function (n, t) {
      return Bt(n, fi(t, 3), _r);
    }, We.floor = Es, We.forEach = xa, We.forEachRight = Sa, We.forIn = function (n, t) {
      return null == n ? n : wr(n, fi(t, 3), Iu);
    }, We.forInRight = function (n, t) {
      return null == n ? n : xr(n, fi(t, 3), Iu);
    }, We.forOwn = function (n, t) {
      return n && Sr(n, fi(t, 3));
    }, We.forOwnRight = function (n, t) {
      return n && _r(n, fi(t, 3));
    }, We.get = Lu, We.gt = Ha, We.gte = Ua, We.has = function (n, t) {
      return null != n && yi(n, t, Lr);
    }, We.hasIn = Ou, We.head = Gi, We.identity = as, We.includes = function (n, t, e, r) {
      n = Ga(n) ? n : Yu(n), e = e && !r ? gu(e) : 0;
      var o = n.length;
      return e < 0 && (e = we(o + e, 0)), lu(n) ? e <= o && n.indexOf(t, e) > -1 : !!o && Ft(n, t, e) > -1;
    }, We.indexOf = function (n, t, e) {
      var r = null == n ? 0 : n.length;
      if (!r) return -1;
      var o = null == e ? 0 : gu(e);
      return o < 0 && (o = we(r + o, 0)), Ft(n, t, o);
    }, We.inRange = function (t, e, r) {
      return e = mu(e), r === n ? (r = e, e = 0) : r = mu(r), function (n, t, e) {
        return n >= xe(t, e) && n < we(t, e);
      }(t = bu(t), e, r);
    }, We.invoke = Nu, We.isArguments = $a, We.isArray = Xa, We.isArrayBuffer = qa, We.isArrayLike = Ga, We.isArrayLikeObject = Ka, We.isBoolean = function (n) {
      return !0 === n || !1 === n || ou(n) && Cr(n) == m;
    }, We.isBuffer = Za, We.isDate = Ja, We.isElement = function (n) {
      return ou(n) && 1 === n.nodeType && !uu(n);
    }, We.isEmpty = function (n) {
      if (null == n) return !0;
      if (Ga(n) && (Xa(n) || "string" == typeof n || "function" == typeof n.splice || Za(n) || pu(n) || $a(n))) return !n.length;
      var t = gi(n);
      if (t == S || t == C) return !n.size;
      if (Pi(n)) return !Mr(n).length;

      for (var e in n) {
        if (jn.call(n, e)) return !1;
      }

      return !0;
    }, We.isEqual = function (n, t) {
      return zr(n, t);
    }, We.isEqualWith = function (t, e, r) {
      var o = (r = "function" == typeof r ? r : n) ? r(t, e) : n;
      return o === n ? zr(t, e, n, r) : !!o;
    }, We.isError = Qa, We.isFinite = function (n) {
      return "number" == typeof n && ge(n);
    }, We.isFunction = nu, We.isInteger = tu, We.isLength = eu, We.isMap = iu, We.isMatch = function (n, t) {
      return n === t || Ir(n, t, di(t));
    }, We.isMatchWith = function (t, e, r) {
      return r = "function" == typeof r ? r : n, Ir(t, e, di(e), r);
    }, We.isNaN = function (n) {
      return au(n) && n != +n;
    }, We.isNative = function (n) {
      if (Ti(n)) throw new Tn("Unsupported core-js use. Try https://npms.io/search?q=ponyfill.");
      return Dr(n);
    }, We.isNil = function (n) {
      return null == n;
    }, We.isNull = function (n) {
      return null === n;
    }, We.isNumber = au, We.isObject = ru, We.isObjectLike = ou, We.isPlainObject = uu, We.isRegExp = su, We.isSafeInteger = function (n) {
      return tu(n) && n >= -9007199254740991 && n <= l;
    }, We.isSet = cu, We.isString = lu, We.isSymbol = fu, We.isTypedArray = pu, We.isUndefined = function (t) {
      return t === n;
    }, We.isWeakMap = function (n) {
      return ou(n) && gi(n) == O;
    }, We.isWeakSet = function (n) {
      return ou(n) && "[object WeakSet]" == Cr(n);
    }, We.join = function (n, t) {
      return null == n ? "" : ye.call(n, t);
    }, We.kebabCase = Xu, We.last = Qi, We.lastIndexOf = function (t, e, r) {
      var o = null == t ? 0 : t.length;
      if (!o) return -1;
      var i = o;
      return r !== n && (i = (i = gu(r)) < 0 ? we(o + i, 0) : xe(i, o - 1)), e == e ? function (n, t, e) {
        for (var r = e + 1; r--;) {
          if (n[r] === t) return r;
        }

        return r;
      }(t, e, i) : Vt(t, Yt, i, !0);
    }, We.lowerCase = qu, We.lowerFirst = Gu, We.lt = du, We.lte = hu, We.max = function (t) {
      return t && t.length ? gr(t, as, Ar) : n;
    }, We.maxBy = function (t, e) {
      return t && t.length ? gr(t, fi(e, 2), Ar) : n;
    }, We.mean = function (n) {
      return Ht(n, as);
    }, We.meanBy = function (n, t) {
      return Ht(n, fi(t, 2));
    }, We.min = function (t) {
      return t && t.length ? gr(t, as, Vr) : n;
    }, We.minBy = function (t, e) {
      return t && t.length ? gr(t, fi(e, 2), Vr) : n;
    }, We.stubArray = ys, We.stubFalse = bs, We.stubObject = function () {
      return {};
    }, We.stubString = function () {
      return "";
    }, We.stubTrue = function () {
      return !0;
    }, We.multiply = Ts, We.nth = function (t, e) {
      return t && t.length ? Ur(t, gu(e)) : n;
    }, We.noConflict = function () {
      return dt._ === this && (dt._ = Wn), this;
    }, We.noop = fs, We.now = La, We.pad = function (n, t, e) {
      n = xu(n);
      var r = (t = gu(t)) ? pe(n) : 0;
      if (!t || r >= t) return n;
      var o = (t - r) / 2;
      return Xo(yt(o), e) + n + Xo(gt(o), e);
    }, We.padEnd = function (n, t, e) {
      n = xu(n);
      var r = (t = gu(t)) ? pe(n) : 0;
      return t && r < t ? n + Xo(t - r, e) : n;
    }, We.padStart = function (n, t, e) {
      n = xu(n);
      var r = (t = gu(t)) ? pe(n) : 0;
      return t && r < t ? Xo(t - r, e) + n : n;
    }, We.parseInt = function (n, t, e) {
      return e || null == t ? t = 0 : t && (t = +t), _e(xu(n).replace(rn, ""), t || 0);
    }, We.random = function (t, e, r) {
      if (r && "boolean" != typeof r && Si(t, e, r) && (e = r = n), r === n && ("boolean" == typeof e ? (r = e, e = n) : "boolean" == typeof t && (r = t, t = n)), t === n && e === n ? (t = 0, e = 1) : (t = mu(t), e === n ? (e = t, t = 0) : e = mu(e)), t > e) {
        var o = t;
        t = e, e = o;
      }

      if (r || t % 1 || e % 1) {
        var i = Ee();
        return xe(t + i * (e - t + ct("1e-" + ((i + "").length - 1))), e);
      }

      return Kr(t, e);
    }, We.reduce = function (n, t, e) {
      var r = Xa(n) ? It : Xt,
          o = arguments.length < 3;
      return r(n, fi(t, 4), e, o, hr);
    }, We.reduceRight = function (n, t, e) {
      var r = Xa(n) ? Dt : Xt,
          o = arguments.length < 3;
      return r(n, fi(t, 4), e, o, vr);
    }, We.repeat = function (t, e, r) {
      return e = (r ? Si(t, e, r) : e === n) ? 1 : gu(e), Zr(xu(t), e);
    }, We.replace = function () {
      var n = arguments,
          t = xu(n[0]);
      return n.length < 3 ? t : t.replace(n[1], n[2]);
    }, We.result = function (t, e, r) {
      var o = -1,
          i = (e = So(e, t)).length;

      for (i || (i = 1, t = n); ++o < i;) {
        var a = null == t ? n : t[Vi(e[o])];
        a === n && (o = i, a = r), t = nu(a) ? a.call(t) : a;
      }

      return t;
    }, We.round = Ps, We.runInContext = x, We.sample = function (n) {
      return (Xa(n) ? Qe : Qr)(n);
    }, We.size = function (n) {
      if (null == n) return 0;
      if (Ga(n)) return lu(n) ? pe(n) : n.length;
      var t = gi(n);
      return t == S || t == C ? n.size : Mr(n).length;
    }, We.snakeCase = Ku, We.some = function (t, e, r) {
      var o = Xa(t) ? jt : ao;
      return r && Si(t, e, r) && (e = n), o(t, fi(e, 3));
    }, We.sortedIndex = function (n, t) {
      return uo(n, t);
    }, We.sortedIndexBy = function (n, t, e) {
      return so(n, t, fi(e, 2));
    }, We.sortedIndexOf = function (n, t) {
      var e = null == n ? 0 : n.length;

      if (e) {
        var r = uo(n, t);
        if (r < e && Ya(n[r], t)) return r;
      }

      return -1;
    }, We.sortedLastIndex = function (n, t) {
      return uo(n, t, !0);
    }, We.sortedLastIndexBy = function (n, t, e) {
      return so(n, t, fi(e, 2), !0);
    }, We.sortedLastIndexOf = function (n, t) {
      if (null != n && n.length) {
        var e = uo(n, t, !0) - 1;
        if (Ya(n[e], t)) return e;
      }

      return -1;
    }, We.startCase = Zu, We.startsWith = function (n, t, e) {
      return n = xu(n), e = null == e ? 0 : cr(gu(e), 0, n.length), t = fo(t), n.slice(e, e + t.length) == t;
    }, We.subtract = Cs, We.sum = function (n) {
      return n && n.length ? qt(n, as) : 0;
    }, We.sumBy = function (n, t) {
      return n && n.length ? qt(n, fi(t, 2)) : 0;
    }, We.template = function (t, e, r) {
      var o = We.templateSettings;
      r && Si(t, e, r) && (e = n), t = xu(t), e = Eu({}, e, o, ti);
      var i,
          a,
          u = Eu({}, e.imports, o.imports, ti),
          s = zu(u),
          c = Jt(u, s),
          l = 0,
          f = e.interpolate || wn,
          p = "__p += '",
          d = Ln((e.escape || wn).source + "|" + f.source + "|" + (f === Z ? pn : wn).source + "|" + (e.evaluate || wn).source + "|$", "g"),
          h = "//# sourceURL=" + (jn.call(e, "sourceURL") ? (e.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++it + "]") + "\n";
      t.replace(d, function (n, e, r, o, u, s) {
        return r || (r = o), p += t.slice(l, s).replace(xn, ie), e && (i = !0, p += "' +\n__e(" + e + ") +\n'"), u && (a = !0, p += "';\n" + u + ";\n__p += '"), r && (p += "' +\n((__t = (" + r + ")) == null ? '' : __t) +\n'"), l = s + n.length, n;
      }), p += "';\n";
      var v = jn.call(e, "variable") && e.variable;

      if (v) {
        if (ln.test(v)) throw new Tn("Invalid `variable` option passed into `_.template`");
      } else p = "with (obj) {\n" + p + "\n}\n";

      p = (a ? p.replace(W, "") : p).replace(Y, "$1").replace(H, "$1;"), p = "function(" + (v || "obj") + ") {\n" + (v ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (i ? ", __e = _.escape" : "") + (a ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + p + "return __p\n}";
      var m = ts(function () {
        return Pn(s, h + "return " + p).apply(n, c);
      });
      if (m.source = p, Qa(m)) throw m;
      return m;
    }, We.times = function (n, t) {
      if ((n = gu(n)) < 1 || n > l) return [];
      var e = p,
          r = xe(n, p);
      t = fi(t), n -= p;

      for (var o = Gt(r, t); ++e < n;) {
        t(e);
      }

      return o;
    }, We.toFinite = mu, We.toInteger = gu, We.toLength = yu, We.toLower = function (n) {
      return xu(n).toLowerCase();
    }, We.toNumber = bu, We.toSafeInteger = function (n) {
      return n ? cr(gu(n), -9007199254740991, l) : 0 === n ? n : 0;
    }, We.toString = xu, We.toUpper = function (n) {
      return xu(n).toUpperCase();
    }, We.trim = function (t, e, r) {
      if ((t = xu(t)) && (r || e === n)) return Kt(t);
      if (!t || !(e = fo(e))) return t;
      var o = de(t),
          i = de(e);
      return Eo(o, ne(o, i), te(o, i) + 1).join("");
    }, We.trimEnd = function (t, e, r) {
      if ((t = xu(t)) && (r || e === n)) return t.slice(0, he(t) + 1);
      if (!t || !(e = fo(e))) return t;
      var o = de(t);
      return Eo(o, 0, te(o, de(e)) + 1).join("");
    }, We.trimStart = function (t, e, r) {
      if ((t = xu(t)) && (r || e === n)) return t.replace(rn, "");
      if (!t || !(e = fo(e))) return t;
      var o = de(t);
      return Eo(o, ne(o, de(e))).join("");
    }, We.truncate = function (t, e) {
      var r = 30,
          o = "...";

      if (ru(e)) {
        var i = "separator" in e ? e.separator : i;
        r = "length" in e ? gu(e.length) : r, o = "omission" in e ? fo(e.omission) : o;
      }

      var a = (t = xu(t)).length;

      if (ae(t)) {
        var u = de(t);
        a = u.length;
      }

      if (r >= a) return t;
      var s = r - pe(o);
      if (s < 1) return o;
      var c = u ? Eo(u, 0, s).join("") : t.slice(0, s);
      if (i === n) return c + o;

      if (u && (s += c.length - s), su(i)) {
        if (t.slice(s).search(i)) {
          var l,
              f = c;

          for (i.global || (i = Ln(i.source, xu(dn.exec(i)) + "g")), i.lastIndex = 0; l = i.exec(f);) {
            var p = l.index;
          }

          c = c.slice(0, p === n ? s : p);
        }
      } else if (t.indexOf(fo(i), s) != s) {
        var d = c.lastIndexOf(i);
        d > -1 && (c = c.slice(0, d));
      }

      return c + o;
    }, We.unescape = function (n) {
      return (n = xu(n)) && X.test(n) ? n.replace(U, ve) : n;
    }, We.uniqueId = function (n) {
      var t = ++Mn;
      return xu(n) + t;
    }, We.upperCase = Ju, We.upperFirst = Qu, We.each = xa, We.eachRight = Sa, We.first = Gi, ls(We, (ws = {}, Sr(We, function (n, t) {
      jn.call(We.prototype, t) || (ws[t] = n);
    }), ws), {
      chain: !1
    }), We.VERSION = "4.17.21", Ct(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function (n) {
      We[n].placeholder = We;
    }), Ct(["drop", "take"], function (t, e) {
      $e.prototype[t] = function (r) {
        r = r === n ? 1 : we(gu(r), 0);
        var o = this.__filtered__ && !e ? new $e(this) : this.clone();
        return o.__filtered__ ? o.__takeCount__ = xe(r, o.__takeCount__) : o.__views__.push({
          size: xe(r, p),
          type: t + (o.__dir__ < 0 ? "Right" : "")
        }), o;
      }, $e.prototype[t + "Right"] = function (n) {
        return this.reverse()[t](n).reverse();
      };
    }), Ct(["filter", "map", "takeWhile"], function (n, t) {
      var e = t + 1,
          r = 1 == e || 3 == e;

      $e.prototype[n] = function (n) {
        var t = this.clone();
        return t.__iteratees__.push({
          iteratee: fi(n, 3),
          type: e
        }), t.__filtered__ = t.__filtered__ || r, t;
      };
    }), Ct(["head", "last"], function (n, t) {
      var e = "take" + (t ? "Right" : "");

      $e.prototype[n] = function () {
        return this[e](1).value()[0];
      };
    }), Ct(["initial", "tail"], function (n, t) {
      var e = "drop" + (t ? "" : "Right");

      $e.prototype[n] = function () {
        return this.__filtered__ ? new $e(this) : this[e](1);
      };
    }), $e.prototype.compact = function () {
      return this.filter(as);
    }, $e.prototype.find = function (n) {
      return this.filter(n).head();
    }, $e.prototype.findLast = function (n) {
      return this.reverse().find(n);
    }, $e.prototype.invokeMap = Jr(function (n, t) {
      return "function" == typeof n ? new $e(this) : this.map(function (e) {
        return Rr(e, n, t);
      });
    }), $e.prototype.reject = function (n) {
      return this.filter(Ma(fi(n)));
    }, $e.prototype.slice = function (t, e) {
      t = gu(t);
      var r = this;
      return r.__filtered__ && (t > 0 || e < 0) ? new $e(r) : (t < 0 ? r = r.takeRight(-t) : t && (r = r.drop(t)), e !== n && (r = (e = gu(e)) < 0 ? r.dropRight(-e) : r.take(e - t)), r);
    }, $e.prototype.takeRightWhile = function (n) {
      return this.reverse().takeWhile(n).reverse();
    }, $e.prototype.toArray = function () {
      return this.take(p);
    }, Sr($e.prototype, function (t, e) {
      var r = /^(?:filter|find|map|reject)|While$/.test(e),
          o = /^(?:head|last)$/.test(e),
          i = We[o ? "take" + ("last" == e ? "Right" : "") : e],
          a = o || /^find/.test(e);
      i && (We.prototype[e] = function () {
        var e = this.__wrapped__,
            u = o ? [1] : arguments,
            s = e instanceof $e,
            c = u[0],
            l = s || Xa(e),
            f = function f(n) {
          var t = i.apply(We, zt([n], u));
          return o && p ? t[0] : t;
        };

        l && r && "function" == typeof c && 1 != c.length && (s = l = !1);
        var p = this.__chain__,
            d = !!this.__actions__.length,
            h = a && !p,
            v = s && !d;

        if (!a && l) {
          e = v ? e : new $e(this);
          var m = t.apply(e, u);
          return m.__actions__.push({
            func: ma,
            args: [f],
            thisArg: n
          }), new Ue(m, p);
        }

        return h && v ? t.apply(this, u) : (m = this.thru(f), h ? o ? m.value()[0] : m.value() : m);
      });
    }), Ct(["pop", "push", "shift", "sort", "splice", "unshift"], function (n) {
      var t = Rn[n],
          e = /^(?:push|sort|unshift)$/.test(n) ? "tap" : "thru",
          r = /^(?:pop|shift)$/.test(n);

      We.prototype[n] = function () {
        var n = arguments;

        if (r && !this.__chain__) {
          var o = this.value();
          return t.apply(Xa(o) ? o : [], n);
        }

        return this[e](function (e) {
          return t.apply(Xa(e) ? e : [], n);
        });
      };
    }), Sr($e.prototype, function (n, t) {
      var e = We[t];

      if (e) {
        var r = e.name + "";
        jn.call(Ne, r) || (Ne[r] = []), Ne[r].push({
          name: t,
          func: e
        });
      }
    }), Ne[Yo(n, 2).name] = [{
      name: "wrapper",
      func: n
    }], $e.prototype.clone = function () {
      var n = new $e(this.__wrapped__);
      return n.__actions__ = Ro(this.__actions__), n.__dir__ = this.__dir__, n.__filtered__ = this.__filtered__, n.__iteratees__ = Ro(this.__iteratees__), n.__takeCount__ = this.__takeCount__, n.__views__ = Ro(this.__views__), n;
    }, $e.prototype.reverse = function () {
      if (this.__filtered__) {
        var n = new $e(this);
        n.__dir__ = -1, n.__filtered__ = !0;
      } else (n = this.clone()).__dir__ *= -1;

      return n;
    }, $e.prototype.value = function () {
      var n = this.__wrapped__.value(),
          t = this.__dir__,
          e = Xa(n),
          r = t < 0,
          o = e ? n.length : 0,
          i = function (n, t, e) {
        for (var r = -1, o = e.length; ++r < o;) {
          var i = e[r],
              a = i.size;

          switch (i.type) {
            case "drop":
              n += a;
              break;

            case "dropRight":
              t -= a;
              break;

            case "take":
              t = xe(t, n + a);
              break;

            case "takeRight":
              n = we(n, t - a);
          }
        }

        return {
          start: n,
          end: t
        };
      }(0, o, this.__views__),
          a = i.start,
          u = i.end,
          s = u - a,
          c = r ? u : a - 1,
          l = this.__iteratees__,
          f = l.length,
          p = 0,
          d = xe(s, this.__takeCount__);

      if (!e || !r && o == s && d == s) return go(n, this.__actions__);
      var h = [];

      n: for (; s-- && p < d;) {
        for (var v = -1, m = n[c += t]; ++v < f;) {
          var g = l[v],
              y = g.iteratee,
              b = g.type,
              w = y(m);
          if (2 == b) m = w;else if (!w) {
            if (1 == b) continue n;
            break n;
          }
        }

        h[p++] = m;
      }

      return h;
    }, We.prototype.at = ga, We.prototype.chain = function () {
      return va(this);
    }, We.prototype.commit = function () {
      return new Ue(this.value(), this.__chain__);
    }, We.prototype.next = function () {
      this.__values__ === n && (this.__values__ = vu(this.value()));
      var t = this.__index__ >= this.__values__.length;
      return {
        done: t,
        value: t ? n : this.__values__[this.__index__++]
      };
    }, We.prototype.plant = function (t) {
      for (var e, r = this; r instanceof He;) {
        var o = Wi(r);
        o.__index__ = 0, o.__values__ = n, e ? i.__wrapped__ = o : e = o;
        var i = o;
        r = r.__wrapped__;
      }

      return i.__wrapped__ = t, e;
    }, We.prototype.reverse = function () {
      var t = this.__wrapped__;

      if (t instanceof $e) {
        var e = t;
        return this.__actions__.length && (e = new $e(this)), (e = e.reverse()).__actions__.push({
          func: ma,
          args: [ra],
          thisArg: n
        }), new Ue(e, this.__chain__);
      }

      return this.thru(ra);
    }, We.prototype.toJSON = We.prototype.valueOf = We.prototype.value = function () {
      return go(this.__wrapped__, this.__actions__);
    }, We.prototype.first = We.prototype.head, et && (We.prototype[et] = function () {
      return this;
    }), We;
  }();

  vt ? ((vt.exports = me)._ = me, ht._ = me) : dt._ = me;
}.call(x);

var In = function In(n) {
  var e = n.options,
      a = n.callbacks,
      u = n.elements,
      s = n.children,
      c = n.defaultOptions,
      l = n.defaultCallbacks,
      f = r(En),
      p = o(null),
      d = o(),
      h = o(!0);
  return i(function () {
    try {
      f.dispatch({
        type: "RESET_LIGHTBOX"
      });
    } catch (n) {
      Ln(n.message = "SRL - ERROR WHEN RESETTING THE LIGHTBOX STATUS");
    }

    return function () {
      h.current = !1;
    };
  }, []), i(function () {
    function n(n) {
      if (n) {
        var e = n.querySelectorAll("img");
        e.length > 0 ? f.isLoaded || (An(e).then(function (n) {
          return h.current ? function (n) {
            var e,
                o = [];
            n.forEach(function (n) {
              o = function (n) {
                var t, e, r, o;
                return n.getAttribute("srl_gallery_image") || "IMG" === n.nodeName && ("A" === (null === (t = n.offsetParent) || void 0 === t ? void 0 : t.nodeName) || "A" === (null === (e = n.parentNode) || void 0 === e ? void 0 : e.nodeName)) || "IMG" === n.nodeName && "PICTURE" === n.parentNode.nodeName && "A" === (null === (r = n.offsetParent) || void 0 === r ? void 0 : r.nodeName) || "A" === (null === (o = n.parentNode) || void 0 === o ? void 0 : o.nodeName);
              }(n) || function (n) {
                return "IMG" === n.nodeName && "PICTURE" === n.parentNode.nodeName && n.parentNode.parentNode.className.includes("gatsby-image-wrapper") && "A" === n.parentNode.parentNode.parentNode.nodeName;
              }(n) ? [].concat(Pn(o), [{
                type: "GALLERY IMAGE",
                element: n
              }]) : function (n) {
                var t;
                return "IMG" === n.nodeName && "A" !== (null === (t = n.parentNode) || void 0 === t ? void 0 : t.nodeName);
              }(n) ? [].concat(Pn(o), [{
                type: "IMAGE",
                element: n
              }]) : Pn(o);
            }), e = 0, r(o.map(function (n) {
              var r,
                  o,
                  i,
                  a,
                  u,
                  s,
                  c = n.element,
                  l = n.type;

              if (!c.ariaHidden) {
                c.setAttribute("srl_elementid", e);
                var f = null === (r = c.src) || void 0 === r ? void 0 : r.includes("base64"),
                    p = null === (o = c.src) || void 0 === o ? void 0 : o.includes("svg+xml"),
                    d = null === (i = c.offsetParent) || void 0 === i ? void 0 : i.className.includes("gatsby-image-wrapper"),
                    h = "picture" !== (null === (a = c.parentNode) || void 0 === a ? void 0 : a.localName),
                    v = "presentation" === c.getAttribute("role"),
                    m = (null === (u = c.src) || void 0 === u ? void 0 : u.includes("data:image/gif")) || (null === (s = c.src) || void 0 === s ? void 0 : s.includes("data:image/svg+xml;base64"));
                if (!(d && (f || p) && h || v || m)) switch (e++, l) {
                  case "IMAGE":
                    var g = {
                      id: c.getAttribute("srl_elementid"),
                      source: c.src || c.currentSrc,
                      caption: c.alt,
                      thumbnail: c.src || c.currentSrc,
                      width: c.naturalWidth,
                      height: c.naturalHeight,
                      type: "image"
                    };
                    return Cn(c, g, t), g;

                  case "GALLERY IMAGE":
                    var y = {
                      id: c.getAttribute("srl_elementid"),
                      source: c.parentElement.href || c.offsetParent.parentElement.href || c.offsetParent.href || c.parentElement.parentElement.parentElement.href || c.src || c.currentSrc || null,
                      caption: c.alt || c.textContent,
                      thumbnail: c.parentElement.href || c.offsetParent.parentElement.href || c.offsetParent.href || c.parentElement.parentElement.parentElement.href || c.src || c.currentSrc,
                      width: null,
                      height: null,
                      type: "gallery_image"
                    };
                    return Cn(c, y, t), y;

                  default:
                    return;
                }
              }
            }).filter(function (n) {
              return void 0 !== n;
            }));
          }(n) : null;
        }), Array.from(e).map(function (n) {
          return n.addEventListener("click", function (n) {
            n.preventDefault();
          });
        })) : u && function (n) {
          r(n.map(function (n, t) {
            return function (n) {
              return n.src;
            }(n) ? {
              id: t + "",
              source: n.src || null,
              caption: n.caption || null,
              thumbnail: n.thumbnail || n.src || null,
              type: "image"
            } : void 0;
          }).filter(function (n) {
            return n && !n.src;
          }));
        }(u);
      }
    }

    var t = function t(n) {
      if (!Rn.exports.isEqual(n, f.selectedElement)) try {
        f.dispatch({
          type: "HANDLE_ELEMENT",
          element: n
        });
      } catch (n) {
        Ln(n.message = "SRL - ERROR WHEN HANDLING THE ELEMENT");
      }
    };

    function r(n) {
      return function (n, t, e) {
        var r = {},
            o = {};
        r = Rn.exports.isEmpty(n) ? zn(zn({}, c), {}, {
          buttons: zn({}, c.buttons),
          settings: zn({}, c.settings),
          caption: zn({}, c.caption),
          thumbnails: zn({}, c.thumbnails),
          progressBar: zn({}, c.progressBar)
        }) : zn(zn(zn({}, c), n), {}, {
          buttons: zn(zn({}, c.buttons), n.buttons),
          settings: zn(zn({}, c.settings), n.settings),
          caption: zn(zn({}, c.caption), n.caption),
          thumbnails: zn(zn({}, c.thumbnails), n.thumbnails),
          progressBar: zn(zn({}, c.progressBar), n.progressBar)
        }), o = Rn.exports.isEmpty(t) ? zn({}, l) : zn(zn({}, l), t);
        var i = {
          options: zn({}, r),
          callbacks: zn({}, o)
        };
        if (!Rn.exports.isEqual(i.options, f.options) || !Rn.exports.isEqual(i.callbacks, f.callbacks) || !Rn.exports.isEqual(e, f.elements)) try {
          f.dispatch({
            type: "READY_LIGHTBOX",
            mergedSettings: i,
            elements: e
          });
        } catch (n) {
          Ln(n.message = "SRL - ERROR GRABBING SETTINGS AND ELEMENTS");
        }
      }(e, a, n);
    }

    d.current = new MutationObserver(function () {
      n(p.current);
    }), d.current.observe(p.current, {
      childList: !0,
      subtree: !0,
      attributeFilter: ["href", "src"]
    }), n(p.current);
  }, [f, l, c, e, a, u]), t.createElement("div", {
    ref: p
  }, s);
};

function Dn() {
  return (Dn = Object.assign || function (n) {
    for (var t = 1; t < arguments.length; t++) {
      var e = arguments[t];

      for (var r in e) {
        Object.prototype.hasOwnProperty.call(e, r) && (n[r] = e[r]);
      }
    }

    return n;
  }).apply(this, arguments);
}

function jn(n, t) {
  return t || (t = n.slice(0)), Object.freeze(Object.defineProperties(n, {
    raw: {
      value: Object.freeze(t)
    }
  }));
}

function Mn(n) {
  var t = Object.create(null);
  return function (e) {
    return void 0 === t[e] && (t[e] = n(e)), t[e];
  };
}

In.propTypes = {
  defaultOptions: mn.shape({
    settings: mn.shape({
      autoplaySpeed: mn.number,
      boxShadow: mn.string,
      disableKeyboardControls: mn.bool,
      disablePanzoom: mn.bool,
      disableWheelControls: mn.bool,
      downloadedFileName: mn.string,
      hideControlsAfter: mn.oneOfType([mn.number, mn.bool]),
      lightboxTransitionSpeed: mn.number,
      lightboxTransitionTimingFunction: mn.oneOfType([mn.string, mn.array]),
      overlayColor: mn.string,
      slideAnimationType: mn.string,
      slideSpringValues: mn.array,
      slideTransitionSpeed: mn.number,
      slideTransitionTimingFunction: mn.oneOfType([mn.string, mn.array]),
      usingPreact: mn.bool
    }),
    buttons: mn.shape({
      backgroundColor: mn.string,
      iconColor: mn.string,
      iconPadding: mn.string,
      showAutoplayButton: mn.bool,
      showCloseButton: mn.bool,
      showDownloadButton: mn.bool,
      showFullscreenButton: mn.bool,
      showNextButton: mn.bool,
      showPrevButton: mn.bool,
      showThumbnailsButton: mn.bool,
      size: mn.string
    }),
    caption: mn.shape({
      captionColor: mn.string,
      captionAlignment: mn.string,
      captionFontFamily: mn.string,
      captionFontSize: mn.string,
      captionFontStyle: mn.string,
      captionFontWeight: mn.oneOfType([mn.number, mn.string]),
      captionContainerPadding: mn.string,
      captionTextTransform: mn.string,
      showCaption: mn.bool
    }),
    thumbnails: mn.shape({
      showThumbnails: mn.bool,
      thumbnailsAlignment: mn.string,
      thumbnailsContainerPadding: mn.string,
      thumbnailsContainerBackgroundColor: mn.string,
      thumbnailsGap: mn.string,
      thumbnailsIconColor: mn.string,
      thumbnailsOpacity: mn.number,
      thumbnailsPosition: mn.string,
      thumbnailsSize: mn.array
    }),
    progressBar: mn.shape({
      backgroundColor: mn.string,
      fillColor: mn.string,
      height: mn.string,
      showProgressBar: mn.bool
    })
  }),
  defaultCallbacks: mn.shape({
    onCountSlides: mn.func,
    onLightboxClosed: mn.func,
    onLightboxOpened: mn.func,
    onSlideChange: mn.func
  }),
  children: mn.oneOfType([mn.arrayOf(mn.node), mn.node]),
  options: mn.object,
  callbacks: mn.object,
  elements: mn.array
}, In.defaultProps = {
  defaultOptions: {
    settings: {
      autoplaySpeed: 3e3,
      boxShadow: "none",
      disableKeyboardControls: !1,
      disablePanzoom: !1,
      disableWheelControls: !1,
      downloadedFileName: "SRL-image",
      hideControlsAfter: !1,
      lightboxTransitionSpeed: .3,
      lightboxTransitionTimingFunction: "linear",
      overlayColor: "rgba(30, 30, 30, 0.9)",
      slideAnimationType: "fade",
      slideSpringValues: [300, 50],
      slideTransitionSpeed: .6,
      slideTransitionTimingFunction: "linear",
      usingPreact: !1
    },
    buttons: {
      backgroundColor: "rgba(30,30,36,0.8)",
      iconColor: "rgba(255, 255, 255, 0.8)",
      iconPadding: "10px",
      showAutoplayButton: !0,
      showCloseButton: !0,
      showDownloadButton: !0,
      showFullscreenButton: !0,
      showNextButton: !0,
      showPrevButton: !0,
      showThumbnailsButton: !0,
      size: "40px"
    },
    caption: {
      captionAlignment: "start",
      captionColor: "#FFFFFF",
      captionContainerPadding: "20px 0 30px 0",
      captionFontFamily: "inherit",
      captionFontSize: "inherit",
      captionFontStyle: "inherit",
      captionFontWeight: "inherit",
      captionTextTransform: "inherit",
      showCaption: !0
    },
    thumbnails: {
      showThumbnails: !0,
      thumbnailsAlignment: "center",
      thumbnailsContainerBackgroundColor: "transparent",
      thumbnailsContainerPadding: "0",
      thumbnailsGap: "0 1px",
      thumbnailsIconColor: "#ffffff",
      thumbnailsOpacity: .4,
      thumbnailsPosition: "bottom",
      thumbnailsSize: ["100px", "80px"]
    },
    progressBar: {
      backgroundColor: "#f2f2f2",
      fillColor: "#000000",
      height: "3px",
      showProgressBar: !0
    }
  },
  defaultCallbacks: {
    onCountSlides: function onCountSlides() {},
    onSlideChange: function onSlideChange() {},
    onLightboxClosed: function onLightboxClosed() {},
    onLightboxOpened: function onLightboxOpened() {}
  }
};
var Bn = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/,
    Vn = Mn(function (n) {
  return Bn.test(n) || 111 === n.charCodeAt(0) && 110 === n.charCodeAt(1) && n.charCodeAt(2) < 91;
}),
    Fn = "undefined" != typeof global ? global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {};

var Wn = function () {
  function n(n) {
    var t = this;
    this._insertTag = function (n) {
      var e;
      e = 0 === t.tags.length ? t.prepend ? t.container.firstChild : t.before : t.tags[t.tags.length - 1].nextSibling, t.container.insertBefore(n, e), t.tags.push(n);
    }, this.isSpeedy = void 0 === n.speedy ? "production" === b.env.NODE_ENV : n.speedy, this.tags = [], this.ctr = 0, this.nonce = n.nonce, this.key = n.key, this.container = n.container, this.prepend = n.prepend, this.before = null;
  }

  var t = n.prototype;
  return t.hydrate = function (n) {
    n.forEach(this._insertTag);
  }, t.insert = function (n) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) == 0 && this._insertTag(function (n) {
      var t = document.createElement("style");
      return t.setAttribute("data-emotion", n.key), void 0 !== n.nonce && t.setAttribute("nonce", n.nonce), t.appendChild(document.createTextNode("")), t.setAttribute("data-s", ""), t;
    }(this));
    var t = this.tags[this.tags.length - 1];

    if ("production" !== b.env.NODE_ENV) {
      var e = 64 === n.charCodeAt(0) && 105 === n.charCodeAt(1);
      e && this._alreadyInsertedOrderInsensitiveRule && console.error("You're attempting to insert the following rule:\n" + n + "\n\n`@import` rules must be before all other types of rules in a stylesheet but other rules have already been inserted. Please ensure that `@import` rules are before all other rules."), this._alreadyInsertedOrderInsensitiveRule = this._alreadyInsertedOrderInsensitiveRule || !e;
    }

    if (this.isSpeedy) {
      var r = function (n) {
        if (n.sheet) return n.sheet;

        for (var t = 0; t < document.styleSheets.length; t++) {
          if (document.styleSheets[t].ownerNode === n) return document.styleSheets[t];
        }
      }(t);

      try {
        r.insertRule(n, r.cssRules.length);
      } catch (t) {
        "production" === b.env.NODE_ENV || /:(-moz-placeholder|-moz-focus-inner|-moz-focusring|-ms-input-placeholder|-moz-read-write|-moz-read-only|-ms-clear){/.test(n) || console.error('There was a problem inserting the following rule: "' + n + '"', t);
      }
    } else t.appendChild(document.createTextNode(n));

    this.ctr++;
  }, t.flush = function () {
    this.tags.forEach(function (n) {
      return n.parentNode.removeChild(n);
    }), this.tags = [], this.ctr = 0, "production" !== b.env.NODE_ENV && (this._alreadyInsertedOrderInsensitiveRule = !1);
  }, n;
}(),
    Yn = "-ms-",
    Hn = "-moz-",
    Un = "-webkit-",
    $n = Math.abs,
    Xn = String.fromCharCode;

function qn(n) {
  return n.trim();
}

function Gn(n, t, e) {
  return n.replace(t, e);
}

function Kn(n, t) {
  return n.indexOf(t);
}

function Zn(n, t) {
  return 0 | n.charCodeAt(t);
}

function Jn(n, t, e) {
  return n.slice(t, e);
}

function Qn(n) {
  return n.length;
}

function nt(n) {
  return n.length;
}

function tt(n, t) {
  return t.push(n), n;
}

var et = 1,
    rt = 1,
    ot = 0,
    it = 0,
    at = 0,
    ut = "";

function st(n, t, e, r, o, i, a) {
  return {
    value: n,
    root: t,
    parent: e,
    type: r,
    props: o,
    children: i,
    line: et,
    column: rt,
    length: a,
    return: ""
  };
}

function ct(n, t, e) {
  return st(n, t.root, t.parent, e, t.props, t.children, 0);
}

function lt() {
  return at = it > 0 ? Zn(ut, --it) : 0, rt--, 10 === at && (rt = 1, et--), at;
}

function ft() {
  return at = it < ot ? Zn(ut, it++) : 0, rt++, 10 === at && (rt = 1, et++), at;
}

function pt() {
  return Zn(ut, it);
}

function dt() {
  return it;
}

function ht(n, t) {
  return Jn(ut, n, t);
}

function vt(n) {
  switch (n) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;

    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;

    case 58:
      return 3;

    case 34:
    case 39:
    case 40:
    case 91:
      return 2;

    case 41:
    case 93:
      return 1;
  }

  return 0;
}

function mt(n) {
  return et = rt = 1, ot = Qn(ut = n), it = 0, [];
}

function gt(n) {
  return ut = "", n;
}

function yt(n) {
  return qn(ht(it - 1, xt(91 === n ? n + 2 : 40 === n ? n + 1 : n)));
}

function bt(n) {
  for (; (at = pt()) && at < 33;) {
    ft();
  }

  return vt(n) > 2 || vt(at) > 3 ? "" : " ";
}

function wt(n, t) {
  for (; --t && ft() && !(at < 48 || at > 102 || at > 57 && at < 65 || at > 70 && at < 97);) {
    ;
  }

  return ht(n, dt() + (t < 6 && 32 == pt() && 32 == ft()));
}

function xt(n) {
  for (; ft();) {
    switch (at) {
      case n:
        return it;

      case 34:
      case 39:
        return xt(34 === n || 39 === n ? n : at);

      case 40:
        41 === n && xt(n);
        break;

      case 92:
        ft();
    }
  }

  return it;
}

function St(n, t) {
  for (; ft() && n + at !== 57 && (n + at !== 84 || 47 !== pt());) {
    ;
  }

  return "/*" + ht(t, it - 1) + "*" + Xn(47 === n ? n : ft());
}

function _t(n) {
  for (; !vt(pt());) {
    ft();
  }

  return ht(n, it);
}

function Et(n) {
  return gt(Tt("", null, null, null, [""], n = mt(n), 0, [0], n));
}

function Tt(n, t, e, r, o, i, a, u, s) {
  for (var c = 0, l = 0, f = a, p = 0, d = 0, h = 0, v = 1, m = 1, g = 1, y = 0, b = "", w = o, x = i, S = r, _ = b; m;) {
    switch (h = y, y = ft()) {
      case 34:
      case 39:
      case 91:
      case 40:
        _ += yt(y);
        break;

      case 9:
      case 10:
      case 13:
      case 32:
        _ += bt(h);
        break;

      case 92:
        _ += wt(dt() - 1, 7);
        continue;

      case 47:
        switch (pt()) {
          case 42:
          case 47:
            tt(Ct(St(ft(), dt()), t, e), s);
            break;

          default:
            _ += "/";
        }

        break;

      case 123 * v:
        u[c++] = Qn(_) * g;

      case 125 * v:
      case 59:
      case 0:
        switch (y) {
          case 0:
          case 125:
            m = 0;

          case 59 + l:
            d > 0 && Qn(_) - f && tt(d > 32 ? At(_ + ";", r, e, f - 1) : At(Gn(_, " ", "") + ";", r, e, f - 2), s);
            break;

          case 59:
            _ += ";";

          default:
            if (tt(S = Pt(_, t, e, c, l, o, u, b, w = [], x = [], f), i), 123 === y) if (0 === l) Tt(_, t, S, S, w, i, f, u, x);else switch (p) {
              case 100:
              case 109:
              case 115:
                Tt(n, S, S, r && tt(Pt(n, S, S, 0, 0, o, u, b, o, w = [], f), x), o, x, f, u, r ? w : x);
                break;

              default:
                Tt(_, S, S, S, [""], x, f, u, x);
            }
        }

        c = l = d = 0, v = g = 1, b = _ = "", f = a;
        break;

      case 58:
        f = 1 + Qn(_), d = h;

      default:
        if (v < 1) if (123 == y) --v;else if (125 == y && 0 == v++ && 125 == lt()) continue;

        switch (_ += Xn(y), y * v) {
          case 38:
            g = l > 0 ? 1 : (_ += "\f", -1);
            break;

          case 44:
            u[c++] = (Qn(_) - 1) * g, g = 1;
            break;

          case 64:
            45 === pt() && (_ += yt(ft())), p = pt(), l = Qn(b = _ += _t(dt())), y++;
            break;

          case 45:
            45 === h && 2 == Qn(_) && (v = 0);
        }

    }
  }

  return i;
}

function Pt(n, t, e, r, o, i, a, u, s, c, l) {
  for (var f = o - 1, p = 0 === o ? i : [""], d = nt(p), h = 0, v = 0, m = 0; h < r; ++h) {
    for (var g = 0, y = Jn(n, f + 1, f = $n(v = a[h])), b = n; g < d; ++g) {
      (b = qn(v > 0 ? p[g] + " " + y : Gn(y, /&\f/g, p[g]))) && (s[m++] = b);
    }
  }

  return st(n, t, e, 0 === o ? "rule" : u, s, c, l);
}

function Ct(n, t, e) {
  return st(n, t, e, "comm", Xn(at), Jn(n, 2, -2), 0);
}

function At(n, t, e, r) {
  return st(n, t, e, "decl", Jn(n, 0, r), Jn(n, r + 1, -1), r);
}

function Lt(n, t) {
  switch (function (n, t) {
    return (((t << 2 ^ Zn(n, 0)) << 2 ^ Zn(n, 1)) << 2 ^ Zn(n, 2)) << 2 ^ Zn(n, 3);
  }(n, t)) {
    case 5103:
      return Un + "print-" + n + n;

    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return Un + n + n;

    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return Un + n + Hn + n + Yn + n + n;

    case 6828:
    case 4268:
      return Un + n + Yn + n + n;

    case 6165:
      return Un + n + Yn + "flex-" + n + n;

    case 5187:
      return Un + n + Gn(n, /(\w+).+(:[^]+)/, "-webkit-box-$1$2-ms-flex-$1$2") + n;

    case 5443:
      return Un + n + Yn + "flex-item-" + Gn(n, /flex-|-self/, "") + n;

    case 4675:
      return Un + n + Yn + "flex-line-pack" + Gn(n, /align-content|flex-|-self/, "") + n;

    case 5548:
      return Un + n + Yn + Gn(n, "shrink", "negative") + n;

    case 5292:
      return Un + n + Yn + Gn(n, "basis", "preferred-size") + n;

    case 6060:
      return Un + "box-" + Gn(n, "-grow", "") + Un + n + Yn + Gn(n, "grow", "positive") + n;

    case 4554:
      return Un + Gn(n, /([^-])(transform)/g, "$1-webkit-$2") + n;

    case 6187:
      return Gn(Gn(Gn(n, /(zoom-|grab)/, Un + "$1"), /(image-set)/, Un + "$1"), n, "") + n;

    case 5495:
    case 3959:
      return Gn(n, /(image-set\([^]*)/, Un + "$1$`$1");

    case 4968:
      return Gn(Gn(n, /(.+:)(flex-)?(.*)/, "-webkit-box-pack:$3-ms-flex-pack:$3"), /s.+-b[^;]+/, "justify") + Un + n + n;

    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return Gn(n, /(.+)-inline(.+)/, Un + "$1$2") + n;

    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (Qn(n) - 1 - t > 6) switch (Zn(n, t + 1)) {
        case 109:
          if (45 !== Zn(n, t + 4)) break;

        case 102:
          return Gn(n, /(.+:)(.+)-([^]+)/, "$1-webkit-$2-$3$1" + Hn + (108 == Zn(n, t + 3) ? "$3" : "$2-$3")) + n;

        case 115:
          return ~Kn(n, "stretch") ? Lt(Gn(n, "stretch", "fill-available"), t) + n : n;
      }
      break;

    case 4949:
      if (115 !== Zn(n, t + 1)) break;

    case 6444:
      switch (Zn(n, Qn(n) - 3 - (~Kn(n, "!important") && 10))) {
        case 107:
          return Gn(n, ":", ":" + Un) + n;

        case 101:
          return Gn(n, /(.+:)([^;!]+)(;|!.+)?/, "$1" + Un + (45 === Zn(n, 14) ? "inline-" : "") + "box$3$1" + Un + "$2$3$1" + Yn + "$2box$3") + n;
      }

      break;

    case 5936:
      switch (Zn(n, t + 11)) {
        case 114:
          return Un + n + Yn + Gn(n, /[svh]\w+-[tblr]{2}/, "tb") + n;

        case 108:
          return Un + n + Yn + Gn(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;

        case 45:
          return Un + n + Yn + Gn(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
      }

      return Un + n + Yn + n + n;
  }

  return n;
}

function Ot(n, t) {
  for (var e = "", r = nt(n), o = 0; o < r; o++) {
    e += t(n[o], o, n, t) || "";
  }

  return e;
}

function kt(n, t, e, r) {
  switch (n.type) {
    case "@import":
    case "decl":
      return n.return = n.return || n.value;

    case "comm":
      return "";

    case "rule":
      n.value = n.props.join(",");
  }

  return Qn(e = Ot(n.children, r)) ? n.return = n.value + "{" + e + "}" : "";
}

function Rt(n) {
  var t = nt(n);
  return function (e, r, o, i) {
    for (var a = "", u = 0; u < t; u++) {
      a += n[u](e, r, o, i) || "";
    }

    return a;
  };
}

var Nt,
    zt,
    It = function It(n, t) {
  return gt(function (n, t) {
    var e = -1,
        r = 44;

    do {
      switch (vt(r)) {
        case 0:
          38 === r && 12 === pt() && (t[e] = 1), n[e] += _t(it - 1);
          break;

        case 2:
          n[e] += yt(r);
          break;

        case 4:
          if (44 === r) {
            n[++e] = 58 === pt() ? "&\f" : "", t[e] = n[e].length;
            break;
          }

        default:
          n[e] += Xn(r);
      }
    } while (r = ft());

    return n;
  }(mt(n), t));
},
    Dt = new WeakMap(),
    jt = function jt(n) {
  if ("rule" === n.type && n.parent && n.length) {
    for (var t = n.value, e = n.parent, r = n.column === e.column && n.line === e.line; "rule" !== e.type;) {
      if (!(e = e.parent)) return;
    }

    if ((1 !== n.props.length || 58 === t.charCodeAt(0) || Dt.get(e)) && !r) {
      Dt.set(n, !0);

      for (var o = [], i = It(t, o), a = e.props, u = 0, s = 0; u < i.length; u++) {
        for (var c = 0; c < a.length; c++, s++) {
          n.props[s] = o[u] ? i[u].replace(/&\f/g, a[c]) : a[c] + " " + i[u];
        }
      }
    }
  }
},
    Mt = function Mt(n) {
  if ("decl" === n.type) {
    var t = n.value;
    108 === t.charCodeAt(0) && 98 === t.charCodeAt(2) && (n.return = "", n.value = "");
  }
},
    Bt = function Bt(n) {
  return 105 === n.type.charCodeAt(1) && 64 === n.type.charCodeAt(0);
},
    Vt = function Vt(n) {
  n.type = "", n.value = "", n.return = "", n.children = "", n.props = "";
},
    Ft = function Ft(n, t, e) {
  Bt(n) && (n.parent ? (console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles."), Vt(n)) : function (n, t) {
    for (var e = n - 1; e >= 0; e--) {
      if (!Bt(t[e])) return !0;
    }

    return !1;
  }(t, e) && (console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules."), Vt(n)));
},
    Wt = "undefined" != typeof document,
    Yt = Wt ? void 0 : (Nt = function Nt() {
  return Mn(function () {
    var n = {};
    return function (t) {
      return n[t];
    };
  });
}, zt = new WeakMap(), function (n) {
  if (zt.has(n)) return zt.get(n);
  var t = Nt(n);
  return zt.set(n, t), t;
}),
    Ht = [function (n, t, e, r) {
  if (!n.return) switch (n.type) {
    case "decl":
      n.return = Lt(n.value, n.length);
      break;

    case "@keyframes":
      return Ot([ct(Gn(n.value, "@", "@" + Un), n, "")], r);

    case "rule":
      if (n.length) return function (n, t) {
        return n.map(t).join("");
      }(n.props, function (t) {
        switch (function (n, t) {
          return (n = t.exec(n)) ? n[0] : n;
        }(t, /(::plac\w+|:read-\w+)/)) {
          case ":read-only":
          case ":read-write":
            return Ot([ct(Gn(t, /:(read-\w+)/, ":-moz-$1"), n, "")], r);

          case "::placeholder":
            return Ot([ct(Gn(t, /:(plac\w+)/, ":-webkit-input-$1"), n, ""), ct(Gn(t, /:(plac\w+)/, ":-moz-$1"), n, ""), ct(Gn(t, /:(plac\w+)/, Yn + "input-$1"), n, "")], r);
        }

        return "";
      });
  }
}],
    Ut = function Ut(n) {
  var t = n.key;
  if ("production" !== b.env.NODE_ENV && !t) throw new Error("You have to configure `key` for your cache. Please make sure it's unique (and not equal to 'css') as it's used for linking styles to your cache.\nIf multiple caches share the same key they might \"fight\" for each other's style elements.");

  if (Wt && "css" === t) {
    var e = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(e, function (n) {
      -1 !== n.getAttribute("data-emotion").indexOf(" ") && (document.head.appendChild(n), n.setAttribute("data-s", ""));
    });
  }

  var r = n.stylisPlugins || Ht;
  if ("production" !== b.env.NODE_ENV && /[^a-z-]/.test(t)) throw new Error('Emotion key must only contain lower case alphabetical characters and - but "' + t + '" was passed');
  var o,
      i,
      a = {},
      u = [];
  Wt && (o = n.container || document.head, Array.prototype.forEach.call(document.querySelectorAll('style[data-emotion^="' + t + ' "]'), function (n) {
    for (var t = n.getAttribute("data-emotion").split(" "), e = 1; e < t.length; e++) {
      a[t[e]] = !0;
    }

    u.push(n);
  }));
  var s,
      c = [jt, Mt];

  if ("production" !== b.env.NODE_ENV && c.push(function (n) {
    return function (t, e, r) {
      if ("rule" === t.type) {
        var o,
            i = t.value.match(/(:first|:nth|:nth-last)-child/g);

        if (i && !0 !== n.compat) {
          var a = e > 0 ? r[e - 1] : null;
          if (a && function (n) {
            return !!n && "comm" === n.type && n.children.indexOf("emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason") > -1;
          }((o = a.children).length ? o[o.length - 1] : null)) return;
          i.forEach(function (n) {
            console.error('The pseudo class "' + n + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + n.split("-child")[0] + '-of-type".');
          });
        }
      }
    };
  }({
    get compat() {
      return g.compat;
    }

  }), Ft), Wt) {
    var l,
        f = [kt, "production" !== b.env.NODE_ENV ? function (n) {
      n.root || (n.return ? l.insert(n.return) : n.value && "comm" !== n.type && l.insert(n.value + "{}"));
    } : (s = function s(n) {
      l.insert(n);
    }, function (n) {
      n.root || (n = n.return) && s(n);
    })],
        p = Rt(c.concat(r, f));

    i = function i(n, t, e, r) {
      l = e, "production" !== b.env.NODE_ENV && void 0 !== t.map && (l = {
        insert: function insert(n) {
          e.insert(n + t.map);
        }
      }), function (n) {
        Ot(Et(n), p);
      }(n ? n + "{" + t.styles + "}" : t.styles), r && (g.inserted[t.name] = !0);
    };
  } else {
    var d = [kt],
        h = Rt(c.concat(r, d)),
        v = Yt(r)(t),
        m = function m(n, t) {
      var e = t.name;
      return void 0 === v[e] && (v[e] = function (n) {
        return Ot(Et(n), h);
      }(n ? n + "{" + t.styles + "}" : t.styles)), v[e];
    };

    i = function i(n, t, e, r) {
      var o = t.name,
          i = m(n, t);
      return void 0 === g.compat ? (r && (g.inserted[o] = !0), "development" === b.env.NODE_ENV && void 0 !== t.map ? i + t.map : i) : r ? void (g.inserted[o] = i) : i;
    };
  }

  var g = {
    key: t,
    sheet: new Wn({
      key: t,
      container: o,
      nonce: n.nonce,
      speedy: n.speedy,
      prepend: n.prepend
    }),
    nonce: n.nonce,
    inserted: a,
    registered: {},
    insert: i
  };
  return g.sheet.hydrate(u), g;
},
    $t = _.exports,
    Xt = {};

Xt[$t.ForwardRef] = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, Xt[$t.Memo] = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
};
var qt = "undefined" != typeof document;

function Gt(n, t, e) {
  var r = "";
  return e.split(" ").forEach(function (e) {
    void 0 !== n[e] ? t.push(n[e] + ";") : r += e + " ";
  }), r;
}

var Kt = function Kt(n, t, e) {
  var r = n.key + "-" + t.name;

  if ((!1 === e || !1 === qt && void 0 !== n.compat) && void 0 === n.registered[r] && (n.registered[r] = t.styles), void 0 === n.inserted[t.name]) {
    var o = "",
        i = t;

    do {
      var a = n.insert(t === i ? "." + r : "", i, n.sheet, !0);
      qt || void 0 === a || (o += a), i = i.next;
    } while (void 0 !== i);

    if (!qt && 0 !== o.length) return o;
  }
};

var Zt = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
},
    Jt = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences",
    Qt = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).",
    ne = /[A-Z]|^ms/g,
    te = /_EMO_([^_]+?)_([^]*?)_EMO_/g,
    ee = function ee(n) {
  return 45 === n.charCodeAt(1);
},
    re = function re(n) {
  return null != n && "boolean" != typeof n;
},
    oe = Mn(function (n) {
  return ee(n) ? n : n.replace(ne, "-$&").toLowerCase();
}),
    ie = function ie(n, t) {
  switch (n) {
    case "animation":
    case "animationName":
      if ("string" == typeof t) return t.replace(te, function (n, t, e) {
        return he = {
          name: t,
          styles: e,
          next: he
        }, t;
      });
  }

  return 1 === Zt[n] || ee(n) || "number" != typeof t || 0 === t ? t : t + "px";
};

if ("production" !== b.env.NODE_ENV) {
  var ae = /(attr|counters?|url|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/,
      ue = ["normal", "none", "initial", "inherit", "unset"],
      se = ie,
      ce = /^-ms-/,
      le = /-(.)/g,
      fe = {};

  ie = function ie(n, t) {
    if ("content" === n && ("string" != typeof t || -1 === ue.indexOf(t) && !ae.test(t) && (t.charAt(0) !== t.charAt(t.length - 1) || '"' !== t.charAt(0) && "'" !== t.charAt(0)))) throw new Error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + t + "\"'`");
    var e = se(n, t);
    return "" === e || ee(n) || -1 === n.indexOf("-") || void 0 !== fe[n] || (fe[n] = !0, console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + n.replace(ce, "ms-").replace(le, function (n, t) {
      return t.toUpperCase();
    }) + "?")), e;
  };
}

function pe(n, t, e) {
  if (null == e) return "";

  if (void 0 !== e.__emotion_styles) {
    if ("production" !== b.env.NODE_ENV && "NO_COMPONENT_SELECTOR" === e.toString()) throw new Error("Component selectors can only be used in conjunction with @emotion/babel-plugin.");
    return e;
  }

  switch (typeof e) {
    case "boolean":
      return "";

    case "object":
      if (1 === e.anim) return he = {
        name: e.name,
        styles: e.styles,
        next: he
      }, e.name;

      if (void 0 !== e.styles) {
        var r = e.next;
        if (void 0 !== r) for (; void 0 !== r;) {
          he = {
            name: r.name,
            styles: r.styles,
            next: he
          }, r = r.next;
        }
        var o = e.styles + ";";
        return "production" !== b.env.NODE_ENV && void 0 !== e.map && (o += e.map), o;
      }

      return function (n, t, e) {
        var r = "";
        if (Array.isArray(e)) for (var o = 0; o < e.length; o++) {
          r += pe(n, t, e[o]) + ";";
        } else for (var i in e) {
          var a = e[i];
          if ("object" != typeof a) null != t && void 0 !== t[a] ? r += i + "{" + t[a] + "}" : re(a) && (r += oe(i) + ":" + ie(i, a) + ";");else {
            if ("NO_COMPONENT_SELECTOR" === i && "production" !== b.env.NODE_ENV) throw new Error("Component selectors can only be used in conjunction with @emotion/babel-plugin.");

            if (!Array.isArray(a) || "string" != typeof a[0] || null != t && void 0 !== t[a[0]]) {
              var u = pe(n, t, a);

              switch (i) {
                case "animation":
                case "animationName":
                  r += oe(i) + ":" + u + ";";
                  break;

                default:
                  "production" !== b.env.NODE_ENV && "undefined" === i && console.error(Qt), r += i + "{" + u + "}";
              }
            } else for (var s = 0; s < a.length; s++) {
              re(a[s]) && (r += oe(i) + ":" + ie(i, a[s]) + ";");
            }
          }
        }
        return r;
      }(n, t, e);

    case "function":
      if (void 0 !== n) {
        var i = he,
            a = e(n);
        return he = i, pe(n, t, a);
      }

      "production" !== b.env.NODE_ENV && console.error("Functions that are interpolated in css calls will be stringified.\nIf you want to have a css call based on props, create a function that returns a css call like this\nlet dynamicStyle = (props) => css`color: ${props.color}`\nIt can be called directly with props or interpolated in a styled call like this\nlet SomeComponent = styled('div')`${dynamicStyle}`");
      break;

    case "string":
      if ("production" !== b.env.NODE_ENV) {
        var u = [],
            s = e.replace(te, function (n, t, e) {
          var r = "animation" + u.length;
          return u.push("const " + r + " = keyframes`" + e.replace(/^@keyframes animation-\w+/, "") + "`"), "${" + r + "}";
        });
        u.length && console.error("`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\nInstead of doing this:\n\n" + [].concat(u, ["`" + s + "`"]).join("\n") + "\n\nYou should wrap it with `css` like this:\n\ncss`" + s + "`");
      }

  }

  if (null == t) return e;
  var c = t[e];
  return void 0 !== c ? c : e;
}

var de,
    he,
    ve = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
"production" !== b.env.NODE_ENV && (de = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g);

var me = function me(n, t, e) {
  if (1 === n.length && "object" == typeof n[0] && null !== n[0] && void 0 !== n[0].styles) return n[0];
  var r = !0,
      o = "";
  he = void 0;
  var i,
      a = n[0];
  null == a || void 0 === a.raw ? (r = !1, o += pe(e, t, a)) : ("production" !== b.env.NODE_ENV && void 0 === a[0] && console.error(Jt), o += a[0]);

  for (var u = 1; u < n.length; u++) {
    o += pe(e, t, n[u]), r && ("production" !== b.env.NODE_ENV && void 0 === a[u] && console.error(Jt), o += a[u]);
  }

  "production" !== b.env.NODE_ENV && (o = o.replace(de, function (n) {
    return i = n, "";
  })), ve.lastIndex = 0;

  for (var s, c = ""; null !== (s = ve.exec(o));) {
    c += "-" + s[1];
  }

  var l = function (n) {
    for (var t, e = 0, r = 0, o = n.length; o >= 4; ++r, o -= 4) {
      t = 1540483477 * (65535 & (t = 255 & n.charCodeAt(r) | (255 & n.charCodeAt(++r)) << 8 | (255 & n.charCodeAt(++r)) << 16 | (255 & n.charCodeAt(++r)) << 24)) + (59797 * (t >>> 16) << 16), e = 1540483477 * (65535 & (t ^= t >>> 24)) + (59797 * (t >>> 16) << 16) ^ 1540483477 * (65535 & e) + (59797 * (e >>> 16) << 16);
    }

    switch (o) {
      case 3:
        e ^= (255 & n.charCodeAt(r + 2)) << 16;

      case 2:
        e ^= (255 & n.charCodeAt(r + 1)) << 8;

      case 1:
        e = 1540483477 * (65535 & (e ^= 255 & n.charCodeAt(r))) + (59797 * (e >>> 16) << 16);
    }

    return (((e = 1540483477 * (65535 & (e ^= e >>> 13)) + (59797 * (e >>> 16) << 16)) ^ e >>> 15) >>> 0).toString(36);
  }(o) + c;

  return "production" !== b.env.NODE_ENV ? {
    name: l,
    styles: o,
    map: i,
    next: he,
    toString: function toString() {
      return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
  } : {
    name: l,
    styles: o,
    next: he
  };
},
    ge = "undefined" != typeof document,
    ye = Object.prototype.hasOwnProperty,
    be = s("undefined" != typeof HTMLElement ? Ut({
  key: "css"
}) : null);

"production" !== b.env.NODE_ENV && (be.displayName = "EmotionCacheContext"), be.Provider;

var we = function we(n) {
  return a(function (t, e) {
    var o = r(be);
    return n(t, o, e);
  });
};

ge || (we = function we(n) {
  return function (t) {
    var e = r(be);
    return null === e ? (e = Ut({
      key: "css"
    }), u(be.Provider, {
      value: e
    }, n(t, e))) : n(t, e);
  };
});
var xe = s({});
"production" !== b.env.NODE_ENV && (xe.displayName = "EmotionThemeContext");
var Se = we(function (n, t, e) {
  var o = n.css;
  "string" == typeof o && void 0 !== t.registered[o] && (o = t.registered[o]);
  var i = n.__EMOTION_TYPE_PLEASE_DO_NOT_USE__,
      a = [o],
      s = "";
  "string" == typeof n.className ? s = Gt(t.registered, a, n.className) : null != n.className && (s = n.className + " ");
  var l = me(a, void 0, r(xe));

  if ("production" !== b.env.NODE_ENV && -1 === l.name.indexOf("-")) {
    var f = n.__EMOTION_LABEL_PLEASE_DO_NOT_USE__;
    f && (l = me([l, "label:" + f + ";"]));
  }

  var p = Kt(t, l, "string" == typeof i);
  s += t.key + "-" + l.name;
  var d = {};

  for (var h in n) {
    !ye.call(n, h) || "css" === h || "__EMOTION_TYPE_PLEASE_DO_NOT_USE__" === h || "production" !== b.env.NODE_ENV && "__EMOTION_LABEL_PLEASE_DO_NOT_USE__" === h || (d[h] = n[h]);
  }

  d.ref = e, d.className = s;
  var v = u(i, d);

  if (!ge && void 0 !== p) {
    for (var m, g = l.name, y = l.next; void 0 !== y;) {
      g += " " + y.name, y = y.next;
    }

    return u(c, null, u("style", ((m = {})["data-emotion"] = t.key + " " + g, m.dangerouslySetInnerHTML = {
      __html: p
    }, m.nonce = t.sheet.nonce, m)), v);
  }

  return v;
});
"production" !== b.env.NODE_ENV && (Se.displayName = "EmotionCssPropInternal");

var _e = !1,
    Ee = we(function (n, t) {
  "production" === b.env.NODE_ENV || _e || !n.className && !n.css || (console.error("It looks like you're using the css prop on Global, did you mean to use the styles prop instead?"), _e = !0);
  var e = n.styles,
      i = me([e], void 0, r(xe));

  if (!ge) {
    for (var a, s = i.name, c = i.styles, f = i.next; void 0 !== f;) {
      s += " " + f.name, c += f.styles, f = f.next;
    }

    var p = !0 === t.compat,
        d = t.insert("", {
      name: s,
      styles: c
    }, t.sheet, p);
    return p ? null : u("style", ((a = {})["data-emotion"] = t.key + "-global " + s, a.dangerouslySetInnerHTML = {
      __html: d
    }, a.nonce = t.sheet.nonce, a));
  }

  var h = o();
  return l(function () {
    var n = t.key + "-global",
        e = new Wn({
      key: n,
      nonce: t.sheet.nonce,
      container: t.sheet.container,
      speedy: t.sheet.isSpeedy
    }),
        r = !1,
        o = document.querySelector('style[data-emotion="' + n + " " + i.name + '"]');
    return t.sheet.tags.length && (e.before = t.sheet.tags[0]), null !== o && (r = !0, o.setAttribute("data-emotion", n), e.hydrate([o])), h.current = [e, r], function () {
      e.flush();
    };
  }, [t]), l(function () {
    var n = h.current,
        e = n[0];
    if (n[1]) n[1] = !1;else {
      if (void 0 !== i.next && Kt(t, i.next, !0), e.tags.length) {
        var r = e.tags[e.tags.length - 1].nextElementSibling;
        e.before = r, e.flush();
      }

      t.insert("", i, e, !1);
    }
  }, [t, i.name]), null;
});

function Te() {
  for (var n = arguments.length, t = new Array(n), e = 0; e < n; e++) {
    t[e] = arguments[e];
  }

  return me(t);
}

"production" !== b.env.NODE_ENV && (Ee.displayName = "EmotionGlobal");

var Pe = function n(t) {
  for (var e = t.length, r = 0, o = ""; r < e; r++) {
    var i = t[r];

    if (null != i) {
      var a = void 0;

      switch (typeof i) {
        case "boolean":
          break;

        case "object":
          if (Array.isArray(i)) a = n(i);else for (var u in "production" !== b.env.NODE_ENV && void 0 !== i.styles && void 0 !== i.name && console.error("You have passed styles created with `css` from `@emotion/react` package to the `cx`.\n`cx` is meant to compose class names (strings) so you should convert those styles to a class name by passing them to the `css` received from <ClassNames/> component."), a = "", i) {
            i[u] && u && (a && (a += " "), a += u);
          }
          break;

        default:
          a = i;
      }

      a && (o && (o += " "), o += a);
    }
  }

  return o;
};

function Ce(n, t, e) {
  var r = [],
      o = Gt(n, r, e);
  return r.length < 2 ? e : o + t(r);
}

var Ae = we(function (n, t) {
  var e,
      o = "",
      i = "",
      a = !1,
      s = function s() {
    if (a && "production" !== b.env.NODE_ENV) throw new Error("css can only be used during render");

    for (var n = arguments.length, e = new Array(n), r = 0; r < n; r++) {
      e[r] = arguments[r];
    }

    var u = me(e, t.registered);
    if (ge) Kt(t, u, !1);else {
      var s = Kt(t, u, !1);
      void 0 !== s && (o += s);
    }
    return ge || (i += " " + u.name), t.key + "-" + u.name;
  },
      l = {
    css: s,
    cx: function cx() {
      if (a && "production" !== b.env.NODE_ENV) throw new Error("cx can only be used during render");

      for (var n = arguments.length, e = new Array(n), r = 0; r < n; r++) {
        e[r] = arguments[r];
      }

      return Ce(t.registered, s, Pe(e));
    },
    theme: r(xe)
  },
      f = n.children(l);

  return a = !0, ge || 0 === o.length ? f : u(c, null, u("style", ((e = {})["data-emotion"] = t.key + " " + i.substring(1), e.dangerouslySetInnerHTML = {
    __html: o
  }, e.nonce = t.sheet.nonce, e)), f);
});

if ("production" !== b.env.NODE_ENV && (Ae.displayName = "EmotionClassNames"), "production" !== b.env.NODE_ENV) {
  var Le = "undefined" != typeof document,
      Oe = "undefined" != typeof jest;

  if (Le && !Oe) {
    var ke = Le ? window : Fn,
        Re = "__EMOTION_REACT_" + "11.4.1".split(".")[0] + "__";
    ke[Re] && console.warn("You are loading @emotion/react when it is already loaded. Running multiple instances may cause problems. This can happen if multiple versions are used, or if multiple builds of the same version are used."), ke[Re] = !0;
  }
}

var Ne = Vn,
    ze = function ze(n) {
  return "theme" !== n;
},
    Ie = function Ie(n) {
  return "string" == typeof n && n.charCodeAt(0) > 96 ? Ne : ze;
},
    De = function De(n, t, e) {
  var r;

  if (t) {
    var o = t.shouldForwardProp;
    r = n.__emotion_forwardProp && o ? function (t) {
      return n.__emotion_forwardProp(t) && o(t);
    } : o;
  }

  return "function" != typeof r && e && (r = n.__emotion_forwardProp), r;
},
    je = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences",
    Me = "undefined" != typeof document,
    Be = function n(t, e) {
  if ("production" !== b.env.NODE_ENV && void 0 === t) throw new Error("You are trying to create a styled element with an undefined component.\nYou may have forgotten to import it.");
  var o,
      i,
      a = t.__emotion_real === t,
      s = a && t.__emotion_base || t;
  void 0 !== e && (o = e.label, i = e.target);
  var l = De(t, e, a),
      f = l || Ie(s),
      p = !f("as");
  return function () {
    var d = arguments,
        h = a && void 0 !== t.__emotion_styles ? t.__emotion_styles.slice(0) : [];
    if (void 0 !== o && h.push("label:" + o + ";"), null == d[0] || void 0 === d[0].raw) h.push.apply(h, d);else {
      "production" !== b.env.NODE_ENV && void 0 === d[0][0] && console.error(je), h.push(d[0][0]);

      for (var v = d.length, m = 1; m < v; m++) {
        "production" !== b.env.NODE_ENV && void 0 === d[0][m] && console.error(je), h.push(d[m], d[0][m]);
      }
    }
    var g = we(function (n, t, e) {
      var o = p && n.as || s,
          a = "",
          d = [],
          v = n;

      if (null == n.theme) {
        for (var m in v = {}, n) {
          v[m] = n[m];
        }

        v.theme = r(xe);
      }

      "string" == typeof n.className ? a = Gt(t.registered, d, n.className) : null != n.className && (a = n.className + " ");
      var g = me(h.concat(d), t.registered, v),
          y = Kt(t, g, "string" == typeof o);
      a += t.key + "-" + g.name, void 0 !== i && (a += " " + i);
      var b = p && void 0 === l ? Ie(o) : f,
          w = {};

      for (var x in n) {
        p && "as" === x || b(x) && (w[x] = n[x]);
      }

      w.className = a, w.ref = e;
      var S = u(o, w);

      if (!Me && void 0 !== y) {
        for (var _, E = g.name, T = g.next; void 0 !== T;) {
          E += " " + T.name, T = T.next;
        }

        return u(c, null, u("style", ((_ = {})["data-emotion"] = t.key + " " + E, _.dangerouslySetInnerHTML = {
          __html: y
        }, _.nonce = t.sheet.nonce, _)), S);
      }

      return S;
    });
    return g.displayName = void 0 !== o ? o : "Styled(" + ("string" == typeof s ? s : s.displayName || s.name || "Component") + ")", g.defaultProps = t.defaultProps, g.__emotion_real = g, g.__emotion_base = s, g.__emotion_styles = h, g.__emotion_forwardProp = l, Object.defineProperty(g, "toString", {
      value: function value() {
        return void 0 === i && "production" !== b.env.NODE_ENV ? "NO_COMPONENT_SELECTOR" : "." + i;
      }
    }), g.withComponent = function (t, r) {
      return n(t, Dn({}, e, r, {
        shouldForwardProp: De(g, r, !0)
      })).apply(void 0, h);
    }, g;
  };
}.bind();

["a", "abbr", "address", "area", "article", "aside", "audio", "b", "base", "bdi", "bdo", "big", "blockquote", "body", "br", "button", "canvas", "caption", "cite", "code", "col", "colgroup", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "div", "dl", "dt", "em", "embed", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "iframe", "img", "input", "ins", "kbd", "keygen", "label", "legend", "li", "link", "main", "map", "mark", "marquee", "menu", "menuitem", "meta", "meter", "nav", "noscript", "object", "ol", "optgroup", "option", "output", "p", "param", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "script", "section", "select", "small", "source", "span", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "textarea", "tfoot", "th", "thead", "time", "title", "tr", "track", "u", "ul", "var", "video", "wbr", "circle", "clipPath", "defs", "ellipse", "foreignObject", "g", "image", "line", "linearGradient", "mask", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "stop", "svg", "text", "tspan"].forEach(function (n) {
  Be[n] = Be(n);
});
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var _Ve = function Ve(n, t) {
  return (_Ve = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (n, t) {
    n.__proto__ = t;
  } || function (n, t) {
    for (var e in t) {
      Object.prototype.hasOwnProperty.call(t, e) && (n[e] = t[e]);
    }
  })(n, t);
};

function Fe(n, t) {
  if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");

  function e() {
    this.constructor = n;
  }

  _Ve(n, t), n.prototype = null === t ? Object.create(t) : (e.prototype = t.prototype, new e());
}

var _We = function We() {
  return (_We = Object.assign || function (n) {
    for (var t, e = 1, r = arguments.length; e < r; e++) {
      for (var o in t = arguments[e]) {
        Object.prototype.hasOwnProperty.call(t, o) && (n[o] = t[o]);
      }
    }

    return n;
  }).apply(this, arguments);
};

function Ye(n, t) {
  var e = {};

  for (var r in n) {
    Object.prototype.hasOwnProperty.call(n, r) && t.indexOf(r) < 0 && (e[r] = n[r]);
  }

  if (null != n && "function" == typeof Object.getOwnPropertySymbols) {
    var o = 0;

    for (r = Object.getOwnPropertySymbols(n); o < r.length; o++) {
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(n, r[o]) && (e[r[o]] = n[r[o]]);
    }
  }

  return e;
}

function He(n, t) {
  var e = "function" == typeof Symbol && n[Symbol.iterator];
  if (!e) return n;
  var r,
      o,
      i = e.call(n),
      a = [];

  try {
    for (; (void 0 === t || t-- > 0) && !(r = i.next()).done;) {
      a.push(r.value);
    }
  } catch (n) {
    o = {
      error: n
    };
  } finally {
    try {
      r && !r.done && (e = i.return) && e.call(i);
    } finally {
      if (o) throw o.error;
    }
  }

  return a;
}

function Ue(n, t, e) {
  if (e || 2 === arguments.length) for (var r, o = 0, i = t.length; o < i; o++) {
    !r && o in t || (r || (r = Array.prototype.slice.call(t, 0, o)), r[o] = t[o]);
  }
  return n.concat(r || Array.prototype.slice.call(t));
}

var $e = function $e(n) {
  return {
    isEnabled: function isEnabled(t) {
      return n.some(function (n) {
        return !!t[n];
      });
    }
  };
},
    Xe = {
  measureLayout: $e(["layout", "layoutId", "drag", "_layoutResetTransform"]),
  animation: $e(["animate", "exit", "variants", "whileHover", "whileTap", "whileFocus", "whileDrag"]),
  exit: $e(["exit"]),
  drag: $e(["drag", "dragControls"]),
  focus: $e(["whileFocus"]),
  hover: $e(["whileHover", "onHoverStart", "onHoverEnd"]),
  tap: $e(["whileTap", "onTap", "onTapStart", "onTapCancel"]),
  pan: $e(["onPan", "onPanStart", "onPanSessionStart", "onPanEnd"]),
  layoutAnimation: $e(["layout", "layoutId"])
};

var qe = function qe() {},
    Ge = function Ge() {};

"production" !== b.env.NODE_ENV && (qe = function qe(n, t) {
  n || "undefined" == typeof console || console.warn(t);
}, Ge = function Ge(n, t) {
  if (!n) throw new Error(t);
});
var Ke = s({
  strict: !1
}),
    Ze = Object.keys(Xe),
    Je = Ze.length;
var Qe = s({
  transformPagePoint: function transformPagePoint(n) {
    return n;
  },
  isStatic: !1
}),
    nr = s({});
var tr = s(null);

function er(n) {
  var t = o(null);
  return null === t.current && (t.current = n()), t.current;
}

function rr() {
  var n = r(tr);
  if (null === n) return [!0, null];
  var t = n.isPresent,
      e = n.onExitComplete,
      o = n.register,
      a = ar();
  i(function () {
    return o(a);
  }, []);
  return !t && e ? [!1, function () {
    return null == e ? void 0 : e(a);
  }] : [!0];
}

var or = 0,
    ir = function ir() {
  return or++;
},
    ar = function ar() {
  return er(ir);
},
    ur = s(null),
    sr = "undefined" != typeof window,
    cr = sr ? l : i;

function lr(n, t, e, a) {
  var u = r(Qe),
      s = r(Ke),
      c = r(nr).visualElement,
      l = r(tr),
      f = function (n) {
    var t = n.layoutId,
        e = r(ur);
    return e && void 0 !== t ? e + "-" + t : t;
  }(e),
      p = o(void 0);

  a || (a = s.renderer), !p.current && a && (p.current = a(n, {
    visualState: t,
    parent: c,
    props: _We(_We({}, e), {
      layoutId: f
    }),
    presenceId: null == l ? void 0 : l.id,
    blockInitialAnimation: !1 === (null == l ? void 0 : l.initial)
  }));
  var d = p.current;
  return cr(function () {
    var n;
    d && (d.setProps(_We(_We(_We({}, u), e), {
      layoutId: f
    })), d.isPresent = null === (n = l) || n.isPresent, d.isPresenceRoot = !c || c.presenceId !== (null == l ? void 0 : l.id), d.syncRender());
  }), i(function () {
    var n;
    d && (null === (n = d.animationState) || void 0 === n || n.animateChanges());
  }), cr(function () {
    return function () {
      return null == d ? void 0 : d.notifyUnmount();
    };
  }, []), d;
}

function fr(n) {
  return "object" == typeof n && Object.prototype.hasOwnProperty.call(n, "current");
}

function pr(n) {
  return Array.isArray(n);
}

function dr(n) {
  return "string" == typeof n || pr(n);
}

function hr(n, t, e, r, o) {
  var i;
  return void 0 === r && (r = {}), void 0 === o && (o = {}), "string" == typeof t && (t = null === (i = n.variants) || void 0 === i ? void 0 : i[t]), "function" == typeof t ? t(null != e ? e : n.custom, r, o) : t;
}

function vr(n, t, e) {
  var r = n.getProps();
  return hr(r, t, null != e ? e : r.custom, function (n) {
    var t = {};
    return n.forEachValue(function (n, e) {
      return t[e] = n.get();
    }), t;
  }(n), function (n) {
    var t = {};
    return n.forEachValue(function (n, e) {
      return t[e] = n.getVelocity();
    }), t;
  }(n));
}

function mr(n) {
  var t;
  return "function" == typeof (null === (t = n.animate) || void 0 === t ? void 0 : t.start) || dr(n.initial) || dr(n.animate) || dr(n.whileHover) || dr(n.whileDrag) || dr(n.whileTap) || dr(n.whileFocus) || dr(n.exit);
}

function gr(n) {
  return Boolean(mr(n) || n.variants);
}

function yr(n, t) {
  var e = function (n, t) {
    if (mr(n)) {
      var e = n.initial,
          r = n.animate;
      return {
        initial: !1 === e || dr(e) ? e : void 0,
        animate: dr(r) ? r : void 0
      };
    }

    return !1 !== n.inherit ? t : {};
  }(n, r(nr)),
      o = e.initial,
      i = e.animate;

  return p(function () {
    return {
      initial: o,
      animate: i
    };
  }, t ? [br(o), br(i)] : []);
}

function br(n) {
  return Array.isArray(n) ? n.join(" ") : n;
}

function wr(t) {
  var e = t.preloadedFeatures,
      o = t.createVisualElement,
      i = t.useRender,
      u = t.useVisualState,
      s = t.Component;
  return e && function (n) {
    for (var t in n) {
      var e = n[t];
      null !== e && (Xe[t].Component = e);
    }
  }(e), a(function (t, a) {
    var c = r(Qe).isStatic,
        l = null,
        p = yr(t, c),
        d = u(t, c);
    return !c && sr && (p.visualElement = lr(s, d, t, o), l = function (t, e, o) {
      var i = [],
          a = r(Ke);
      if (!e) return null;
      "production" !== b.env.NODE_ENV && o && a.strict && Ge(!1, "You have rendered a `motion` component within a `LazyMotion` component. This will break tree shaking. Import and render a `m` component instead.");

      for (var u = 0; u < Je; u++) {
        var s = Ze[u],
            c = Xe[s],
            l = c.isEnabled,
            f = c.Component;
        l(t) && f && i.push(n.createElement(f, _We({
          key: s
        }, t, {
          visualElement: e
        })));
      }

      return i;
    }(t, p.visualElement, e)), n.createElement(n.Fragment, null, n.createElement(nr.Provider, {
      value: p
    }, i(s, t, function (n, t, e) {
      return f(function (r) {
        var o;
        r && (null === (o = n.mount) || void 0 === o || o.call(n, r)), t && (r ? t.mount(r) : t.unmount()), e && ("function" == typeof e ? e(r) : fr(e) && (e.current = r));
      }, [t]);
    }(d, p.visualElement, a), d, c)), l);
  });
}

function xr(n) {
  function t(t, e) {
    return void 0 === e && (e = {}), wr(n(t, e));
  }

  var e = new Map();
  return new Proxy(t, {
    get: function get(n, r) {
      return e.has(r) || e.set(r, t(r)), e.get(r);
    }
  });
}

var Sr = ["animate", "circle", "defs", "desc", "ellipse", "g", "image", "line", "filter", "marker", "mask", "metadata", "path", "pattern", "polygon", "polyline", "rect", "stop", "svg", "switch", "symbol", "text", "tspan", "use", "view"];

function _r(n) {
  return "string" == typeof n && !n.includes("-") && !!(Sr.indexOf(n) > -1 || /[A-Z]/.test(n));
}

var Er = {};
var Tr = ["", "X", "Y", "Z"],
    Pr = ["transformPerspective", "x", "y", "z"];

function Cr(n, t) {
  return Pr.indexOf(n) - Pr.indexOf(t);
}

["translate", "scale", "rotate", "skew"].forEach(function (n) {
  return Tr.forEach(function (t) {
    return Pr.push(n + t);
  });
});
var Ar = new Set(Pr);

function Lr(n) {
  return Ar.has(n);
}

var Or = new Set(["originX", "originY", "originZ"]);

function kr(n) {
  return Or.has(n);
}

function Rr(n, t) {
  var e = t.layout,
      r = t.layoutId;
  return Lr(n) || kr(n) || (e || void 0 !== r) && (!!Er[n] || "opacity" === n);
}

var Nr = function Nr(n) {
  return null !== n && "object" == typeof n && n.getVelocity;
},
    zr = {
  x: "translateX",
  y: "translateY",
  z: "translateZ",
  transformPerspective: "perspective"
};

function Ir(n) {
  return n.startsWith("--");
}

var Dr = function Dr(n, t) {
  return t && "number" == typeof n ? t.transform(n) : n;
},
    jr = function jr(n, t) {
  return function (e) {
    return Math.max(Math.min(e, t), n);
  };
},
    Mr = function Mr(n) {
  return n % 1 ? Number(n.toFixed(5)) : n;
},
    Br = /(-)?([\d]*\.?[\d])+/g,
    Vr = /(#[0-9a-f]{6}|#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2,3}\s*\/*\s*[\d\.]+%?\))/gi,
    Fr = /^(#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2,3}\s*\/*\s*[\d\.]+%?\))$/i;

function Wr(n) {
  return "string" == typeof n;
}

var Yr = {
  test: function test(n) {
    return "number" == typeof n;
  },
  parse: parseFloat,
  transform: function transform(n) {
    return n;
  }
},
    Hr = _We(_We({}, Yr), {
  transform: jr(0, 1)
}),
    Ur = _We(_We({}, Yr), {
  default: 1
}),
    $r = function $r(n) {
  return {
    test: function test(t) {
      return Wr(t) && t.endsWith(n) && 1 === t.split(" ").length;
    },
    parse: parseFloat,
    transform: function transform(t) {
      return "" + t + n;
    }
  };
},
    Xr = $r("deg"),
    qr = $r("%"),
    Gr = $r("px"),
    Kr = $r("vh"),
    Zr = $r("vw"),
    Jr = _We(_We({}, qr), {
  parse: function parse(n) {
    return qr.parse(n) / 100;
  },
  transform: function transform(n) {
    return qr.transform(100 * n);
  }
}),
    Qr = function Qr(n, t) {
  return function (e) {
    return Boolean(Wr(e) && Fr.test(e) && e.startsWith(n) || t && Object.prototype.hasOwnProperty.call(e, t));
  };
},
    no = function no(n, t, e) {
  return function (r) {
    var o;
    if (!Wr(r)) return r;
    var i = r.match(Br),
        a = i[0],
        u = i[1],
        s = i[2],
        c = i[3];
    return (o = {})[n] = parseFloat(a), o[t] = parseFloat(u), o[e] = parseFloat(s), o.alpha = void 0 !== c ? parseFloat(c) : 1, o;
  };
},
    to = {
  test: Qr("hsl", "hue"),
  parse: no("hue", "saturation", "lightness"),
  transform: function transform(n) {
    var t = n.hue,
        e = n.saturation,
        r = n.lightness,
        o = n.alpha,
        i = void 0 === o ? 1 : o;
    return "hsla(" + Math.round(t) + ", " + qr.transform(Mr(e)) + ", " + qr.transform(Mr(r)) + ", " + Mr(Hr.transform(i)) + ")";
  }
},
    eo = jr(0, 255),
    ro = _We(_We({}, Yr), {
  transform: function transform(n) {
    return Math.round(eo(n));
  }
}),
    oo = {
  test: Qr("rgb", "red"),
  parse: no("red", "green", "blue"),
  transform: function transform(n) {
    var t = n.red,
        e = n.green,
        r = n.blue,
        o = n.alpha,
        i = void 0 === o ? 1 : o;
    return "rgba(" + ro.transform(t) + ", " + ro.transform(e) + ", " + ro.transform(r) + ", " + Mr(Hr.transform(i)) + ")";
  }
};

var io = {
  test: Qr("#"),
  parse: function parse(n) {
    var t = "",
        e = "",
        r = "",
        o = "";
    return n.length > 5 ? (t = n.substr(1, 2), e = n.substr(3, 2), r = n.substr(5, 2), o = n.substr(7, 2)) : (t = n.substr(1, 1), e = n.substr(2, 1), r = n.substr(3, 1), o = n.substr(4, 1), t += t, e += e, r += r, o += o), {
      red: parseInt(t, 16),
      green: parseInt(e, 16),
      blue: parseInt(r, 16),
      alpha: o ? parseInt(o, 16) / 255 : 1
    };
  },
  transform: oo.transform
},
    ao = {
  test: function test(n) {
    return oo.test(n) || io.test(n) || to.test(n);
  },
  parse: function parse(n) {
    return oo.test(n) ? oo.parse(n) : to.test(n) ? to.parse(n) : io.parse(n);
  },
  transform: function transform(n) {
    return Wr(n) ? n : n.hasOwnProperty("red") ? oo.transform(n) : to.transform(n);
  }
};

function uo(n) {
  var t = [],
      e = 0,
      r = n.match(Vr);
  r && (e = r.length, n = n.replace(Vr, "${c}"), t.push.apply(t, r.map(ao.parse)));
  var o = n.match(Br);
  return o && (n = n.replace(Br, "${n}"), t.push.apply(t, o.map(Yr.parse))), {
    values: t,
    numColors: e,
    tokenised: n
  };
}

function so(n) {
  return uo(n).values;
}

function co(n) {
  var t = uo(n),
      e = t.values,
      r = t.numColors,
      o = t.tokenised,
      i = e.length;
  return function (n) {
    for (var t = o, e = 0; e < i; e++) {
      t = t.replace(e < r ? "${c}" : "${n}", e < r ? ao.transform(n[e]) : Mr(n[e]));
    }

    return t;
  };
}

var lo = function lo(n) {
  return "number" == typeof n ? 0 : n;
};

var fo = {
  test: function test(n) {
    var t, e, r, o;
    return isNaN(n) && Wr(n) && (null !== (e = null === (t = n.match(Br)) || void 0 === t ? void 0 : t.length) && void 0 !== e ? e : 0) + (null !== (o = null === (r = n.match(Vr)) || void 0 === r ? void 0 : r.length) && void 0 !== o ? o : 0) > 0;
  },
  parse: so,
  createTransformer: co,
  getAnimatableNone: function getAnimatableNone(n) {
    var t = so(n);
    return co(n)(t.map(lo));
  }
},
    po = new Set(["brightness", "contrast", "saturate", "opacity"]);

function ho(n) {
  var t = n.slice(0, -1).split("("),
      e = t[0],
      r = t[1];
  if ("drop-shadow" === e) return n;
  var o = (r.match(Br) || [])[0];
  if (!o) return n;
  var i = r.replace(o, ""),
      a = po.has(e) ? 1 : 0;
  return o !== r && (a *= 100), e + "(" + a + i + ")";
}

var vo = /([a-z-]*)\(.*?\)/g,
    mo = _We(_We({}, fo), {
  getAnimatableNone: function getAnimatableNone(n) {
    var t = n.match(vo);
    return t ? t.map(ho).join(" ") : n;
  }
}),
    go = _We(_We({}, Yr), {
  transform: Math.round
}),
    yo = {
  borderWidth: Gr,
  borderTopWidth: Gr,
  borderRightWidth: Gr,
  borderBottomWidth: Gr,
  borderLeftWidth: Gr,
  borderRadius: Gr,
  radius: Gr,
  borderTopLeftRadius: Gr,
  borderTopRightRadius: Gr,
  borderBottomRightRadius: Gr,
  borderBottomLeftRadius: Gr,
  width: Gr,
  maxWidth: Gr,
  height: Gr,
  maxHeight: Gr,
  size: Gr,
  top: Gr,
  right: Gr,
  bottom: Gr,
  left: Gr,
  padding: Gr,
  paddingTop: Gr,
  paddingRight: Gr,
  paddingBottom: Gr,
  paddingLeft: Gr,
  margin: Gr,
  marginTop: Gr,
  marginRight: Gr,
  marginBottom: Gr,
  marginLeft: Gr,
  rotate: Xr,
  rotateX: Xr,
  rotateY: Xr,
  rotateZ: Xr,
  scale: Ur,
  scaleX: Ur,
  scaleY: Ur,
  scaleZ: Ur,
  skew: Xr,
  skewX: Xr,
  skewY: Xr,
  distance: Gr,
  translateX: Gr,
  translateY: Gr,
  translateZ: Gr,
  x: Gr,
  y: Gr,
  z: Gr,
  perspective: Gr,
  transformPerspective: Gr,
  opacity: Hr,
  originX: Jr,
  originY: Jr,
  originZ: Gr,
  zIndex: go,
  fillOpacity: Hr,
  strokeOpacity: Hr,
  numOctaves: go
};

function bo(n, t, e, r, o, i, a, u) {
  var s,
      c = n.style,
      l = n.vars,
      f = n.transform,
      p = n.transformKeys,
      d = n.transformOrigin;
  p.length = 0;
  var h = !1,
      v = !1,
      m = !0;

  for (var g in t) {
    var y = t[g];
    if (Ir(g)) l[g] = y;else {
      var b = yo[g],
          w = Dr(y, b);

      if (Lr(g)) {
        if (h = !0, f[g] = w, p.push(g), !m) continue;
        y !== (null !== (s = b.default) && void 0 !== s ? s : 0) && (m = !1);
      } else if (kr(g)) d[g] = w, v = !0;else if ((null == e ? void 0 : e.isHydrated) && (null == r ? void 0 : r.isHydrated) && Er[g]) {
        var x = Er[g].process(y, r, e),
            S = Er[g].applyTo;
        if (S) for (var _ = S.length, E = 0; E < _; E++) {
          c[S[E]] = x;
        } else c[g] = x;
      } else c[g] = w;
    }
  }

  r && e && a && u ? (c.transform = a(r.deltaFinal, r.treeScale, h ? f : void 0), i && (c.transform = i(f, c.transform)), c.transformOrigin = u(r)) : (h && (c.transform = function (n, t, e, r) {
    var o = n.transform,
        i = n.transformKeys,
        a = t.enableHardwareAcceleration,
        u = void 0 === a || a,
        s = t.allowTransformNone,
        c = void 0 === s || s,
        l = "";
    i.sort(Cr);

    for (var f = !1, p = i.length, d = 0; d < p; d++) {
      var h = i[d];
      l += (zr[h] || h) + "(" + o[h] + ") ", "z" === h && (f = !0);
    }

    return !f && u ? l += "translateZ(0)" : l = l.trim(), r ? l = r(o, e ? "" : l) : c && e && (l = "none"), l;
  }(n, o, m, i)), v && (c.transformOrigin = function (n) {
    var t = n.originX,
        e = void 0 === t ? "50%" : t,
        r = n.originY,
        o = void 0 === r ? "50%" : r,
        i = n.originZ;
    return e + " " + o + " " + (void 0 === i ? 0 : i);
  }(d)));
}

var wo = function wo() {
  return {
    style: {},
    transform: {},
    transformKeys: [],
    transformOrigin: {},
    vars: {}
  };
};

function xo(n, t, e) {
  for (var r in t) {
    Nr(t[r]) || Rr(r, e) || (n[r] = t[r]);
  }
}

function So(n, t, e) {
  var r = {};
  return xo(r, n.style || {}, n), Object.assign(r, function (n, t, e) {
    var r = n.transformTemplate;
    return p(function () {
      var n = {
        style: {},
        transform: {},
        transformKeys: [],
        transformOrigin: {},
        vars: {}
      };
      bo(n, t, void 0, void 0, {
        enableHardwareAcceleration: !e
      }, r);
      var o = n.style;
      return _We(_We({}, n.vars), o);
    }, [t]);
  }(n, t, e)), n.transformValues && (r = n.transformValues(r)), r;
}

function _o(n, t, e) {
  var r = {},
      o = So(n, t, e);
  return Boolean(n.drag) && (r.draggable = !1, o.userSelect = o.WebkitUserSelect = o.WebkitTouchCallout = "none", o.touchAction = !0 === n.drag ? "none" : "pan-" + ("x" === n.drag ? "y" : "x")), r.style = o, r;
}

var Eo = new Set(["initial", "animate", "exit", "style", "variants", "transition", "transformTemplate", "transformValues", "custom", "inherit", "layout", "layoutId", "_layoutResetTransform", "onLayoutAnimationComplete", "onViewportBoxUpdate", "onLayoutMeasure", "onBeforeLayoutMeasure", "onAnimationStart", "onAnimationComplete", "onUpdate", "onDragStart", "onDrag", "onDragEnd", "onMeasureDragConstraints", "onDirectionLock", "onDragTransitionEnd", "drag", "dragControls", "dragListener", "dragConstraints", "dragDirectionLock", "_dragX", "_dragY", "dragElastic", "dragMomentum", "dragPropagation", "dragTransition", "whileDrag", "onPan", "onPanStart", "onPanEnd", "onPanSessionStart", "onTap", "onTapStart", "onTapCancel", "onHoverStart", "onHoverEnd", "whileFocus", "whileTap", "whileHover"]);

function To(n) {
  return Eo.has(n);
}

var Po = function Po(n) {
  return !To(n);
};

try {
  var Co = require("@emotion/is-prop-valid").default;

  Po = function Po(n) {
    return n.startsWith("on") ? !To(n) : Co(n);
  };
} catch (n) {}

function Ao(n, t, e) {
  return "string" == typeof n ? n : Gr.transform(t + e * n);
}

var Lo = function Lo(n, t) {
  return Gr.transform(n * t);
},
    Oo = {
  offset: "stroke-dashoffset",
  array: "stroke-dasharray"
},
    ko = {
  offset: "strokeDashoffset",
  array: "strokeDasharray"
};

function Ro(n, t, e, r, o, i, a, u) {
  var s = t.attrX,
      c = t.attrY,
      l = t.originX,
      f = t.originY,
      p = t.pathLength,
      d = t.pathSpacing,
      h = void 0 === d ? 1 : d,
      v = t.pathOffset,
      m = void 0 === v ? 0 : v;
  bo(n, Ye(t, ["attrX", "attrY", "originX", "originY", "pathLength", "pathSpacing", "pathOffset"]), e, r, o, i, a, u), n.attrs = n.style, n.style = {};
  var g = n.attrs,
      y = n.style,
      b = n.dimensions,
      w = n.totalPathLength;
  g.transform && (b && (y.transform = g.transform), delete g.transform), b && (void 0 !== l || void 0 !== f || y.transform) && (y.transformOrigin = function (n, t, e) {
    return Ao(t, n.x, n.width) + " " + Ao(e, n.y, n.height);
  }(b, void 0 !== l ? l : .5, void 0 !== f ? f : .5)), void 0 !== s && (g.x = s), void 0 !== c && (g.y = c), void 0 !== w && void 0 !== p && function (n, t, e, r, o, i) {
    void 0 === r && (r = 1), void 0 === o && (o = 0), void 0 === i && (i = !0);
    var a = i ? Oo : ko;
    n[a.offset] = Lo(-o, t);
    var u = Lo(e, t),
        s = Lo(r, t);
    n[a.array] = u + " " + s;
  }(g, w, p, h, m, !1);
}

var No = function No() {
  return _We(_We({}, {
    style: {},
    transform: {},
    transformKeys: [],
    transformOrigin: {},
    vars: {}
  }), {
    attrs: {}
  });
};

function zo(n, t) {
  var e = p(function () {
    var e = No();
    return Ro(e, t, void 0, void 0, {
      enableHardwareAcceleration: !1
    }, n.transformTemplate), _We(_We({}, e.attrs), {
      style: _We({}, e.style)
    });
  }, [t]);

  if (n.style) {
    var r = {};
    xo(r, n.style, n), e.style = _We(_We({}, r), e.style);
  }

  return e;
}

function Io(n) {
  void 0 === n && (n = !1);
  return function (t, e, r, o, i) {
    var a = o.latestValues,
        s = (_r(t) ? zo : _o)(e, a, i),
        c = function (n, t, e) {
      var r = {};

      for (var o in n) {
        (Po(o) || !0 === e && To(o) || !t && !To(o)) && (r[o] = n[o]);
      }

      return r;
    }(e, "string" == typeof t, n),
        l = _We(_We(_We({}, c), s), {
      ref: r
    });

    return u(t, l);
  };
}

var Do = /([a-z])([A-Z])/g,
    jo = function jo(n) {
  return n.replace(Do, "$1-$2").toLowerCase();
};

function Mo(n, t) {
  var e = t.style,
      r = t.vars;

  for (var o in Object.assign(n.style, e), r) {
    n.style.setProperty(o, r[o]);
  }
}

var Bo = new Set(["baseFrequency", "diffuseConstant", "kernelMatrix", "kernelUnitLength", "keySplines", "keyTimes", "limitingConeAngle", "markerHeight", "markerWidth", "numOctaves", "targetX", "targetY", "surfaceScale", "specularConstant", "specularExponent", "stdDeviation", "tableValues", "viewBox", "gradientTransform"]);

function Vo(n, t) {
  for (var e in Mo(n, t), t.attrs) {
    n.setAttribute(Bo.has(e) ? e : jo(e), t.attrs[e]);
  }
}

function Fo(n) {
  var t = n.style,
      e = {};

  for (var r in t) {
    (Nr(t[r]) || Rr(r, n)) && (e[r] = t[r]);
  }

  return e;
}

function Wo(n) {
  var t = Fo(n);

  for (var e in n) {
    if (Nr(n[e])) t["x" === e || "y" === e ? "attr" + e.toUpperCase() : e] = n[e];
  }

  return t;
}

function Yo(n) {
  return "object" == typeof n && "function" == typeof n.start;
}

var Ho = function Ho(n) {
  return Array.isArray(n);
},
    Uo = function Uo(n) {
  return Ho(n) ? n[n.length - 1] || 0 : n;
};

function $o(n) {
  var t = Nr(n) ? n.get() : n;
  return function (n) {
    return Boolean(n && "object" == typeof n && n.mix && n.toValue);
  }(t) ? t.toValue() : t;
}

function Xo(n, t, e, r) {
  var o = n.scrapeMotionValuesFromProps,
      i = n.createRenderState,
      a = n.onMount,
      u = {
    latestValues: Go(t, e, r, o),
    renderState: i()
  };
  return a && (u.mount = function (n) {
    return a(t, n, u);
  }), u;
}

var qo = function qo(n) {
  return function (t, e) {
    var o = r(nr),
        i = r(tr);
    return e ? Xo(n, t, o, i) : er(function () {
      return Xo(n, t, o, i);
    });
  };
};

function Go(n, t, e, r) {
  var o = {},
      i = !1 === (null == e ? void 0 : e.initial),
      a = r(n);

  for (var u in a) {
    o[u] = $o(a[u]);
  }

  var s = n.initial,
      c = n.animate,
      l = mr(n),
      f = gr(n);
  t && f && !l && !1 !== n.inherit && (null != s || (s = t.initial), null != c || (c = t.animate));
  var p = i || !1 === s ? c : s;
  p && "boolean" != typeof p && !Yo(p) && (Array.isArray(p) ? p : [p]).forEach(function (t) {
    var e = hr(n, t);

    if (e) {
      var r = e.transitionEnd;
      e.transition;
      var i = Ye(e, ["transitionEnd", "transition"]);

      for (var a in i) {
        o[a] = i[a];
      }

      for (var a in r) {
        o[a] = r[a];
      }
    }
  });
  return o;
}

var Ko = {
  useVisualState: qo({
    scrapeMotionValuesFromProps: Wo,
    createRenderState: No,
    onMount: function onMount(n, t, e) {
      var r = e.renderState,
          o = e.latestValues;

      try {
        r.dimensions = "function" == typeof t.getBBox ? t.getBBox() : t.getBoundingClientRect();
      } catch (n) {
        r.dimensions = {
          x: 0,
          y: 0,
          width: 0,
          height: 0
        };
      }

      "path" === t.tagName && (r.totalPathLength = t.getTotalLength()), Ro(r, o, void 0, void 0, {
        enableHardwareAcceleration: !1
      }, n.transformTemplate), Vo(t, r);
    }
  })
};
var Zo,
    Jo = {
  useVisualState: qo({
    scrapeMotionValuesFromProps: Fo,
    createRenderState: wo
  })
};

function Qo(n, t, e, r) {
  return n.addEventListener(t, e, r), function () {
    return n.removeEventListener(t, e, r);
  };
}

function ni(n, t, e, r) {
  i(function () {
    var o = n.current;
    if (e && o) return Qo(o, t, e, r);
  }, [n, t, e, r]);
}

function ti(n) {
  return "undefined" != typeof PointerEvent && n instanceof PointerEvent ? !("mouse" !== n.pointerType) : n instanceof MouseEvent;
}

function ei(n) {
  return !!n.touches;
}

!function (n) {
  n.Animate = "animate", n.Hover = "whileHover", n.Tap = "whileTap", n.Drag = "whileDrag", n.Focus = "whileFocus", n.Exit = "exit";
}(Zo || (Zo = {}));
var ri = {
  pageX: 0,
  pageY: 0
};

function oi(n, t) {
  void 0 === t && (t = "page");
  var e = n.touches[0] || n.changedTouches[0] || ri;
  return {
    x: e[t + "X"],
    y: e[t + "Y"]
  };
}

function ii(n, t) {
  return void 0 === t && (t = "page"), {
    x: n[t + "X"],
    y: n[t + "Y"]
  };
}

function ai(n, t) {
  return void 0 === t && (t = "page"), {
    point: ei(n) ? oi(n, t) : ii(n, t)
  };
}

var ui = function ui(n, t) {
  void 0 === t && (t = !1);

  var e,
      r = function r(t) {
    return n(t, ai(t));
  };

  return t ? (e = r, function (n) {
    var t = n instanceof MouseEvent;
    (!t || t && 0 === n.button) && e(n);
  }) : r;
},
    si = {
  pointerdown: "mousedown",
  pointermove: "mousemove",
  pointerup: "mouseup",
  pointercancel: "mousecancel",
  pointerover: "mouseover",
  pointerout: "mouseout",
  pointerenter: "mouseenter",
  pointerleave: "mouseleave"
},
    ci = {
  pointerdown: "touchstart",
  pointermove: "touchmove",
  pointerup: "touchend",
  pointercancel: "touchcancel"
};

function li(n) {
  return sr && null === window.onpointerdown ? n : sr && null === window.ontouchstart ? ci[n] : sr && null === window.onmousedown ? si[n] : n;
}

function fi(n, t, e, r) {
  return Qo(n, li(t), ui(e, "pointerdown" === t), r);
}

function pi(n, t, e, r) {
  return ni(n, li(t), e && ui(e, "pointerdown" === t), r);
}

function di(n) {
  var t = null;
  return function () {
    return null === t && (t = n, function () {
      t = null;
    });
  };
}

var hi = di("dragHorizontal"),
    vi = di("dragVertical");

function mi(n) {
  var t = !1;
  if ("y" === n) t = vi();else if ("x" === n) t = hi();else {
    var e = hi(),
        r = vi();
    e && r ? t = function t() {
      e(), r();
    } : (e && e(), r && r());
  }
  return t;
}

function gi() {
  var n = mi(!0);
  return !n || (n(), !1);
}

function yi(n, t, e) {
  return function (r, o) {
    var i;
    ti(r) && !gi() && (null == e || e(r, o), null === (i = n.animationState) || void 0 === i || i.setActive(Zo.Hover, t));
  };
}

var bi = function bi(n, t) {
  return !!t && (n === t || bi(n, t.parentElement));
};

function wi(n) {
  return i(function () {
    return function () {
      return n();
    };
  }, []);
}

var xi = function xi(n, t, e) {
  return Math.min(Math.max(e, n), t);
};

function Si(n) {
  var t,
      e,
      r = n.duration,
      o = void 0 === r ? 800 : r,
      i = n.bounce,
      a = void 0 === i ? .25 : i,
      u = n.velocity,
      s = void 0 === u ? 0 : u,
      c = n.mass,
      l = void 0 === c ? 1 : c;
  qe(o <= 1e4, "Spring duration must be 10 seconds or less");
  var f = 1 - a;
  f = xi(.05, 1, f), o = xi(.01, 10, o / 1e3), f < 1 ? (t = function t(n) {
    var t = n * f,
        e = t * o;
    return .001 - (t - s) / _i(n, f) * Math.exp(-e);
  }, e = function e(n) {
    var e = n * f * o,
        r = e * s + s,
        i = Math.pow(f, 2) * Math.pow(n, 2) * o,
        a = Math.exp(-e),
        u = _i(Math.pow(n, 2), f);

    return (.001 - t(n) > 0 ? -1 : 1) * ((r - i) * a) / u;
  }) : (t = function t(n) {
    return Math.exp(-n * o) * ((n - s) * o + 1) - .001;
  }, e = function e(n) {
    return Math.exp(-n * o) * (o * o * (s - n));
  });

  var p = function (n, t, e) {
    for (var r = e, o = 1; o < 12; o++) {
      r -= n(r) / t(r);
    }

    return r;
  }(t, e, 5 / o);

  if (o *= 1e3, isNaN(p)) return {
    stiffness: 100,
    damping: 10,
    duration: o
  };
  var d = Math.pow(p, 2) * l;
  return {
    stiffness: d,
    damping: 2 * f * Math.sqrt(l * d),
    duration: o
  };
}

function _i(n, t) {
  return n * Math.sqrt(1 - t * t);
}

var Ei = ["duration", "bounce"],
    Ti = ["stiffness", "damping", "mass"];

function Pi(n, t) {
  return t.some(function (t) {
    return void 0 !== n[t];
  });
}

function Ci(n) {
  var t = n.from,
      e = void 0 === t ? 0 : t,
      r = n.to,
      o = void 0 === r ? 1 : r,
      i = n.restSpeed,
      a = void 0 === i ? 2 : i,
      u = n.restDelta,
      s = Ye(n, ["from", "to", "restSpeed", "restDelta"]),
      c = {
    done: !1,
    value: e
  },
      l = function (n) {
    var t = _We({
      velocity: 0,
      stiffness: 100,
      damping: 10,
      mass: 1,
      isResolvedFromDuration: !1
    }, n);

    if (!Pi(n, Ti) && Pi(n, Ei)) {
      var e = Si(n);
      (t = _We(_We(_We({}, t), e), {
        velocity: 0,
        mass: 1
      })).isResolvedFromDuration = !0;
    }

    return t;
  }(s),
      f = l.stiffness,
      p = l.damping,
      d = l.mass,
      h = l.velocity,
      v = l.duration,
      m = l.isResolvedFromDuration,
      g = Ai,
      y = Ai;

  function b() {
    var n = h ? -h / 1e3 : 0,
        t = o - e,
        r = p / (2 * Math.sqrt(f * d)),
        i = Math.sqrt(f / d) / 1e3;

    if (null != u || (u = Math.abs(o - e) <= 1 ? .01 : .4), r < 1) {
      var a = _i(i, r);

      g = function g(e) {
        var u = Math.exp(-r * i * e);
        return o - u * ((n + r * i * t) / a * Math.sin(a * e) + t * Math.cos(a * e));
      }, y = function y(e) {
        var o = Math.exp(-r * i * e);
        return r * i * o * (Math.sin(a * e) * (n + r * i * t) / a + t * Math.cos(a * e)) - o * (Math.cos(a * e) * (n + r * i * t) - a * t * Math.sin(a * e));
      };
    } else if (1 === r) g = function g(e) {
      return o - Math.exp(-i * e) * (t + (n + i * t) * e);
    };else {
      var s = i * Math.sqrt(r * r - 1);

      g = function g(e) {
        var a = Math.exp(-r * i * e),
            u = Math.min(s * e, 300);
        return o - a * ((n + r * i * t) * Math.sinh(u) + s * t * Math.cosh(u)) / s;
      };
    }
  }

  return b(), {
    next: function next(n) {
      var t = g(n);
      if (m) c.done = n >= v;else {
        var e = 1e3 * y(n),
            r = Math.abs(e) <= a,
            i = Math.abs(o - t) <= u;
        c.done = r && i;
      }
      return c.value = c.done ? o : t, c;
    },
    flipTarget: function flipTarget() {
      var n;
      h = -h, e = (n = [o, e])[0], o = n[1], b();
    }
  };
}

Ci.needsInterpolation = function (n, t) {
  return "string" == typeof n || "string" == typeof t;
};

var Ai = function Ai(n) {
  return 0;
},
    Li = function Li(n, t, e) {
  var r = t - n;
  return 0 === r ? 1 : (e - n) / r;
},
    Oi = function Oi(n, t, e) {
  return -e * n + e * t + n;
},
    ki = function ki(n, t, e) {
  var r = n * n,
      o = t * t;
  return Math.sqrt(Math.max(0, e * (o - r) + r));
},
    Ri = [io, oo, to],
    Ni = function Ni(n) {
  return Ri.find(function (t) {
    return t.test(n);
  });
},
    zi = function zi(n) {
  return "'" + n + "' is not an animatable color. Use the equivalent color code instead.";
},
    Ii = function Ii(n, t) {
  var e = Ni(n),
      r = Ni(t);
  Ge(!!e, zi(n)), Ge(!!r, zi(t)), Ge(e.transform === r.transform, "Both colors must be hex/RGBA, OR both must be HSLA.");

  var o = e.parse(n),
      i = r.parse(t),
      a = _We({}, o),
      u = e === to ? Oi : ki;

  return function (n) {
    for (var t in a) {
      "alpha" !== t && (a[t] = u(o[t], i[t], n));
    }

    return a.alpha = Oi(o.alpha, i.alpha, n), e.transform(a);
  };
},
    Di = function Di(n) {
  return "number" == typeof n;
},
    ji = function ji(n, t) {
  return function (e) {
    return t(n(e));
  };
},
    Mi = function Mi() {
  for (var n = [], t = 0; t < arguments.length; t++) {
    n[t] = arguments[t];
  }

  return n.reduce(ji);
};

function Bi(n, t) {
  return Di(n) ? function (e) {
    return Oi(n, t, e);
  } : ao.test(n) ? Ii(n, t) : Yi(n, t);
}

var Vi = function Vi(n, t) {
  var e = Ue([], n),
      r = e.length,
      o = n.map(function (n, e) {
    return Bi(n, t[e]);
  });
  return function (n) {
    for (var t = 0; t < r; t++) {
      e[t] = o[t](n);
    }

    return e;
  };
},
    Fi = function Fi(n, t) {
  var e = _We(_We({}, n), t),
      r = {};

  for (var o in e) {
    void 0 !== n[o] && void 0 !== t[o] && (r[o] = Bi(n[o], t[o]));
  }

  return function (n) {
    for (var t in r) {
      e[t] = r[t](n);
    }

    return e;
  };
};

function Wi(n) {
  for (var t = fo.parse(n), e = t.length, r = 0, o = 0, i = 0, a = 0; a < e; a++) {
    r || "number" == typeof t[a] ? r++ : void 0 !== t[a].hue ? i++ : o++;
  }

  return {
    parsed: t,
    numNumbers: r,
    numRGB: o,
    numHSL: i
  };
}

var Yi = function Yi(n, t) {
  var e = fo.createTransformer(t),
      r = Wi(n),
      o = Wi(t);
  return Ge(r.numHSL === o.numHSL && r.numRGB === o.numRGB && r.numNumbers >= o.numNumbers, "Complex values '" + n + "' and '" + t + "' too different to mix. Ensure all colors are of the same type."), Mi(Vi(r.parsed, o.parsed), e);
},
    Hi = function Hi(n, t) {
  return function (e) {
    return Oi(n, t, e);
  };
};

function Ui(n, t, e) {
  for (var r = [], o = e || function (n) {
    return "number" == typeof n ? Hi : "string" == typeof n ? ao.test(n) ? Ii : Yi : Array.isArray(n) ? Vi : "object" == typeof n ? Fi : void 0;
  }(n[0]), i = n.length - 1, a = 0; a < i; a++) {
    var u = o(n[a], n[a + 1]);

    if (t) {
      var s = Array.isArray(t) ? t[a] : t;
      u = Mi(s, u);
    }

    r.push(u);
  }

  return r;
}

function $i(n, t, e) {
  var r = void 0 === e ? {} : e,
      o = r.clamp,
      i = void 0 === o || o,
      a = r.ease,
      u = r.mixer,
      s = n.length;
  Ge(s === t.length, "Both input and output ranges must be the same length"), Ge(!a || !Array.isArray(a) || a.length === s - 1, "Array of easing functions must be of length `input.length - 1`, as it applies to the transitions **between** the defined values."), n[0] > n[s - 1] && (n = [].concat(n), t = [].concat(t), n.reverse(), t.reverse());
  var c = Ui(t, a, u),
      l = 2 === s ? function (n, t) {
    var e = n[0],
        r = n[1],
        o = t[0];
    return function (n) {
      return o(Li(e, r, n));
    };
  }(n, c) : function (n, t) {
    var e = n.length,
        r = e - 1;
    return function (o) {
      var i = 0,
          a = !1;

      if (o <= n[0] ? a = !0 : o >= n[r] && (i = r - 1, a = !0), !a) {
        for (var u = 1; u < e && !(n[u] > o || u === r); u++) {
          ;
        }

        i = u - 1;
      }

      var s = Li(n[i], n[i + 1], o);
      return t[i](s);
    };
  }(n, c);
  return i ? function (t) {
    return l(xi(n[0], n[s - 1], t));
  } : l;
}

var Xi,
    qi = function qi(n) {
  return function (t) {
    return 1 - n(1 - t);
  };
},
    Gi = function Gi(n) {
  return function (t) {
    return t <= .5 ? n(2 * t) / 2 : (2 - n(2 * (1 - t))) / 2;
  };
},
    Ki = function Ki(n) {
  return function (t) {
    return t * t * ((n + 1) * t - n);
  };
},
    Zi = function Zi(n) {
  return n;
},
    Ji = (Xi = 2, function (n) {
  return Math.pow(n, Xi);
}),
    Qi = qi(Ji),
    na = Gi(Ji),
    ta = function ta(n) {
  return 1 - Math.sin(Math.acos(n));
},
    ea = qi(ta),
    ra = Gi(ea),
    oa = Ki(1.525),
    ia = qi(oa),
    aa = Gi(oa),
    ua = function (n) {
  var t = Ki(n);
  return function (n) {
    return (n *= 2) < 1 ? .5 * t(n) : .5 * (2 - Math.pow(2, -10 * (n - 1)));
  };
}(1.525),
    sa = function sa(n) {
  if (1 === n || 0 === n) return n;
  var t = n * n;
  return n < .36363636363636365 ? 7.5625 * t : n < .7272727272727273 ? 9.075 * t - 9.9 * n + 3.4 : n < .9 ? 12.066481994459833 * t - 19.63545706371191 * n + 8.898060941828255 : 10.8 * n * n - 20.52 * n + 10.72;
},
    ca = qi(sa);

function la(n, t) {
  return n.map(function () {
    return t || na;
  }).splice(0, n.length - 1);
}

function fa(n) {
  var t = n.from,
      e = void 0 === t ? 0 : t,
      r = n.to,
      o = void 0 === r ? 1 : r,
      i = n.ease,
      a = n.offset,
      u = n.duration,
      s = void 0 === u ? 300 : u,
      c = {
    done: !1,
    value: e
  },
      l = Array.isArray(o) ? o : [e, o],
      f = function (n, t) {
    return n.map(function (n) {
      return n * t;
    });
  }(a && a.length === l.length ? a : function (n) {
    var t = n.length;
    return n.map(function (n, e) {
      return 0 !== e ? e / (t - 1) : 0;
    });
  }(l), s);

  function p() {
    return $i(f, l, {
      ease: Array.isArray(i) ? i : la(l, i)
    });
  }

  var d = p();
  return {
    next: function next(n) {
      return c.value = d(n), c.done = n >= s, c;
    },
    flipTarget: function flipTarget() {
      l.reverse(), d = p();
    }
  };
}

var pa = {
  keyframes: fa,
  spring: Ci,
  decay: function decay(n) {
    var t = n.velocity,
        e = void 0 === t ? 0 : t,
        r = n.from,
        o = void 0 === r ? 0 : r,
        i = n.power,
        a = void 0 === i ? .8 : i,
        u = n.timeConstant,
        s = void 0 === u ? 350 : u,
        c = n.restDelta,
        l = void 0 === c ? .5 : c,
        f = n.modifyTarget,
        p = {
      done: !1,
      value: o
    },
        d = a * e,
        h = o + d,
        v = void 0 === f ? h : f(h);
    return v !== h && (d = v - o), {
      next: function next(n) {
        var t = -d * Math.exp(-n / s);
        return p.done = !(t > l || t < -l), p.value = p.done ? v : v + t, p;
      },
      flipTarget: function flipTarget() {}
    };
  }
};
var da = "undefined" != typeof performance ? function () {
  return performance.now();
} : function () {
  return Date.now();
},
    ha = "undefined" != typeof window ? function (n) {
  return window.requestAnimationFrame(n);
} : function (n) {
  return setTimeout(function () {
    return n(da());
  }, 16.666666666666668);
};

var va = !0,
    ma = !1,
    ga = !1,
    ya = {
  delta: 0,
  timestamp: 0
},
    ba = ["read", "update", "preRender", "render", "postRender"],
    wa = ba.reduce(function (n, t) {
  return n[t] = function (n) {
    var t = [],
        e = [],
        r = 0,
        o = !1,
        i = new WeakSet(),
        a = {
      schedule: function schedule(n, a, u) {
        void 0 === a && (a = !1), void 0 === u && (u = !1);
        var s = u && o,
            c = s ? t : e;
        return a && i.add(n), -1 === c.indexOf(n) && (c.push(n), s && o && (r = t.length)), n;
      },
      cancel: function cancel(n) {
        var t = e.indexOf(n);
        -1 !== t && e.splice(t, 1), i.delete(n);
      },
      process: function process(u) {
        var s;
        if (o = !0, t = (s = [e, t])[0], (e = s[1]).length = 0, r = t.length) for (var c = 0; c < r; c++) {
          var l = t[c];
          l(u), i.has(l) && (a.schedule(l), n());
        }
        o = !1;
      }
    };
    return a;
  }(function () {
    return ma = !0;
  }), n;
}, {}),
    xa = ba.reduce(function (n, t) {
  var e = wa[t];
  return n[t] = function (n, t, r) {
    return void 0 === t && (t = !1), void 0 === r && (r = !1), ma || Pa(), e.schedule(n, t, r);
  }, n;
}, {}),
    Sa = ba.reduce(function (n, t) {
  return n[t] = wa[t].cancel, n;
}, {}),
    _a = ba.reduce(function (n, t) {
  return n[t] = function () {
    return wa[t].process(ya);
  }, n;
}, {}),
    Ea = function Ea(n) {
  return wa[n].process(ya);
},
    Ta = function Ta(n) {
  ma = !1, ya.delta = va ? 16.666666666666668 : Math.max(Math.min(n - ya.timestamp, 40), 1), ya.timestamp = n, ga = !0, ba.forEach(Ea), ga = !1, ma && (va = !1, ha(Ta));
},
    Pa = function Pa() {
  ma = !0, va = !0, ga || ha(Ta);
},
    Ca = function Ca() {
  return ya;
};

function Aa(n, t, e) {
  return void 0 === e && (e = 0), n - t - e;
}

var La = function La(n) {
  var t = function t(_t2) {
    var e = _t2.delta;
    return n(e);
  };

  return {
    start: function start() {
      return xa.update(t, !0);
    },
    stop: function stop() {
      return Sa.update(t);
    }
  };
};

function Oa(n) {
  var t,
      e,
      r,
      o,
      i,
      a = n.from,
      u = n.autoplay,
      s = void 0 === u || u,
      c = n.driver,
      l = void 0 === c ? La : c,
      f = n.elapsed,
      p = void 0 === f ? 0 : f,
      d = n.repeat,
      h = void 0 === d ? 0 : d,
      v = n.repeatType,
      m = void 0 === v ? "loop" : v,
      g = n.repeatDelay,
      y = void 0 === g ? 0 : g,
      b = n.onPlay,
      w = n.onStop,
      x = n.onComplete,
      S = n.onRepeat,
      _ = n.onUpdate,
      E = Ye(n, ["from", "autoplay", "driver", "elapsed", "repeat", "repeatType", "repeatDelay", "onPlay", "onStop", "onComplete", "onRepeat", "onUpdate"]),
      T = E.to,
      P = 0,
      C = E.duration,
      A = !1,
      L = !0,
      O = function (n) {
    if (Array.isArray(n.to)) return fa;
    if (pa[n.type]) return pa[n.type];
    var t = new Set(Object.keys(n));
    return t.has("ease") || t.has("duration") && !t.has("dampingRatio") ? fa : t.has("dampingRatio") || t.has("stiffness") || t.has("mass") || t.has("damping") || t.has("restSpeed") || t.has("restDelta") ? Ci : fa;
  }(E);

  (null === (e = (t = O).needsInterpolation) || void 0 === e ? void 0 : e.call(t, a, T)) && (i = $i([0, 100], [a, T], {
    clamp: !1
  }), a = 0, T = 100);
  var k = O(_We(_We({}, E), {
    from: a,
    to: T
  }));

  function R() {
    P++, "reverse" === m ? p = function (n, t, e, r) {
      return void 0 === e && (e = 0), void 0 === r && (r = !0), r ? Aa(t + -n, t, e) : t - (n - t) + e;
    }(p, C, y, L = P % 2 == 0) : (p = Aa(p, C, y), "mirror" === m && k.flipTarget()), A = !1, S && S();
  }

  function N(n) {
    if (L || (n = -n), p += n, !A) {
      var t = k.next(Math.max(0, p));
      o = t.value, i && (o = i(o)), A = L ? t.done : p <= 0;
    }

    null == _ || _(o), A && (0 === P && (null != C || (C = p)), P < h ? function (n, t, e, r) {
      return r ? n >= t + e : n <= -e;
    }(p, C, y, L) && R() : (r.stop(), x && x()));
  }

  return s && (null == b || b(), (r = l(N)).start()), {
    stop: function stop() {
      null == w || w(), r.stop();
    }
  };
}

function ka(n, t) {
  return t ? n * (1e3 / t) : 0;
}

var Ra = function Ra(n) {
  return n.hasOwnProperty("x") && n.hasOwnProperty("y");
},
    Na = function Na(n) {
  return Ra(n) && n.hasOwnProperty("z");
},
    za = function za(n, t) {
  return Math.abs(n - t);
};

function Ia(n, t) {
  if (Di(n) && Di(t)) return za(n, t);

  if (Ra(n) && Ra(t)) {
    var e = za(n.x, t.x),
        r = za(n.y, t.y),
        o = Na(n) && Na(t) ? za(n.z, t.z) : 0;
    return Math.sqrt(Math.pow(e, 2) + Math.pow(r, 2) + Math.pow(o, 2));
  }
}

var Da = function Da(n, t) {
  return 1 - 3 * t + 3 * n;
},
    ja = function ja(n, t) {
  return 3 * t - 6 * n;
},
    Ma = function Ma(n) {
  return 3 * n;
},
    Ba = function Ba(n, t, e) {
  return ((Da(t, e) * n + ja(t, e)) * n + Ma(t)) * n;
},
    Va = function Va(n, t, e) {
  return 3 * Da(t, e) * n * n + 2 * ja(t, e) * n + Ma(t);
};

function Fa(n, t, e, r) {
  if (n === t && e === r) return Zi;

  for (var o = new Float32Array(11), i = 0; i < 11; ++i) {
    o[i] = Ba(.1 * i, n, e);
  }

  function a(t) {
    for (var r = 0, i = 1; 10 !== i && o[i] <= t; ++i) {
      r += .1;
    }

    --i;
    var a = r + .1 * ((t - o[i]) / (o[i + 1] - o[i])),
        u = Va(a, n, e);
    return u >= .001 ? function (n, t, e, r) {
      for (var o = 0; o < 8; ++o) {
        var i = Va(t, e, r);
        if (0 === i) return t;
        t -= (Ba(t, e, r) - n) / i;
      }

      return t;
    }(t, a, n, e) : 0 === u ? a : function (n, t, e, r, o) {
      var i,
          a,
          u = 0;

      do {
        (i = Ba(a = t + (e - t) / 2, r, o) - n) > 0 ? e = a : t = a;
      } while (Math.abs(i) > 1e-7 && ++u < 10);

      return a;
    }(t, r, r + .1, n, e);
  }

  return function (n) {
    return 0 === n || 1 === n ? n : Ba(a(n), t, r);
  };
}

var Wa = function Wa(n) {
  return function (t) {
    return n(t), null;
  };
},
    Ya = {
  tap: Wa(function (n) {
    var t = n.onTap,
        e = n.onTapStart,
        r = n.onTapCancel,
        i = n.whileTap,
        a = n.visualElement,
        u = t || e || r || i,
        s = o(!1),
        c = o(null);

    function l() {
      var n;
      null === (n = c.current) || void 0 === n || n.call(c), c.current = null;
    }

    function f() {
      var n;
      return l(), s.current = !1, null === (n = a.animationState) || void 0 === n || n.setActive(Zo.Tap, !1), !gi();
    }

    function p(n, e) {
      f() && (bi(a.getInstance(), n.target) ? null == t || t(n, e) : null == r || r(n, e));
    }

    function d(n, t) {
      f() && (null == r || r(n, t));
    }

    pi(a, "pointerdown", u ? function (n, t) {
      var r;
      l(), s.current || (s.current = !0, c.current = Mi(fi(window, "pointerup", p), fi(window, "pointercancel", d)), null == e || e(n, t), null === (r = a.animationState) || void 0 === r || r.setActive(Zo.Tap, !0));
    } : void 0), wi(l);
  }),
  focus: Wa(function (n) {
    var t = n.whileFocus,
        e = n.visualElement;
    ni(e, "focus", t ? function () {
      var n;
      null === (n = e.animationState) || void 0 === n || n.setActive(Zo.Focus, !0);
    } : void 0), ni(e, "blur", t ? function () {
      var n;
      null === (n = e.animationState) || void 0 === n || n.setActive(Zo.Focus, !1);
    } : void 0);
  }),
  hover: Wa(function (n) {
    var t = n.onHoverStart,
        e = n.onHoverEnd,
        r = n.whileHover,
        o = n.visualElement;
    pi(o, "pointerenter", t || r ? yi(o, !0, t) : void 0), pi(o, "pointerleave", e || r ? yi(o, !1, e) : void 0);
  })
};

function Ha(n, t) {
  if (!Array.isArray(t)) return !1;
  var e = t.length;
  if (e !== n.length) return !1;

  for (var r = 0; r < e; r++) {
    if (t[r] !== n[r]) return !1;
  }

  return !0;
}

var Ua = function Ua(n) {
  return 1e3 * n;
},
    $a = {
  linear: Zi,
  easeIn: Ji,
  easeInOut: na,
  easeOut: Qi,
  circIn: ta,
  circInOut: ra,
  circOut: ea,
  backIn: oa,
  backInOut: aa,
  backOut: ia,
  anticipate: ua,
  bounceIn: ca,
  bounceInOut: function bounceInOut(n) {
    return n < .5 ? .5 * (1 - sa(1 - 2 * n)) : .5 * sa(2 * n - 1) + .5;
  },
  bounceOut: sa
},
    Xa = function Xa(n) {
  if (Array.isArray(n)) {
    Ge(4 === n.length, "Cubic bezier arrays must contain four numerical values.");
    var t = He(n, 4);
    return Fa(t[0], t[1], t[2], t[3]);
  }

  return "string" == typeof n ? (Ge(void 0 !== $a[n], "Invalid easing type '" + n + "'"), $a[n]) : n;
},
    qa = function qa(n, t) {
  return "zIndex" !== n && (!("number" != typeof t && !Array.isArray(t)) || !("string" != typeof t || !fo.test(t) || t.startsWith("url(")));
},
    Ga = function Ga() {
  return {
    type: "spring",
    stiffness: 500,
    damping: 25,
    restDelta: .5,
    restSpeed: 10
  };
},
    Ka = function Ka(n) {
  return {
    type: "spring",
    stiffness: 550,
    damping: 0 === n ? 2 * Math.sqrt(550) : 30,
    restDelta: .01,
    restSpeed: 10
  };
},
    Za = function Za() {
  return {
    type: "keyframes",
    ease: "linear",
    duration: .3
  };
},
    Ja = function Ja(n) {
  return {
    type: "keyframes",
    duration: .8,
    values: n
  };
},
    Qa = {
  x: Ga,
  y: Ga,
  z: Ga,
  rotate: Ga,
  rotateX: Ga,
  rotateY: Ga,
  rotateZ: Ga,
  scaleX: Ka,
  scaleY: Ka,
  scale: Ka,
  opacity: Za,
  backgroundColor: Za,
  color: Za,
  default: Ka
},
    nu = _We(_We({}, yo), {
  color: ao,
  backgroundColor: ao,
  outlineColor: ao,
  fill: ao,
  stroke: ao,
  borderColor: ao,
  borderTopColor: ao,
  borderRightColor: ao,
  borderBottomColor: ao,
  borderLeftColor: ao,
  filter: mo,
  WebkitFilter: mo
}),
    tu = function tu(n) {
  return nu[n];
};

function eu(n, t) {
  var e,
      r = tu(n);
  return r !== mo && (r = fo), null === (e = r.getAnimatableNone) || void 0 === e ? void 0 : e.call(r, t);
}

var ru = !1;

function ou(n) {
  var t = n.ease,
      e = n.times,
      r = n.yoyo,
      o = n.flip,
      i = n.loop,
      a = Ye(n, ["ease", "times", "yoyo", "flip", "loop"]),
      u = _We({}, a);

  return e && (u.offset = e), a.duration && (u.duration = Ua(a.duration)), a.repeatDelay && (u.repeatDelay = Ua(a.repeatDelay)), t && (u.ease = function (n) {
    return Array.isArray(n) && "number" != typeof n[0];
  }(t) ? t.map(Xa) : Xa(t)), "tween" === a.type && (u.type = "keyframes"), (r || i || o) && (qe(!ru, "yoyo, loop and flip have been removed from the API. Replace with repeat and repeatType options."), ru = !0, r ? u.repeatType = "reverse" : i ? u.repeatType = "loop" : o && (u.repeatType = "mirror"), u.repeat = i || r || o || a.repeat), "spring" !== a.type && (u.type = "keyframes"), u;
}

function iu(n, t, e) {
  var r, o, i, a;
  return Array.isArray(t.to) && (null !== (r = n.duration) && void 0 !== r || (n.duration = .8)), function (n) {
    Array.isArray(n.to) && null === n.to[0] && (n.to = Ue([], He(n.to)), n.to[0] = n.from);
  }(t), function (n) {
    n.when, n.delay, n.delayChildren, n.staggerChildren, n.staggerDirection, n.repeat, n.repeatType, n.repeatDelay, n.from;
    var t = Ye(n, ["when", "delay", "delayChildren", "staggerChildren", "staggerDirection", "repeat", "repeatType", "repeatDelay", "from"]);
    return !!Object.keys(t).length;
  }(n) || (n = _We(_We({}, n), (o = e, i = t.to, a = Ho(i) ? Ja : Qa[o] || Qa.default, _We({
    to: i
  }, a(i))))), _We(_We({}, t), ou(n));
}

function au(n, t, e, r, o) {
  var i,
      a = cu(r, n),
      u = null !== (i = a.from) && void 0 !== i ? i : t.get(),
      s = qa(n, e);
  "none" === u && s && "string" == typeof e ? u = eu(n, e) : uu(u) && "string" == typeof e ? u = su(e) : !Array.isArray(e) && uu(e) && "string" == typeof u && (e = su(u));
  var c = qa(n, u);
  return qe(c === s, "You are trying to animate " + n + ' from "' + u + '" to "' + e + '". ' + u + " is not an animatable value - to enable this animation set " + u + " to a value animatable to " + e + " via the `style` property."), c && s && !1 !== a.type ? function () {
    var r = {
      from: u,
      to: e,
      velocity: t.getVelocity(),
      onComplete: o,
      onUpdate: function onUpdate(n) {
        return t.set(n);
      }
    };
    return "inertia" === a.type || "decay" === a.type ? function (n) {
      var t,
          e = n.from,
          r = void 0 === e ? 0 : e,
          o = n.velocity,
          i = void 0 === o ? 0 : o,
          a = n.min,
          u = n.max,
          s = n.power,
          c = void 0 === s ? .8 : s,
          l = n.timeConstant,
          f = void 0 === l ? 750 : l,
          p = n.bounceStiffness,
          d = void 0 === p ? 500 : p,
          h = n.bounceDamping,
          v = void 0 === h ? 10 : h,
          m = n.restDelta,
          g = void 0 === m ? 1 : m,
          y = n.modifyTarget,
          b = n.driver,
          w = n.onUpdate,
          x = n.onComplete;

      function S(n) {
        return void 0 !== a && n < a || void 0 !== u && n > u;
      }

      function _(n) {
        return void 0 === a ? u : void 0 === u || Math.abs(a - n) < Math.abs(u - n) ? a : u;
      }

      function E(n) {
        null == t || t.stop(), t = Oa(_We(_We({}, n), {
          driver: b,
          onUpdate: function onUpdate(t) {
            var e;
            null == w || w(t), null === (e = n.onUpdate) || void 0 === e || e.call(n, t);
          },
          onComplete: x
        }));
      }

      function T(n) {
        E(_We({
          type: "spring",
          stiffness: d,
          damping: v,
          restDelta: g
        }, n));
      }

      if (S(r)) T({
        from: r,
        velocity: i,
        to: _(r)
      });else {
        var P = c * i + r;
        void 0 !== y && (P = y(P));

        var C,
            A,
            L = _(P),
            O = L === a ? -1 : 1;

        E({
          type: "decay",
          from: r,
          velocity: i,
          timeConstant: f,
          power: c,
          restDelta: g,
          modifyTarget: y,
          onUpdate: S(P) ? function (n) {
            C = A, A = n, i = ka(n - C, Ca().delta), (1 === O && n > L || -1 === O && n < L) && T({
              from: n,
              to: L,
              velocity: i
            });
          } : void 0
        });
      }
      return {
        stop: function stop() {
          return null == t ? void 0 : t.stop();
        }
      };
    }(_We(_We({}, r), a)) : Oa(_We(_We({}, iu(a, r, n)), {
      onUpdate: function onUpdate(n) {
        var t;
        r.onUpdate(n), null === (t = a.onUpdate) || void 0 === t || t.call(a, n);
      },
      onComplete: function onComplete() {
        var n;
        r.onComplete(), null === (n = a.onComplete) || void 0 === n || n.call(a);
      }
    }));
  } : function () {
    var n;
    return t.set(e), o(), null === (n = null == a ? void 0 : a.onComplete) || void 0 === n || n.call(a), {
      stop: function stop() {}
    };
  };
}

function uu(n) {
  return 0 === n || "string" == typeof n && 0 === parseFloat(n) && -1 === n.indexOf(" ");
}

function su(n) {
  return "number" == typeof n ? 0 : eu("", n);
}

function cu(n, t) {
  return n[t] || n.default || n;
}

function lu(n, t, e, r) {
  return void 0 === r && (r = {}), t.start(function (o) {
    var i,
        a,
        u = au(n, t, e, r, o),
        s = function (n, t) {
      var e;
      return null !== (e = (cu(n, t) || {}).delay) && void 0 !== e ? e : 0;
    }(r, n),
        c = function c() {
      return a = u();
    };

    return s ? i = setTimeout(c, Ua(s)) : c(), function () {
      clearTimeout(i), null == a || a.stop();
    };
  });
}

var fu = function fu(n) {
  return /^\-?\d*\.?\d+$/.test(n);
};

function pu(n, t) {
  -1 === n.indexOf(t) && n.push(t);
}

function du(n, t) {
  var e = n.indexOf(t);
  e > -1 && n.splice(e, 1);
}

var hu = function () {
  function n() {
    this.subscriptions = [];
  }

  return n.prototype.add = function (n) {
    var t = this;
    return pu(this.subscriptions, n), function () {
      return du(t.subscriptions, n);
    };
  }, n.prototype.notify = function (n, t, e) {
    var r = this.subscriptions.length;
    if (r) if (1 === r) this.subscriptions[0](n, t, e);else for (var o = 0; o < r; o++) {
      var i = this.subscriptions[o];
      i && i(n, t, e);
    }
  }, n.prototype.getSize = function () {
    return this.subscriptions.length;
  }, n.prototype.clear = function () {
    this.subscriptions.length = 0;
  }, n;
}(),
    vu = function () {
  function n(n) {
    var t,
        e = this;
    this.timeDelta = 0, this.lastUpdated = 0, this.updateSubscribers = new hu(), this.velocityUpdateSubscribers = new hu(), this.renderSubscribers = new hu(), this.canTrackVelocity = !1, this.updateAndNotify = function (n, t) {
      void 0 === t && (t = !0), e.prev = e.current, e.current = n;
      var r = Ca(),
          o = r.delta,
          i = r.timestamp;
      e.lastUpdated !== i && (e.timeDelta = o, e.lastUpdated = i, xa.postRender(e.scheduleVelocityCheck)), e.prev !== e.current && e.updateSubscribers.notify(e.current), e.velocityUpdateSubscribers.getSize() && e.velocityUpdateSubscribers.notify(e.getVelocity()), t && e.renderSubscribers.notify(e.current);
    }, this.scheduleVelocityCheck = function () {
      return xa.postRender(e.velocityCheck);
    }, this.velocityCheck = function (n) {
      n.timestamp !== e.lastUpdated && (e.prev = e.current, e.velocityUpdateSubscribers.notify(e.getVelocity()));
    }, this.hasAnimated = !1, this.prev = this.current = n, this.canTrackVelocity = (t = this.current, !isNaN(parseFloat(t)));
  }

  return n.prototype.onChange = function (n) {
    return this.updateSubscribers.add(n);
  }, n.prototype.clearListeners = function () {
    this.updateSubscribers.clear();
  }, n.prototype.onRenderRequest = function (n) {
    return n(this.get()), this.renderSubscribers.add(n);
  }, n.prototype.attach = function (n) {
    this.passiveEffect = n;
  }, n.prototype.set = function (n, t) {
    void 0 === t && (t = !0), t && this.passiveEffect ? this.passiveEffect(n, this.updateAndNotify) : this.updateAndNotify(n, t);
  }, n.prototype.get = function () {
    return this.current;
  }, n.prototype.getPrevious = function () {
    return this.prev;
  }, n.prototype.getVelocity = function () {
    return this.canTrackVelocity ? ka(parseFloat(this.current) - parseFloat(this.prev), this.timeDelta) : 0;
  }, n.prototype.start = function (n) {
    var t = this;
    return this.stop(), new Promise(function (e) {
      t.hasAnimated = !0, t.stopAnimation = n(e);
    }).then(function () {
      return t.clearAnimation();
    });
  }, n.prototype.stop = function () {
    this.stopAnimation && this.stopAnimation(), this.clearAnimation();
  }, n.prototype.isAnimating = function () {
    return !!this.stopAnimation;
  }, n.prototype.clearAnimation = function () {
    this.stopAnimation = null;
  }, n.prototype.destroy = function () {
    this.updateSubscribers.clear(), this.renderSubscribers.clear(), this.stop();
  }, n;
}();

function mu(n) {
  return new vu(n);
}

var gu = function gu(n) {
  return function (t) {
    return t.test(n);
  };
},
    yu = [Yr, Gr, qr, Xr, Zr, Kr, {
  test: function test(n) {
    return "auto" === n;
  },
  parse: function parse(n) {
    return n;
  }
}],
    bu = function bu(n) {
  return yu.find(gu(n));
},
    wu = Ue(Ue([], He(yu)), [ao, fo]),
    xu = function xu(n) {
  return wu.find(gu(n));
};

function Su(n, t, e) {
  n.hasValue(t) ? n.getValue(t).set(e) : n.addValue(t, mu(e));
}

function _u(n, t) {
  if (t) return (t[n] || t.default || t).from;
}

function Eu(n, t, e) {
  var r;
  void 0 === e && (e = {});
  var o = vr(n, t, e.custom),
      i = (o || {}).transition,
      a = void 0 === i ? n.getDefaultTransition() || {} : i;
  e.transitionOverride && (a = e.transitionOverride);
  var u = o ? function () {
    return Tu(n, o, e);
  } : function () {
    return Promise.resolve();
  },
      s = (null === (r = n.variantChildren) || void 0 === r ? void 0 : r.size) ? function (r) {
    void 0 === r && (r = 0);
    var o = a.delayChildren,
        i = void 0 === o ? 0 : o,
        u = a.staggerChildren,
        s = a.staggerDirection;
    return function (n, t, e, r, o, i) {
      void 0 === e && (e = 0);
      void 0 === r && (r = 0);
      void 0 === o && (o = 1);
      var a = [],
          u = (n.variantChildren.size - 1) * r,
          s = 1 === o ? function (n) {
        return void 0 === n && (n = 0), n * r;
      } : function (n) {
        return void 0 === n && (n = 0), u - n * r;
      };
      return Array.from(n.variantChildren).sort(Pu).forEach(function (n, r) {
        a.push(Eu(n, t, _We(_We({}, i), {
          delay: e + s(r)
        })).then(function () {
          return n.notifyAnimationComplete(t);
        }));
      }), Promise.all(a);
    }(n, t, i + r, u, s, e);
  } : function () {
    return Promise.resolve();
  },
      c = a.when;

  if (c) {
    var l = He("beforeChildren" === c ? [u, s] : [s, u], 2),
        f = l[0],
        p = l[1];
    return f().then(p);
  }

  return Promise.all([u(), s(e.delay)]);
}

function Tu(n, t, e) {
  var r,
      o = void 0 === e ? {} : e,
      i = o.delay,
      a = void 0 === i ? 0 : i,
      u = o.transitionOverride,
      s = o.type,
      c = n.makeTargetAnimatable(t),
      l = c.transition,
      f = void 0 === l ? n.getDefaultTransition() : l,
      p = c.transitionEnd,
      d = Ye(c, ["transition", "transitionEnd"]);
  u && (f = u);
  var h = [],
      v = s && (null === (r = n.animationState) || void 0 === r ? void 0 : r.getState()[s]);

  for (var m in d) {
    var g = n.getValue(m),
        y = d[m];

    if (!(!g || void 0 === y || v && Cu(v, m))) {
      var b = lu(m, g, y, _We({
        delay: a
      }, f));
      h.push(b);
    }
  }

  return Promise.all(h).then(function () {
    p && function (n, t) {
      var e = vr(n, t),
          r = e ? n.makeTargetAnimatable(e, !1) : {},
          o = r.transitionEnd,
          i = void 0 === o ? {} : o;
      r.transition;
      var a = Ye(r, ["transitionEnd", "transition"]);

      for (var u in a = _We(_We({}, a), i)) {
        Su(n, u, Uo(a[u]));
      }
    }(n, p);
  });
}

function Pu(n, t) {
  return n.sortNodePosition(t);
}

function Cu(n, t) {
  var e = n.protectedKeys,
      r = n.needsAnimating,
      o = e.hasOwnProperty(t) && !0 !== r[t];
  return r[t] = !1, o;
}

var Au = [Zo.Animate, Zo.Hover, Zo.Tap, Zo.Drag, Zo.Focus, Zo.Exit],
    Lu = Ue([], He(Au)).reverse(),
    Ou = Au.length;

function ku(n) {
  return function (t) {
    return Promise.all(t.map(function (t) {
      var e = t.animation,
          r = t.options;
      return function (n, t, e) {
        var r;

        if (void 0 === e && (e = {}), n.notifyAnimationStart(), Array.isArray(t)) {
          var o = t.map(function (t) {
            return Eu(n, t, e);
          });
          r = Promise.all(o);
        } else if ("string" == typeof t) r = Eu(n, t, e);else {
          var i = "function" == typeof t ? vr(n, t, e.custom) : t;
          r = Tu(n, i, e);
        }

        return r.then(function () {
          return n.notifyAnimationComplete(t);
        });
      }(n, e, r);
    }));
  };
}

function Ru(n) {
  var t,
      e = ku(n),
      r = ((t = {})[Zo.Animate] = Nu(!0), t[Zo.Hover] = Nu(), t[Zo.Tap] = Nu(), t[Zo.Drag] = Nu(), t[Zo.Focus] = Nu(), t[Zo.Exit] = Nu(), t),
      o = {},
      i = !0,
      a = function a(t, e) {
    var r = vr(n, e);

    if (r) {
      r.transition;
      var o = r.transitionEnd,
          i = Ye(r, ["transition", "transitionEnd"]);
      t = _We(_We(_We({}, t), i), o);
    }

    return t;
  };

  function u(t, u) {
    for (var s, c = n.getProps(), l = n.getVariantContext(!0) || {}, f = [], p = new Set(), d = {}, h = 1 / 0, v = function v(e) {
      var o = Lu[e],
          v = r[o],
          m = null !== (s = c[o]) && void 0 !== s ? s : l[o],
          g = dr(m),
          y = o === u ? v.isActive : null;
      !1 === y && (h = e);
      var b = m === l[o] && m !== c[o] && g;
      if (b && i && n.manuallyAnimateOnMount && (b = !1), v.protectedKeys = _We({}, d), !v.isActive && null === y || !m && !v.prevProp || Yo(m) || "boolean" == typeof m) return "continue";

      var w = function (n, t) {
        if ("string" == typeof t) return t !== n;
        if (pr(t)) return !Ha(t, n);
        return !1;
      }(v.prevProp, m) || o === u && v.isActive && !b && g || e > h && g,
          x = Array.isArray(m) ? m : [m],
          S = x.reduce(a, {});

      !1 === y && (S = {});

      var _ = v.prevResolvedValues,
          E = void 0 === _ ? {} : _,
          T = _We(_We({}, E), S),
          P = function P(n) {
        w = !0, p.delete(n), v.needsAnimating[n] = !0;
      };

      for (var C in T) {
        var A = S[C],
            L = E[C];
        d.hasOwnProperty(C) || (A !== L ? Ho(A) && Ho(L) ? Ha(A, L) ? v.protectedKeys[C] = !0 : P(C) : void 0 !== A ? P(C) : p.add(C) : void 0 !== A && p.has(C) ? P(C) : v.protectedKeys[C] = !0);
      }

      v.prevProp = m, v.prevResolvedValues = S, v.isActive && (d = _We(_We({}, d), S)), i && n.blockInitialAnimation && (w = !1), w && !b && f.push.apply(f, Ue([], He(x.map(function (n) {
        return {
          animation: n,
          options: _We({
            type: o
          }, t)
        };
      }))));
    }, m = 0; m < Ou; m++) {
      v(m);
    }

    if (o = _We({}, d), p.size) {
      var g = {};
      p.forEach(function (t) {
        var e = n.getBaseTarget(t);
        void 0 !== e && (g[t] = e);
      }), f.push({
        animation: g
      });
    }

    var y = Boolean(f.length);
    return i && !1 === c.initial && !n.manuallyAnimateOnMount && (y = !1), i = !1, y ? e(f) : Promise.resolve();
  }

  return {
    isAnimated: function isAnimated(n) {
      return void 0 !== o[n];
    },
    animateChanges: u,
    setActive: function setActive(t, e, o) {
      var i;
      return r[t].isActive === e ? Promise.resolve() : (null === (i = n.variantChildren) || void 0 === i || i.forEach(function (n) {
        var r;
        return null === (r = n.animationState) || void 0 === r ? void 0 : r.setActive(t, e);
      }), r[t].isActive = e, u(o, t));
    },
    setAnimateFunction: function setAnimateFunction(t) {
      e = t(n);
    },
    getState: function getState() {
      return r;
    }
  };
}

function Nu(n) {
  return void 0 === n && (n = !1), {
    isActive: n,
    protectedKeys: {},
    needsAnimating: {},
    prevResolvedValues: {}
  };
}

var zu = {
  animation: Wa(function (n) {
    var t = n.visualElement,
        e = n.animate;
    t.animationState || (t.animationState = Ru(t)), Yo(e) && i(function () {
      return e.subscribe(t);
    }, [e]);
  }),
  exit: Wa(function (n) {
    var t = n.custom,
        e = n.visualElement,
        o = He(rr(), 2),
        a = o[0],
        u = o[1],
        s = r(tr);
    i(function () {
      var n,
          r,
          o = null === (n = e.animationState) || void 0 === n ? void 0 : n.setActive(Zo.Exit, !a, {
        custom: null !== (r = null == s ? void 0 : s.custom) && void 0 !== r ? r : t
      });
      !a && (null == o || o.then(u));
    }, [a]);
  })
},
    Iu = function () {
  function n(n, t, e) {
    var r = this,
        o = (void 0 === e ? {} : e).transformPagePoint;

    if (this.startEvent = null, this.lastMoveEvent = null, this.lastMoveEventInfo = null, this.handlers = {}, this.updatePoint = function () {
      if (r.lastMoveEvent && r.lastMoveEventInfo) {
        var n = Mu(r.lastMoveEventInfo, r.history),
            t = null !== r.startEvent,
            e = Ia(n.offset, {
          x: 0,
          y: 0
        }) >= 3;

        if (t || e) {
          var o = n.point,
              i = Ca().timestamp;
          r.history.push(_We(_We({}, o), {
            timestamp: i
          }));
          var a = r.handlers,
              u = a.onStart,
              s = a.onMove;
          t || (u && u(r.lastMoveEvent, n), r.startEvent = r.lastMoveEvent), s && s(r.lastMoveEvent, n);
        }
      }
    }, this.handlePointerMove = function (n, t) {
      r.lastMoveEvent = n, r.lastMoveEventInfo = Du(t, r.transformPagePoint), ti(n) && 0 === n.buttons ? r.handlePointerUp(n, t) : xa.update(r.updatePoint, !0);
    }, this.handlePointerUp = function (n, t) {
      r.end();
      var e = r.handlers,
          o = e.onEnd,
          i = e.onSessionEnd,
          a = Mu(Du(t, r.transformPagePoint), r.history);
      r.startEvent && o && o(n, a), i && i(n, a);
    }, !(ei(n) && n.touches.length > 1)) {
      this.handlers = t, this.transformPagePoint = o;
      var i = Du(ai(n), this.transformPagePoint),
          a = i.point,
          u = Ca().timestamp;
      this.history = [_We(_We({}, a), {
        timestamp: u
      })];
      var s = t.onSessionStart;
      s && s(n, Mu(i, this.history)), this.removeListeners = Mi(fi(window, "pointermove", this.handlePointerMove), fi(window, "pointerup", this.handlePointerUp), fi(window, "pointercancel", this.handlePointerUp));
    }
  }

  return n.prototype.updateHandlers = function (n) {
    this.handlers = n;
  }, n.prototype.end = function () {
    this.removeListeners && this.removeListeners(), Sa.update(this.updatePoint);
  }, n;
}();

function Du(n, t) {
  return t ? {
    point: t(n.point)
  } : n;
}

function ju(n, t) {
  return {
    x: n.x - t.x,
    y: n.y - t.y
  };
}

function Mu(n, t) {
  var e = n.point;
  return {
    point: e,
    delta: ju(e, Vu(t)),
    offset: ju(e, Bu(t)),
    velocity: Fu(t, .1)
  };
}

function Bu(n) {
  return n[0];
}

function Vu(n) {
  return n[n.length - 1];
}

function Fu(n, t) {
  if (n.length < 2) return {
    x: 0,
    y: 0
  };

  for (var e = n.length - 1, r = null, o = Vu(n); e >= 0 && (r = n[e], !(o.timestamp - r.timestamp > Ua(t)));) {
    e--;
  }

  if (!r) return {
    x: 0,
    y: 0
  };
  var i = (o.timestamp - r.timestamp) / 1e3;
  if (0 === i) return {
    x: 0,
    y: 0
  };
  var a = {
    x: (o.x - r.x) / i,
    y: (o.y - r.y) / i
  };
  return a.x === 1 / 0 && (a.x = 0), a.y === 1 / 0 && (a.y = 0), a;
}

function Wu(n) {
  return n;
}

function Yu(n) {
  var t = n.top;
  return {
    x: {
      min: n.left,
      max: n.right
    },
    y: {
      min: t,
      max: n.bottom
    }
  };
}

var Hu = {
  translate: 0,
  scale: 1,
  origin: 0,
  originPoint: 0
};

function Uu() {
  return {
    x: _We({}, Hu),
    y: _We({}, Hu)
  };
}

function $u(n) {
  return [n("x"), n("y")];
}

function Xu(n, t, e) {
  var r = t.min,
      o = t.max;
  return void 0 !== r && n < r ? n = e ? Oi(r, n, e.min) : Math.max(n, r) : void 0 !== o && n > o && (n = e ? Oi(o, n, e.max) : Math.min(n, o)), n;
}

function qu(n, t, e) {
  return {
    min: void 0 !== t ? n.min + t : void 0,
    max: void 0 !== e ? n.max + e - (n.max - n.min) : void 0
  };
}

function Gu(n, t) {
  var e,
      r = t.min - n.min,
      o = t.max - n.max;
  return t.max - t.min < n.max - n.min && (r = (e = He([o, r], 2))[0], o = e[1]), {
    min: n.min + r,
    max: n.min + o
  };
}

function Ku(n, t, e) {
  return {
    min: Zu(n, t),
    max: Zu(n, e)
  };
}

function Zu(n, t) {
  var e;
  return "number" == typeof n ? n : null !== (e = n[t]) && void 0 !== e ? e : 0;
}

function Ju(n, t) {
  return Yu(function (n, t) {
    var e = n.top,
        r = n.left,
        o = n.bottom,
        i = n.right;
    void 0 === t && (t = Wu);
    var a = t({
      x: r,
      y: e
    }),
        u = t({
      x: i,
      y: o
    });
    return {
      top: a.y,
      left: a.x,
      bottom: u.y,
      right: u.x
    };
  }(n.getBoundingClientRect(), t));
}

function Qu(n, t, e) {
  return void 0 === t && (t = 0), void 0 === e && (e = .01), Ia(n, t) < e;
}

function ns(n) {
  return n.max - n.min;
}

function ts(n, t) {
  var e = .5,
      r = ns(n),
      o = ns(t);
  return o > r ? e = Li(t.min, t.max - r, n.min) : r > o && (e = Li(n.min, n.max - o, t.min)), function (n) {
    return xi(0, 1, n);
  }(e);
}

function es(n, t, e, r) {
  void 0 === r && (r = .5), n.origin = r, n.originPoint = Oi(t.min, t.max, n.origin), n.scale = ns(e) / ns(t), Qu(n.scale, 1, 1e-4) && (n.scale = 1), n.translate = Oi(e.min, e.max, n.origin) - n.originPoint, Qu(n.translate) && (n.translate = 0);
}

function rs(n, t, e, r) {
  es(n.x, t.x, e.x, os(r.originX)), es(n.y, t.y, e.y, os(r.originY));
}

function os(n) {
  return "number" == typeof n ? n : .5;
}

function is(n, t, e) {
  n.min = e.min + t.min, n.max = n.min + ns(t);
}

var as = function as(n, t) {
  return n.depth - t.depth;
};

function us(n) {
  return n.projection.isEnabled || n.shouldResetTransform();
}

function ss(n, t) {
  void 0 === t && (t = []);
  var e = n.parent;
  return e && ss(e, t), us(n) && t.push(n), t;
}

function cs(n) {
  if (!n.shouldResetTransform()) {
    var t,
        e = n.getLayoutState();
    n.notifyBeforeLayoutMeasure(e.layout), e.isHydrated = !0, e.layout = n.measureViewportBox(), e.layoutCorrected = (t = e.layout, {
      x: _We({}, t.x),
      y: _We({}, t.y)
    }), n.notifyLayoutMeasure(e.layout, n.prevViewportBox || e.layout), xa.update(function () {
      return n.rebaseProjectionTarget();
    });
  }
}

function ls(n, t) {
  return {
    min: t.min - n.min,
    max: t.max - n.min
  };
}

function fs(n, t) {
  return {
    x: ls(n.x, t.x),
    y: ls(n.y, t.y)
  };
}

function ps(n, t) {
  var e = n.getLayoutId(),
      r = t.getLayoutId();
  return e !== r || void 0 === r && n !== t;
}

function ds(n) {
  var t = n.getProps(),
      e = t.drag,
      r = t._dragX;
  return e && !r;
}

function hs(n, t) {
  n.min = t.min, n.max = t.max;
}

function vs(n, t, e) {
  return e + t * (n - e);
}

function ms(n, t, e, r, o) {
  return void 0 !== o && (n = vs(n, o, r)), vs(n, e, r) + t;
}

function gs(n, t, e, r, o) {
  void 0 === t && (t = 0), void 0 === e && (e = 1), n.min = ms(n.min, t, e, r, o), n.max = ms(n.max, t, e, r, o);
}

function ys(n, t) {
  var e = t.x,
      r = t.y;
  gs(n.x, e.translate, e.scale, e.originPoint), gs(n.y, r.translate, r.scale, r.originPoint);
}

function bs(n, t, e, r) {
  var o = He(r, 3),
      i = o[0],
      a = o[1],
      u = o[2];
  n.min = t.min, n.max = t.max;
  var s = void 0 !== e[u] ? e[u] : .5,
      c = Oi(t.min, t.max, s);
  gs(n, e[i], e[a], c, e.scale);
}

var ws = ["x", "scaleX", "originX"],
    xs = ["y", "scaleY", "originY"];

function Ss(n, t, e) {
  bs(n.x, t.x, e, ws), bs(n.y, t.y, e, xs);
}

function _s(n, t, e, r, o) {
  return n = vs(n -= t, 1 / e, r), void 0 !== o && (n = vs(n, 1 / o, r)), n;
}

function Es(n, t, e) {
  var r = He(e, 3),
      o = r[0],
      i = r[1],
      a = r[2];
  !function (n, t, e, r, o) {
    void 0 === t && (t = 0), void 0 === e && (e = 1), void 0 === r && (r = .5);
    var i = Oi(n.min, n.max, r) - t;
    n.min = _s(n.min, t, e, i, o), n.max = _s(n.max, t, e, i, o);
  }(n, t[o], t[i], t[a], t.scale);
}

function Ts(n, t) {
  Es(n.x, t, ws), Es(n.y, t, xs);
}

var Ps = new Set();

function Cs(n, t, e) {
  n[e] || (n[e] = []), n[e].push(t);
}

function As(n) {
  return Ps.add(n), function () {
    return Ps.delete(n);
  };
}

function Ls() {
  if (Ps.size) {
    var n = 0,
        t = [[]],
        e = [],
        r = function r(e) {
      return Cs(t, e, n);
    },
        o = function o(t) {
      Cs(e, t, n), n++;
    };

    Ps.forEach(function (t) {
      t(r, o), n = 0;
    }), Ps.clear();

    for (var i = e.length, a = 0; a <= i; a++) {
      t[a] && t[a].forEach(ks), e[a] && e[a].forEach(ks);
    }
  }
}

var Os,
    ks = function ks(n) {
  return n();
},
    Rs = new WeakMap(),
    Ns = function () {
  function n(n) {
    var t = n.visualElement;
    this.isDragging = !1, this.currentDirection = null, this.constraints = !1, this.elastic = {
      x: {
        min: 0,
        max: 1
      },
      y: {
        min: 0,
        max: 1
      }
    }, this.props = {}, this.hasMutatedConstraints = !1, this.cursorProgress = {
      x: .5,
      y: .5
    }, this.originPoint = {}, this.openGlobalLock = null, this.panSession = null, this.visualElement = t, this.visualElement.enableLayoutProjection(), Rs.set(t, this);
  }

  return n.prototype.start = function (n, t) {
    var e = this,
        r = void 0 === t ? {} : t,
        o = r.snapToCursor,
        i = void 0 !== o && o,
        a = r.cursorProgress,
        u = this.props.transformPagePoint;
    this.panSession = new Iu(n, {
      onSessionStart: function onSessionStart(n) {
        var t;
        e.stopMotion();

        var r = function (n) {
          return ai(n, "client");
        }(n).point;

        null === (t = e.cancelLayout) || void 0 === t || t.call(e), e.cancelLayout = As(function (n, t) {
          var o = ss(e.visualElement),
              u = function (n) {
            var t = [],
                e = function e(n) {
              us(n) && t.push(n), n.children.forEach(e);
            };

            return n.children.forEach(e), t.sort(as);
          }(e.visualElement),
              s = Ue(Ue([], He(o)), He(u)),
              c = !1;

          e.isLayoutDrag() && e.visualElement.lockProjectionTarget(), t(function () {
            s.forEach(function (n) {
              return n.resetTransform();
            });
          }), n(function () {
            cs(e.visualElement), u.forEach(cs);
          }), t(function () {
            s.forEach(function (n) {
              return n.restoreTransform();
            }), i && (c = e.snapToCursor(r));
          }), n(function () {
            Boolean(e.getAxisMotionValue("x") && !e.isExternalDrag()) || e.visualElement.rebaseProjectionTarget(!0, e.visualElement.measureViewportBox(!1)), e.visualElement.scheduleUpdateLayoutProjection();
            var n = e.visualElement.projection;
            $u(function (t) {
              if (!c) {
                var o = n.target[t],
                    i = o.min,
                    u = o.max;
                e.cursorProgress[t] = a ? a[t] : Li(i, u, r[t]);
              }

              var s = e.getAxisMotionValue(t);
              s && (e.originPoint[t] = s.get());
            });
          }), t(function () {
            _a.update(), _a.preRender(), _a.render(), _a.postRender();
          }), n(function () {
            return e.resolveDragConstraints();
          });
        });
      },
      onStart: function onStart(n, t) {
        var r,
            o,
            i,
            a = e.props,
            u = a.drag,
            s = a.dragPropagation;
        (!u || s || (e.openGlobalLock && e.openGlobalLock(), e.openGlobalLock = mi(u), e.openGlobalLock)) && (Ls(), e.isDragging = !0, e.currentDirection = null, null === (o = (r = e.props).onDragStart) || void 0 === o || o.call(r, n, t), null === (i = e.visualElement.animationState) || void 0 === i || i.setActive(Zo.Drag, !0));
      },
      onMove: function onMove(n, t) {
        var r,
            o,
            i,
            a,
            u = e.props,
            s = u.dragPropagation,
            c = u.dragDirectionLock;

        if (s || e.openGlobalLock) {
          var l = t.offset;
          if (c && null === e.currentDirection) return e.currentDirection = function (n, t) {
            void 0 === t && (t = 10);
            var e = null;
            Math.abs(n.y) > t ? e = "y" : Math.abs(n.x) > t && (e = "x");
            return e;
          }(l), void (null !== e.currentDirection && (null === (o = (r = e.props).onDirectionLock) || void 0 === o || o.call(r, e.currentDirection)));
          e.updateAxis("x", t.point, l), e.updateAxis("y", t.point, l), null === (a = (i = e.props).onDrag) || void 0 === a || a.call(i, n, t), Os = n;
        }
      },
      onSessionEnd: function onSessionEnd(n, t) {
        return e.stop(n, t);
      }
    }, {
      transformPagePoint: u
    });
  }, n.prototype.resolveDragConstraints = function () {
    var n = this,
        t = this.props,
        e = t.dragConstraints,
        r = t.dragElastic,
        o = this.visualElement.getLayoutState().layoutCorrected;
    this.constraints = !!e && (fr(e) ? this.resolveRefConstraints(o, e) : function (n, t) {
      var e = t.top,
          r = t.left,
          o = t.bottom,
          i = t.right;
      return {
        x: qu(n.x, r, i),
        y: qu(n.y, e, o)
      };
    }(o, e)), this.elastic = function (n) {
      return !1 === n ? n = 0 : !0 === n && (n = .35), {
        x: Ku(n, "left", "right"),
        y: Ku(n, "top", "bottom")
      };
    }(r), this.constraints && !this.hasMutatedConstraints && $u(function (t) {
      n.getAxisMotionValue(t) && (n.constraints[t] = function (n, t) {
        var e = {};
        return void 0 !== t.min && (e.min = t.min - n.min), void 0 !== t.max && (e.max = t.max - n.min), e;
      }(o[t], n.constraints[t]));
    });
  }, n.prototype.resolveRefConstraints = function (n, t) {
    var e = this.props,
        r = e.onMeasureDragConstraints,
        o = e.transformPagePoint,
        i = t.current;
    Ge(null !== i, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop."), this.constraintsBox = Ju(i, o);

    var a = function (n, t) {
      return {
        x: Gu(n.x, t.x),
        y: Gu(n.y, t.y)
      };
    }(n, this.constraintsBox);

    if (r) {
      var u = r(function (n) {
        var t = n.x,
            e = n.y;
        return {
          top: e.min,
          bottom: e.max,
          left: t.min,
          right: t.max
        };
      }(a));
      this.hasMutatedConstraints = !!u, u && (a = Yu(u));
    }

    return a;
  }, n.prototype.cancelDrag = function () {
    var n, t;
    this.visualElement.unlockProjectionTarget(), null === (n = this.cancelLayout) || void 0 === n || n.call(this), this.isDragging = !1, this.panSession && this.panSession.end(), this.panSession = null, !this.props.dragPropagation && this.openGlobalLock && (this.openGlobalLock(), this.openGlobalLock = null), null === (t = this.visualElement.animationState) || void 0 === t || t.setActive(Zo.Drag, !1);
  }, n.prototype.stop = function (n, t) {
    var e, r, o;
    null === (e = this.panSession) || void 0 === e || e.end(), this.panSession = null;
    var i = this.isDragging;

    if (this.cancelDrag(), i) {
      var a = t.velocity;
      this.animateDragEnd(a), null === (o = (r = this.props).onDragEnd) || void 0 === o || o.call(r, n, t);
    }
  }, n.prototype.snapToCursor = function (n) {
    var t = this;
    return $u(function (e) {
      if (zs(e, t.props.drag, t.currentDirection)) {
        var r = t.getAxisMotionValue(e);
        if (!r) return t.cursorProgress[e] = .5, !0;
        var o = t.visualElement.getLayoutState().layout,
            i = o[e].max - o[e].min,
            a = o[e].min + i / 2,
            u = n[e] - a;
        t.originPoint[e] = n[e], r.set(u);
      }
    }).includes(!0);
  }, n.prototype.updateAxis = function (n, t, e) {
    if (zs(n, this.props.drag, this.currentDirection)) return this.getAxisMotionValue(n) ? this.updateAxisMotionValue(n, e) : this.updateVisualElementAxis(n, t);
  }, n.prototype.updateAxisMotionValue = function (n, t) {
    var e = this.getAxisMotionValue(n);

    if (t && e) {
      var r = this.originPoint[n] + t[n],
          o = this.constraints ? Xu(r, this.constraints[n], this.elastic[n]) : r;
      e.set(o);
    }
  }, n.prototype.updateVisualElementAxis = function (n, t) {
    var e,
        r = this.visualElement.getLayoutState().layout[n],
        o = r.max - r.min,
        i = this.cursorProgress[n],
        a = function (n, t, e, r, o) {
      var i = n - t * e;
      return r ? Xu(i, r, o) : i;
    }(t[n], o, i, null === (e = this.constraints) || void 0 === e ? void 0 : e[n], this.elastic[n]);

    this.visualElement.setProjectionTargetAxis(n, a, a + o);
  }, n.prototype.setProps = function (n) {
    var t = n.drag,
        e = void 0 !== t && t,
        r = n.dragDirectionLock,
        o = void 0 !== r && r,
        i = n.dragPropagation,
        a = void 0 !== i && i,
        u = n.dragConstraints,
        s = void 0 !== u && u,
        c = n.dragElastic,
        l = void 0 === c ? .35 : c,
        f = n.dragMomentum,
        p = void 0 === f || f,
        d = Ye(n, ["drag", "dragDirectionLock", "dragPropagation", "dragConstraints", "dragElastic", "dragMomentum"]);
    this.props = _We({
      drag: e,
      dragDirectionLock: o,
      dragPropagation: a,
      dragConstraints: s,
      dragElastic: l,
      dragMomentum: p
    }, d);
  }, n.prototype.getAxisMotionValue = function (n) {
    var t = this.props,
        e = t.layout,
        r = t.layoutId,
        o = "_drag" + n.toUpperCase();
    return this.props[o] ? this.props[o] : e || void 0 !== r ? void 0 : this.visualElement.getValue(n, 0);
  }, n.prototype.isLayoutDrag = function () {
    return !this.getAxisMotionValue("x");
  }, n.prototype.isExternalDrag = function () {
    var n = this.props,
        t = n._dragX,
        e = n._dragY;
    return t || e;
  }, n.prototype.animateDragEnd = function (n) {
    var t = this,
        e = this.props,
        r = e.drag,
        o = e.dragMomentum,
        i = e.dragElastic,
        a = e.dragTransition,
        u = function (n, t) {
      void 0 === t && (t = !0);
      var e,
          r = n.getProjectionParent();
      return !!r && (t ? Ts(e = fs(r.projection.target, n.projection.target), r.getLatestValues()) : e = fs(r.getLayoutState().layout, n.getLayoutState().layout), $u(function (t) {
        return n.setProjectionTargetAxis(t, e[t].min, e[t].max, !0);
      }), !0);
    }(this.visualElement, this.isLayoutDrag() && !this.isExternalDrag()),
        s = this.constraints || {};

    if (u && Object.keys(s).length && this.isLayoutDrag()) {
      var c = this.visualElement.getProjectionParent();

      if (c) {
        var l = fs(c.projection.targetFinal, s);
        $u(function (n) {
          var t = l[n],
              e = t.min,
              r = t.max;
          s[n] = {
            min: isNaN(e) ? void 0 : e,
            max: isNaN(r) ? void 0 : r
          };
        });
      }
    }

    var f = $u(function (e) {
      var c;

      if (zs(e, r, t.currentDirection)) {
        var l = null !== (c = null == s ? void 0 : s[e]) && void 0 !== c ? c : {},
            f = i ? 200 : 1e6,
            p = i ? 40 : 1e7,
            d = _We(_We({
          type: "inertia",
          velocity: o ? n[e] : 0,
          bounceStiffness: f,
          bounceDamping: p,
          timeConstant: 750,
          restDelta: 1,
          restSpeed: 10
        }, a), l);

        return t.getAxisMotionValue(e) ? t.startAxisValueAnimation(e, d) : t.visualElement.startLayoutAnimation(e, d, u);
      }
    });
    return Promise.all(f).then(function () {
      var n, e;
      null === (e = (n = t.props).onDragTransitionEnd) || void 0 === e || e.call(n);
    });
  }, n.prototype.stopMotion = function () {
    var n = this;
    $u(function (t) {
      var e = n.getAxisMotionValue(t);
      e ? e.stop() : n.visualElement.stopLayoutAnimation();
    });
  }, n.prototype.startAxisValueAnimation = function (n, t) {
    var e = this.getAxisMotionValue(n);

    if (e) {
      var r = e.get();
      return e.set(r), e.set(r), lu(n, e, 0, t);
    }
  }, n.prototype.scalePoint = function () {
    var n = this,
        t = this.props,
        e = t.drag;

    if (fr(t.dragConstraints) && this.constraintsBox) {
      this.stopMotion();
      var r = {
        x: 0,
        y: 0
      };
      $u(function (t) {
        r[t] = ts(n.visualElement.projection.target[t], n.constraintsBox[t]);
      }), this.updateConstraints(function () {
        $u(function (t) {
          if (zs(t, e, null)) {
            var o = function (n, t, e) {
              var r = n.max - n.min,
                  o = Oi(t.min, t.max - r, e);
              return {
                min: o,
                max: o + r
              };
            }(n.visualElement.projection.target[t], n.constraintsBox[t], r[t]),
                i = o.min,
                a = o.max;

            n.visualElement.setProjectionTargetAxis(t, i, a);
          }
        });
      }), setTimeout(Ls, 1);
    }
  }, n.prototype.updateConstraints = function (n) {
    var t = this;
    this.cancelLayout = As(function (e, r) {
      var o = ss(t.visualElement);
      r(function () {
        return o.forEach(function (n) {
          return n.resetTransform();
        });
      }), e(function () {
        return cs(t.visualElement);
      }), r(function () {
        return o.forEach(function (n) {
          return n.restoreTransform();
        });
      }), e(function () {
        t.resolveDragConstraints();
      }), n && r(n);
    });
  }, n.prototype.mount = function (n) {
    var t = this,
        e = fi(n.getInstance(), "pointerdown", function (n) {
      var e = t.props,
          r = e.drag,
          o = e.dragListener;
      r && (void 0 === o || o) && t.start(n);
    }),
        r = Qo(window, "resize", function () {
      t.scalePoint();
    }),
        o = n.onLayoutUpdate(function () {
      t.isDragging && t.resolveDragConstraints();
    }),
        i = n.prevDragCursor;
    return i && this.start(Os, {
      cursorProgress: i
    }), function () {
      null == e || e(), null == r || r(), null == o || o(), t.cancelDrag();
    };
  }, n;
}();

function zs(n, t, e) {
  return !(!0 !== t && t !== n || null !== e && e !== n);
}

var Is,
    Ds,
    js = {
  pan: Wa(function (n) {
    var t = n.onPan,
        e = n.onPanStart,
        a = n.onPanEnd,
        u = n.onPanSessionStart,
        s = n.visualElement,
        c = t || e || a || u,
        l = o(null),
        f = r(Qe).transformPagePoint,
        p = {
      onSessionStart: u,
      onStart: e,
      onMove: t,
      onEnd: function onEnd(n, t) {
        l.current = null, a && a(n, t);
      }
    };
    i(function () {
      null !== l.current && l.current.updateHandlers(p);
    }), pi(s, "pointerdown", c && function (n) {
      l.current = new Iu(n, p, {
        transformPagePoint: f
      });
    }), wi(function () {
      return l.current && l.current.end();
    });
  }),
  drag: Wa(function (n) {
    var t = n.dragControls,
        e = n.visualElement,
        o = r(Qe).transformPagePoint,
        a = er(function () {
      return new Ns({
        visualElement: e
      });
    });
    a.setProps(_We(_We({}, n), {
      transformPagePoint: o
    })), i(function () {
      return t && t.subscribe(a);
    }, [a]), i(function () {
      return a.mount(e);
    }, []);
  })
};

function Ms(n) {
  return "string" == typeof n && n.startsWith("var(--");
}

!function (n) {
  n[n.Entering = 0] = "Entering", n[n.Present = 1] = "Present", n[n.Exiting = 2] = "Exiting";
}(Is || (Is = {})), function (n) {
  n[n.Hide = 0] = "Hide", n[n.Show = 1] = "Show";
}(Ds || (Ds = {}));
var Bs = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;

function Vs(n, t, e) {
  void 0 === e && (e = 1), Ge(e <= 4, 'Max CSS variable fallback depth detected in property "' + n + '". This may indicate a circular fallback dependency.');
  var r = He(function (n) {
    var t = Bs.exec(n);
    if (!t) return [,];
    var e = He(t, 3);
    return [e[1], e[2]];
  }(n), 2),
      o = r[0],
      i = r[1];

  if (o) {
    var a = window.getComputedStyle(t).getPropertyValue(o);
    return a ? a.trim() : Ms(i) ? Vs(i, t, e + 1) : i;
  }
}

function Fs(n, t) {
  return n / (t.max - t.min) * 100;
}

var Ws = {
  process: function process(n, t, e) {
    var r = e.target;

    if ("string" == typeof n) {
      if (!Gr.test(n)) return n;
      n = parseFloat(n);
    }

    return Fs(n, r.x) + "% " + Fs(n, r.y) + "%";
  }
},
    Ys = {
  borderRadius: _We(_We({}, Ws), {
    applyTo: ["borderTopLeftRadius", "borderTopRightRadius", "borderBottomLeftRadius", "borderBottomRightRadius"]
  }),
  borderTopLeftRadius: Ws,
  borderTopRightRadius: Ws,
  borderBottomLeftRadius: Ws,
  borderBottomRightRadius: Ws,
  boxShadow: {
    process: function process(n, t) {
      var e = t.delta,
          r = t.treeScale,
          o = n,
          i = n.includes("var("),
          a = [];
      i && (n = n.replace(Bs, function (n) {
        return a.push(n), "_$css";
      }));
      var u = fo.parse(n);
      if (u.length > 5) return o;
      var s = fo.createTransformer(n),
          c = "number" != typeof u[0] ? 1 : 0,
          l = e.x.scale * r.x,
          f = e.y.scale * r.y;
      u[0 + c] /= l, u[1 + c] /= f;
      var p = Oi(l, f, .5);
      "number" == typeof u[2 + c] && (u[2 + c] /= p), "number" == typeof u[3 + c] && (u[3 + c] /= p);
      var d = s(u);

      if (i) {
        var h = 0;
        d = d.replace("_$css", function () {
          var n = a[h];
          return h++, n;
        });
      }

      return d;
    }
  }
},
    Hs = function (n) {
  function t() {
    var t = null !== n && n.apply(this, arguments) || this;
    return t.frameTarget = {
      x: {
        min: 0,
        max: 1
      },
      y: {
        min: 0,
        max: 1
      }
    }, t.currentAnimationTarget = {
      x: {
        min: 0,
        max: 1
      },
      y: {
        min: 0,
        max: 1
      }
    }, t.isAnimating = {
      x: !1,
      y: !1
    }, t.stopAxisAnimation = {
      x: void 0,
      y: void 0
    }, t.isAnimatingTree = !1, t.animate = function (n, e, r) {
      void 0 === r && (r = {});
      var o = r.originBox,
          i = r.targetBox,
          a = r.visibilityAction,
          u = r.shouldStackAnimate,
          s = r.onComplete,
          c = r.prevParent,
          l = Ye(r, ["originBox", "targetBox", "visibilityAction", "shouldStackAnimate", "onComplete", "prevParent"]),
          f = t.props,
          p = f.visualElement,
          d = f.layout;
      if (!1 === u) return t.isAnimatingTree = !1, t.safeToRemove();

      if (!t.isAnimatingTree || !0 === u) {
        u && (t.isAnimatingTree = !0), e = o || e, n = i || n;
        var h = !1,
            v = p.getProjectionParent();

        if (v) {
          var m = v.prevViewportBox,
              g = v.getLayoutState().layout;
          c && (i && (g = c.getLayoutState().layout), o && !ps(c, v) && c.prevViewportBox && (m = c.prevViewportBox)), m && Ks(c, o, i) && (h = !0, e = fs(m, e), n = fs(g, n));
        }

        var y = Us(e, n),
            b = $u(function (r) {
          var o, i;

          if ("position" === d) {
            var u = n[r].max - n[r].min;
            e[r].max = e[r].min + u;
          }

          if (!p.projection.isTargetLocked) return void 0 === a ? y ? t.animateAxis(r, n[r], e[r], _We(_We({}, l), {
            isRelative: h
          })) : (null === (i = (o = t.stopAxisAnimation)[r]) || void 0 === i || i.call(o), p.setProjectionTargetAxis(r, n[r].min, n[r].max, h)) : void p.setVisibility(a === Ds.Show);
        });
        return p.syncRender(), Promise.all(b).then(function () {
          t.isAnimatingTree = !1, s && s(), p.notifyLayoutAnimationComplete();
        });
      }
    }, t;
  }

  return Fe(t, n), t.prototype.componentDidMount = function () {
    var n = this,
        t = this.props.visualElement;
    t.animateMotionValue = lu, t.enableLayoutProjection(), this.unsubLayoutReady = t.onLayoutUpdate(this.animate), t.layoutSafeToRemove = function () {
      return n.safeToRemove();
    }, function (n) {
      for (var t in n) {
        Er[t] = n[t];
      }
    }(Ys);
  }, t.prototype.componentWillUnmount = function () {
    var n = this;
    this.unsubLayoutReady(), $u(function (t) {
      var e, r;
      return null === (r = (e = n.stopAxisAnimation)[t]) || void 0 === r ? void 0 : r.call(e);
    });
  }, t.prototype.animateAxis = function (n, t, e, r) {
    var o,
        i,
        a = this,
        u = void 0 === r ? {} : r,
        s = u.transition,
        c = u.isRelative;

    if (!this.isAnimating[n] || !qs(t, this.currentAnimationTarget[n])) {
      null === (i = (o = this.stopAxisAnimation)[n]) || void 0 === i || i.call(o), this.isAnimating[n] = !0;
      var l = this.props.visualElement,
          f = this.frameTarget[n],
          p = l.getProjectionAnimationProgress()[n];
      p.clearListeners(), p.set(0), p.set(0);

      var d = function d() {
        var r = p.get() / 1e3;
        !function (n, t, e, r) {
          n.min = Oi(t.min, e.min, r), n.max = Oi(t.max, e.max, r);
        }(f, e, t, r), l.setProjectionTargetAxis(n, f.min, f.max, c);
      };

      d();
      var h = p.onChange(d);
      this.stopAxisAnimation[n] = function () {
        a.isAnimating[n] = !1, p.stop(), h();
      }, this.currentAnimationTarget[n] = t;
      var v = s || l.getDefaultTransition() || Gs;
      return lu("x" === n ? "layoutX" : "layoutY", p, 1e3, v && cu(v, "layout")).then(this.stopAxisAnimation[n]);
    }
  }, t.prototype.safeToRemove = function () {
    var n, t;
    null === (t = (n = this.props).safeToRemove) || void 0 === t || t.call(n);
  }, t.prototype.render = function () {
    return null;
  }, t;
}(n.Component);

function Us(n, t) {
  return !(Xs(n) || Xs(t) || qs(n.x, t.x) && qs(n.y, t.y));
}

var $s = {
  min: 0,
  max: 0
};

function Xs(n) {
  return qs(n.x, $s) && qs(n.y, $s);
}

function qs(n, t) {
  return n.min === t.min && n.max === t.max;
}

var Gs = {
  duration: .45,
  ease: [.4, 0, .1, 1]
};

function Ks(n, t, e) {
  return n || !n && !(t || e);
}

var Zs = {
  layoutReady: function layoutReady(n) {
    return n.notifyLayoutReady();
  }
};

function Js() {
  var n = new Set();
  return {
    add: function add(t) {
      return n.add(t);
    },
    flush: function flush(t) {
      var e = void 0 === t ? Zs : t,
          r = e.layoutReady,
          o = e.parent;
      As(function (t, e) {
        var i = Array.from(n).sort(as),
            a = o ? ss(o) : [];
        e(function () {
          Ue(Ue([], He(a)), He(i)).forEach(function (n) {
            return n.resetTransform();
          });
        }), t(function () {
          i.forEach(cs);
        }), e(function () {
          a.forEach(function (n) {
            return n.restoreTransform();
          }), i.forEach(r);
        }), t(function () {
          i.forEach(function (n) {
            n.isPresent && (n.presence = Is.Present);
          });
        }), e(function () {
          _a.preRender(), _a.render();
        }), t(function () {
          xa.postRender(function () {
            return i.forEach(Qs);
          }), n.clear();
        });
      }), Ls();
    }
  };
}

function Qs(n) {
  n.prevViewportBox = n.projection.target;
}

var nc = s(Js()),
    tc = s(Js());

function ec(n) {
  return !!n.forceUpdate;
}

var rc = function (n) {
  function t() {
    return null !== n && n.apply(this, arguments) || this;
  }

  return Fe(t, n), t.prototype.componentDidMount = function () {
    var n = this.props,
        t = n.syncLayout,
        e = n.framerSyncLayout,
        r = n.visualElement;
    ec(t) && t.register(r), ec(e) && e.register(r), r.onUnmount(function () {
      ec(t) && t.remove(r), ec(e) && e.remove(r);
    });
  }, t.prototype.getSnapshotBeforeUpdate = function () {
    var n = this.props,
        t = n.syncLayout,
        e = n.visualElement;
    return ec(t) ? t.syncUpdate() : (!function (n) {
      n.shouldResetTransform() || (n.prevViewportBox = n.measureViewportBox(!1), n.rebaseProjectionTarget(!1, n.prevViewportBox));
    }(e), t.add(e)), null;
  }, t.prototype.componentDidUpdate = function () {
    var n = this.props.syncLayout;
    ec(n) || n.flush();
  }, t.prototype.render = function () {
    return null;
  }, t;
}(t.Component);

var oc = {
  measureLayout: function measureLayout(n) {
    var e = r(nc),
        o = r(tc);
    return t.createElement(rc, _We({}, n, {
      syncLayout: e,
      framerSyncLayout: o
    }));
  },
  layoutAnimation: function layoutAnimation(t) {
    var e = He(rr(), 2)[1];
    return n.createElement(Hs, _We({}, t, {
      safeToRemove: e
    }));
  }
};

function ic() {
  return {
    isHydrated: !1,
    layout: {
      x: {
        min: 0,
        max: 1
      },
      y: {
        min: 0,
        max: 1
      }
    },
    layoutCorrected: {
      x: {
        min: 0,
        max: 1
      },
      y: {
        min: 0,
        max: 1
      }
    },
    treeScale: {
      x: 1,
      y: 1
    },
    delta: Uu(),
    deltaFinal: Uu(),
    deltaTransform: ""
  };
}

var ac = ic();

function uc(n, t, e) {
  var r = n.x,
      o = n.y,
      i = "translate3d(" + r.translate / t.x + "px, " + o.translate / t.y + "px, 0) ";

  if (e) {
    var a = e.rotate,
        u = e.rotateX,
        s = e.rotateY;
    a && (i += "rotate(" + a + ") "), u && (i += "rotateX(" + u + ") "), s && (i += "rotateY(" + s + ") ");
  }

  return i += "scale(" + r.scale + ", " + o.scale + ")", e || i !== cc ? i : "";
}

function sc(n) {
  var t = n.deltaFinal;
  return 100 * t.x.origin + "% " + 100 * t.y.origin + "% 0";
}

var cc = uc(ac.delta, ac.treeScale, {
  x: 1,
  y: 1
}),
    lc = ["LayoutMeasure", "BeforeLayoutMeasure", "LayoutUpdate", "ViewportBoxUpdate", "Update", "Render", "AnimationComplete", "LayoutAnimationComplete", "AnimationStart", "SetAxisTarget", "Unmount"];

function fc(n, t, e, r) {
  var o,
      i,
      a = n.delta,
      u = n.layout,
      s = n.layoutCorrected,
      c = n.treeScale,
      l = t.target;
  i = u, hs((o = s).x, i.x), hs(o.y, i.y), function (n, t, e) {
    var r = e.length;

    if (r) {
      var o, i;
      t.x = t.y = 1;

      for (var a = 0; a < r; a++) {
        i = (o = e[a]).getLayoutState().delta, t.x *= i.x.scale, t.y *= i.y.scale, ys(n, i), ds(o) && Ss(n, n, o.getLatestValues());
      }
    }
  }(s, c, e), rs(a, s, l, r);
}

var pc = function () {
  function n() {
    this.children = [], this.isDirty = !1;
  }

  return n.prototype.add = function (n) {
    pu(this.children, n), this.isDirty = !0;
  }, n.prototype.remove = function (n) {
    du(this.children, n), this.isDirty = !0;
  }, n.prototype.forEach = function (n) {
    this.isDirty && this.children.sort(as), this.isDirty = !1, this.children.forEach(n);
  }, n;
}();

var dc = function dc(n) {
  var t = n.treeType,
      e = void 0 === t ? "" : t,
      r = n.build,
      o = n.getBaseTarget,
      i = n.makeTargetAnimatable,
      a = n.measureViewportBox,
      u = n.render,
      s = n.readValueFromInstance,
      c = n.resetTransform,
      l = n.restoreTransform,
      f = n.removeValueFromRenderState,
      p = n.sortNodePosition,
      d = n.scrapeMotionValuesFromProps;
  return function (n, t) {
    var h = n.parent,
        v = n.props,
        m = n.presenceId,
        g = n.blockInitialAnimation,
        y = n.visualState;
    void 0 === t && (t = {});

    var b,
        w,
        x,
        S,
        _,
        E,
        T = y.latestValues,
        P = y.renderState,
        C = function () {
      var n = lc.map(function () {
        return new hu();
      }),
          t = {},
          e = {
        clearAllListeners: function clearAllListeners() {
          return n.forEach(function (n) {
            return n.clear();
          });
        },
        updatePropListeners: function updatePropListeners(n) {
          return lc.forEach(function (r) {
            var o;
            null === (o = t[r]) || void 0 === o || o.call(t);
            var i = "on" + r,
                a = n[i];
            a && (t[r] = e[i](a));
          });
        }
      };
      return n.forEach(function (n, t) {
        e["on" + lc[t]] = function (t) {
          return n.add(t);
        }, e["notify" + lc[t]] = function () {
          for (var t = [], e = 0; e < arguments.length; e++) {
            t[e] = arguments[e];
          }

          return n.notify.apply(n, Ue([], He(t)));
        };
      }), e;
    }(),
        A = {
      isEnabled: !1,
      isHydrated: !1,
      isTargetLocked: !1,
      target: {
        x: {
          min: 0,
          max: 1
        },
        y: {
          min: 0,
          max: 1
        }
      },
      targetFinal: {
        x: {
          min: 0,
          max: 1
        },
        y: {
          min: 0,
          max: 1
        }
      }
    },
        L = A,
        O = T,
        k = ic(),
        R = !1,
        N = new Map(),
        z = new Map(),
        I = {},
        D = _We({}, T);

    function j() {
      b && ($.isProjectionReady() && (Ss(L.targetFinal, L.target, O), rs(k.deltaFinal, k.layoutCorrected, L.targetFinal, T)), M(), u(b, P));
    }

    function M() {
      var n = T;

      if (S && S.isActive()) {
        var e = S.getCrossfadeState($);
        e && (n = e);
      }

      r($, P, n, L, k, t, v);
    }

    function B() {
      C.notifyUpdate(T);
    }

    function V() {
      $.layoutTree.forEach(vc);
    }

    var F = d(v);

    for (var W in F) {
      var Y = F[W];
      void 0 !== T[W] && Nr(Y) && Y.set(T[W], !1);
    }

    var H = mr(v),
        U = gr(v),
        $ = _We(_We({
      treeType: e,
      current: null,
      depth: h ? h.depth + 1 : 0,
      parent: h,
      children: new Set(),
      path: h ? Ue(Ue([], He(h.path)), [h]) : [],
      layoutTree: h ? h.layoutTree : new pc(),
      presenceId: m,
      projection: A,
      variantChildren: U ? new Set() : void 0,
      isVisible: void 0,
      manuallyAnimateOnMount: Boolean(null == h ? void 0 : h.isMounted()),
      blockInitialAnimation: g,
      isMounted: function isMounted() {
        return Boolean(b);
      },
      mount: function mount(n) {
        b = $.current = n, $.pointTo($), U && h && !H && (E = null == h ? void 0 : h.addVariantChild($)), null == h || h.children.add($);
      },
      unmount: function unmount() {
        Sa.update(B), Sa.render(j), Sa.preRender($.updateLayoutProjection), z.forEach(function (n) {
          return n();
        }), $.stopLayoutAnimation(), $.layoutTree.remove($), null == E || E(), null == h || h.children.delete($), null == x || x(), C.clearAllListeners();
      },
      addVariantChild: function addVariantChild(n) {
        var t,
            e = $.getClosestVariantNode();
        if (e) return null === (t = e.variantChildren) || void 0 === t || t.add(n), function () {
          return e.variantChildren.delete(n);
        };
      },
      sortNodePosition: function sortNodePosition(n) {
        return p && e === n.treeType ? p($.getInstance(), n.getInstance()) : 0;
      },
      getClosestVariantNode: function getClosestVariantNode() {
        return U ? $ : null == h ? void 0 : h.getClosestVariantNode();
      },
      scheduleUpdateLayoutProjection: h ? h.scheduleUpdateLayoutProjection : function () {
        return xa.preRender($.updateTreeLayoutProjection, !1, !0);
      },
      getLayoutId: function getLayoutId() {
        return v.layoutId;
      },
      getInstance: function getInstance() {
        return b;
      },
      getStaticValue: function getStaticValue(n) {
        return T[n];
      },
      setStaticValue: function setStaticValue(n, t) {
        return T[n] = t;
      },
      getLatestValues: function getLatestValues() {
        return T;
      },
      setVisibility: function setVisibility(n) {
        $.isVisible !== n && ($.isVisible = n, $.scheduleRender());
      },
      makeTargetAnimatable: function makeTargetAnimatable(n, t) {
        return void 0 === t && (t = !0), i($, n, v, t);
      },
      addValue: function addValue(n, t) {
        $.hasValue(n) && $.removeValue(n), N.set(n, t), T[n] = t.get(), function (n, t) {
          var e = t.onChange(function (t) {
            T[n] = t, v.onUpdate && xa.update(B, !1, !0);
          }),
              r = t.onRenderRequest($.scheduleRender);
          z.set(n, function () {
            e(), r();
          });
        }(n, t);
      },
      removeValue: function removeValue(n) {
        var t;
        N.delete(n), null === (t = z.get(n)) || void 0 === t || t(), z.delete(n), delete T[n], f(n, P);
      },
      hasValue: function hasValue(n) {
        return N.has(n);
      },
      getValue: function getValue(n, t) {
        var e = N.get(n);
        return void 0 === e && void 0 !== t && (e = mu(t), $.addValue(n, e)), e;
      },
      forEachValue: function forEachValue(n) {
        return N.forEach(n);
      },
      readValue: function readValue(n) {
        var e;
        return null !== (e = T[n]) && void 0 !== e ? e : s(b, n, t);
      },
      setBaseTarget: function setBaseTarget(n, t) {
        D[n] = t;
      },
      getBaseTarget: function getBaseTarget(n) {
        if (o) {
          var t = o(v, n);
          if (void 0 !== t && !Nr(t)) return t;
        }

        return D[n];
      }
    }, C), {
      build: function build() {
        return M(), P;
      },
      scheduleRender: function scheduleRender() {
        xa.render(j, !1, !0);
      },
      syncRender: j,
      setProps: function setProps(n) {
        v = n, C.updatePropListeners(n), I = function (n, t, e) {
          var r;

          for (var o in t) {
            var i = t[o],
                a = e[o];
            if (Nr(i)) n.addValue(o, i);else if (Nr(a)) n.addValue(o, mu(i));else if (a !== i) if (n.hasValue(o)) {
              var u = n.getValue(o);
              !u.hasAnimated && u.set(i);
            } else n.addValue(o, mu(null !== (r = n.getStaticValue(o)) && void 0 !== r ? r : i));
          }

          for (var o in e) {
            void 0 === t[o] && n.removeValue(o);
          }

          return t;
        }($, d(v), I);
      },
      getProps: function getProps() {
        return v;
      },
      getVariant: function getVariant(n) {
        var t;
        return null === (t = v.variants) || void 0 === t ? void 0 : t[n];
      },
      getDefaultTransition: function getDefaultTransition() {
        return v.transition;
      },
      getVariantContext: function getVariantContext(n) {
        if (void 0 === n && (n = !1), n) return null == h ? void 0 : h.getVariantContext();

        if (!H) {
          var t = (null == h ? void 0 : h.getVariantContext()) || {};
          return void 0 !== v.initial && (t.initial = v.initial), t;
        }

        for (var e = {}, r = 0; r < yc; r++) {
          var o = gc[r],
              i = v[o];
          (dr(i) || !1 === i) && (e[o] = i);
        }

        return e;
      },
      enableLayoutProjection: function enableLayoutProjection() {
        A.isEnabled = !0, $.layoutTree.add($);
      },
      lockProjectionTarget: function lockProjectionTarget() {
        A.isTargetLocked = !0;
      },
      unlockProjectionTarget: function unlockProjectionTarget() {
        $.stopLayoutAnimation(), A.isTargetLocked = !1;
      },
      getLayoutState: function getLayoutState() {
        return k;
      },
      setCrossfader: function setCrossfader(n) {
        S = n;
      },
      isProjectionReady: function isProjectionReady() {
        return A.isEnabled && A.isHydrated && k.isHydrated;
      },
      startLayoutAnimation: function startLayoutAnimation(n, t, e) {
        void 0 === e && (e = !1);
        var r = $.getProjectionAnimationProgress()[n],
            o = e ? A.relativeTarget[n] : A.target[n],
            i = o.min,
            a = o.max - i;
        return r.clearListeners(), r.set(i), r.set(i), r.onChange(function (t) {
          $.setProjectionTargetAxis(n, t, t + a, e);
        }), $.animateMotionValue(n, r, 0, t);
      },
      stopLayoutAnimation: function stopLayoutAnimation() {
        $u(function (n) {
          return $.getProjectionAnimationProgress()[n].stop();
        });
      },
      measureViewportBox: function measureViewportBox(n) {
        void 0 === n && (n = !0);
        var e = a(b, t);
        return n || Ts(e, T), e;
      },
      getProjectionAnimationProgress: function getProjectionAnimationProgress() {
        return _ || (_ = {
          x: mu(0),
          y: mu(0)
        }), _;
      },
      setProjectionTargetAxis: function setProjectionTargetAxis(n, t, e, r) {
        var o;
        void 0 === r && (r = !1), r ? (A.relativeTarget || (A.relativeTarget = {
          x: {
            min: 0,
            max: 1
          },
          y: {
            min: 0,
            max: 1
          }
        }), o = A.relativeTarget[n]) : (A.relativeTarget = void 0, o = A.target[n]), A.isHydrated = !0, o.min = t, o.max = e, R = !0, C.notifySetAxisTarget();
      },
      rebaseProjectionTarget: function rebaseProjectionTarget(n, t) {
        void 0 === t && (t = k.layout);
        var e = $.getProjectionAnimationProgress(),
            r = e.x,
            o = e.y,
            i = !(A.relativeTarget || A.isTargetLocked || r.isAnimating() || o.isAnimating());
        (n || i) && $u(function (n) {
          var e = t[n],
              r = e.min,
              o = e.max;
          $.setProjectionTargetAxis(n, r, o);
        });
      },
      notifyLayoutReady: function notifyLayoutReady(n) {
        !function (n) {
          var t = n.getProjectionParent();

          if (t) {
            var e = fs(t.getLayoutState().layout, n.getLayoutState().layout);
            $u(function (t) {
              n.setProjectionTargetAxis(t, e[t].min, e[t].max, !0);
            });
          } else n.rebaseProjectionTarget();
        }($), $.notifyLayoutUpdate(k.layout, $.prevViewportBox || k.layout, n);
      },
      resetTransform: function resetTransform() {
        return c($, b, v);
      },
      restoreTransform: function restoreTransform() {
        return l(b, P);
      },
      updateLayoutProjection: function updateLayoutProjection() {
        if ($.isProjectionReady()) {
          var n = k.delta,
              t = k.treeScale,
              e = t.x,
              r = t.y,
              o = k.deltaTransform;
          fc(k, L, $.path, T), R && $.notifyViewportBoxUpdate(L.target, n), R = !1;
          var i = uc(n, t);
          i === o && e === t.x && r === t.y || $.scheduleRender(), k.deltaTransform = i;
        }
      },
      updateTreeLayoutProjection: function updateTreeLayoutProjection() {
        $.layoutTree.forEach(hc), xa.preRender(V, !1, !0);
      },
      getProjectionParent: function getProjectionParent() {
        if (void 0 === w) {
          for (var n = !1, t = $.path.length - 1; t >= 0; t--) {
            var e = $.path[t];

            if (e.projection.isEnabled) {
              n = e;
              break;
            }
          }

          w = n;
        }

        return w;
      },
      resolveRelativeTargetBox: function resolveRelativeTargetBox() {
        var n = $.getProjectionParent();

        if (A.relativeTarget && n && (function (n, t) {
          is(n.target.x, n.relativeTarget.x, t.target.x), is(n.target.y, n.relativeTarget.y, t.target.y);
        }(A, n.projection), ds(n))) {
          var t = A.target;
          Ss(t, t, n.getLatestValues());
        }
      },
      shouldResetTransform: function shouldResetTransform() {
        return Boolean(v._layoutResetTransform);
      },
      pointTo: function pointTo(n) {
        L = n.projection, O = n.getLatestValues(), null == x || x(), x = Mi(n.onSetAxisTarget($.scheduleUpdateLayoutProjection), n.onLayoutAnimationComplete(function () {
          var n;
          $.isPresent ? $.presence = Is.Present : null === (n = $.layoutSafeToRemove) || void 0 === n || n.call($);
        }));
      },
      isPresent: !0,
      presence: Is.Entering
    });

    return $;
  };
};

function hc(n) {
  n.resolveRelativeTargetBox();
}

function vc(n) {
  n.updateLayoutProjection();
}

var mc,
    gc = Ue(["initial"], He(Au)),
    yc = gc.length,
    bc = new Set(["width", "height", "top", "left", "right", "bottom", "x", "y"]),
    wc = function wc(n) {
  return bc.has(n);
},
    xc = function xc(n, t) {
  n.set(t, !1), n.set(t);
},
    Sc = function Sc(n) {
  return n === Yr || n === Gr;
};

!function (n) {
  n.width = "width", n.height = "height", n.left = "left", n.right = "right", n.top = "top", n.bottom = "bottom";
}(mc || (mc = {}));

var _c = function _c(n, t) {
  return parseFloat(n.split(", ")[t]);
},
    Ec = function Ec(n, t) {
  return function (e, r) {
    var o = r.transform;
    if ("none" === o || !o) return 0;
    var i = o.match(/^matrix3d\((.+)\)$/);
    if (i) return _c(i[1], t);
    var a = o.match(/^matrix\((.+)\)$/);
    return a ? _c(a[1], n) : 0;
  };
},
    Tc = new Set(["x", "y", "z"]),
    Pc = Pr.filter(function (n) {
  return !Tc.has(n);
});

var Cc = {
  width: function width(n) {
    var t = n.x;
    return t.max - t.min;
  },
  height: function height(n) {
    var t = n.y;
    return t.max - t.min;
  },
  top: function top(n, t) {
    var e = t.top;
    return parseFloat(e);
  },
  left: function left(n, t) {
    var e = t.left;
    return parseFloat(e);
  },
  bottom: function bottom(n, t) {
    var e = n.y,
        r = t.top;
    return parseFloat(r) + (e.max - e.min);
  },
  right: function right(n, t) {
    var e = n.x,
        r = t.left;
    return parseFloat(r) + (e.max - e.min);
  },
  x: Ec(4, 13),
  y: Ec(5, 14)
},
    Ac = function Ac(n, t, e, r) {
  void 0 === e && (e = {}), void 0 === r && (r = {}), t = _We({}, t), r = _We({}, r);
  var o = Object.keys(t).filter(wc),
      i = [],
      a = !1,
      u = [];

  if (o.forEach(function (o) {
    var s = n.getValue(o);

    if (n.hasValue(o)) {
      var c,
          l = e[o],
          f = t[o],
          p = bu(l);
      if (Ho(f)) for (var d = f.length, h = null === f[0] ? 1 : 0; h < d; h++) {
        c ? Ge(bu(f[h]) === c, "All keyframes must be of the same type") : (c = bu(f[h]), Ge(c === p || Sc(p) && Sc(c), "Keyframes must be of the same dimension as the current value"));
      } else c = bu(f);
      if (p !== c) if (Sc(p) && Sc(c)) {
        var v = s.get();
        "string" == typeof v && s.set(parseFloat(v)), "string" == typeof f ? t[o] = parseFloat(f) : Array.isArray(f) && c === Gr && (t[o] = f.map(parseFloat));
      } else (null == p ? void 0 : p.transform) && (null == c ? void 0 : c.transform) && (0 === l || 0 === f) ? 0 === l ? s.set(c.transform(l)) : t[o] = p.transform(f) : (a || (i = function (n) {
        var t = [];
        return Pc.forEach(function (e) {
          var r = n.getValue(e);
          void 0 !== r && (t.push([e, r.get()]), r.set(e.startsWith("scale") ? 1 : 0));
        }), t.length && n.syncRender(), t;
      }(n), a = !0), u.push(o), r[o] = void 0 !== r[o] ? r[o] : t[o], xc(s, f));
    }
  }), u.length) {
    var s = function (n, t, e) {
      var r = t.measureViewportBox(),
          o = t.getInstance(),
          i = getComputedStyle(o),
          a = i.display,
          u = {
        top: i.top,
        left: i.left,
        bottom: i.bottom,
        right: i.right,
        transform: i.transform
      };
      "none" === a && t.setStaticValue("display", n.display || "block"), t.syncRender();
      var s = t.measureViewportBox();
      return e.forEach(function (e) {
        var o = t.getValue(e);
        xc(o, Cc[e](r, u)), n[e] = Cc[e](s, i);
      }), n;
    }(t, n, u);

    return i.length && i.forEach(function (t) {
      var e = He(t, 2),
          r = e[0],
          o = e[1];
      n.getValue(r).set(o);
    }), n.syncRender(), {
      target: s,
      transitionEnd: r
    };
  }

  return {
    target: t,
    transitionEnd: r
  };
};

function Lc(n, t, e, r) {
  return function (n) {
    return Object.keys(n).some(wc);
  }(t) ? Ac(n, t, e, r) : {
    target: t,
    transitionEnd: r
  };
}

var Oc = function Oc(n, t, e, r) {
  var o = function (n, t, e) {
    var r,
        o = Ye(t, []),
        i = n.getInstance();
    if (!(i instanceof HTMLElement)) return {
      target: o,
      transitionEnd: e
    };

    for (var a in e && (e = _We({}, e)), n.forEachValue(function (n) {
      var t = n.get();

      if (Ms(t)) {
        var e = Vs(t, i);
        e && n.set(e);
      }
    }), o) {
      var u = o[a];

      if (Ms(u)) {
        var s = Vs(u, i);
        s && (o[a] = s, e && (null !== (r = e[a]) && void 0 !== r || (e[a] = u)));
      }
    }

    return {
      target: o,
      transitionEnd: e
    };
  }(n, t, r);

  return Lc(n, t = o.target, e, r = o.transitionEnd);
};

var kc = {
  treeType: "dom",
  readValueFromInstance: function readValueFromInstance(n, t) {
    if (Lr(t)) {
      var e = tu(t);
      return e && e.default || 0;
    }

    var r,
        o = (r = n, window.getComputedStyle(r));
    return (Ir(t) ? o.getPropertyValue(t) : o[t]) || 0;
  },
  sortNodePosition: function sortNodePosition(n, t) {
    return 2 & n.compareDocumentPosition(t) ? 1 : -1;
  },
  getBaseTarget: function getBaseTarget(n, t) {
    var e;
    return null === (e = n.style) || void 0 === e ? void 0 : e[t];
  },
  measureViewportBox: function measureViewportBox(n, t) {
    return Ju(n, t.transformPagePoint);
  },
  resetTransform: function resetTransform(n, t, e) {
    var r = e.transformTemplate;
    t.style.transform = r ? r({}, "") : "none", n.scheduleRender();
  },
  restoreTransform: function restoreTransform(n, t) {
    n.style.transform = t.style.transform;
  },
  removeValueFromRenderState: function removeValueFromRenderState(n, t) {
    var e = t.vars,
        r = t.style;
    delete e[n], delete r[n];
  },
  makeTargetAnimatable: function makeTargetAnimatable(n, t, e, r) {
    var o = e.transformValues;
    void 0 === r && (r = !0);

    var i = t.transition,
        a = t.transitionEnd,
        u = Ye(t, ["transition", "transitionEnd"]),
        s = function (n, t, e) {
      var r,
          o,
          i = {};

      for (var a in n) {
        i[a] = null !== (r = _u(a, t)) && void 0 !== r ? r : null === (o = e.getValue(a)) || void 0 === o ? void 0 : o.get();
      }

      return i;
    }(u, i || {}, n);

    if (o && (a && (a = o(a)), u && (u = o(u)), s && (s = o(s))), r) {
      !function (n, t, e) {
        var r,
            o,
            i,
            a,
            u = Object.keys(t).filter(function (t) {
          return !n.hasValue(t);
        }),
            s = u.length;
        if (s) for (var c = 0; c < s; c++) {
          var l = u[c],
              f = t[l],
              p = null;
          Array.isArray(f) && (p = f[0]), null === p && (p = null !== (o = null !== (r = e[l]) && void 0 !== r ? r : n.readValue(l)) && void 0 !== o ? o : t[l]), null != p && ("string" == typeof p && fu(p) ? p = parseFloat(p) : !xu(p) && fo.test(f) && (p = eu(l, f)), n.addValue(l, mu(p)), null !== (i = (a = e)[l]) && void 0 !== i || (a[l] = p), n.setBaseTarget(l, p));
        }
      }(n, u, s);
      var c = Oc(n, u, s, a);
      a = c.transitionEnd, u = c.target;
    }

    return _We({
      transition: i,
      transitionEnd: a
    }, u);
  },
  scrapeMotionValuesFromProps: Fo,
  build: function build(n, t, e, r, o, i, a) {
    void 0 !== n.isVisible && (t.style.visibility = n.isVisible ? "visible" : "hidden");
    var u = r.isEnabled && o.isHydrated;
    bo(t, e, r, o, i, a.transformTemplate, u ? uc : void 0, u ? sc : void 0);
  },
  render: Mo
},
    Rc = dc(kc),
    Nc = dc(_We(_We({}, kc), {
  getBaseTarget: function getBaseTarget(n, t) {
    return n[t];
  },
  readValueFromInstance: function readValueFromInstance(n, t) {
    var e;
    return Lr(t) ? (null === (e = tu(t)) || void 0 === e ? void 0 : e.default) || 0 : (t = Bo.has(t) ? t : jo(t), n.getAttribute(t));
  },
  scrapeMotionValuesFromProps: Wo,
  build: function build(n, t, e, r, o, i, a) {
    var u = r.isEnabled && o.isHydrated;
    Ro(t, e, r, o, i, a.transformTemplate, u ? uc : void 0, u ? sc : void 0);
  },
  render: Vo
})),
    zc = function zc(n, t) {
  return _r(n) ? Nc(t, {
    enableHardwareAcceleration: !1
  }) : Rc(t, {
    enableHardwareAcceleration: !0
  });
},
    Ic = _We(_We(_We(_We({}, zu), Ya), js), oc),
    Dc = xr(function (n, t) {
  return function (n, t, e, r) {
    var o = t.forwardMotionProps,
        i = void 0 !== o && o,
        a = _r(n) ? Ko : Jo;
    return _We(_We({}, a), {
      preloadedFeatures: e,
      useRender: Io(i),
      createVisualElement: r,
      Component: n
    });
  }(n, t, Ic, zc);
});

var jc = 0;

function Mc() {
  var n = jc;
  return jc++, n;
}

var Bc = function Bc(t) {
  var e = t.children,
      r = t.initial,
      o = t.isPresent,
      i = t.onExitComplete,
      a = t.custom,
      u = t.presenceAffectsLayout,
      s = er(Vc),
      c = er(Mc),
      l = p(function () {
    return {
      id: c,
      initial: r,
      isPresent: o,
      custom: a,
      onExitComplete: function onExitComplete(n) {
        s.set(n, !0);
        var t = !0;
        s.forEach(function (n) {
          n || (t = !1);
        }), t && (null == i || i());
      },
      register: function register(n) {
        return s.set(n, !1), function () {
          return s.delete(n);
        };
      }
    };
  }, u ? void 0 : [o]);
  return p(function () {
    s.forEach(function (n, t) {
      return s.set(t, !1);
    });
  }, [o]), n.useEffect(function () {
    !o && !s.size && (null == i || i());
  }, [o]), n.createElement(tr.Provider, {
    value: l
  }, e);
};

function Vc() {
  return new Map();
}

function Fc(n) {
  return n.key || "";
}

var Wc,
    Yc,
    Hc,
    Uc,
    $c,
    Xc,
    qc,
    Gc,
    Kc,
    Zc,
    Jc = function Jc(t) {
  var e = t.children,
      i = t.custom,
      a = t.initial,
      u = void 0 === a || a,
      s = t.onExitComplete,
      c = t.exitBeforeEnter,
      l = t.presenceAffectsLayout,
      p = void 0 === l || l,
      g = function () {
    var n = o(!1),
        t = He(d(0), 2),
        e = t[0],
        r = t[1];
    return wi(function () {
      return n.current = !0;
    }), f(function () {
      !n.current && r(e + 1);
    }, [e]);
  }(),
      y = r(nc);

  ec(y) && (g = y.forceUpdate);

  var w = o(!0),
      x = function (n) {
    var t = [];
    return v.forEach(n, function (n) {
      m(n) && t.push(n);
    }), t;
  }(e),
      S = o(x),
      _ = o(new Map()).current,
      E = o(new Set()).current;

  if (function (n, t) {
    var e = "production" !== b.env.NODE_ENV ? new Set() : null;
    n.forEach(function (n) {
      var r = Fc(n);
      "production" !== b.env.NODE_ENV && e && (e.has(r) && console.warn('Children of AnimatePresence require unique keys. "' + r + '" is a duplicate.'), e.add(r)), t.set(r, n);
    });
  }(x, _), w.current) return w.current = !1, n.createElement(n.Fragment, null, x.map(function (t) {
    return n.createElement(Bc, {
      key: Fc(t),
      isPresent: !0,
      initial: !!u && void 0,
      presenceAffectsLayout: p
    }, t);
  }));

  for (var T = Ue([], He(x)), P = S.current.map(Fc), C = x.map(Fc), A = P.length, L = 0; L < A; L++) {
    var O = P[L];
    -1 === C.indexOf(O) ? E.add(O) : E.delete(O);
  }

  return c && E.size && (T = []), E.forEach(function (t) {
    if (-1 === C.indexOf(t)) {
      var e = _.get(t);

      if (e) {
        var r = P.indexOf(t);
        T.splice(r, 0, n.createElement(Bc, {
          key: Fc(e),
          isPresent: !1,
          onExitComplete: function onExitComplete() {
            _.delete(t), E.delete(t);
            var n = S.current.findIndex(function (n) {
              return n.key === t;
            });
            S.current.splice(n, 1), E.size || (S.current = x, g(), s && s());
          },
          custom: i,
          presenceAffectsLayout: p
        }, e));
      }
    }
  }), T = T.map(function (t) {
    var e = t.key;
    return E.has(e) ? t : n.createElement(Bc, {
      key: Fc(t),
      isPresent: !0,
      presenceAffectsLayout: p
    }, t);
  }), S.current = T, "production" !== b.env.NODE_ENV && c && T.length > 1 && console.warn("You're attempting to animate multiple children within AnimatePresence, but its exitBeforeEnter prop is set to true. This will lead to odd visual behaviour."), n.createElement(n.Fragment, null, E.size ? T : T.map(function (n) {
    return h(n);
  }));
},
    Qc = Be(Dc.div)(Wc || (Wc = jn(["\n  background-color: ", ";\n  position: fixed;\n  width: 100%;\n  height: 100vh;\n  height: calc(var(--vh, 1vh) * 100);\n  top: 0;\n  left: 0;\n  z-index: 9999;\n"])), function (n) {
  return n.overlayColor;
}),
    nl = {
  visible: {
    opacity: 1
  },
  hidden: {
    opacity: 0
  }
},
    tl = function tl(n) {
  var e = n.isOpened,
      o = n.children,
      i = n.className,
      a = r(En).options,
      u = t.createElement(Qc, {
    id: "SRLLightbox",
    initial: "hidden",
    animate: "visible",
    exit: "hidden",
    variants: nl,
    overlayColor: a.settings.overlayColor,
    transition: {
      duration: a.settings.lightboxTransitionSpeed,
      ease: a.settings.lightboxTransitionTimingFunction
    },
    className: i
  }, o);
  return e && "undefined" != typeof window ? w.createPortal(u, document.body) : null;
};

function el(n) {
  return (el = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (n) {
    return typeof n;
  } : function (n) {
    return n && "function" == typeof Symbol && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  })(n);
}

tl.propTypes = {
  selector: mn.string,
  isOpened: mn.bool,
  children: mn.oneOfType([mn.arrayOf(mn.node), mn.node]).isRequired
};

var rl = function rl(n) {
  return Te(Yc || (Yc = jn(["\n  flex-direction: column;\n  -ms-grid-column: 2;\n  grid-column-start: 2;\n  -ms-grid-row: 1;\n  grid-row-start: 1;\n  -ms-grid-row-span: 2;\n  grid-row-end: 3;\n  height: 100%;\n  width: auto;\n\n  /* SAFARI HACK */\n  @media not all and (min-resolution: 0.001dpcm) {\n    @media {\n      height: 100vh;\n    }\n  }\n\n  /* IE 11 HACK **/\n  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n    height: 100vh;\n  }\n"])));
},
    ol = function ol(n) {
  return Te(Hc || (Hc = jn(["\n  flex-direction: column;\n  -ms-grid-column: 1;\n  grid-column-start: 1;\n  -ms-grid-row: 1;\n  grid-row-start: 1;\n  -ms-grid-row-span: 2;\n  grid-row-end: 3;\n  height: 100%;\n  width: auto;\n\n  /* SAFARI HACK */\n  @media not all and (min-resolution: 0.001dpcm) {\n    @media {\n      height: 100vh;\n    }\n  }\n\n  /* IE 11 HACK **/\n  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n    height: 100vh;\n  }\n"])));
},
    il = Be.div(Uc || (Uc = jn(["\n  display: flex;\n  color: white;\n  height: auto;\n  width: 100vw;\n  justify-content: center;\n  overflow-x: hidden;\n  overflow-y: hidden;\n  -webkit-overflow-scrolling: touch;\n  opacity: 1;\n  transition: 0.3s ease;\n  will-change: transform, opacity;\n  position: relative;\n  z-index: 9997;\n  cursor: pointer;\n  padding: ", ";\n  background-color: ", ";\n\n  /* Thumbnails alignment */\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  /* Thumbnails aligned to the right */\n  ", ";\n\n  /* Thumbnails aligned to the left */\n  ", ";\n\n  /* if the body has a class of SRLIdle */\n  .SRLIdle & {\n    opacity: 0;\n  }\n\n  /* if the thumbnails are draggable */\n  &.SRLDraggable {\n    cursor: grabbing;\n  }\n\n  @media (max-width: 768px) {\n    justify-content: start;\n    overflow: scroll !important;\n    flex-direction: row;\n    width: 100vw !important;\n    height: auto;\n    grid-column: auto;\n    grid-row: auto;\n  }\n"])), function (n) {
  return n.thumbnailsContainerPadding ? n.thumbnailsContainerPadding : "0";
}, function (n) {
  return n.thumbnailsContainerBackgroundColor ? n.thumbnailsContainerBackgroundColor : "transparent";
}, function (n) {
  return "start" === n.thumbnailsAlignment && Te($c || ($c = jn(["\n      justify-content: flex-start;\n    "])));
}, function (n) {
  return "end" === n.thumbnailsAlignment && Te(Xc || (Xc = jn(["\n      justify-content: flex-end;\n    "])));
}, function (n) {
  return "space-between" === n.thumbnailsAlignment && Te(qc || (qc = jn(["\n      justify-content: space-between;\n    "])));
}, function (n) {
  return "space-evenly" === n.thumbnailsAlignment && Te(Gc || (Gc = jn(["\n      justify-content: space-evenly;\n    "])));
}, function (n) {
  return "right" === n.thumbnailsPosition && rl;
}, function (n) {
  return "left" === n.thumbnailsPosition && ol;
}),
    al = Be.a(Kc || (Kc = jn(["\n  width: ", ";\n  height: ", ";\n  background-repeat: no-repeat;\n  background-size: cover;\n  margin: ", ";\n  opacity: ", ";\n  transition: 0.3s ease;\n  will-change: opacity;\n  display: block;\n  cursor: draggable;\n  flex: 0 0 auto;\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  &.SRLThumbnailSelected {\n    opacity: 1;\n  }\n\n  @media (max-width: 768px) {\n    height: 60px;\n    width: 80px;\n  }\n"])), function (n) {
  return n.thumbnailsSize ? n.thumbnailsSize[0] : "80px";
}, function (n) {
  return n.thumbnailsSize ? n.thumbnailsSize[1] : "80px";
}, function (n) {
  return n.thumbnailsGap ? n.thumbnailsGap : "1px";
}, function (n) {
  return n.thumbnailsOpacity ? n.thumbnailsOpacity : "0.4";
}),
    ul = Be.svg(Zc || (Zc = jn(["\n  width: ", ";\n  height: ", ";\n  opacity: ", ";\n"])), function (n) {
  return n.thumbnailsSize ? n.thumbnailsSize[0] / 2 : "40px";
}, function (n) {
  return n.thumbnailsSize ? n.thumbnailsSize[1] / 2 : "40px";
}, function (n) {
  return n.thumbnailsOpacity ? n.thumbnailsOpacity : "0.4";
});

function sl(n) {
  var e = n.thumbnailsIconColor;
  return t.createElement(ul, {
    "aria-hidden": "true",
    "data-prefix": "fas",
    "data-icon": "play-circle",
    className: "SRLThumbIcon",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512"
  }, t.createElement("path", {
    fill: e,
    className: "SRLThumbIcon",
    d: "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm115.7 272l-176 101c-15.8 8.8-35.7-2.5-35.7-21V152c0-18.4 19.8-29.8 35.7-21l176 107c16.4 9.2 16.4 32.9 0 42z"
  }));
}

sl.propTypes = {
  thumbnailsIconColor: mn.string
};

var cl,
    ll,
    fl,
    pl = function pl(n) {
  var e = n.elements,
      r = n.currentId,
      a = n.handleCurrentElement,
      u = n.thumbnails,
      s = n.SRLThumbnailsRef,
      c = u.thumbnailsOpacity,
      l = u.thumbnailsSize,
      f = u.thumbnailsPosition,
      p = u.thumbnailsAlignment,
      d = u.thumbnailsContainerBackgroundColor,
      h = u.thumbnailsContainerPadding,
      v = u.thumbnailsGap,
      m = u.thumbnailsIconColor,
      g = o(0),
      y = o(0),
      b = o(0),
      w = o(0),
      x = o(0),
      S = o();
  return i(function () {
    var n = s.current,
        t = document.querySelector(".SRLThumb".concat(r));

    if (t) {
      var e = t.getBoundingClientRect();
      n.scrollWidth > n.offsetWidth || n.scrollHeight > n.offsetHeight ? n.style.justifyContent = "start" : n.style.justifyContent = p || "center", n.scrollWidth > n.offsetWidth ? "scrollBehavior" in document.documentElement.style ? n.scrollBy({
        top: 0,
        left: e.left,
        behavior: "smooth"
      }) : n.scrollLeft = 80 * parseInt(r) : n.scrollHeight > n.offsetHeight && ("scrollBehavior" in document.documentElement.style ? n.scrollBy({
        top: e.top,
        left: 0,
        behavior: "smooth"
      }) : n.scrollTop = e.top);
    }

    function o(t, e) {
      n.scrollWidth > n.offsetWidth ? (g.current = !0, y.current = t - n.offsetLeft, w.current = n.scrollLeft, n.classList.add("SRLDraggable")) : n.scrollHeight > n.offsetHeight && (g.current = !0, b.current = e - n.offsetTop, x.current = n.scrollTop, n.classList.add("SRLDraggable"));
    }

    function i() {
      g.current = !1, n.classList.remove("SRLDraggable");
    }

    function u(t, e) {
      if (g.current) if (n.scrollHeight > n.offsetHeight) {
        var r = e - n.offsetTop - b.current;
        n.scrollTop = x.current - r;
      } else {
        var o = t - n.offsetLeft - y.current;
        n.scrollLeft = w.current - o;
      }
    }

    return S.current = function (t, e, o) {
      (n.scrollWidth > n.offsetWidth || n.scrollHeight > n.offsetHeight) && Math.trunc(t) !== Math.trunc(y.current) && Math.trunc(e) !== Math.trunc(b.current) || a(o, r);
    }, n.addEventListener("mousedown", function (n) {
      return o(n.pageX, n.pageY);
    }), n.addEventListener("mouseleave", function () {
      return i();
    }), n.addEventListener("mouseup", function () {
      return i();
    }), n.addEventListener("mousemove", function (n) {
      return u(n.pageX, n.pageY);
    }), function () {
      n.removeEventListener("mousedown", function (n) {
        return o(n.pageX);
      }), n.removeEventListener("mouseleave", function () {
        return i();
      }), n.removeEventListener("mouseup", function () {
        return i();
      }), n.removeEventListener("mousemove", function (n) {
        return u(n);
      });
    };
  }, [r, a, s, p]), t.createElement(il, {
    ref: s,
    thumbnailsPosition: f,
    thumbnailsSize: l,
    thumbnailsAlignment: p,
    thumbnailsContainerBackgroundColor: d,
    thumbnailsContainerPadding: h,
    className: "SRLThumbnailsContainer"
  }, e.map(function (n) {
    return t.createElement(al, {
      onClick: function onClick(t) {
        return S.current(t.pageX, t.pageY, n.id);
      },
      thumbnailsOpacity: c,
      thumbnailsSize: l,
      thumbnailsGap: v,
      key: n.id,
      id: n.id,
      className: "SRLThumb SRLThumb".concat(n.id, " ").concat(r === n.id ? "SRLThumbnailSelected" : ""),
      style: {
        backgroundImage: "url('".concat(n.thumbnail, "')")
      }
    }, ("video" === n.type || "embed_video" === n.type) && t.createElement(sl, {
      thumbnailsIconColor: m
    }));
  }));
};

pl.propTypes = {
  elements: mn.array,
  handleCurrentElement: mn.func,
  currentId: mn.string,
  SRLThumbnailsRef: mn.object,
  thumbnails: mn.shape({
    thumbnailsAlignment: mn.string,
    thumbnailsContainerBackgroundColor: mn.string,
    thumbnailsContainerPadding: mn.string,
    thumbnailsGap: mn.string,
    thumbnailsIconColor: mn.string,
    thumbnailsOpacity: mn.number,
    thumbnailsPosition: mn.string,
    thumbnailsSize: mn.array
  })
};

var dl = Be.div(cl || (cl = jn(["\n  color: white;\n  font-family: inherit;\n  outline: none;\n  border: 0;\n  position: relative;\n  z-index: 9996;\n  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n    width: 100vw;\n  }\n  width: 100%;\n  min-height: 50px;\n  box-sizing: border-box;\n  display: flex;\n  justify-content: center;\n  align-content: ", ";\n  padding: ", ";\n\n  ", ";\n\n  /* Thumbnails aligned to the left */\n  ", ";\n\n  @media (max-width: 768px) {\n    grid-column: auto;\n  }\n\n  /* Paragraph inside the caption container */\n  p {\n    margin: 0;\n    text-align: center;\n    font-weight: ", ";\n    font-size: ", ";\n    font-family: ", ";\n    color: ", ";\n    font-style: ", ";\n    text-transform: ", ";\n\n    @media (max-width: 768px) {\n      font-size: 14px;\n      padding: 0 15px;\n    }\n  }\n"])), function (n) {
  return n.captionAlignment;
}, function (n) {
  return n.captionStyle.captionContainerPadding ? n.captionStyle.captionContainerPadding : "20px 0 30px 0";
}, function (n) {
  return "right" === n.thumbnailsPosition && Te(ll || (ll = jn(["\n      grid-column: 1/2;\n      -ms-grid-column: 1;\n      -ms-grid-column-span: 1;\n      align-items: start;\n    "])));
}, function (n) {
  return "left" === n.thumbnailsPosition && Te(fl || (fl = jn(["\n      grid-column: 2/2;\n      -ms-grid-column: 2;\n      align-items: start;\n    "])));
}, function (n) {
  return n.captionStyle.captionFontWeight ? n.captionStyle.captionFontWeight : "inherit";
}, function (n) {
  return n.captionStyle.captionFontSize ? n.captionStyle.captionFontSize : "inherit";
}, function (n) {
  return n.captionStyle.captionColor ? n.captionStyle.captionFontFamily : "inherit";
}, function (n) {
  return n.captionStyle.captionColor ? n.captionStyle.captionColor : "white";
}, function (n) {
  return n.captionStyle.captionFontStyle ? n.captionStyle.captionFontStyle : "inherit";
}, function (n) {
  return n.captionStyle.captionTextTransform ? n.captionStyle.captionTextTransform : "inherit";
}),
    hl = function hl(n) {
  var e = n.captionOptions,
      r = n.caption,
      o = n.thumbnailsPosition,
      i = n.SRLCaptionRef;
  return t.createElement(dl, {
    captionStyle: e,
    thumbnailsPosition: o,
    className: "SRLCaptionContainer",
    ref: i
  }, t.createElement("p", {
    className: "SRLCaptionText"
  }, r));
};

function vl() {
  return (vl = Object.assign || function (n) {
    for (var t = 1; t < arguments.length; t++) {
      var e = arguments[t];

      for (var r in e) {
        Object.prototype.hasOwnProperty.call(e, r) && (n[r] = e[r]);
      }
    }

    return n;
  }).apply(this, arguments);
}

hl.propTypes = {
  captionOptions: mn.shape({
    showCaption: mn.bool,
    captionColor: mn.string,
    captionFontFamily: mn.string,
    captionFontSize: mn.string,
    captionFontStyle: mn.string,
    captionFontWeight: mn.oneOfType([mn.number, mn.string]),
    captionTextTransform: mn.string
  }),
  SRLCaptionRef: mn.object,
  thumbnailsPosition: mn.string,
  caption: mn.string
};
var ml = {
  delta: 10,
  preventDefaultTouchmoveEvent: !1,
  rotationAngle: 0,
  trackMouse: !1,
  trackTouch: !0
},
    gl = {
  first: !0,
  initial: [0, 0],
  start: 0,
  swiping: !1,
  xy: [0, 0]
};

function yl(n, t) {
  if (0 === t) return n;
  var e = Math.PI / 180 * t;
  return [n[0] * Math.cos(e) + n[1] * Math.sin(e), n[1] * Math.cos(e) - n[0] * Math.sin(e)];
}

function bl(t) {
  var e = t.trackMouse,
      r = n.useRef(vl({}, gl)),
      o = n.useRef(vl({}, ml));
  o.current = vl({}, ml, t);
  var i = n.useMemo(function () {
    return function (n, t) {
      var e = function e(t) {
        t && "touches" in t && t.touches.length > 1 || n(function (n, e) {
          e.trackMouse && (document.addEventListener("mousemove", r), document.addEventListener("mouseup", a));
          var o = "touches" in t ? t.touches[0] : t,
              i = yl([o.clientX, o.clientY], e.rotationAngle);
          return vl({}, n, gl, {
            initial: [].concat(i),
            xy: i,
            start: t.timeStamp || 0
          });
        });
      },
          r = function r(t) {
        n(function (n, e) {
          if ("touches" in t && t.touches.length > 1) return n;

          var r = "touches" in t ? t.touches[0] : t,
              o = yl([r.clientX, r.clientY], e.rotationAngle),
              i = o[0],
              a = o[1],
              u = i - n.xy[0],
              s = a - n.xy[1],
              c = Math.abs(u),
              l = Math.abs(s),
              f = (t.timeStamp || 0) - n.start,
              p = Math.sqrt(c * c + l * l) / (f || 1),
              d = [u / (f || 1), s / (f || 1)],
              h = function (n, t, e, r) {
            return n > t ? e > 0 ? "Right" : "Left" : r > 0 ? "Down" : "Up";
          }(c, l, u, s),
              v = "number" == typeof e.delta ? e.delta : e.delta[h.toLowerCase()] || ml.delta;

          if (c < v && l < v && !n.swiping) return n;
          var m = {
            absX: c,
            absY: l,
            deltaX: u,
            deltaY: s,
            dir: h,
            event: t,
            first: n.first,
            initial: n.initial,
            velocity: p,
            vxvy: d
          };
          m.first && e.onSwipeStart && e.onSwipeStart(m), e.onSwiping && e.onSwiping(m);
          var g = !1;
          return (e.onSwiping || e.onSwiped || "onSwiped" + h in e) && (g = !0), g && e.preventDefaultTouchmoveEvent && e.trackTouch && t.cancelable && t.preventDefault(), vl({}, n, {
            first: !1,
            eventData: m,
            swiping: !0
          });
        });
      },
          o = function o(t) {
        n(function (n, e) {
          var r;

          if (n.swiping && n.eventData) {
            r = vl({}, n.eventData, {
              event: t
            }), e.onSwiped && e.onSwiped(r);
            var o = e["onSwiped" + r.dir];
            o && o(r);
          } else e.onTap && e.onTap({
            event: t
          });

          return vl({}, n, gl, {
            eventData: r
          });
        });
      },
          i = function i() {
        document.removeEventListener("mousemove", r), document.removeEventListener("mouseup", a);
      },
          a = function a(n) {
        i(), o(n);
      },
          u = function u(n, t) {
        var i = function i() {};

        if (n && n.addEventListener) {
          var a = [["touchstart", e], ["touchmove", r], ["touchend", o]];
          a.forEach(function (e) {
            var r = e[0],
                o = e[1];
            return n.addEventListener(r, o, {
              passive: t
            });
          }), i = function i() {
            return a.forEach(function (t) {
              var e = t[0],
                  r = t[1];
              return n.removeEventListener(e, r);
            });
          };
        }

        return i;
      },
          s = {
        ref: function ref(t) {
          null !== t && n(function (n, e) {
            if (n.el === t) return n;
            var r = {};
            return n.el && n.el !== t && n.cleanUpTouch && (n.cleanUpTouch(), r.cleanUpTouch = void 0), e.trackTouch && t && (r.cleanUpTouch = u(t, !e.preventDefaultTouchmoveEvent)), vl({}, n, {
              el: t
            }, r);
          });
        }
      };

      return t.trackMouse && (s.onMouseDown = e), [s, u];
    }(function (n) {
      return r.current = n(r.current, o.current);
    }, {
      trackMouse: e
    });
  }, [e]),
      a = i[0],
      u = i[1];
  return r.current = function (n, t, e) {
    var r = {};
    return !t.trackTouch && n.cleanUpTouch ? (n.cleanUpTouch(), r.cleanUpTouch = void 0) : t.trackTouch && !n.cleanUpTouch && n.el && (r.cleanUpTouch = e(n.el, !t.preventDefaultTouchmoveEvent)), vl({}, n, r);
  }(r.current, o.current, u), a;
}

function wl(n, t, e) {
  var r = this,
      a = o(null),
      u = o(0),
      s = o(null),
      c = o([]),
      l = o(),
      f = o(),
      d = o(n),
      h = o(!0);
  d.current = n;
  var v = !t && 0 !== t && "undefined" != typeof window;
  if ("function" != typeof n) throw new TypeError("Expected a function");
  t = +t || 0;
  var m = !!(e = e || {}).leading,
      g = !("trailing" in e) || !!e.trailing,
      y = ("maxWait" in e),
      b = y ? Math.max(+e.maxWait || 0, t) : null;
  return i(function () {
    return h.current = !0, function () {
      h.current = !1;
    };
  }, []), p(function () {
    var n = function n(_n2) {
      var t = c.current,
          e = l.current;
      return c.current = l.current = null, u.current = _n2, f.current = d.current.apply(e, t);
    },
        e = function e(n, t) {
      v && cancelAnimationFrame(s.current), s.current = v ? requestAnimationFrame(n) : setTimeout(n, t);
    },
        o = function o(n) {
      if (!h.current) return !1;
      var e = n - a.current,
          r = n - u.current;
      return !a.current || e >= t || e < 0 || y && r >= b;
    },
        i = function i(t) {
      return s.current = null, g && c.current ? n(t) : (c.current = l.current = null, f.current);
    },
        p = function p() {
      var n = Date.now();
      if (o(n)) return i(n);

      if (h.current) {
        var r = n - a.current,
            s = n - u.current,
            c = t - r,
            l = y ? Math.min(c, b - s) : c;
        e(p, l);
      }
    },
        w = function w() {
      for (var i = [], d = 0; d < arguments.length; d++) {
        i[d] = arguments[d];
      }

      var v = Date.now(),
          g = o(v);

      if (c.current = i, l.current = r, a.current = v, g) {
        if (!s.current && h.current) return u.current = a.current, e(p, t), m ? n(a.current) : f.current;
        if (y) return e(p, t), n(a.current);
      }

      return s.current || e(p, t), f.current;
    };

    return w.cancel = function () {
      s.current && (v ? cancelAnimationFrame(s.current) : clearTimeout(s.current)), u.current = 0, c.current = a.current = l.current = s.current = null;
    }, w.isPending = function () {
      return !!s.current;
    }, w.flush = function () {
      return s.current ? i(Date.now()) : f.current;
    }, w;
  }, [m, y, t, b, g, v]);
}

var xl = {
  exports: {}
};
!function (n, t) {
  !function () {
    function t(n, t, e, r) {
      var o = "removeEventListener",
          i = function i() {
        n[o](t, e);
      };

      return n.addEventListener ? (n.addEventListener(t, e, r), i) : n.attachEvent ? (t = "on" + t, n.attachEvent(t, e), o = "detachEvent", i) : n.on ? (n.on(t, e), o = "off", i) : void 0;
    }

    t.define = function (n, t) {
      return function (e, r, o, i) {
        return e[n](r, o, i), function () {
          e[t](r, o);
        };
      };
    }, n.exports = t;
  }();
}(xl);

var Sl,
    _l,
    El,
    Tl,
    Pl,
    Cl,
    Al,
    Ll = xl.exports;

function Ol() {
  var n = r(En);
  return {
    openLightbox: function openLightbox() {
      var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0;
      n.isLoaded && n.dispatch({
        type: "OPEN_AT_INDEX",
        index: t
      });
    },
    closeLightbox: function closeLightbox() {
      n.isLoaded && n.dispatch({
        type: "CLOSE_LIGHTBOX"
      });
    }
  };
}

function kl(n, t, e) {
  var r = o();
  i(function () {
    r.current = n;
  }, [n, e]), i(function () {
    if (null !== t) {
      var n = setInterval(function () {
        r.current();
      }, t);
      return function () {
        return clearInterval(n);
      };
    }
  }, [t, e]);
}

function Rl(n) {
  var t = bn(d({
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    scrollHeight: 0,
    scrollWidth: 0
  }), 2),
      e = t[0],
      r = t[1],
      o = "object" === ("undefined" == typeof window ? "undefined" : el(window));
  return i(function () {
    if (n.current || o) return n.current && r(t()), window.addEventListener("resize", e), function () {
      return window.removeEventListener("resize", e);
    };

    function t() {
      var t = n.current.getBoundingClientRect(),
          e = t.x,
          r = t.y,
          o = t.width,
          i = t.height,
          a = t.top,
          u = t.left,
          s = t.bottom,
          c = t.right;
      return {
        width: o,
        height: i,
        scrollWidth: n.current.scrollWidth,
        scrollHeight: n.current.scrollHeight,
        x: e,
        y: r,
        top: a,
        left: u,
        bottom: s,
        right: c
      };
    }

    function e() {
      n.current && r(t());
    }
  }, [n, o]), [e];
}

var Nl = function Nl(n) {
  return Te(Sl || (Sl = jn(["\n  grid-column: 1/2;\n  -ms-grid-column: 1;\n  -ms-grid-column-span: 1;\n  width: 100%;\n  height: calc(100vh - ", "px);\n"])), n.captionDivSizes.height);
},
    zl = function zl(n) {
  return Te(_l || (_l = jn(["\n  grid-column: 2/2;\n  -ms-grid-column: 2;\n  width: 100%;\n  height: calc(100vh - ", "px);\n"])), n.captionDivSizes.height);
},
    Il = Be.div(El || (El = jn(["\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  outline: none;\n  width: 100vw;\n  height: ", ";\n\n  /* Thumbnails aligned to the right.\n  We need to exclude the height of the div containing the thumbnails this time */\n  ", ";\n\n  /* Thumbnails aligned to the left.\n    We need to exclude the height of the div containing the thumbnails this time */\n  ", ";\n  /* Thumbnails hidden */\n  ", ";\n\n  @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (-webkit-min-device-pixel-ratio: 2) {\n    grid-column: auto;\n    width: 100vw;\n    height: ", ";\n  }\n\n  @media only screen and (min-device-width: 1024px) and (max-device-width: 1366px) {\n    grid-column: auto;\n    width: 100vw;\n    height: ", ";\n  }\n\n  @media (max-width: 768px) {\n    grid-column: auto;\n    width: 100vw;\n    height: ", ";\n  }\n"])), function (n) {
  return n ? "calc(100vh - ".concat(n.captionDivSizes.height + n.thumbnailsDivSizes.height, "px)") : "100%";
}, function (n) {
  return "right" === n.thumbnailsPosition && Nl;
}, function (n) {
  return "left" === n.thumbnailsPosition && zl;
}, function (n) {
  return n.hideThumbnails && "bottom" === n.thumbnailsPosition && Te(Tl || (Tl = jn(["\n      height: calc(100vh - ", "px);\n    "])), n.thumbnailsDivSizes.height);
}, function (n) {
  return n ? "calc((var(--vh, 1vh) * 100) - ".concat(n.captionDivSizes.height + n.thumbnailsDivSizes.height, "px)") : "100%";
}, function (n) {
  return n ? "calc((var(--vh, 1vh) * 100) - ".concat(n.captionDivSizes.height + n.thumbnailsDivSizes.height, "px)") : "100%";
}, function (n) {
  return n ? "calc((var(--vh, 1vh) * 100) - ".concat(n.captionDivSizes.height + n.thumbnailsDivSizes.height, "px)") : "100%";
}),
    Dl = Be(Dc.div)(Pl || (Pl = jn(["\n  width: 100%;\n  height: 90%;\n  position: absolute;\n  /* IE 11 HACK **/\n  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n    top: 5%;\n    left: 0;\n  }\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  outline: none;\n  border: 0;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n\n  @keyframes spin {\n    0% {\n      transform: rotate(0deg);\n    }\n    100% {\n      transform: rotate(360deg);\n    }\n  }\n\n  .SRLLoadingIndicator {\n    animation: spin 1.2s linear infinite;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n  }\n\n  /* react-zoom-pan-pinch library styles overrides*/\n  .react-transform-component {\n    width: fit-content;\n    width: auto;\n    height: fit-content;\n    height: auto;\n    z-index: 9997;\n    overflow: inherit;\n    cursor: grab;\n  }\n  .react-transform-element {\n    width: fit-content;\n    width: auto;\n    height: fit-content;\n    height: auto;\n    top: 0;\n    left: 0;\n    position: relative;\n\n    z-index: 9997;\n    display: block;\n    max-width: 100%;\n    max-height: 100%;\n    width: auto;\n    height: auto;\n  }\n"]))),
    jl = Be(Dc.img)(Cl || (Cl = jn(["\n  background: transparent;\n  border: 0;\n  position: relative;\n  display: block;\n  max-width: 100%;\n  max-height: 100%;\n  width: auto;\n  height: auto;\n  outline: none;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  transition: all 200ms ease;\n  opacity: 1;\n  margin: auto;\n  z-index: 9997;\n  box-shadow: ", ";\n  cursor: ", ";\n"])), function (n) {
  return n.boxShadow;
}, function (n) {
  return n.disablePanzoom ? "auto" : "zoom-in";
}),
    Ml = Be(Dc.img)(Al || (Al = jn(["\n  top: 0;\n  left: 0;\n  position: relative;\n  z-index: 9997;\n  display: block;\n  max-width: 100%;\n  max-height: 100%;\n  width: auto;\n  height: auto;\n"])));

function Bl() {
  return t.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "50px",
    height: "50px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    className: "SRLLoadingIndicator"
  }, t.createElement("circle", {
    cx: "50",
    cy: "50",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: "10",
    r: "35",
    strokeDasharray: "164.93361431346415 56.97787143782138"
  }));
}
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */


var _Vl = function Vl(n, t) {
  return (_Vl = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (n, t) {
    n.__proto__ = t;
  } || function (n, t) {
    for (var e in t) {
      Object.prototype.hasOwnProperty.call(t, e) && (n[e] = t[e]);
    }
  })(n, t);
};

var _Fl = function Fl() {
  return (_Fl = Object.assign || function (n) {
    for (var t, e = 1, r = arguments.length; e < r; e++) {
      for (var o in t = arguments[e]) {
        Object.prototype.hasOwnProperty.call(t, o) && (n[o] = t[o]);
      }
    }

    return n;
  }).apply(this, arguments);
};

function Wl(n, t, e) {
  if (e || 2 === arguments.length) for (var r, o = 0, i = t.length; o < i; o++) {
    !r && o in t || (r || (r = Array.prototype.slice.call(t, 0, o)), r[o] = t[o]);
  }
  return n.concat(r || t);
}

var Yl = function Yl(n, t) {
  return Number(n.toFixed(t));
},
    Hl = function Hl(n, t, e) {
  e && "function" == typeof e && e(n, t);
},
    Ul = {
  easeOut: function easeOut(n) {
    return -Math.cos(n * Math.PI) / 2 + .5;
  },
  linear: function linear(n) {
    return n;
  },
  easeInQuad: function easeInQuad(n) {
    return n * n;
  },
  easeOutQuad: function easeOutQuad(n) {
    return n * (2 - n);
  },
  easeInOutQuad: function easeInOutQuad(n) {
    return n < .5 ? 2 * n * n : (4 - 2 * n) * n - 1;
  },
  easeInCubic: function easeInCubic(n) {
    return n * n * n;
  },
  easeOutCubic: function easeOutCubic(n) {
    return --n * n * n + 1;
  },
  easeInOutCubic: function easeInOutCubic(n) {
    return n < .5 ? 4 * n * n * n : (n - 1) * (2 * n - 2) * (2 * n - 2) + 1;
  },
  easeInQuart: function easeInQuart(n) {
    return n * n * n * n;
  },
  easeOutQuart: function easeOutQuart(n) {
    return 1 - --n * n * n * n;
  },
  easeInOutQuart: function easeInOutQuart(n) {
    return n < .5 ? 8 * n * n * n * n : 1 - 8 * --n * n * n * n;
  },
  easeInQuint: function easeInQuint(n) {
    return n * n * n * n * n;
  },
  easeOutQuint: function easeOutQuint(n) {
    return 1 + --n * n * n * n * n;
  },
  easeInOutQuint: function easeInOutQuint(n) {
    return n < .5 ? 16 * n * n * n * n * n : 1 + 16 * --n * n * n * n * n;
  }
},
    $l = function $l(n) {
  "number" == typeof n && cancelAnimationFrame(n);
},
    Xl = function Xl(n) {
  n.mounted && ($l(n.animation), n.animate = !1, n.animation = null, n.velocity = null);
};

function ql(n, t, e, r) {
  if (n.mounted) {
    var o = new Date().getTime();
    Xl(n), n.animation = function () {
      if (!n.mounted) return $l(n.animation);
      var i = new Date().getTime() - o,
          a = (0, Ul[t])(i / e);
      i >= e ? (r(1), n.animation = null) : n.animation && (r(a), requestAnimationFrame(n.animation));
    }, requestAnimationFrame(n.animation);
  }
}

function Gl(n, t, e, r) {
  var o = function (n) {
    var t = n.scale,
        e = n.positionX,
        r = n.positionY;
    if (isNaN(t) || isNaN(e) || isNaN(r)) return !1;
    return !0;
  }(t);

  if (n.mounted && o) {
    var i = n.setTransformState,
        a = n.transformState,
        u = a.scale,
        s = a.positionX,
        c = a.positionY,
        l = t.scale - u,
        f = t.positionX - s,
        p = t.positionY - c;
    0 === e ? i(t.scale, t.positionX, t.positionY) : ql(n, r, e, function (n) {
      i(u + l * n, s + f * n, c + p * n);
    });
  }
}

var Kl = function Kl(n, t) {
  var e = n.wrapperComponent,
      r = n.contentComponent,
      o = n.setup.centerZoomedOut;
  if (!e || !r) throw new Error("Components are not mounted");

  var i = function (n, t, e) {
    var r = n.offsetWidth,
        o = n.offsetHeight,
        i = t.offsetWidth * e,
        a = t.offsetHeight * e;
    return {
      wrapperWidth: r,
      wrapperHeight: o,
      newContentWidth: i,
      newDiffWidth: r - i,
      newContentHeight: a,
      newDiffHeight: o - a
    };
  }(e, r, t),
      a = i.wrapperWidth,
      u = i.wrapperHeight;

  return function (n, t, e, r, o, i, a) {
    var u = n > t ? e * (a ? 1 : .5) : 0,
        s = r > o ? i * (a ? 1 : .5) : 0;
    return {
      minPositionX: n - t - u,
      maxPositionX: u,
      minPositionY: r - o - s,
      maxPositionY: s
    };
  }(a, i.newContentWidth, i.newDiffWidth, u, i.newContentHeight, i.newDiffHeight, Boolean(o));
},
    Zl = function Zl(n, t) {
  var e = Kl(n, t);
  return n.bounds = e, e;
};

function Jl(n, t, e, r, o, i, a) {
  var u = e.minPositionX,
      s = e.minPositionY,
      c = e.maxPositionX,
      l = e.maxPositionY,
      f = 0,
      p = 0;
  return a && (f = o, p = i), {
    x: Ql(n, u - f, c + f, r),
    y: Ql(t, s - p, l + p, r)
  };
}

var Ql = function Ql(n, t, e, r) {
  return Yl(r ? n < t ? t : n > e ? e : n : n, 2);
};

function nf(n, t, e, r, o, i) {
  var a = n.transformState,
      u = a.scale,
      s = a.positionX,
      c = a.positionY,
      l = r - u;
  return "number" != typeof t || "number" != typeof e ? (console.error("Mouse X and Y position were not provided!"), {
    x: s,
    y: c
  }) : Jl(s - t * l, c - e * l, o, i, 0, 0, null);
}

function tf(n, t, e, r, o) {
  var i = t - (o ? r : 0);
  return !isNaN(e) && n >= e ? e : !isNaN(t) && n <= i ? i : n;
}

var ef = function ef(n, t) {
  var e = n.setup.panning.excluded,
      r = n.isInitialized,
      o = n.wrapperComponent,
      i = t.target,
      a = null == o ? void 0 : o.contains(i);
  return !!(r && i && a) && !Of(i, e);
},
    rf = function rf(n) {
  var t = n.isInitialized,
      e = n.isPanning,
      r = n.setup.panning.disabled;
  return !(!t || !e || r);
};

var of = function of(n, t) {
  var e = n.setup,
      r = n.transformState.scale,
      o = e.minScale;
  return t > 0 && r >= o ? t : 0;
};

function af(n, t, e, r, o, i, a, u, s, c) {
  if (o) {
    var l;
    if (t > a && e > a) return (l = a + (n - a) * c) > s ? s : l < a ? a : l;
    if (t < i && e < i) return (l = i + (n - i) * c) < u ? u : l > i ? i : l;
  }

  return r ? t : Ql(n, i, a, o);
}

function uf(n, t) {
  if (function (n) {
    var t = n.mounted,
        e = n.setup,
        r = e.disabled,
        o = e.velocityAnimation,
        i = n.transformState.scale;
    return !(o.disabled && !(i > 1) && r && !t);
  }(n)) {
    var e = n.lastMousePosition,
        r = n.velocityTime,
        o = n.setup,
        i = n.wrapperComponent,
        a = o.velocityAnimation.equalToMove,
        u = Date.now();

    if (e && r && i) {
      var s = function (n, t) {
        return t ? Math.min(1, n.offsetWidth / window.innerWidth) : 1;
      }(i, a),
          c = t.x - e.x,
          l = t.y - e.y,
          f = c / s,
          p = l / s,
          d = u - r,
          h = c * c + l * l,
          v = Math.sqrt(h) / d;

      n.velocity = {
        velocityX: f,
        velocityY: p,
        total: v
      };
    }

    n.lastMousePosition = t, n.velocityTime = u;
  }
}

function sf(n, t) {
  var e = n.transformState.scale;
  Xl(n), Zl(n, e), t.touches ? function (n, t) {
    var e = t.touches,
        r = n.transformState,
        o = r.positionX,
        i = r.positionY;

    if (n.isPanning = !0, 1 === e.length) {
      var a = e[0].clientX,
          u = e[0].clientY;
      n.startCoords = {
        x: a - o,
        y: u - i
      };
    }
  }(n, t) : function (n, t) {
    var e = n.transformState,
        r = e.positionX,
        o = e.positionY;
    n.isPanning = !0;
    var i = t.clientX,
        a = t.clientY;
    n.startCoords = {
      x: i - r,
      y: a - o
    };
  }(n, t);
}

function cf(n, t, e) {
  var r = n.startCoords,
      o = n.setup.alignmentAnimation,
      i = o.sizeX,
      a = o.sizeY;

  if (r) {
    var u = function (n, t, e) {
      var r = n.startCoords,
          o = n.transformState,
          i = n.setup.panning,
          a = i.lockAxisX,
          u = i.lockAxisY,
          s = o.positionX,
          c = o.positionY;
      if (!r) return {
        x: s,
        y: c
      };
      var l = t - r.x,
          f = e - r.y;
      return {
        x: a ? s : l,
        y: u ? c : f
      };
    }(n, t, e),
        s = u.x,
        c = u.y,
        l = of(n, i),
        f = of(n, a);

    uf(n, {
      x: s,
      y: c
    }), function (n, t, e, r, o) {
      var i = n.setup.limitToBounds,
          a = n.wrapperComponent,
          u = n.bounds,
          s = n.transformState,
          c = s.scale,
          l = s.positionX,
          f = s.positionY;

      if (a && t !== l && e !== f && u) {
        var p = Jl(t, e, u, i, r, o, a),
            d = p.x,
            h = p.y;
        n.setTransformState(c, d, h);
      }
    }(n, s, c, l, f);
  }
}

function lf(n) {
  if (n.isPanning) {
    var t = n.setup.panning.velocityDisabled,
        e = n.velocity,
        r = n.wrapperComponent,
        o = n.contentComponent;
    n.isPanning = !1, n.animate = !1, n.animation = null;
    var i = null == r ? void 0 : r.getBoundingClientRect(),
        a = null == o ? void 0 : o.getBoundingClientRect(),
        u = (null == i ? void 0 : i.width) || 0,
        s = (null == i ? void 0 : i.height) || 0,
        c = (null == a ? void 0 : a.width) || 0,
        l = (null == a ? void 0 : a.height) || 0,
        f = u < c || s < l;
    !t && e && (null == e ? void 0 : e.total) > .1 && f ? function (n) {
      var t = n.velocity,
          e = n.bounds,
          r = n.setup,
          o = n.wrapperComponent;

      if (function (n) {
        var t = n.mounted,
            e = n.velocity,
            r = n.bounds,
            o = n.setup,
            i = o.disabled,
            a = o.velocityAnimation,
            u = n.transformState.scale;
        return !(a.disabled && !(u > 1) && i && !t || !e || !r);
      }(n) && t && e && o) {
        var i = t.velocityX,
            a = t.velocityY,
            u = t.total,
            s = e.maxPositionX,
            c = e.minPositionX,
            l = e.maxPositionY,
            f = e.minPositionY,
            p = r.limitToBounds,
            d = r.alignmentAnimation,
            h = r.zoomAnimation,
            v = r.panning,
            m = v.lockAxisY,
            g = v.lockAxisX,
            y = h.animationType,
            b = d.sizeX,
            w = d.sizeY,
            x = d.velocityAlignmentTime,
            S = function (n, t) {
          var e = n.setup.velocityAnimation,
              r = e.equalToMove,
              o = e.animationTime,
              i = e.sensitivity;
          return r ? o * t * i : o;
        }(n, u),
            _ = Math.max(S, x),
            E = of(n, b),
            T = of(n, w),
            P = E * o.offsetWidth / 100,
            C = T * o.offsetHeight / 100,
            A = s + P,
            L = c - P,
            O = l + C,
            k = f - C,
            R = n.transformState,
            N = new Date().getTime();

        ql(n, y, _, function (t) {
          var e = n.transformState,
              r = e.scale,
              o = e.positionX,
              u = e.positionY,
              h = (new Date().getTime() - N) / x,
              v = 1 - (0, Ul[d.animationType])(Math.min(1, h)),
              y = 1 - t,
              b = o + i * y,
              w = u + a * y,
              S = af(b, R.positionX, o, g, p, c, s, L, A, v),
              _ = af(w, R.positionY, u, m, p, f, l, k, O, v);

          o === b && u === w || n.setTransformState(r, S, _);
        });
      }
    }(n) : ff(n);
  }
}

function ff(n) {
  var t = n.transformState.scale,
      e = n.setup,
      r = e.minScale,
      o = e.alignmentAnimation,
      i = o.disabled,
      a = o.sizeX,
      u = o.sizeY,
      s = o.animationTime,
      c = o.animationType;

  if (!(i || t < r || !a && !u)) {
    var l = function (n) {
      var t = n.transformState,
          e = t.positionX,
          r = t.positionY,
          o = t.scale,
          i = n.setup,
          a = i.disabled,
          u = i.limitToBounds,
          s = i.centerZoomedOut,
          c = n.wrapperComponent;

      if (!a && c && n.bounds) {
        var l = n.bounds,
            f = l.maxPositionX,
            p = l.minPositionX,
            d = l.maxPositionY,
            h = l.minPositionY,
            v = e > f || e < p,
            m = r > d || r < h,
            g = nf(n, e > f ? c.offsetWidth : n.setup.minPositionX || 0, r > d ? c.offsetHeight : n.setup.minPositionY || 0, o, n.bounds, u || s),
            y = g.x,
            b = g.y;
        return {
          scale: o,
          positionX: v ? y : e,
          positionY: m ? b : r
        };
      }
    }(n);

    l && Gl(n, l, s, c);
  }
}

function pf(n, t, e) {
  var r = n.transformState.scale,
      o = n.wrapperComponent,
      i = n.setup,
      a = i.minScale,
      u = i.limitToBounds,
      s = i.zoomAnimation,
      c = s.disabled,
      l = s.animationTime,
      f = s.animationType,
      p = c || r >= a;

  if ((r >= 1 || u) && ff(n), !p && o && n.mounted) {
    var d = df(n, a, t || o.offsetWidth / 2, e || o.offsetHeight / 2);
    d && Gl(n, d, l, f);
  }
}

function df(n, t, e, r) {
  var o = n.setup,
      i = o.minScale,
      a = o.maxScale,
      u = o.limitToBounds,
      s = tf(Yl(t, 2), i, a, 0, !1),
      c = nf(n, e, r, s, Zl(n, s), u);
  return {
    scale: s,
    positionX: c.x,
    positionY: c.y
  };
}

var hf = {
  previousScale: 1,
  scale: 1,
  positionX: 0,
  positionY: 0
},
    vf = _Fl(_Fl({}, hf), {
  setComponents: function setComponents() {},
  contextInstance: null
}),
    mf = {
  disabled: !1,
  minPositionX: null,
  maxPositionX: null,
  minPositionY: null,
  maxPositionY: null,
  minScale: 1,
  maxScale: 8,
  limitToBounds: !0,
  centerZoomedOut: !1,
  centerOnInit: !1,
  wheel: {
    step: .2,
    disabled: !1,
    wheelDisabled: !1,
    touchPadDisabled: !1,
    activationKeys: [],
    excluded: []
  },
  panning: {
    disabled: !1,
    velocityDisabled: !1,
    lockAxisX: !1,
    lockAxisY: !1,
    activationKeys: [],
    excluded: []
  },
  pinch: {
    step: 5,
    disabled: !1,
    excluded: []
  },
  doubleClick: {
    disabled: !1,
    step: .7,
    mode: "zoomIn",
    animationType: "easeOut",
    animationTime: 200,
    excluded: []
  },
  zoomAnimation: {
    disabled: !1,
    size: .4,
    animationTime: 200,
    animationType: "easeOut"
  },
  alignmentAnimation: {
    disabled: !1,
    sizeX: 100,
    sizeY: 100,
    animationTime: 200,
    velocityAlignmentTime: 400,
    animationType: "easeOut"
  },
  velocityAnimation: {
    disabled: !1,
    sensitivity: 1,
    animationTime: 400,
    animationType: "easeOut",
    equalToMove: !0
  }
},
    gf = function gf(n) {
  var t, e, r, o;
  return {
    previousScale: null !== (t = n.initialScale) && void 0 !== t ? t : hf.scale,
    scale: null !== (e = n.initialScale) && void 0 !== e ? e : hf.scale,
    positionX: null !== (r = n.initialPositionX) && void 0 !== r ? r : hf.positionX,
    positionY: null !== (o = n.initialPositionY) && void 0 !== o ? o : hf.positionY
  };
},
    yf = function yf(n) {
  var t = _Fl({}, mf);

  return Object.keys(n).forEach(function (e) {
    var r = void 0 !== n[e];

    if (void 0 !== mf[e] && r) {
      var o = Object.prototype.toString.call(mf[e]),
          i = "[object Object]" === o,
          a = "[object Array]" === o;
      t[e] = i ? _Fl(_Fl({}, mf[e]), n[e]) : a ? Wl(Wl([], mf[e]), n[e]) : n[e];
    }
  }), t;
},
    bf = function bf(n, t, e) {
  var r = n.transformState.scale,
      o = n.wrapperComponent,
      i = n.setup,
      a = i.maxScale,
      u = i.minScale,
      s = i.zoomAnimation.size;
  if (!o) throw new Error("Wrapper is not mounted");
  var c = r * Math.exp(t * e);
  return tf(Yl(c, 3), u, a, s, !1);
};

function wf(n, t, e, r, o) {
  var i = n.wrapperComponent,
      a = n.transformState,
      u = a.scale,
      s = a.positionX,
      c = a.positionY;
  if (!i) return console.error("No WrapperComponent found");
  var l = (i.offsetWidth / 2 - s) / u,
      f = (i.offsetHeight / 2 - c) / u,
      p = df(n, bf(n, t, e), l, f);
  if (!p) return console.error("Error during zoom event. New transformation state was not calculated.");
  Gl(n, p, r, o);
}

function xf(n, t, e) {
  var r = n.setup,
      o = n.wrapperComponent,
      i = r.limitToBounds,
      a = gf(n.props),
      u = n.transformState,
      s = u.scale,
      c = u.positionX,
      l = u.positionY;

  if (o) {
    var f = Kl(n, a.scale),
        p = Jl(a.positionX, a.positionY, f, i, 0, 0, o),
        d = {
      scale: a.scale,
      positionX: p.x,
      positionY: p.y
    };
    s === a.scale && c === a.positionX && l === a.positionY || Gl(n, d, t, e);
  }
}

var Sf = function Sf(n) {
  return function (t, e, r) {
    void 0 === t && (t = .5), void 0 === e && (e = 300), void 0 === r && (r = "easeOut"), wf(n, 1, t, e, r);
  };
},
    _f = function _f(n) {
  return function (t, e, r) {
    void 0 === t && (t = .5), void 0 === e && (e = 300), void 0 === r && (r = "easeOut"), wf(n, -1, t, e, r);
  };
},
    Ef = function Ef(n) {
  return function (t, e, r, o, i) {
    void 0 === o && (o = 300), void 0 === i && (i = "easeOut");
    var a = n.transformState,
        u = a.positionX,
        s = a.positionY,
        c = a.scale,
        l = n.wrapperComponent,
        f = n.contentComponent;

    if (!n.setup.disabled && l && f) {
      var p = {
        positionX: isNaN(t) ? u : t,
        positionY: isNaN(e) ? s : e,
        scale: isNaN(r) ? c : r
      };
      Gl(n, p, o, i);
    }
  };
},
    Tf = function Tf(n) {
  return function (t, e) {
    void 0 === t && (t = 200), void 0 === e && (e = "easeOut"), xf(n, t, e);
  };
},
    Pf = function Pf(n) {
  return function (t, e, r) {
    void 0 === e && (e = 200), void 0 === r && (r = "easeOut");
    var o = n.transformState,
        i = n.wrapperComponent,
        a = n.contentComponent;

    if (i && a) {
      var u = Nf(t || o.scale, i, a);
      Gl(n, u, e, r);
    }
  };
},
    Cf = function Cf(n) {
  return function (t, e, r, o) {
    void 0 === r && (r = 600), void 0 === o && (o = "easeOut"), Xl(n);
    var i = n.wrapperComponent,
        a = "string" == typeof t ? document.getElementById(t) : t;

    if (i && function (n) {
      return n ? void 0 !== (null == n ? void 0 : n.offsetWidth) && void 0 !== (null == n ? void 0 : n.offsetHeight) || (console.error("Zoom node is not valid - it must contain offsetWidth and offsetHeight"), !1) : (console.error("Zoom node not found"), !1);
    }(a) && a && i.contains(a)) {
      var u = function (n, t, e) {
        var r = n.wrapperComponent,
            o = n.setup,
            i = o.limitToBounds,
            a = o.minScale,
            u = o.maxScale;
        if (!r) return hf;

        var s = r.getBoundingClientRect(),
            c = function (n) {
          for (var t = n, e = 0, r = 0; t;) {
            e += t.offsetLeft, r += t.offsetTop, t = t.offsetParent;
          }

          return {
            x: e,
            y: r
          };
        }(t),
            l = c.x,
            f = c.y,
            p = t.offsetWidth,
            d = t.offsetHeight,
            h = r.offsetWidth / p,
            v = r.offsetHeight / d,
            m = tf(e || Math.min(h, v), a, u, 0, !1),
            g = (s.width - p * m) / 2,
            y = (s.height - d * m) / 2,
            b = Jl((s.left - l) * m + g, (s.top - f) * m + y, Kl(n, m), i, 0, 0, r);

        return {
          positionX: b.x,
          positionY: b.y,
          scale: m
        };
      }(n, a, e);

      Gl(n, u, r, o);
    }
  };
},
    Af = function Af(n) {
  return {
    instance: n,
    state: n.transformState,
    zoomIn: Sf(n),
    zoomOut: _f(n),
    setTransform: Ef(n),
    resetTransform: Tf(n),
    centerView: Pf(n),
    zoomToElement: Cf(n)
  };
};

function Lf() {
  try {
    return {
      get passive() {
        return !0, !1;
      }

    };
  } catch (n) {
    return !1;
  }
}

var Of = function Of(n, t) {
  var e = n.tagName.toUpperCase();
  return !!t.find(function (n) {
    return n.toUpperCase() === e;
  }) || !!t.find(function (t) {
    return n.classList.contains(t);
  });
},
    kf = function kf(n) {
  n && clearTimeout(n);
},
    Rf = function Rf(n, t, e) {
  return "translate3d(" + n + "px, " + t + "px, 0) scale(" + e + ")";
},
    Nf = function Nf(n, t, e) {
  var r = e.offsetWidth * n,
      o = e.offsetHeight * n;
  return {
    scale: n,
    positionX: (t.offsetWidth - r) / 2,
    positionY: (t.offsetHeight - o) / 2
  };
},
    zf = function zf(n, t) {
  var e = n.setup.wheel,
      r = e.disabled,
      o = e.wheelDisabled,
      i = e.touchPadDisabled,
      a = e.excluded,
      u = n.isInitialized,
      s = n.isPanning,
      c = t.target;
  return !(!u || s || r || !c) && !(o && !t.ctrlKey) && (!i || !t.ctrlKey) && !Of(c, a);
};

function If(n, t, e) {
  var r = t.getBoundingClientRect(),
      o = 0,
      i = 0;
  if ("clientX" in n) o = (n.clientX - r.left) / e, i = (n.clientY - r.top) / e;else {
    var a = n.touches[0];
    o = (a.clientX - r.left) / e, i = (a.clientY - r.top) / e;
  }
  return (isNaN(o) || isNaN(i)) && console.error("No mouse or touch offset found"), {
    x: o,
    y: i
  };
}

var Df = function Df(n, t) {
  var e = n.setup.pinch,
      r = e.disabled,
      o = e.excluded,
      i = n.isInitialized,
      a = t.target;
  return !(!i || r || !a) && !Of(a, o);
},
    jf = function jf(n) {
  var t = n.setup.pinch.disabled,
      e = n.isInitialized,
      r = n.pinchStartDistance;
  return !(!e || t || !r);
},
    Mf = function Mf(n) {
  return Math.sqrt(Math.pow(n.touches[0].pageX - n.touches[1].pageX, 2) + Math.pow(n.touches[0].pageY - n.touches[1].pageY, 2));
},
    Bf = function Bf(n, t) {
  var e = n.props,
      r = e.onWheelStart,
      o = e.onZoomStart;
  n.wheelStopEventTimer || (Xl(n), Hl(Af(n), t, r), Hl(Af(n), t, o));
},
    Vf = function Vf(n, t) {
  var e = n.props,
      r = e.onWheel,
      o = e.onZoom,
      i = n.contentComponent,
      a = n.setup,
      u = n.transformState.scale,
      s = a.limitToBounds,
      c = a.centerZoomedOut,
      l = a.zoomAnimation,
      f = a.wheel,
      p = l.size,
      d = l.disabled,
      h = f.step;
  if (!i) throw new Error("Component not mounted");
  t.preventDefault(), t.stopPropagation();

  var v = function (n, t, e, r, o) {
    var i = n.transformState.scale,
        a = n.wrapperComponent,
        u = n.setup,
        s = u.maxScale,
        c = u.minScale,
        l = u.zoomAnimation,
        f = l.size,
        p = l.disabled;
    if (!a) throw new Error("Wrapper is not mounted");
    var d = i + t * (i - i * e) * e;
    if (o) return d;
    var h = !r && !p;
    return tf(Yl(d, 3), c, s, f, h);
  }(n, function (n, t) {
    var e,
        r,
        o = n ? n.deltaY < 0 ? 1 : -1 : 0;
    return r = o, "number" == typeof (e = t) ? e : r;
  }(t, null), h, !t.ctrlKey);

  if (u !== v) {
    var m = Zl(n, v),
        g = If(t, i, u),
        y = s && (d || 0 === p || c),
        b = nf(n, g.x, g.y, v, m, y),
        w = b.x,
        x = b.y;
    n.previousWheelEvent = t, n.setTransformState(v, w, x), Hl(Af(n), t, r), Hl(Af(n), t, o);
  }
},
    Ff = function Ff(n, t) {
  var e = n.props,
      r = e.onWheelStop,
      o = e.onZoomStop;
  kf(n.wheelAnimationTimer), n.wheelAnimationTimer = setTimeout(function () {
    n.mounted && (pf(n, t.x, t.y), n.wheelAnimationTimer = null);
  }, 100), function (n, t) {
    var e = n.previousWheelEvent,
        r = n.transformState.scale,
        o = n.setup,
        i = o.maxScale,
        a = o.minScale;
    return !!e && (r < i || r > a || Math.sign(e.deltaY) !== Math.sign(t.deltaY) || e.deltaY > 0 && e.deltaY < t.deltaY || e.deltaY < 0 && e.deltaY > t.deltaY || Math.sign(e.deltaY) !== Math.sign(t.deltaY));
  }(n, t) && (kf(n.wheelStopEventTimer), n.wheelStopEventTimer = setTimeout(function () {
    n.mounted && (n.wheelStopEventTimer = null, Hl(Af(n), t, r), Hl(Af(n), t, o));
  }, 160));
},
    Wf = function Wf(n, t) {
  var e = Mf(t);
  n.pinchStartDistance = e, n.lastDistance = e, n.pinchStartScale = n.transformState.scale, n.isPanning = !1, Xl(n);
},
    Yf = function Yf(n, t) {
  var e = n.contentComponent,
      r = n.pinchStartDistance,
      o = n.transformState.scale,
      i = n.setup,
      a = i.limitToBounds,
      u = i.centerZoomedOut,
      s = i.zoomAnimation,
      c = s.disabled,
      l = s.size;

  if (null !== r && e) {
    var f = function (n, t, e) {
      var r = e.getBoundingClientRect(),
          o = n.touches,
          i = Yl(o[0].clientX - r.left, 5),
          a = Yl(o[0].clientY - r.top, 5);
      return {
        x: (i + Yl(o[1].clientX - r.left, 5)) / 2 / t,
        y: (a + Yl(o[1].clientY - r.top, 5)) / 2 / t
      };
    }(t, o, e);

    if (isFinite(f.x) && isFinite(f.y)) {
      var p = Mf(t),
          d = function (n, t) {
        var e = n.pinchStartScale,
            r = n.pinchStartDistance,
            o = n.setup,
            i = o.maxScale,
            a = o.minScale,
            u = o.zoomAnimation,
            s = u.size,
            c = u.disabled;
        if (!e || null === r || !t) throw new Error("Pinch touches distance was not provided");
        return t < 0 ? n.transformState.scale : tf(Yl(t / r * e, 2), a, i, s, !c);
      }(n, p);

      if (d !== o) {
        var h = Zl(n, d),
            v = a && (c || 0 === l || u),
            m = nf(n, f.x, f.y, d, h, v),
            g = m.x,
            y = m.y;
        n.pinchMidpoint = f, n.lastDistance = p, n.setTransformState(d, g, y);
      }
    }
  }
},
    Hf = function Hf(n) {
  var t = n.pinchMidpoint;
  n.velocity = null, n.lastDistance = null, n.pinchMidpoint = null, n.pinchStartScale = null, n.pinchStartDistance = null, pf(n, null == t ? void 0 : t.x, null == t ? void 0 : t.y);
};

function Uf(n, t) {
  var e = n.setup.doubleClick,
      r = e.disabled,
      o = e.mode,
      i = e.step,
      a = e.animationTime,
      u = e.animationType;

  if (!r) {
    if ("reset" === o) return xf(n, a, u);
    var s = n.transformState.scale,
        c = n.contentComponent;
    if (!c) return console.error("No ContentComponent found");
    var l = bf(n, "zoomOut" === o ? -1 : 1, i),
        f = If(t, c, s),
        p = df(n, l, f.x, f.y);
    if (!p) return console.error("Error during zoom event. New transformation state was not calculated.");
    Gl(n, p, a, u);
  }
}

var $f = function $f(n, t) {
  var e = n.isInitialized,
      r = n.setup,
      o = n.wrapperComponent,
      i = r.doubleClick,
      a = i.disabled,
      u = i.excluded,
      s = t.target,
      c = null == o ? void 0 : o.contains(s),
      l = e && s && c && !a;
  return !!l && !Of(s, u) && !!l;
},
    Xf = t.createContext(vf),
    qf = function (n) {
  function e() {
    var t = null !== n && n.apply(this, arguments) || this;
    return t.mounted = !0, t.transformState = gf(t.props), t.setup = yf(t.props), t.wrapperComponent = null, t.contentComponent = null, t.isInitialized = !1, t.bounds = null, t.previousWheelEvent = null, t.wheelStopEventTimer = null, t.wheelAnimationTimer = null, t.isPanning = !1, t.startCoords = null, t.lastTouch = null, t.distance = null, t.lastDistance = null, t.pinchStartDistance = null, t.pinchStartScale = null, t.pinchMidpoint = null, t.velocity = null, t.velocityTime = null, t.lastMousePosition = null, t.animate = !1, t.animation = null, t.maxBounds = null, t.pressedKeys = {}, t.handleInitializeWrapperEvents = function (n) {
      var e = Lf();
      n.addEventListener("wheel", t.onWheelZoom, e), n.addEventListener("dblclick", t.onDoubleClick, e), n.addEventListener("touchstart", t.onTouchPanningStart, e), n.addEventListener("touchmove", t.onTouchPanning, e), n.addEventListener("touchend", t.onTouchPanningStop, e);
    }, t.handleInitialize = function () {
      var n = t.setup.centerOnInit;
      t.applyTransformation(), t.forceUpdate(), n && (setTimeout(function () {
        t.mounted && t.setCenter();
      }, 50), setTimeout(function () {
        t.mounted && t.setCenter();
      }, 100), setTimeout(function () {
        t.mounted && t.setCenter();
      }, 200));
    }, t.onWheelZoom = function (n) {
      t.setup.disabled || zf(t, n) && t.isPressingKeys(t.setup.wheel.activationKeys) && (Bf(t, n), Vf(t, n), Ff(t, n));
    }, t.onPanningStart = function (n) {
      var e = t.setup.disabled,
          r = t.props.onPanningStart;
      e || ef(t, n) && t.isPressingKeys(t.setup.panning.activationKeys) && (n.preventDefault(), n.stopPropagation(), Xl(t), sf(t, n), Hl(Af(t), n, r));
    }, t.onPanning = function (n) {
      var e = t.setup.disabled,
          r = t.props.onPanning;
      e || rf(t) && t.isPressingKeys(t.setup.panning.activationKeys) && (n.preventDefault(), n.stopPropagation(), cf(t, n.clientX, n.clientY), Hl(Af(t), n, r));
    }, t.onPanningStop = function (n) {
      var e = t.props.onPanningStop;
      t.isPanning && (lf(t), Hl(Af(t), n, e));
    }, t.onPinchStart = function (n) {
      var e = t.setup.disabled,
          r = t.props,
          o = r.onPinchingStart,
          i = r.onZoomStart;
      e || Df(t, n) && (Wf(t, n), Xl(t), Hl(Af(t), n, o), Hl(Af(t), n, i));
    }, t.onPinch = function (n) {
      var e = t.setup.disabled,
          r = t.props,
          o = r.onPinching,
          i = r.onZoom;
      e || jf(t) && (n.preventDefault(), n.stopPropagation(), Yf(t, n), Hl(Af(t), n, o), Hl(Af(t), n, i));
    }, t.onPinchStop = function (n) {
      var e = t.props,
          r = e.onPinchingStop,
          o = e.onZoomStop;
      t.pinchStartScale && (Hf(t), Hl(Af(t), n, r), Hl(Af(t), n, o));
    }, t.onTouchPanningStart = function (n) {
      var e = t.setup.disabled,
          r = t.props.onPanningStart;
      if (!e && ef(t, n)) if (t.lastTouch && +new Date() - t.lastTouch < 200 && 1 === n.touches.length) t.onDoubleClick(n);else {
        t.lastTouch = +new Date(), Xl(t);
        var o = n.touches,
            i = 1 === o.length,
            a = 2 === o.length;
        i && (Xl(t), sf(t, n), Hl(Af(t), n, r)), a && t.onPinchStart(n);
      }
    }, t.onTouchPanning = function (n) {
      var e = t.setup.disabled,
          r = t.props.onPanning;

      if (t.isPanning && 1 === n.touches.length) {
        if (e) return;
        if (!rf(t)) return;
        n.preventDefault(), n.stopPropagation();
        var o = n.touches[0];
        cf(t, o.clientX, o.clientY), Hl(Af(t), n, r);
      } else n.touches.length > 1 && t.onPinch(n);
    }, t.onTouchPanningStop = function (n) {
      t.onPanningStop(n), t.onPinchStop(n);
    }, t.onDoubleClick = function (n) {
      t.setup.disabled || $f(t, n) && Uf(t, n);
    }, t.clearPanning = function (n) {
      t.isPanning && t.onPanningStop(n);
    }, t.setKeyPressed = function (n) {
      t.pressedKeys[n.key] = !0;
    }, t.setKeyUnPressed = function (n) {
      t.pressedKeys[n.key] = !1;
    }, t.isPressingKeys = function (n) {
      return !n.length || Boolean(n.find(function (n) {
        return t.pressedKeys[n];
      }));
    }, t.setComponents = function (n, e) {
      t.wrapperComponent = n, t.contentComponent = e, Zl(t, t.transformState.scale), t.handleInitializeWrapperEvents(n), t.handleInitialize(), t.handleRef(), t.isInitialized = !0, Hl(Af(t), void 0, t.props.onInit);
    }, t.setTransformState = function (n, e, r) {
      isNaN(n) || isNaN(e) || isNaN(r) ? console.error("Detected NaN set state values") : (n !== t.transformState.scale && (t.transformState.previousScale = t.transformState.scale, t.transformState.scale = n), t.transformState.positionX = e, t.transformState.positionY = r, t.applyTransformation());
    }, t.setCenter = function () {
      if (t.wrapperComponent && t.contentComponent) {
        var n = Nf(t.transformState.scale, t.wrapperComponent, t.contentComponent);
        t.setTransformState(n.scale, n.positionX, n.positionY);
      }
    }, t.applyTransformation = function () {
      if (t.mounted && t.contentComponent) {
        var n = t.transformState,
            e = n.scale,
            r = n.positionX,
            o = n.positionY,
            i = Rf(r, o, e);
        t.contentComponent.style.transform = i, t.handleRef();
      }
    }, t.handleRef = function () {
      t.props.setRef(Af(t));
    }, t;
  }

  return function (n, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");

    function e() {
      this.constructor = n;
    }

    _Vl(n, t), n.prototype = null === t ? Object.create(t) : (e.prototype = t.prototype, new e());
  }(e, n), e.prototype.componentDidMount = function () {
    var n = Lf();
    window.addEventListener("mousedown", this.onPanningStart, n), window.addEventListener("mousemove", this.onPanning, n), window.addEventListener("mouseup", this.onPanningStop, n), document.addEventListener("mouseleave", this.clearPanning, n), window.addEventListener("keyup", this.setKeyUnPressed, n), window.addEventListener("keydown", this.setKeyPressed, n), this.handleRef();
  }, e.prototype.componentWillUnmount = function () {
    var n = Lf();
    window.removeEventListener("mousedown", this.onPanningStart, n), window.removeEventListener("mousemove", this.onPanning, n), window.removeEventListener("mouseup", this.onPanningStop, n), window.removeEventListener("keyup", this.setKeyUnPressed, n), window.removeEventListener("keydown", this.setKeyPressed, n), Xl(this);
  }, e.prototype.componentDidUpdate = function (n) {
    n !== this.props && (Zl(this, this.transformState.scale), this.setup = yf(this.props));
  }, e.prototype.render = function () {
    var n = Af(this),
        e = this.props.children,
        r = "function" == typeof e ? e(n) : e;
    return t.createElement(Xf.Provider, {
      value: _Fl(_Fl({}, this.transformState), {
        setComponents: this.setComponents,
        contextInstance: this
      })
    }, r);
  }, e;
}(y),
    Gf = t.forwardRef(function (n, e) {
  var r = d(null),
      o = r[0],
      i = r[1];
  return g(e, function () {
    return o;
  }, [o]), t.createElement(qf, _Fl({}, n, {
    setRef: i
  }));
});

var Kf = "transform-component-module_wrapper__1_Fgj",
    Zf = "transform-component-module_content__2jYgh";
!function (n, t) {
  void 0 === t && (t = {});
  var e = t.insertAt;

  if (n && "undefined" != typeof document) {
    var r = document.head || document.getElementsByTagName("head")[0],
        o = document.createElement("style");
    o.type = "text/css", "top" === e && r.firstChild ? r.insertBefore(o, r.firstChild) : r.appendChild(o), o.styleSheet ? o.styleSheet.cssText = n : o.appendChild(document.createTextNode(n));
  }
}(".transform-component-module_wrapper__1_Fgj {\n  position: relative;\n  width: -moz-fit-content;\n  width: fit-content;\n  height: -moz-fit-content;\n  height: fit-content;\n  overflow: hidden;\n  -webkit-touch-callout: none; /* iOS Safari */\n  -webkit-user-select: none; /* Safari */\n  -khtml-user-select: none; /* Konqueror HTML */\n  -moz-user-select: none; /* Firefox */\n  -ms-user-select: none; /* Internet Explorer/Edge */\n  user-select: none;\n  margin: 0;\n  padding: 0;\n}\n.transform-component-module_content__2jYgh {\n  display: flex;\n  flex-wrap: wrap;\n  width: -moz-fit-content;\n  width: fit-content;\n  height: -moz-fit-content;\n  height: fit-content;\n  margin: 0;\n  padding: 0;\n  transform-origin: 0% 0%;\n}\n.transform-component-module_content__2jYgh img {\n  pointer-events: none;\n}\n");

var Jf,
    Qf,
    np,
    tp,
    ep,
    rp = function rp(n) {
  var e = n.children,
      a = n.wrapperClass,
      u = void 0 === a ? "" : a,
      s = n.contentClass,
      c = void 0 === s ? "" : s,
      l = n.wrapperStyle,
      f = n.contentStyle,
      p = r(Xf).setComponents,
      d = o(null),
      h = o(null);
  return i(function () {
    var n = d.current,
        t = h.current;
    null !== n && null !== t && p && p(n, t);
  }, []), t.createElement("div", {
    ref: d,
    className: "react-transform-wrapper " + Kf + " " + u,
    style: l
  }, t.createElement("div", {
    ref: h,
    className: "react-transform-component " + Zf + " " + c,
    style: f
  }, e));
},
    op = t.memo(function (n) {
  var e = n.src,
      r = n.caption,
      o = n.disablePanzoom,
      a = n.handlePanzoom,
      u = n.panzoomEnabled,
      s = n.boxShadow,
      c = n.imgHeight,
      l = n.imgWidth,
      f = bn(d(!0), 2),
      p = f[0],
      h = f[1];

  function v(n) {
    n.touches.length > 1 && !u && n.cancelable && (n.preventDefault(), a(!0));
  }

  i(function () {
    var n = new Image();
    n.src = e, n.onload = function () {
      h(!1);
    };
  }, [e]), i(function () {
    return document.addEventListener("touchstart", v, {
      passive: !1
    }), function () {
      document.addEventListener("touchstart", v, {
        passive: !1
      });
    };
  }, []);
  var m = p ? t.createElement(Bl, null) : u ? t.createElement(Gf, {
    maxScale: 6,
    minScale: .5,
    wheel: {
      step: .5
    },
    zoomAnimation: {
      animationType: "easeInOutQuad"
    }
  }, t.createElement(rp, null, t.createElement(Ml, {
    src: e,
    className: "SRLImage SRLImageZoomed",
    alt: r,
    initial: {
      opacity: 0
    },
    animate: {
      opacity: 1
    },
    exit: {
      opacity: 0
    },
    transition: {
      ease: "easeInOut"
    }
  }))) : t.createElement(jl, {
    src: e,
    className: "SRLImage",
    disablePanzoom: o,
    onClick: function onClick() {
      return a(!0);
    },
    alt: r,
    boxShadow: s,
    initial: {
      opacity: 0
    },
    animate: {
      opacity: 1
    },
    exit: {
      opacity: 0
    },
    transition: {
      ease: "easeInOut"
    },
    width: l,
    height: c
  });
  return t.createElement(Jc, null, m);
});

op.displayName = "ImageLoad", op.propTypes = {
  handlePanzoom: mn.func,
  src: mn.string,
  caption: mn.string,
  disablePanzoom: mn.bool,
  boxShadow: mn.string,
  panzoomEnabled: mn.bool,
  containerRef: mn.any,
  imgWidth: mn.number,
  imgHeight: mn.number
};

var ip,
    ap,
    up,
    sp,
    cp,
    lp,
    fp,
    pp,
    dp,
    hp,
    vp,
    mp,
    gp,
    yp,
    bp,
    wp,
    xp,
    Sp,
    _p,
    Ep = Te(Jf || (Jf = jn(["\n  -ms-grid-columns: 1fr auto;\n  grid-template-columns: 1fr auto;\n  -ms-grid-rows: 90% auto;\n  grid-template-rows: 90% auto;\n\n  > *:nth-of-type(1) {\n    -ms-grid-row: 1;\n  }\n\n  > *:nth-of-type(2) {\n    -ms-grid-row: 2;\n  }\n\n  > *:nth-of-type(3) {\n    -ms-grid-row: 1;\n  }\n"]))),
    Tp = Te(Qf || (Qf = jn(["\n  -ms-grid-columns: auto 1fr;\n  grid-template-columns: auto 1fr;\n  -ms-grid-rows: 90% auto;\n  grid-template-rows: 90% auto;\n\n  > *:nth-of-type(1) {\n    -ms-grid-row: 1;\n  }\n\n  > *:nth-of-type(2) {\n    -ms-grid-row: 2;\n  }\n\n  > *:nth-of-type(3) {\n    -ms-grid-row: 1;\n  }\n"]))),
    Pp = Be.div(np || (np = jn(["\n  bottom: 0;\n  left: 0;\n  right: 0;\n  top: 0;\n  display: grid;\n  display: -ms-grid;\n  -ms-grid-rows: auto;\n  grid-template-rows: auto;\n  align-items: center;\n  justify-content: center;\n  justify-items: center;\n  width: 100vw;\n  height: 100vh;\n  height: calc(var(--vh, 1vh) * 100);\n\n  > *:nth-of-type(1) {\n    -ms-grid-row: 1;\n  }\n\n  > *:nth-of-type(2) {\n    -ms-grid-row: 2;\n  }\n\n  > *:nth-of-type(3) {\n    -ms-grid-row: 3;\n  }\n\n  /* Thumbnails aligned to the right */\n  ", ";\n\n  /* Thumbnails aligned to the left */\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  @media (max-width: 768px) {\n    grid-template-columns: auto;\n    grid-template-rows: auto;\n  }\n"])), function (n) {
  return "right" === n.thumbnailsPosition && Ep;
}, function (n) {
  return "left" === n.thumbnailsPosition && Tp;
}, function (n) {
  return n.hideThumbnails && Te(tp || (tp = jn(["\n      -ms-grid-rows: 90% auto;\n      grid-template-rows: 90% auto;\n    "])));
}, function (n) {
  return !n.showCaption && Te(ep || (ep = jn(["\n      -ms-grid-rows: auto;\n      grid-template-rows: auto;\n    "])));
});

function Cp(n) {
  var e,
      r,
      a = n.caption,
      u = n.direction,
      s = n.elements,
      c = n.handleCurrentElement,
      l = n.handleCloseLightbox,
      f = n.handleNextElement,
      p = n.handlePanzoom,
      d = n.handlePrevElement,
      h = n.height,
      v = n.hideThumbnails,
      m = n.id,
      g = n.options,
      y = n.panzoomEnabled,
      b = n.source,
      w = n.SRLThumbnailsRef,
      x = n.SRLCaptionRef,
      S = n.width,
      _ = g.settings,
      E = g.thumbnails,
      T = g.caption,
      P = bn(Rl(x), 1)[0],
      C = bn(Rl(w), 1)[0],
      A = o(),
      L = !!window.MSInputMethodContext && !!document.documentMode,
      O = L ? 1e3 : "100%",
      k = L ? -1e3 : "-100%",
      R = {
    slideIn: function slideIn(n) {
      return {
        x: void 0 === n ? 0 : "next" === n ? O : k,
        transition: {
          ease: _.slideTransitionTimingFunction
        }
      };
    },
    slideOut: function slideOut(n) {
      return {
        x: "previous" === n ? O : k,
        transition: {
          ease: _.slideTransitionTimingFunction
        }
      };
    },
    fadeIn: {
      opacity: 0,
      transition: {
        ease: _.slideTransitionTimingFunction
      }
    },
    fadeOut: {
      opacity: 0,
      transition: {
        ease: _.slideTransitionTimingFunction
      }
    },
    bothIn: function bothIn(n) {
      return {
        opacity: 1,
        x: void 0 === n ? "0" : "next" === n ? 1e3 : -1e3,
        transition: {
          ease: _.slideTransitionTimingFunction
        }
      };
    },
    bothOut: function bothOut(n) {
      return {
        opacity: 0,
        x: "previous" === n ? 1e3 : -1e3,
        transition: {
          ease: _.slideTransitionTimingFunction
        }
      };
    },
    center: {
      x: 0,
      opacity: 1
    }
  },
      N = bl({
    onSwipedLeft: function onSwipedLeft() {
      return f(m);
    },
    onSwipedRight: function onSwipedRight() {
      return d(m);
    },
    delta: y ? 500 : 90,
    preventDefaultTouchmoveEvent: !0,
    trackTouch: !0,
    trackMouse: !1
  }),
      z = wl(function (n) {
    n > 0 ? f(m) : n < 0 && d(m);
  }, 150);
  i(function () {
    if (!y && !_.disableWheelControls) {
      var n = Ll(document, "wheel", function (n) {
        return z(n.deltaY);
      });
      return function () {
        n();
      };
    }
  }, [z, y, _.disableWheelControls]), i(function () {
    var n = function n(_n3) {
      !e.current || _n3.target.classList.contains("SRLImage") || _n3.target.classList.contains("SRLPanzoomImage") || _n3.target.classList.contains("SRLNextButton") || _n3.target.classList.contains("SRLPrevButton") || _n3.target.classList.contains("SRLCloseButton") || _n3.target.classList.contains("SRLAutoplayButton") || _n3.target.classList.contains("SRLExpandButton") || _n3.target.classList.contains("SRLZoomOutButton") || _n3.target.classList.contains("SRLDownloadButton") || _n3.target.classList.contains("SRLThumbnailsButton") || _n3.target.classList.contains("SRLCaptionContainer") || _n3.target.classList.contains("SRLCaptionText") || _n3.target.classList.contains("SRLCustomCaption") || _n3.target.classList.contains("SRLThumbnails") || _n3.target.classList.contains("SRLThumb") || _n3.target.classList.contains("SRLCaption") || _n3.target.classList.contains("react-transform-component") || _n3.target.classList.contains("react-transform-element") || "touchstart" === _n3.type || 0 !== _n3.button || r(_n3);
    };

    return "undefined" != typeof window && (document.addEventListener("mousedown", n), document.addEventListener("touchstart", n)), function () {
      "undefined" != typeof window && (document.removeEventListener("mousedown", n), document.removeEventListener("touchstart", n));
    };
  }, [e = A, r = function r() {
    return l();
  }]);
  var I = {
    captionAlignment: g.caption.captionAlignment,
    captionColor: g.caption.captionColor,
    captionContainerPadding: g.caption.captionContainerPadding,
    captionFontFamily: g.caption.captionFontFamily,
    captionFontSize: g.caption.captionFontSize,
    captionFontStyle: g.caption.captionFontStyle,
    captionFontWeight: g.caption.captionFontWeight,
    captionTextTransform: g.caption.captionTextTransform
  };
  return t.createElement(Pp, {
    className: "SRLContainer",
    ref: A,
    thumbnailsPosition: E.thumbnailsPosition,
    showCaption: T.showCaption,
    hideThumbnails: v
  }, t.createElement(Il, Dn({
    thumbnailsPosition: E.thumbnailsPosition,
    showThumbnails: E.showThumbnails,
    hideThumbnails: v,
    showCaption: T.showCaption,
    className: "SRLElementContainer",
    captionDivSizes: P,
    thumbnailsDivSizes: C
  }, N), t.createElement(Jc, {
    className: "SRLAnimatePresence",
    custom: u
  }, t.createElement(Dl, {
    variants: R,
    custom: u,
    initial: "slide" === _.slideAnimationType ? "slideIn" : "both" === _.slideAnimationType ? "bothIn" : "fadeIn",
    animate: "center",
    exit: "slide" === _.slideAnimationType ? "slideOut" : "both" === _.slideAnimationType ? "bothOut" : "fadeOut",
    className: "SRLElementWrapper",
    key: m || 0,
    transition: {
      x: {
        type: "spring",
        stiffness: _.slideSpringValues[0],
        damping: _.slideSpringValues[1]
      },
      opacity: {
        duration: _.slideTransitionSpeed
      }
    }
  }, t.createElement(op, {
    disablePanzoom: _.disablePanzoom,
    panzoomEnabled: y,
    handlePanzoom: p,
    containerRef: A,
    imgHeight: h,
    imgWidth: S,
    src: b,
    caption: a,
    boxShadow: _.boxShadow
  })))), T.showCaption && t.createElement(hl, {
    id: m,
    thumbnailsPosition: E.thumbnailsPosition,
    captionOptions: I,
    caption: a,
    SRLCaptionRef: x
  }), E.showThumbnails && !v && t.createElement(pl, {
    handleCurrentElement: c,
    thumbnails: E,
    currentId: m,
    elements: s || [],
    SRLThumbnailsRef: w
  }));
}

Cp.propTypes = {
  caption: mn.string,
  direction: mn.string,
  elements: mn.array,
  handleCloseLightbox: mn.func,
  handleCurrentElement: mn.func,
  handleNextElement: mn.func,
  handlePanzoom: mn.func,
  handlePrevElement: mn.func,
  height: mn.oneOfType([mn.number, mn.string]),
  hideThumbnails: mn.bool,
  id: mn.string,
  options: mn.shape({
    settings: mn.shape({
      boxShadow: mn.string,
      disablePanzoom: mn.bool,
      disableWheelControls: mn.bool,
      slideAnimationType: mn.string,
      slideSpringValues: mn.array,
      slideTransitionSpeed: mn.number,
      slideTransitionTimingFunction: mn.oneOfType([mn.string, mn.array])
    }),
    caption: mn.shape({
      captionAlignment: mn.string,
      captionColor: mn.string,
      captionFontFamily: mn.string,
      captionFontSize: mn.string,
      captionFontStyle: mn.string,
      captionFontWeight: mn.oneOfType([mn.number, mn.string]),
      captionContainerPadding: mn.string,
      captionTextTransform: mn.string,
      showCaption: mn.bool
    }),
    thumbnails: mn.shape({
      showThumbnails: mn.bool,
      thumbnailsOpacity: mn.number,
      thumbnailsPosition: mn.string,
      thumbnailsSize: mn.array
    })
  }),
  panzoomEnabled: mn.bool,
  showControls: mn.bool,
  source: mn.oneOfType([mn.string, mn.object]),
  SRLCaptionRef: mn.object,
  SRLThumbnailsRef: mn.object,
  thumbnailsOpacity: mn.number,
  type: mn.string,
  width: mn.oneOfType([mn.number, mn.string])
};

var Ap,
    Lp,
    Op = Be.button(ip || (ip = jn(["\n  position: absolute;\n  height: ", ";\n  width: ", ";\n  transition: color 0.3s ease;\n  background-color: ", ";\n  border: 0;\n  border-radius: 0;\n  box-shadow: none;\n  cursor: pointer;\n  margin: 0;\n  padding: 0;\n  visibility: inherit;\n  z-index: 9998;\n  opacity: 1;\n  transition: opacity 0.3s ease;\n  display: flex;\n  align-items: center;\n  align-content: center;\n  justify-content: center;\n\n  .SRLIdle & {\n    opacity: 0;\n\n    @media (max-width: 768px) {\n      opacity: 1;\n    }\n\n    @media (max-width: 360px) {\n      opacity: 1;\n    }\n  }\n\n  &:focus {\n    outline: none;\n  }\n\n  @media (max-width: 768px) {\n    height: ", ";\n    width: ", ";\n\n    .SRLIdle & {\n      opacity: 1;\n    }\n  }\n\n  div {\n    height: ", ";\n    width: ", ";\n    padding: ", ";\n    box-sizing: border-box;\n    display: flex;\n    align-items: center;\n\n    @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (-webkit-min-device-pixel-ratio: 2) {\n      padding: 10px;\n      height: ", ";\n      width: ", ";\n    }\n\n    @media only screen and (min-device-width: 1024px) and (max-device-width: 1366px) {\n      padding: 10px;\n      height: ", ";\n      width: ", ";\n    }\n\n    @media (max-width: 768px) {\n      padding: 10px;\n      height: ", ";\n      width: ", ";\n\n      .SRLIdle & {\n        opacity: 1;\n      }\n    }\n\n    svg {\n      display: block;\n      height: 100%;\n      width: 100%;\n      overflow: visible;\n      position: relative;\n      path {\n        transition: fill 0.3s ease;\n        fill: ", ";\n      }\n    }\n    &:hover {\n      svg path {\n        fill: ", ";\n      }\n    }\n  }\n"])), function (n) {
  return n.buttonsSize ? n.buttonsSize : "30px";
}, function (n) {
  return n.buttonsSize ? n.buttonsSize : "30px";
}, function (n) {
  return n.buttonsBackgroundColor ? n.buttonsBackgroundColor : "rgba(30, 30, 36, 0.8)";
}, function (n) {
  return n.buttonsSize ? Math.round(parseInt(n.buttonsSize, 10) / 1.2) + "px" : "30px";
}, function (n) {
  return n.buttonsSize ? Math.round(parseInt(n.buttonsSize, 10) / 1.2) + "px" : "30px";
}, function (n) {
  return n.buttonsSize ? n.buttonsSize : "30px";
}, function (n) {
  return n.buttonsSize ? n.buttonsSize : "30px";
}, function (n) {
  return n.buttonsIconPadding ? n.buttonsIconPadding : "5px";
}, function (n) {
  return n.buttonsSize ? Math.round(parseInt(n.buttonsSize, 10) / 1) + "px" : "30px";
}, function (n) {
  return n.buttonsSize ? Math.round(parseInt(n.buttonsSize, 10) / 1) + "px" : "30px";
}, function (n) {
  return n.buttonsSize ? Math.round(parseInt(n.buttonsSize, 10) / 1) + "px" : "30px";
}, function (n) {
  return n.buttonsSize ? Math.round(parseInt(n.buttonsSize, 10) / 1) + "px" : "30px";
}, function (n) {
  return n.buttonsSize ? Math.round(parseInt(n.buttonsSize, 10) / 1.1) + "px" : "30px";
}, function (n) {
  return n.buttonsSize ? Math.round(parseInt(n.buttonsSize, 10) / 1.1) + "px" : "30px";
}, function (n) {
  return n.buttonsIconColor ? n.buttonsIconColor : "rgba(255, 255, 255, 0.8)";
}, function (n) {
  return n.buttonsIconColor && n.buttonsIconColor.replace(/[\d\.]+\)$/g, "1)");
}),
    kp = Be.div(ap || (ap = jn(['\n  position: absolute;\n  top: 5px;\n  right: 5px;\n  top: calc(env(safe-area-inset-top) + 5px);\n  right: calc(env(safe-area-inset-right) + 5px);\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  transition: 0.3s ease;\n  will-change: right;\n\n  /* Offset the buttons if the progress bar is active and the autoplay is "playing" */\n  ', ";\n\n  /* Offset the buttons if the thumbnails are on the right */\n  ", ";\n\n  /* Thumbnails on right are closed so we need to reset the position */\n  ", ";\n\n  @media (max-width: 768px) {\n    right: 5px;\n    right: calc(env(safe-area-inset-right) + 5px) !important;\n  }\n"])), function (n) {
  return n.showProgressBar && n.autoplay && Te(up || (up = jn(["\n      top: ", "px;\n      top: calc(\n        env(safe-area-inset-top) +\n          ", "px\n      );\n    "])), 2 * Math.round(parseInt(n.buttonsOffsetFromProgressBar, 10)), 2 * Math.round(parseInt(n.buttonsOffsetFromProgressBar, 10)));
}, function (n) {
  return "right" === n.thumbnailsPosition && Te(sp || (sp = jn(["\n      right: ", "px;\n      right: calc(\n        env(safe-area-inset-top) + ", "px\n      );\n    "])), n.thumbnailsDivSizes.width + 5, n.thumbnailsDivSizes.width + 5);
}, function (n) {
  return n.hideThumbnails && "right" === n.thumbnailsPosition && Te(cp || (cp = jn(["\n      right: 5px;\n      right: calc(env(safe-area-inset-right) + 5px);\n    "])));
}),
    Rp = Be(Op)(lp || (lp = jn(["\n  position: relative;\n"]))),
    Np = Be(Op)(fp || (fp = jn(["\n  position: relative;\n  margin-right: 5px;\n\n  @media (max-width: 768px) {\n    display: none;\n  }\n"]))),
    zp = Be(Op)(pp || (pp = jn(["\n  position: relative;\n  margin-right: 5px;\n"]))),
    Ip = Be(Op)(dp || (dp = jn(["\n  position: relative;\n  margin-right: 5px;\n  display: ", ";\n"])), function (n) {
  return 0 === n.autoplaySpeed ? "none" : "flex";
}),
    Dp = Be(Op)(hp || (hp = jn(["\n  position: relative;\n  margin-right: 5px;\n\n  ", "\n\n  ", "\n\n  @media (max-width: 768px) {\n    svg {\n      transform: rotate(0) !important;\n    }\n  }\n"])), function (n) {
  return "right" === n.thumbnailsPosition && Te(vp || (vp = jn(["\n      svg {\n        transform: rotate(-90deg);\n      }\n    "])));
}, function (n) {
  return "left" === n.thumbnailsPosition && Te(mp || (mp = jn(["\n      svg {\n        transform: rotate(90deg);\n      }\n    "])));
}),
    jp = Be(Op)(gp || (gp = jn(["\n  position: relative;\n  margin-right: 5px;\n"]))),
    Mp = Be(Op)(yp || (yp = jn(["\n  top: calc(50% - 50px);\n  right: 5px;\n  right: calc(env(safe-area-inset-right) + 5px);\n  transition: 0.3s ease;\n  will-change: right;\n\n  /* Offset the thumbnails with the width of the div of the thumbnails */\n  ", ";\n\n  /* Thumbnails on right are closed so we need to reset the position */\n  ", ";\n\n  @media (max-width: 768px) {\n    display: none;\n  }\n"])), function (n) {
  return "right" === n.thumbnailsPosition && Te(bp || (bp = jn(["\n      right: ", "px;\n      right: calc(\n        env(safe-area-inset-right) + ", "px\n      );\n    "])), n.thumbnailsDivSizes.width + 5, n.thumbnailsDivSizes.width + 5);
}, function (n) {
  return n.hideThumbnails && "right" === n.thumbnailsPosition && Te(wp || (wp = jn(["\n      right: 5px;\n      right: calc(env(safe-area-inset-right) + 5px);\n    "])));
}),
    Bp = Be(Op)(xp || (xp = jn(["\n  top: calc(50% - 50px);\n  left: 5px;\n  left: calc(env(safe-area-inset-left) + 5px);\n  transition: 0.3s ease;\n  will-change: left;\n\n  /* Offset the thumbnails with the width of the div of the thumbnails */\n  ", ";\n\n  /* Thumbnails on left are closed so we need to reset the position */\n  ", ";\n\n  @media (max-width: 768px) {\n    display: none;\n  }\n"])), function (n) {
  return "left" === n.thumbnailsPosition && Te(Sp || (Sp = jn(["\n      left: ", "px;\n      left: calc(\n        env(safe-area-inset-right) + ", "px\n      );\n    "])), n.thumbnailsDivSizes.width + 5, n.thumbnailsDivSizes.width + 5);
}, function (n) {
  return n.hideThumbnails && "left" === n.thumbnailsPosition && Te(_p || (_p = jn(["\n      left: 5px;\n      left: calc(env(safe-area-inset-right) + 5px);\n    "])));
}),
    Vp = function Vp(n) {
  var e = n.autoplay,
      r = n.buttons,
      o = n.buttonsOffsetFromProgressBar,
      i = n.currentElementID,
      a = n.handleCloseLightbox,
      u = n.handleFullScreen,
      s = n.handleImageDownload,
      c = n.handleNextElement,
      l = n.handlePanzoom,
      f = n.handlePrevElement,
      p = n.handleThumbnails,
      d = n.hideThumbnails,
      h = n.panzoomEnabled,
      v = n.setAutoplay,
      m = n.settings,
      g = n.showProgressBar,
      y = n.showThumbnails,
      b = n.SRLThumbnailsRef,
      w = n.thumbnailsPosition,
      x = n.thumbnailsSize,
      S = bn(Rl(b), 1)[0];
  return t.createElement(t.Fragment, null, t.createElement(kp, {
    className: "SRLControls",
    autoplay: e,
    showProgressBar: g,
    buttonsOffsetFromProgressBar: o,
    thumbnailsPosition: w,
    thumbnailsDivSizes: S,
    thumbnailsSize: x,
    hideThumbnails: d
  }, r.showAutoplayButton && t.createElement(Ip, {
    buttonsBackgroundColor: r.backgroundColor,
    buttonsIconColor: r.iconColor,
    buttonsSize: r.size,
    buttonsIconPadding: r.iconPadding,
    autoplaySpeed: m.autoplaySpeed,
    title: e ? "Pause" : "Play",
    className: "SRLAutoplayButton",
    onClick: function onClick() {
      return v(!e);
    }
  }, t.createElement("div", {
    className: "SRLAutoplayButton"
  }, e ? t.createElement("svg", {
    className: "SRLAutoplayButton",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "11 11 30 30"
  }, t.createElement("path", {
    className: "SRLAutoplayButton",
    d: "M14.2 38.7h5.9c1.6 0 2.9-1.3 2.9-2.9V14.2c0-1.6-1.3-2.9-2.9-2.9h-5.9c-1.6 0-2.9 1.3-2.9 2.9v21.6c0 1.6 1.3 2.9 2.9 2.9zm-1-24.5c0-.5.4-1 1-1h5.9c.5 0 1 .4 1 1v21.6c0 .5-.4 1-1 1h-5.9c-.5 0-1-.4-1-1V14.2zm16.7 24.5h5.9c1.6 0 2.9-1.3 2.9-2.9V14.2c0-1.6-1.3-2.9-2.9-2.9h-5.9c-1.6 0-2.9 1.3-2.9 2.9v21.6c0 1.6 1.3 2.9 2.9 2.9zm-1-24.5c0-.5.4-1 1-1h5.9c.5 0 1 .4 1 1v21.6c0 .5-.4 1-1 1h-5.9c-.5 0-1-.4-1-1V14.2z"
  })) : t.createElement("svg", {
    className: "SRLAutoplayButton",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "11 11 30 30"
  }, t.createElement("path", {
    className: "SRLAutoplayButton",
    d: "M35.7 22.8L16.9 11.6c-1.5-.9-3.9 0-3.9 2.2v22.3c0 2 2.2 3.2 3.9 2.2l18.9-11.1c1.6-1 1.6-3.4-.1-4.4zm-.8 2.9L16 36.9c-.6.3-1.3-.1-1.3-.7V13.8c0-.9.9-1 1.3-.7l18.9 11.1c.5.4.5 1.2 0 1.5z"
  })))), r.showThumbnailsButton && y && t.createElement(Dp, {
    buttonsBackgroundColor: r.backgroundColor,
    buttonsIconColor: r.iconColor,
    buttonsSize: r.size,
    buttonsIconPadding: r.iconPadding,
    thumbnailsPosition: w,
    onClick: p,
    title: d ? "Show Thumbnails" : "Hide Thumbnails",
    className: "SRLThumbnailsButton"
  }, t.createElement("div", {
    className: "SRLThumbnailsButton"
  }, t.createElement("svg", {
    className: "SRLThumbnailsButton",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "11 11 30 30"
  }, t.createElement("g", {
    fill: "#fff",
    className: "SRLThumbnailsButton"
  }, t.createElement("path", {
    className: "SRLThumbnailsButton",
    d: "M15.4 27.4h-4.8c-1.3 0-2.4 1.1-2.4 2.4v4.8c0 1.3 1.1 2.4 2.4 2.4h4.8c1.3 0 2.4-1.1 2.4-2.4v-4.8c0-1.3-1.1-2.4-2.4-2.4zm12 0h-4.8c-1.3 0-2.4 1.1-2.4 2.4v4.8c0 1.3 1.1 2.4 2.4 2.4h4.8c1.3 0 2.4-1.1 2.4-2.4v-4.8c0-1.3-1.1-2.4-2.4-2.4zm12 0h-4.8c-1.3 0-2.4 1.1-2.4 2.4v4.8c0 1.3 1.1 2.4 2.4 2.4h4.8c1.3 0 2.4-1.1 2.4-2.4v-4.8c0-1.3-1.1-2.4-2.4-2.4z",
    opacity: ".4"
  }), t.createElement("path", {
    className: "SRLThumbnailsButton",
    d: "M39.4 13h-4.8c-1.3 0-2.4 1.1-2.4 2.4v4.8c0 1.3 1.1 2.4 2.4 2.4h4.8c1.3 0 2.4-1.1 2.4-2.4v-4.8c0-1.3-1.1-2.4-2.4-2.4zm-24 0h-4.8c-1.3 0-2.4 1.1-2.4 2.4v4.8c0 1.3 1.1 2.4 2.4 2.4h4.8c1.3 0 2.4-1.1 2.4-2.4v-4.8c0-1.3-1.1-2.4-2.4-2.4zm12 0h-4.8c-1.3 0-2.4 1.1-2.4 2.4v4.8c0 1.3 1.1 2.4 2.4 2.4h4.8c1.3 0 2.4-1.1 2.4-2.4v-4.8c0-1.3-1.1-2.4-2.4-2.4z"
  }))))), r.showDownloadButton && t.createElement(jp, {
    buttonsBackgroundColor: r.backgroundColor,
    buttonsIconColor: r.iconColor,
    buttonsSize: r.size,
    buttonsIconPadding: r.iconPadding,
    title: "Download image",
    className: "SRLDownloadButton",
    onClick: s
  }, t.createElement("div", {
    className: "SRLDownloadButton"
  }, t.createElement("svg", {
    className: "SRLDownloadButton",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "11 11 30 30"
  }, t.createElement("path", {
    className: "SRLDownloadButton",
    d: "M35.7 34.1c0 .6-.5 1-1.1 1-.6 0-1.1-.5-1.1-1s.5-1 1.1-1c.6 0 1.1.5 1.1 1zm-4.6-1c-.6 0-1.1.5-1.1 1s.5 1 1.1 1c.6 0 1.1-.5 1.1-1s-.5-1-1.1-1zm7.8-2.5V36c0 1.3-1.1 2.3-2.4 2.3h-23c-1.3 0-2.4-1-2.4-2.3v-5.4c0-1.3 1.1-2.3 2.4-2.3h5.4l-3.1-2.9c-1.4-1.3-.4-3.5 1.5-3.5h2.9v-8.1c0-1.1 1-2.1 2.2-2.1h5.2c1.2 0 2.2.9 2.2 2.1v8.1h2.9c1.9 0 2.9 2.2 1.5 3.5l-3.1 2.9h5.4c1.3 0 2.4 1 2.4 2.3zm-14.2.9c.2.2.4.2.6 0l7.6-7.3c.3-.3.1-.7-.3-.7H28v-9.7c0-.2-.2-.4-.4-.4h-5.2c-.2 0-.4.2-.4.4v9.7h-4.6c-.4 0-.6.4-.3.7l7.6 7.3zm12.5-.9c0-.3-.3-.6-.7-.6h-7.1l-2.8 2.7c-.8.8-2.2.8-3.1 0L20.6 30h-7.1c-.4 0-.7.3-.7.6V36c0 .3.3.6.7.6h23c.4 0 .7-.3.7-.6v-5.4z"
  })))), h ? t.createElement(zp, {
    buttonsBackgroundColor: r.backgroundColor,
    buttonsIconColor: r.iconColor,
    buttonsSize: r.size,
    buttonsIconPadding: r.iconPadding,
    title: "Zoom out",
    className: "SRLZoomOutButton",
    onClick: function onClick() {
      return l(!1);
    }
  }, t.createElement("div", {
    className: "SRLZoomOutButton"
  }, t.createElement("svg", {
    className: "SRLZoomOutButton",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "11 11 30 30"
  }, t.createElement("path", {
    className: "SRLZoomOutButton",
    d: "M27.9 21.6v1.3c0 .4-.3.7-.7.7h-10c-.4 0-.7-.3-.7-.7v-1.3c0-.4.3-.7.7-.7h10c.4 0 .7.3.7.7zm10.7 15.8l-1.2 1.2c-.3.3-.7.3-.9 0L29.9 32c-.1-.1-.2-.3-.2-.5v-.7c-2 1.7-4.6 2.8-7.4 2.8C16 33.6 11 28.5 11 22.3s5-11.4 11.3-11.4S33.6 16 33.6 22.3c0 2.8-1 5.4-2.8 7.4h.7c.2 0 .3.1.5.2l6.6 6.6c.3.2.3.6 0 .9zM31 22.3c0-4.8-3.9-8.7-8.7-8.7s-8.7 3.9-8.7 8.7 3.9 8.7 8.7 8.7 8.7-3.9 8.7-8.7z"
  })))) : "", r.showFullscreenButton && t.createElement(Np, {
    buttonsBackgroundColor: r.backgroundColor,
    buttonsIconColor: r.iconColor,
    buttonsSize: r.size,
    buttonsIconPadding: r.iconPadding,
    title: "Enter fullscreen",
    className: "SRLExpandButton",
    onClick: u
  }, t.createElement("div", {
    className: "SRLExpandButton"
  }, t.createElement("svg", {
    className: "SRLExpandButton",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "11 11 30 30"
  }, t.createElement("path", {
    className: "SRLExpandButton",
    d: "M11.22 20.66v-7.91a1.52 1.52 0 011.53-1.53h7.91a.76.76 0 01.76.76v1.53a.77.77 0 01-.76.77h-6.38v6.38a.77.77 0 01-.77.76H12a.76.76 0 01-.78-.76zM29.58 12v1.53a.78.78 0 00.77.77h6.38v6.38a.76.76 0 00.76.76H39a.77.77 0 00.77-.76v-7.93a1.52 1.52 0 00-1.53-1.53h-7.89a.77.77 0 00-.77.78zM39 29.58h-1.51a.77.77 0 00-.76.77v6.38h-6.38a.77.77 0 00-.77.76V39a.78.78 0 00.77.77h7.91a1.52 1.52 0 001.53-1.53v-7.89a.78.78 0 00-.79-.77zM21.42 39v-1.51a.76.76 0 00-.76-.76h-6.38v-6.38a.78.78 0 00-.77-.77H12a.77.77 0 00-.76.77v7.91a1.52 1.52 0 001.53 1.53h7.91a.77.77 0 00.74-.79z"
  })))), r.showCloseButton && t.createElement(Rp, {
    buttonsBackgroundColor: r.backgroundColor,
    buttonsIconColor: r.iconColor,
    buttonsSize: r.size,
    buttonsIconPadding: r.iconPadding,
    title: "Close",
    className: "SRLCloseButton",
    onClick: function onClick() {
      return a();
    }
  }, t.createElement("div", {
    className: "SRLCloseButton"
  }, t.createElement("svg", {
    className: "SRLCloseButton",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "11 11 30 30"
  }, t.createElement("path", {
    className: "SRLCloseButton",
    d: "M27.92 25l8.84-8.84 1.82-1.82c.27-.27.27-.71 0-.97l-1.95-1.95a.682.682 0 0 0-.97 0L25 22.08 14.34 11.42a.682.682 0 0 0-.97 0l-1.95 1.95c-.27.27-.27.71 0 .97L22.08 25 11.42 35.66c-.27.27-.27.71 0 .97l1.95 1.95c.27.27.71.27.97 0L25 27.92l8.84 8.84 1.82 1.82c.27.27.71.27.97 0l1.95-1.95c.27-.27.27-.71 0-.97L27.92 25z"
  }))))), r.showNextButton && t.createElement(Mp, {
    buttonsBackgroundColor: r.backgroundColor,
    buttonsIconColor: r.iconColor,
    buttonsSize: r.size,
    buttonsIconPadding: r.iconPadding,
    thumbnailsPosition: w,
    thumbnailsDivSizes: S,
    thumbnailsSize: x,
    hideThumbnails: d,
    title: "Next",
    className: "SRLNextButton",
    onClick: function onClick() {
      return c(i);
    }
  }, t.createElement("div", {
    className: "SRLNextButton"
  }, t.createElement("svg", {
    className: "SRLNextButton",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "11 11 30 30"
  }, t.createElement("path", {
    className: "SRLPrevButton",
    d: "M24.53 11.36l-.44.44c-.29.29-.29.76 0 1.05l11.09 11.09H11.83c-.41 0-.75.33-.75.75v.62c0 .41.33.75.75.75h23.35L24.09 37.14c-.29.29-.29.76 0 1.05l.44.44c.29.29.76.29 1.05 0l13.11-13.11c.29-.29.29-.76 0-1.05l-13.1-13.11a.754.754 0 0 0-1.06 0z"
  })))), r.showPrevButton && t.createElement(Bp, {
    buttonsBackgroundColor: r.backgroundColor,
    buttonsIconColor: r.iconColor,
    buttonsSize: r.size,
    buttonsIconPadding: r.iconPadding,
    title: "Previous",
    className: "SRLPrevButton",
    thumbnailsPosition: w,
    thumbnailsDivSizes: S,
    thumbnailsSize: x,
    hideThumbnails: d,
    onClick: function onClick() {
      return f(i);
    }
  }, t.createElement("div", {
    className: "SRLPrevButton"
  }, t.createElement("svg", {
    className: "SRLPrevButton",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "11 11 30 30"
  }, t.createElement("path", {
    className: "SRLPrevButton",
    d: "M25.47 38.64l.44-.44c.29-.29.29-.76 0-1.05L14.82 26.06h23.35c.41 0 .75-.33.75-.75v-.62c0-.41-.33-.75-.75-.75H14.82l11.09-11.09c.29-.29.29-.76 0-1.05l-.44-.44a.742.742 0 0 0-1.05 0L11.31 24.47c-.29.29-.29.76 0 1.05l13.11 13.11c.29.3.76.3 1.05.01z"
  })))));
};

Vp.propTypes = {
  autoplay: mn.bool,
  buttons: mn.shape({
    backgroundColor: mn.string,
    iconColor: mn.string,
    iconPadding: mn.string,
    showAutoplayButton: mn.bool,
    showCloseButton: mn.bool,
    showDownloadButton: mn.bool,
    showFullscreenButton: mn.bool,
    showNextButton: mn.bool,
    showPrevButton: mn.bool,
    showThumbnailsButton: mn.bool,
    size: mn.string
  }),
  hideThumbnails: mn.bool,
  buttonsOffsetFromProgressBar: mn.string,
  currentElementID: mn.string,
  handleCloseLightbox: mn.func,
  handleFullScreen: mn.func,
  handleImageDownload: mn.func,
  handleNextElement: mn.func,
  handlePanzoom: mn.func,
  handlePrevElement: mn.func,
  handleThumbnails: mn.func,
  panzoomEnabled: mn.bool,
  setAutoplay: mn.func,
  settings: mn.shape({
    autoplaySpeed: mn.number
  }),
  showProgressBar: mn.bool,
  showThumbnails: mn.bool,
  thumbnailsPosition: mn.string,
  SRLThumbnailsRef: mn.object,
  thumbnailsSize: mn.array
};

var Fp = Be.div(Ap || (Ap = jn(["\n  width: 100%;\n  height: ", ";\n  background-color: ", ";\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 9999;\n"])), function (n) {
  return n.barHeight;
}, function (n) {
  return n.backgroundColor;
}),
    Wp = Be.div(Lp || (Lp = jn(["\n  height: ", ";\n  width: 100%;\n  background-color: ", ";\n  position: absolute;\n  top: 0;\n  left: 0;\n  transform: scaleX(0);\n  transform-origin: 0;\n"])), function (n) {
  return n.barHeight;
}, function (n) {
  return n.fillColor;
}),
    Yp = function Yp(n) {
  var e = n.autoplay,
      r = n.autoplaySpeed,
      o = n.progressBar,
      a = n.currentElementID,
      u = bn(d(!1), 2),
      s = u[0],
      c = u[1];
  return i(function () {
    c(!1);
  }, [a]), kl(function () {
    c(!0);
  }, e ? r / 100 : null, a), t.createElement(Fp, {
    barHeight: o.height,
    backgroundColor: o.backgroundColor,
    className: "SRLProgressBar"
  }, t.createElement(Wp, {
    barHeight: o.height,
    fillColor: o.fillColor,
    style: {
      transform: "scaleX(".concat(s ? 1 : 0, ")"),
      transitionDuration: "".concat(s ? r + "ms" : "0ms")
    }
  }));
};

function Hp(n) {
  for (var t = [], e = 1; e < arguments.length; e++) {
    t[e - 1] = arguments[e];
  }

  n && n.addEventListener && n.addEventListener.apply(n, t);
}

function Up(n) {
  for (var t = [], e = 1; e < arguments.length; e++) {
    t[e - 1] = arguments[e];
  }

  n && n.removeEventListener && n.removeEventListener.apply(n, t);
}

Yp.propTypes = {
  autoplay: mn.bool,
  autoplaySpeed: mn.number,
  currentElementID: mn.string,
  progressBar: mn.shape({
    backgroundColor: mn.string,
    fillColor: mn.string,
    height: mn.string
  })
};

var $p = ["mousemove", "mousedown", "resize", "keydown", "touchstart", "wheel"],
    Xp = function Xp(n, t, e) {
  void 0 === n && (n = 6e4), void 0 === t && (t = !1), void 0 === e && (e = $p);
  var r = d(t),
      o = r[0],
      a = r[1];
  return i(function () {
    for (var t, r = !0, i = o, u = function u(n) {
      r && (i = n, a(n));
    }, s = function (n, t, e, r) {
      var o,
          i = !1,
          a = 0;

      function u() {
        o && clearTimeout(o);
      }

      function s() {
        for (var s = arguments.length, c = new Array(s), l = 0; l < s; l++) {
          c[l] = arguments[l];
        }

        var f = this,
            p = Date.now() - a;

        function d() {
          a = Date.now(), e.apply(f, c);
        }

        function h() {
          o = void 0;
        }

        i || (r && !o && d(), u(), void 0 === r && p > n ? d() : !0 !== t && (o = setTimeout(r ? h : d, void 0 === r ? n - p : n)));
      }

      return "boolean" != typeof t && (r = e, e = t, t = void 0), s.cancel = function () {
        u(), i = !0;
      }, s;
    }(50, function () {
      i && u(!1), clearTimeout(t), t = setTimeout(function () {
        return u(!0);
      }, n);
    }), c = function c() {
      document.hidden || s();
    }, l = 0; l < e.length; l++) {
      Hp(window, e[l], s);
    }

    return Hp(document, "visibilitychange", c), t = setTimeout(function () {
      return u(!0);
    }, n), function () {
      r = !1;

      for (var n = 0; n < e.length; n++) {
        Up(window, e[n], s);
      }

      Up(document, "visibilitychange", c);
    };
  }, [n, e]), o;
};

var qp = !1;

if ("undefined" != typeof window) {
  var Gp = {
    get passive() {
      qp = !0;
    }

  };
  window.addEventListener("testPassive", null, Gp), window.removeEventListener("testPassive", null, Gp);
}

var Kp = "undefined" != typeof window && window.navigator && window.navigator.platform && (/iP(ad|hone|od)/.test(window.navigator.platform) || "MacIntel" === window.navigator.platform && window.navigator.maxTouchPoints > 1),
    Zp = [],
    Jp = !1,
    Qp = -1,
    nd = void 0,
    td = void 0,
    ed = function ed(n) {
  return Zp.some(function (t) {
    return !(!t.options.allowTouchMove || !t.options.allowTouchMove(n));
  });
},
    rd = function rd(n) {
  var t = n || window.event;
  return !!ed(t.target) || t.touches.length > 1 || (t.preventDefault && t.preventDefault(), !1);
},
    od = function od(n, t) {
  if (n) {
    if (!Zp.some(function (t) {
      return t.targetElement === n;
    })) {
      var e = {
        targetElement: n,
        options: t || {}
      };
      Zp = [].concat(function (n) {
        if (Array.isArray(n)) {
          for (var t = 0, e = Array(n.length); t < n.length; t++) {
            e[t] = n[t];
          }

          return e;
        }

        return Array.from(n);
      }(Zp), [e]), Kp ? (n.ontouchstart = function (n) {
        1 === n.targetTouches.length && (Qp = n.targetTouches[0].clientY);
      }, n.ontouchmove = function (t) {
        1 === t.targetTouches.length && function (n, t) {
          var e = n.targetTouches[0].clientY - Qp;
          !ed(n.target) && (t && 0 === t.scrollTop && e > 0 || function (n) {
            return !!n && n.scrollHeight - n.scrollTop <= n.clientHeight;
          }(t) && e < 0 ? rd(n) : n.stopPropagation());
        }(t, n);
      }, Jp || (document.addEventListener("touchmove", rd, qp ? {
        passive: !1
      } : void 0), Jp = !0)) : function (n) {
        if (void 0 === td) {
          var t = !!n && !0 === n.reserveScrollBarGap,
              e = window.innerWidth - document.documentElement.clientWidth;
          t && e > 0 && (td = document.body.style.paddingRight, document.body.style.paddingRight = e + "px");
        }

        void 0 === nd && (nd = document.body.style.overflow, document.body.style.overflow = "hidden");
      }(t);
    }
  } else console.error("disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.");
},
    id = function id() {
  Kp ? (Zp.forEach(function (n) {
    n.targetElement.ontouchstart = null, n.targetElement.ontouchmove = null;
  }), Jp && (document.removeEventListener("touchmove", rd, qp ? {
    passive: !1
  } : void 0), Jp = !1), Qp = -1) : (void 0 !== td && (document.body.style.paddingRight = td, td = void 0), void 0 !== nd && (document.body.style.overflow = nd, nd = void 0)), Zp = [];
},
    ad = function ad(n) {
  var e = n.options,
      a = n.callbacks,
      u = n.selectedElement,
      s = n.elements,
      c = n.dispatch,
      l = n.compensateForScrollbar,
      p = r(En),
      h = o(),
      v = o(),
      m = o(),
      g = o(),
      y = e.buttons,
      b = e.settings,
      w = e.progressBar,
      x = e.thumbnails,
      S = a.onCountSlides,
      _ = a.onSlideChange,
      E = a.onLightboxClosed,
      T = a.onLightboxOpened,
      P = f(function (n) {
    if ("function" == typeof _) return p.callbacks.onSlideChange(n);
    console.error('Simple React Lightbox error: you are not passing a function in your "onSlideChange" callback! You are passing a '.concat(el(_), "."));
  }, [p.callbacks, _]),
      C = f(function (n) {
    "function" == typeof T ? p.callbacks.onLightboxOpened(n) : console.error('Simple React Lightbox error: you are not passing a function in your "onLightboxOpened" callback! You are passing a '.concat(el(T), "."));
  }, [p.callbacks, T]),
      A = f(function (n) {
    "function" == typeof E ? p.callbacks.onLightboxClosed(n) : console.error('Simple React Lightbox error: you are not passing a function in your "onLightboxClosed" callback! You are passing a '.concat(el(E), "."));
  }, [p.callbacks, E]),
      L = f(function (n) {
    "function" == typeof S ? p.callbacks.onCountSlides(n) : console.error('Simple React Lightbox error: you are not passing a function in your "onCountSlides" callback! You are passing a '.concat(el(S), "."));
  }, [p.callbacks, S]),
      O = bn(d(!1), 2),
      k = O[0],
      R = O[1],
      N = bn(d(!1), 2),
      z = N[0],
      I = N[1],
      D = bn(d(), 2),
      j = D[0],
      M = D[1],
      B = bn(d(!1), 2),
      V = B[0],
      F = B[1],
      W = Xp(b.hideControlsAfter < 1e3 ? 9999999 : b.hideControlsAfter),
      Y = f(function (n) {
    return Rn.exports.findIndex(s, function (t) {
      return t.id === n;
    });
  }, [s]),
      H = f(function (n, t, e) {
    M(e ? "next" === e ? "next" : "previous" === e ? "previous" : void 0 : n > t ? "next" : n < t ? "previous" : void 0);
  }, []),
      U = f(function () {
    F(!V);
  }, [V]),
      $ = f(function (n) {
    b.disablePanzoom || I(n);
  }, [b.disablePanzoom]),
      X = f(function (n, t, e, r) {
    $(!1), H(n, t, r), c({
      type: "HANDLE_ELEMENT",
      element: e
    });
  }, [H, $, c]);
  var q = f(function (n, t) {
    var e = Y(n),
        r = s[e];
    X(n, t, r), P({
      action: "selected",
      slides: {
        previous: s[e - 1],
        current: r,
        next: s[e + 1]
      },
      index: e
    });
  }, [s, Y, P, X]),
      G = f(function (n) {
    var t = Y(n),
        e = s[t - 1] || s[s.length - 1];
    X(n, null, e, "previous");
    var r = t - 1 == -1 ? s.length - 1 : t - 1;
    P({
      action: "left",
      slides: {
        previous: s[r - 1],
        current: e,
        next: s[r + 1]
      },
      index: r
    });
  }, [s, Y, P, X]),
      K = f(function (n) {
    var t = Y(n),
        e = s[t + 1] || s[0];
    X(n, null, e, "next");
    var r = t + 1 === s.length ? 0 : t + 1;
    P({
      action: "right",
      slides: {
        previous: s[r - 1],
        current: e,
        next: s[r + 1]
      },
      index: r
    });
  }, [s, Y, P, X]),
      Z = f(function () {
    c({
      type: "CLOSE_LIGHTBOX"
    }), A({
      opened: !1,
      currentSlide: p.selectedElement
    });
  }, [c, A, p.selectedElement]);
  kl(function () {
    return K(u.id);
  }, k ? b.autoplaySpeed : null, u.id);
  var J = wl(function (n) {
    "ArrowRight" !== n && "ArrowUp" !== n || K(u.id), "ArrowLeft" !== n && "ArrowDown" !== n || G(u.id), "Escape" === n && Z();
  }, 300);
  i(function () {
    return C({
      opened: !0,
      currentSlide: p.selectedElement
    }), L({
      totalSlide: p.elements.length
    }), "undefined" != typeof window && (document.body.classList.add("SRLOpened"), document.body.style.marginRight = l + "px", od(document.getElementsByClassName(".SRLOpened"), {
      allowTouchMove: function allowTouchMove(n) {
        return n.className.includes("SRLThumbnailsContainer") || n.className.includes("SRLThumb");
      }
    })), function () {
      document.body.classList.remove("SRLOpened"), document.body.style.marginRight = "0", id();
    };
  }, []), i(function () {
    return 0 === b.hideControlsAfter && b.hideControlsAfter || (W ? null !== m.current && void 0 !== m.current && m.current.classList.add("SRLIdle") : null !== m.current && void 0 !== m.current && m.current.classList.contains("SRLIdle") && m.current.classList.remove("SRLIdle")), void 0 === u.id && c({
      type: "HANDLE_ELEMENT",
      element: {
        source: s[0].source,
        caption: s[0].caption,
        id: s[0].id,
        width: s[0].width,
        height: s[0].height,
        type: s[0].type,
        showControls: s[0].showControls,
        videoAutoplay: s[0].videoAutoplay,
        muted: s[0].muted
      }
    }), b.disableKeyboardControls || (g.current = Ll(document, "keydown", function (n) {
      return J(n.key);
    }, !1)), function () {
      b.disableKeyboardControls || g.current();
    };
  }, [u.id, s, b.disablePanzoom, b.disableKeyboardControls, z, b.hideControlsAfter, W, J, j, p, c, u]);
  var Q = {
    autoplay: k,
    buttons: y,
    currentElementID: u.id,
    direction: j,
    handleCloseLightbox: Z,
    handleCurrentElement: q,
    handleFullScreen: function handleFullScreen() {
      var n = "";
      if ("undefined" != typeof window && (n = document.querySelector("#SRLLightbox")), document.fullscreenElement) document.exitFullscreen();else if (R(!1), null !== n) try {
        -1 !== navigator.userAgent.indexOf("Safari") && -1 === navigator.userAgent.indexOf("Chrome") ? n.webkitRequestFullScreen() : n.requestFullscreen();
      } catch (n) {
        !function (n) {
          console.error(n), console.warn("Sorry, your browser doesn't support this functionality!");
        }(n.message = "SRL - ERROR WHEN USING FULLSCREEN API");
      }
    },
    handleImageDownload: function handleImageDownload() {
      var n;
      (n = u.source, fetch(n).then(function (n) {
        return n.blob();
      }).then(function (n) {
        return new Promise(function (t, e) {
          var r = new FileReader();
          r.onloadend = function () {
            return t(r.result);
          }, r.onerror = e, r.readAsDataURL(n);
        });
      })).then(function (n) {
        var t = document.createElement("a");
        t.href = n, t.download = "".concat(p.options.settings.downloadedFileName, "-").concat(u.id), t.click();
      });
    },
    handleNextElement: K,
    handlePanzoom: $,
    handlePrevElement: G,
    handleThumbnails: U,
    hideThumbnails: V,
    panzoomEnabled: z,
    setAutoplay: R,
    settings: b,
    SRLThumbnailsRef: h,
    SRLCaptionRef: v
  },
      nn = {
    buttonsBackgroundColor: y.backgroundColor,
    buttonsIconColor: y.iconColor,
    buttonsSize: y.size,
    buttonsIconPadding: y.iconPadding,
    buttonsOffsetFromProgressBar: w.height,
    showProgressBar: w.showProgressBar,
    translations: p.options.translations,
    icons: p.options.icons
  };
  return t.createElement("div", {
    ref: m,
    className: "SRLStage"
  }, w.showProgressBar && k && t.createElement(Yp, {
    autoplay: k,
    autoplaySpeed: b.autoplaySpeed,
    progressBar: w,
    currentElementID: u.id
  }), t.createElement(Vp, Dn({}, nn, Q, {
    thumbnailsPosition: x.thumbnailsPosition,
    thumbnailsSize: x.thumbnailsSize,
    thumbnailsContainerPadding: x.thumbnailsContainerPadding,
    showThumbnails: x.showThumbnails,
    SRLThumbnailsRef: h
  })), t.createElement(Cp, Dn({}, u, Q, {
    elements: s,
    options: e
  })));
};

function ud() {
  var n = r(En),
      e = n.isOpened,
      a = n.options.settings.usingPreact,
      u = bn(d(0), 2),
      s = u[0],
      c = u[1],
      l = o();
  return i(function () {
    function n() {
      "undefined" != typeof window && (l.current = .01 * window.innerHeight, document.documentElement.style.setProperty("--vh", "".concat(l.current, "px")));
    }

    return n(), window.addEventListener("resize", n), function () {
      return window.removeEventListener("resize", n);
    };
  }, []), i(function () {
    "undefined" != typeof window && document.body.scrollHeight > window.innerHeight && c(window.innerWidth - document.documentElement.clientWidth);
  }), a ? t.createElement(tl, {
    selector: "SRLLightbox",
    isOpened: e
  }, t.createElement(ad, Dn({}, n, {
    compensateForScrollbar: s
  }))) : t.createElement(Jc, null, e && t.createElement(tl, {
    selector: "SRLLightbox",
    isOpened: e
  }, t.createElement(ad, Dn({}, n, {
    compensateForScrollbar: s
  }))));
}

ad.propTypes = {
  callbacks: mn.object,
  compensateForScrollbar: mn.number,
  elements: mn.array,
  isOpened: mn.bool,
  dispatch: mn.func,
  selectedElement: mn.object,
  options: mn.shape({
    thumbnails: mn.shape({
      thumbnailsContainerPadding: mn.string,
      thumbnailsPosition: mn.string,
      thumbnailsSize: mn.array,
      showThumbnails: mn.bool
    }),
    settings: mn.shape({
      overlayColor: mn.string,
      autoplaySpeed: mn.number,
      disableKeyboardControls: mn.bool,
      disablePanzoom: mn.bool,
      hideControlsAfter: mn.oneOfType([mn.number, mn.bool])
    }),
    buttons: mn.shape({
      backgroundColor: mn.string,
      iconColor: mn.string,
      iconPadding: mn.string,
      size: mn.string
    }),
    progressBar: mn.shape({
      showProgressBar: mn.bool,
      background: mn.string,
      height: mn.string
    })
  })
}, ud.propTypes = {
  context: mn.object
};

var sd = function sd(n) {
  var e = n.children;
  return t.createElement(Tn, null, e, t.createElement(ud, null));
};

sd.propTypes = {
  children: mn.oneOfType([mn.arrayOf(mn.node), mn.node]).isRequired
};
export { In as SRLWrapper, sd as default, Ol as useLightbox };